/** Tự sinh bởi scripts/fetch-articles.mjs lúc build — không sửa tay. */
export default [
  {
    "slug": "ba-bao-cao-tai-chinh-cua-startup",
    "title": "Ba báo cáo tài chính của startup: vì sao có kế hoạch lãi vẫn có thể hết tiền",
    "excerpt": "Đọc kết quả kinh doanh, lưu chuyển tiền tệ và bảng cân đối như nhà đầu tư, qua một ví dụ SaaS 36 tháng tính đến từng tháng và mẫu Excel tải miễn phí.",
    "category": "Báo cáo tài chính",
    "stages": [
      "Pre-seed",
      "Seed"
    ],
    "storyType": "huong-dan",
    "templates": [
      "mo-hinh-tai-chinh-36-thang-saas"
    ],
    "consentConfirmed": false,
    "coverImage": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Fba-bao-cao-tai-chinh-cua-startup%2F1790080542709-cover.webp?alt=media&token=edd400c8-75fd-4921-8c10-c2ae177a2cd1",
    "coverAlt": "Ba báo cáo tài chính của startup: vì sao có kế hoạch lãi vẫn có thể hết tiền",
    "coverCaption": "",
    "ogImage": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Fba-bao-cao-tai-chinh-cua-startup%2F1790080549037-cover.jpg?alt=media&token=334dddd5-1ce6-449e-88d2-6834d4ac8017",
    "author": "Fundraising Vietnam",
    "authorRole": "",
    "status": "PUBLISHED",
    "featured": false,
    "sections": [
      {
        "heading": "Ba báo cáo trả lời ba câu hỏi khác nhau",
        "paragraphs": [
          "Phần lớn founder gọi vốn lần đầu chỉ gửi một bảng: doanh thu trừ chi phí ra lợi nhuận. Nhà đầu tư đọc bảng đó xong vẫn chưa trả lời được câu hỏi họ quan tâm nhất: công ty còn tiền đến tháng nào?",
          "Lý do là lợi nhuận và tiền mặt là hai thứ khác nhau. Một bộ hồ sơ tài chính đầy đủ có ba báo cáo, mỗi báo cáo trả lời một câu hỏi riêng. Không báo cáo nào thay được báo cáo nào.",
          "Bài này đi qua cả ba bằng một ví dụ: một startup SaaS giả định, gọi vốn ba đợt trong 36 tháng. Toàn bộ số liệu lấy từ mẫu Excel đính kèm, nên bạn có thể mở file và đối chiếu từng con số."
        ],
        "bullets": [
          "Kết quả kinh doanh: công ty đang lãi hay lỗ, và vì sao?",
          "Lưu chuyển tiền tệ: tiền thật sự vào và ra bao nhiêu mỗi tháng?",
          "Cân đối kế toán: đến thời điểm này, công ty đang có gì và nợ ai?"
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Kết quả kinh doanh: lỗ bao nhiêu, và lỗ vì đâu",
        "paragraphs": [
          "Trong ví dụ, doanh thu năm 1 là khoảng 0,5 tỷ, năm 2 là 2,9 tỷ và năm 3 là 8,2 tỷ. Biên lợi nhuận gộp giữ ở 78%. Dù vậy, EBITDA vẫn âm cả ba năm, lần lượt khoảng −3,7 tỷ, −4,1 tỷ và −2,3 tỷ. Công ty chưa có lãi hoạt động trong 36 tháng.",
          "Với SaaS gọi vốn sớm, điều này bình thường. Nhà đầu tư không dừng ở con số lỗ mà nhìn vào cấu trúc của nó. Chi phí nào đang tăng nhanh hơn doanh thu? Khoản lỗ nhỏ dần hay to dần? Ở năm 3, khoản lỗ đã bắt đầu thu hẹp dù đội ngũ đông hơn. Đó là tín hiệu mô hình kinh doanh đang dần tự đứng được.",
          "Mẫu tách chi phí hoạt động thành ba nhóm: R&D, bán hàng & marketing, và quản lý. Cách chia này cho người đọc thấy tiền đang được tiêu vào làm sản phẩm, đi tìm khách hay vận hành bộ máy. Nếu cần xem lại EBITDA hay biên gộp là gì, bạn tra ở trang Thuật ngữ."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Lưu chuyển tiền tệ: báo cáo quyết định sống còn",
        "paragraphs": [
          "Đây là báo cáo nhà đầu tư mở đầu tiên, và cũng là báo cáo founder hay bỏ qua nhất.",
          "Trong ví dụ, năm 1 lỗ khoảng 3,77 tỷ nhưng tiền thực chi ra, trước khi tính vốn góp, là khoảng 3,88 tỷ. Phần chênh lệch đến từ tiền mua laptop và thiết bị. Khoản này chi ra ngay nhưng chỉ được tính vào chi phí dần qua khấu hao. Ngược lại, việc trả nhà cung cấp sau 30 ngày trong khi thu tiền khách sau 15 ngày giúp dòng tiền dễ thở hơn một chút.",
          "Con số đáng chú ý nhất trong cả file: tiền mặt thấp nhất chỉ còn khoảng 133 triệu, rơi vào tháng 5, đúng một tháng trước khi nhận vốn pre-seed. Trên giấy, kế hoạch không bao giờ âm tiền. Trên thực tế, chỉ cần vòng pre-seed chậm một tháng, và gọi vốn chậm là chuyện thường xảy ra, công ty sẽ không trả nổi lương tháng 6.",
          "Nhà đầu tư có kinh nghiệm sẽ thấy điểm này trong vài giây. Họ sẽ hỏi: \"Nếu vòng này đóng trễ hai tháng thì sao?\" Bạn nên tìm ra câu trả lời trước khi họ hỏi."
        ],
        "bullets": [
          "Nhìn tháng tiền mặt thấp nhất, không chỉ số dư cuối năm",
          "Tách dòng tiền trước huy động vốn để thấy mức đốt tiền thật mỗi tháng",
          "Nếu tiền thấp nhất sát 0 ngay trước tháng nhận vốn, kế hoạch đang đặt cược vào việc gọi vốn đúng hạn"
        ],
        "image": null,
        "quote": {
          "text": "\"Lợi nhuận là quan điểm, tiền mặt là sự thật.\"",
          "by": "My Nguyễn"
        },
        "table": null,
        "notes": []
      },
      {
        "heading": "Cân đối kế toán: đã đốt bao nhiêu phần vốn",
        "paragraphs": [
          "Bảng cân đối thường bị founder coi là thủ tục kế toán, nhưng nó trả lời một câu hỏi rất thực tế: tiền của cổ đông đã đi đâu.",
          "Cuối năm 3 trong ví dụ, tổng vốn góp là 19,5 tỷ và lỗ lũy kế khoảng 10,3 tỷ. Như vậy hơn một nửa số vốn đã được dùng để đổi lấy doanh thu và đội ngũ. Phần còn lại nằm chủ yếu ở tiền mặt, khoảng 9,3 tỷ.",
          "Hai kiểm tra nhà đầu tư luôn làm:"
        ],
        "bullets": [
          "Tổng tài sản phải bằng tổng nguồn vốn ở mọi tháng. Mô hình lệch cân đối cho thấy công thức có lỗi, và người đọc sẽ nghi ngờ mọi con số khác",
          "Lỗ lũy kế so với vốn góp: đã tiêu bao nhiêu phần, và phần đó đổi được cột mốc gì",
          "Mẫu có sẵn sheet Kiem_tra, tự so hai vế cân đối cho cả 36 tháng và báo OK hoặc LỖI."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Ba báo cáo nối với nhau như thế nào",
        "paragraphs": [
          "Ba báo cáo không phải ba bảng tính độc lập. Lợi nhuận sau thuế ở báo cáo kết quả kinh doanh là dòng đầu tiên của báo cáo lưu chuyển tiền tệ. Tiền cuối kỳ ở báo cáo lưu chuyển tiền tệ là dòng tiền mặt trên bảng cân đối. Lỗ lũy kế trên bảng cân đối là tổng lợi nhuận các tháng cộng lại.",
          "Nếu ba báo cáo được liên kết đúng, sửa một giả định sẽ làm cả ba cùng thay đổi. Ví dụ, khi tăng CAC, doanh thu giảm, tiền thấp nhất giảm theo, và bảng cân đối vẫn khớp. Đó chính là thứ nhà đầu tư kiểm tra khi họ tự sửa vài ô trong file của bạn.",
          "Nếu bạn đang ở bước dựng mô hình từ đầu, hãy đọc thêm bài về cấu trúc mô hình tài chính và bài về bảy biến số của SaaS trong mục Cẩm nang."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Dùng mẫu đính kèm để làm bản của bạn",
        "paragraphs": [
          "Mẫu Excel đính kèm có đủ ba báo cáo được liên kết sẵn cho 36 tháng, cùng một Dashboard tổng hợp: nhu cầu vốn bổ sung, tiền mặt thấp nhất và thời điểm xảy ra, burn trung bình, tháng EBITDA dương đầu tiên và 6 KPI SaaS.",
          "Bạn chỉ nhập vào ô nền vàng, theo thứ tự: nhân sự, chi phí cố định, giả định ngành, kế hoạch gọi vốn. Ba báo cáo tự tính.",
          "Trước khi gửi cho nhà đầu tư, hãy thử lùi tháng nhận vốn thêm hai tháng và xem Dashboard báo gì. Nếu dòng \"Nhu cầu vốn bổ sung tối thiểu\" lớn hơn 0, bạn biết mình cần xin thêm bao nhiêu, hoặc cần cắt chi phí nào."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      }
    ],
    "relatedTools": [
      {
        "slug": "tinh-runway",
        "label": "Tính runway"
      },
      {
        "slug": "goi-bao-nhieu",
        "label": "Lập kế hoạch số vốn"
      }
    ],
    "sources": [],
    "seoTitle": "Báo cáo tài chính startup: đọc như nhà đầu tư",
    "seoDescription": "Vì sao startup có kế hoạch lãi vẫn hết tiền? Đọc kết quả kinh doanh, lưu chuyển tiền tệ và bảng cân đối qua ví dụ SaaS 36 tháng, kèm mẫu Excel miễn phí.",
    "publishedAt": "2026-09-19",
    "updatedAt": "2026-09-22",
    "track": "cam-nang",
    "readingMinutes": 5
  },
  {
    "slug": "ban-co-phan-thu-cap-secondary",
    "title": "Bán cổ phần thứ cấp: khi nào founder và nhà đầu tư thiên thần được bán bớt trước khi công ty được mua",
    "excerpt": "Không phải ai cũng phải chờ tới lúc công ty được bán mới nhận được tiền. Trong một vòng gọi vốn, nhà đầu tư mới có thể mua lại một phần cổ phần của nhà đầu tư cũ hoặc của founder. Bài này giải thích bán cổ phần thứ cấp khác gọi vốn thế nào, ai thường bán và ai mua, mức giá thường thấp hơn vì sao, các điều khoản và quy định pháp luật Việt Nam cần kiểm, và quy",
    "category": "Cổ phần & cap table",
    "stages": [
      "Seed",
      "Series A"
    ],
    "storyType": "huong-dan",
    "templates": [],
    "consentConfirmed": false,
    "coverImage": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Fban-co-phan-thu-cap-secondary%2F1791381648598-cover.webp?alt=media&token=008544dc-c8b0-494f-ba95-c82cc8c227f4",
    "coverAlt": "Hai dòng tiền trong một vòng gọi vốn: tiền vào công ty và tiền trả cho cổ đông bán lại cổ phần",
    "coverCaption": "Trong giao dịch thứ cấp, tiền không vào công ty mà vào túi người bán.",
    "ogImage": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Fban-co-phan-thu-cap-secondary%2F1791381651491-cover.jpg?alt=media&token=e8299fdb-cf0c-46e0-b817-5ec4f87eec0e",
    "author": "Fundraising Vietnam",
    "authorRole": "",
    "status": "PUBLISHED",
    "featured": false,
    "sections": [
      {
        "heading": "Tiền vào công ty và tiền vào túi người bán",
        "paragraphs": [
          "Khi gọi vốn, công ty phát hành cổ phần mới và nhận tiền. Đó là giao dịch sơ cấp. Bán cổ phần thứ cấp (secondary) thì khác: một cổ đông đang có cổ phần bán lại cho người khác. Công ty không phát hành thêm gì và không nhận đồng nào; tiền đi thẳng từ người mua sang người bán.",
          "Hai loại giao dịch này thường diễn ra cùng lúc. Trong một vòng Series A, nhà đầu tư mới có thể vừa rót tiền vào công ty, vừa mua thêm một phần cổ phần của nhà đầu tư thiên thần cũ để đạt tỷ lệ sở hữu mong muốn."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": {
          "caption": "Sơ cấp và thứ cấp",
          "headers": [
            "",
            "Gọi vốn (sơ cấp)",
            "Bán cổ phần thứ cấp"
          ],
          "rows": [
            {
              "cells": [
                "Tiền đi đâu",
                "Vào công ty",
                "Vào người bán"
              ]
            },
            {
              "cells": [
                "Số cổ phần của công ty",
                "Tăng, mọi cổ đông bị pha loãng",
                "Không đổi, chỉ đổi người sở hữu"
              ]
            },
            {
              "cells": [
                "Mục đích",
                "Có tiền để tăng trưởng",
                "Cổ đông hiện hữu nhận một phần tiền trước"
              ]
            },
            {
              "cells": [
                "Giá",
                "Theo định giá vòng gọi vốn",
                "Thường thấp hơn giá vòng gọi vốn"
              ]
            }
          ]
        },
        "notes": []
      },
      {
        "heading": "Ai bán, ai mua",
        "paragraphs": [
          "Người bán thường là những người đã ở với công ty lâu nhất và chưa có lối ra nào khác."
        ],
        "bullets": [
          "Nhà đầu tư thiên thần và quỹ rất sớm: muốn thu hồi một phần vốn sau nhiều năm, hoặc quỹ sắp hết thời hạn hoạt động.",
          "Founder: bán một phần nhỏ để giải quyết nhu cầu tài chính cá nhân sau nhiều năm nhận lương thấp, để tiếp tục tập trung xây công ty.",
          "Nhân viên có quyền chọn cổ phần đã thực hiện: công ty tổ chức một đợt mua lại để nhân viên nhận được tiền từ phần thưởng cổ phần.",
          "Người mua thường là quỹ dẫn dắt vòng mới muốn tăng tỷ lệ sở hữu, quỹ chuyên mua cổ phần thứ cấp, hoặc chính công ty mua lại."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Khi nào founder nên bán, và bán bao nhiêu",
        "paragraphs": [
          "Nhà đầu tư lo nhất khi founder bán cổ phần là động lực: founder đã có tiền thì có còn dốc sức không. Vì thế việc founder bán thường chỉ được chấp nhận khi công ty đã qua giai đoạn rủi ro nhất và phần bán ra nhỏ so với phần founder còn giữ.",
          "Ở vòng thiên thần và pre-seed, founder bán cổ phần hầu như luôn là tín hiệu xấu. Từ Series A trở đi, khi công ty tăng trưởng tốt và có nhà đầu tư mới muốn mua thêm, việc founder bán một phần nhỏ để ổn định tài chính gia đình thường được thảo luận cởi mở hơn. Cách an toàn là để nhà đầu tư dẫn dắt vòng chủ động đề xuất, hoặc nêu rõ con số và lý do ngay từ đầu, thay vì để họ phát hiện trong hồ sơ."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Vì sao giá thường thấp hơn vòng gọi vốn",
        "paragraphs": [
          "Nhà đầu tư vòng mới mua cổ phần ưu đãi: có ưu đãi thanh lý, quyền phủ quyết và các quyền khác. Cổ phần của founder và nhân viên thường là cổ phần phổ thông, không có các quyền đó. Cổ phần của nhà đầu tư thiên thần cũ có thể có ít quyền hơn vòng mới. Vì vậy người mua thường trả thấp hơn giá vòng gọi vốn.",
          "Ví dụ minh họa: vòng Series A định giá 10 nghìn đồng mỗi cổ phần ưu đãi. Nhà đầu tư mới đồng ý mua thêm cổ phần phổ thông của một nhà đầu tư thiên thần với giá 7 nghìn đồng mỗi cổ phần, tức chiết khấu 30%. Mức chiết khấu cụ thể tuỳ thương lượng, tuỳ cổ phần đi kèm quyền gì và tuỳ có bao nhiêu người muốn mua."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": [
          "Đừng để giá bán thứ cấp quá thấp được ghi nhận rộng rãi. Một giao dịch bán rẻ có thể bị dùng làm căn cứ để ép định giá ở vòng sau, hoặc ảnh hưởng tới cách tính giá quyền chọn cổ phần cho nhân viên."
        ]
      },
      {
        "heading": "Điều khoản và quy định cần kiểm trước",
        "paragraphs": [
          "Một giao dịch thứ cấp liên quan tới nhiều bên hơn người mua và người bán. Trước khi thương lượng giá, hãy rà các điểm sau."
        ],
        "bullets": [
          "Quyền ưu tiên mua (ROFR): theo thoả thuận cổ đông, công ty hoặc nhà đầu tư hiện hữu thường được quyền mua trước với cùng giá trước khi bạn bán cho người ngoài.",
          "Quyền bán cùng (tag-along hoặc co-sale): khi founder bán, nhà đầu tư có thể được quyền bán kèm một phần theo cùng điều kiện, làm giảm số cổ phần founder bán được.",
          "Thời gian hạn chế chuyển nhượng: thoả thuận đầu tư có thể cấm founder bán trong một khoảng thời gian, hoặc yêu cầu hội đồng quản trị đồng ý.",
          "Luật Doanh nghiệp 2020: trong 3 năm kể từ ngày công ty được cấp đăng ký doanh nghiệp, cổ phần phổ thông của cổ đông sáng lập chỉ được chuyển nhượng cho người ngoài nhóm sáng lập khi Đại hội đồng cổ đông chấp thuận. Điều lệ công ty còn có thể đặt thêm hạn chế, nếu ghi rõ trên cổ phiếu.",
          "Công ty TNHH: thành viên muốn chuyển nhượng phần vốn góp phải chào bán cho các thành viên còn lại trước, theo tỷ lệ phần vốn góp của họ.",
          "Người mua nước ngoài: trong một số trường hợp, nhà đầu tư nước ngoài phải làm thủ tục đăng ký góp vốn, mua cổ phần theo Luật Đầu tư trước khi thay đổi cổ đông. Nếu công ty mẹ đặt ở nước ngoài, giao dịch theo luật nơi đó.",
          "Thuế thu nhập cá nhân: từ ngày 01/7/2026, Luật Thuế thu nhập cá nhân số 109/2025/QH15 và Nghị định 253/2026/NĐ-CP thay đổi cách tính thuế khi chuyển nhượng cổ phần và phần vốn góp. Cách tính khác nhau giữa cổ phần công ty cổ phần và vốn góp công ty TNHH, giữa công ty niêm yết và chưa niêm yết, và một số nội dung hướng dẫn vẫn đang được điều chỉnh. Hỏi kế toán thuế trước khi chốt giá, vì thuế ảnh hưởng trực tiếp tới số tiền bạn thật sự nhận."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Quy trình sáu bước",
        "paragraphs": [
          "Một giao dịch thứ cấp gọn gàng thường đi theo thứ tự dưới đây. Làm ngược thứ tự, như chốt giá với người mua trước rồi mới hỏi ý kiến cổ đông khác, là cách nhanh nhất để làm hỏng quan hệ với nhà đầu tư."
        ],
        "bullets": [
          "Bước 1: đọc lại điều lệ công ty, thoả thuận cổ đông và các thoả thuận đầu tư để biết ai có quyền ưu tiên mua, quyền bán cùng và ai phải đồng ý.",
          "Bước 2: báo trước cho hội đồng quản trị và nhà đầu tư dẫn dắt. Nói rõ ai bán, bán bao nhiêu và vì sao.",
          "Bước 3: chào bán cho những người có quyền ưu tiên mua theo đúng thời hạn trong thoả thuận.",
          "Bước 4: thương lượng giá và điều kiện với người mua, có tính tới chênh lệch giữa cổ phần phổ thông và cổ phần ưu đãi.",
          "Bước 5: ký hợp đồng chuyển nhượng bằng văn bản, có xác nhận của công ty; hỏi kế toán thuế về nghĩa vụ thuế trước khi ký.",
          "Bước 6: cập nhật sổ đăng ký cổ đông, cap table và thông báo thay đổi với cơ quan đăng ký kinh doanh nếu thuộc trường hợp phải thông báo; nộp thuế đúng hạn."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Tóm lại",
        "paragraphs": [
          "Bán cổ phần thứ cấp cho phép nhà đầu tư sớm, nhân viên và đôi khi founder nhận một phần tiền trước khi công ty được bán, mà không làm công ty nhận thêm tiền hay pha loãng ai. Nó hữu ích khi công ty đã đủ trưởng thành, phần bán ra nhỏ và mọi bên được biết trước.",
          "Trước khi bán, hãy kiểm quyền ưu tiên mua, quyền bán cùng, hạn chế chuyển nhượng của cổ đông sáng lập và nghĩa vụ thuế. Phần lớn rắc rối đến từ việc bỏ qua một trong bốn điểm đó."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      }
    ],
    "relatedTools": [
      {
        "slug": "bang-co-phan-va-pha-loang",
        "label": "Xem cap table trước và sau khi bán"
      },
      {
        "slug": "doc-term-sheet",
        "label": "Đọc quyền ưu tiên mua và quyền bán cùng trong term sheet"
      },
      {
        "slug": "ho-so-phap-ly-khoi-nghiep",
        "label": "Rà hồ sơ pháp lý trước khi chuyển nhượng"
      }
    ],
    "sources": [
      {
        "label": "Bộ Tư pháp: Trường hợp hạn chế chuyển nhượng cổ phần và lưu ý khi ký hợp đồng chuyển nhượng cổ phần",
        "url": "https://htpldn.moj.gov.vn/Pages/chi-tiet-pho-bien.aspx?ItemID=161"
      },
      {
        "label": "Cổng thông tin Chính phủ: Thuế TNCN đối với thu nhập từ chuyển nhượng chứng khoán (07/2026)",
        "url": "https://xaydungchinhsach.chinhphu.vn/thue-thu-nhap-ca-nhan-doi-voi-thu-nhap-tu-chuyen-nhuong-chung-khoan-119260703164200344.htm"
      },
      {
        "label": "Thời báo Tài chính Việt Nam: Đề xuất quy định chi tiết thuế thu nhập với chuyển nhượng vốn, chứng khoán (03/2026)",
        "url": "https://thoibaotaichinhvietnam.vn/de-xuat-quy-dinh-chi-tiet-thue-thu-nhap-voi-chuyen-nhuong-von-chung-khoan-194747.html"
      },
      {
        "label": "Y Combinator: A guide to seed fundraising",
        "url": "https://www.ycombinator.com/library/4A-a-guide-to-seed-fundraising"
      }
    ],
    "seoTitle": "Bán cổ phần thứ cấp (secondary) cho startup: khác gọi vốn ra sao, giá, điều khoản và quy định",
    "seoDescription": "Bán cổ phần thứ cấp là khi cổ đông hiện hữu bán lại cổ phần cho nhà đầu tư mới. Ai bán, ai mua, vì sao giá thấp hơn vòng gọi vốn, quyền ưu tiên mua, quyền bán cùng, hạn chế chuyển nhượng của cổ đông sáng lập theo Luật Doanh nghiệp 2020 và quy trình sáu bước.",
    "publishedAt": "2026-10-07",
    "updatedAt": "2026-10-07",
    "track": "cam-nang",
    "readingMinutes": 6
  },
  {
    "slug": "ban-do-ba-tang-goi-von-viet-nam",
    "title": "Bản đồ gọi vốn ở Việt Nam: ba tầng nhà đầu tư và bạn nên gõ cửa tầng nào",
    "excerpt": "Phần lớn lời từ chối \"còn quá sớm với chúng tôi\" đến từ việc gõ nhầm cửa, không phải vì công ty dở. Bài này chia thị trường vốn khởi nghiệp Việt Nam thành ba tầng: vốn sớm, vốn tăng trưởng và thoái vốn. Mỗi tầng có người cầm tiền, cỡ khoản và điều họ cần thấy khác nhau. Kèm số liệu thị trường 2025, bảng tự xác định tầng và cách chọn 15 đến 20 nhà đầu tư thay",
    "category": "Tiếp cận nhà đầu tư",
    "stages": [
      "Idea",
      "Pre-seed",
      "Seed"
    ],
    "storyType": "huong-dan",
    "templates": [
      "theo-doi-tiep-can-nha-dau-tu"
    ],
    "consentConfirmed": false,
    "coverImage": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Fban-do-ba-tang-goi-von-viet-nam%2F1791380718705-cover.webp?alt=media&token=f46eb0a4-4056-4198-ada7-07589cb8dde7",
    "coverAlt": "Ba tầng gọi vốn xếp chồng: vốn sớm, vốn tăng trưởng và thoái vốn, kèm cỡ vòng trung vị của từng tầng",
    "coverCaption": "Mỗi tầng có người cầm tiền, cỡ khoản và điều kiện riêng. Gõ đúng tầng là bước đầu tiên của một vòng gọi vốn.",
    "ogImage": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Fban-do-ba-tang-goi-von-viet-nam%2F1791380726417-cover.jpg?alt=media&token=1dab6ceb-fb87-49dc-b0e7-c42087a9c593",
    "author": "Fundraising Vietnam",
    "authorRole": "",
    "status": "PUBLISHED",
    "featured": false,
    "sections": [
      {
        "heading": "Bị từ chối vì gõ nhầm cửa",
        "paragraphs": [
          "Một founder vừa có sản phẩm thử, chưa có khách trả tiền, gửi deck cho mười quỹ đầu tư mạo hiểm có tên tuổi. Ba quỹ trả lời, cả ba cùng một câu: còn quá sớm với chúng tôi, giữ liên lạc nhé. Bảy quỹ còn lại im lặng. Founder kết luận ý tưởng của mình không ai tin.",
          "Thực ra cả mười quỹ đều không đầu tư ở giai đoạn đó. Họ không chê ý tưởng; họ chỉ không phải người cầm loại tiền founder đang cần. Thị trường vốn khởi nghiệp chia thành nhiều tầng, mỗi tầng có người cầm tiền, cỡ khoản và điều kiện riêng. Biết mình đang đứng ở tầng nào giúp bạn tránh được phần lớn các lời từ chối vô ích, và giữ được uy tín trong một cộng đồng nhà đầu tư khá nhỏ.",
          "Bài này chia thị trường ở Việt Nam thành ba tầng: vốn sớm, vốn tăng trưởng và thoái vốn. Trước khi đi vào từng tầng, hãy xem bức tranh chung năm 2025."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Thị trường 2025 bằng số: hai báo cáo, một xu hướng",
        "paragraphs": [
          "Hai báo cáo lớn về năm 2025 đưa ra con số rất khác nhau, và đó là điều founder nên biết trước khi trích dẫn bất kỳ con số thị trường nào trong deck. Báo cáo của Trung tâm Đổi mới sáng tạo Quốc gia (NIC), Cơ quan Vốn tư nhân Việt Nam (VPCA) và Do Ventures ghi nhận vốn đầu tư mạo hiểm khoảng 509 triệu USD qua 104 thương vụ, tăng 28% so với năm trước. Báo cáo của VinVentures chỉ ghi nhận khoảng 215 triệu USD qua 41 thương vụ, giảm khoảng 30%.",
          "Chênh lệch đến từ cách đếm: thương vụ nào được tính là đầu tư mạo hiểm, có tính các vòng lớn ở giai đoạn sau hay không, có tính startup đăng ký ở nước ngoài nhưng hoạt động tại Việt Nam hay không. Không báo cáo nào sai; chúng đo những thứ khác nhau. Khi dùng số thị trường trong deck, hãy ghi rõ nguồn và năm, và đừng ghép số của hai báo cáo vào cùng một phép tính.",
          "Điều quan trọng hơn là cả hai cùng chỉ một hướng: tiền đang dồn về những công ty đã chứng minh được mình kiếm ra tiền."
        ],
        "bullets": [
          "Chỉ khoảng 29,5% startup gọi vốn trong năm 2025 thành công, và 70% trong số đó đã có doanh thu (VinVentures).",
          "Thương vụ từ 1 đến 5 triệu USD tăng từ 21% năm 2023 lên khoảng 41 đến 43% năm 2025; thương vụ dưới 1 triệu USD tiếp tục giảm (VinVentures).",
          "10 thương vụ lớn nhất chiếm 72% tổng vốn (VinVentures). Tiền tập trung vào ít công ty hơn.",
          "Vốn vào startup AI tăng khoảng 13 lần từ 2023 đến 2025 (NIC, VPCA và Do Ventures)."
        ],
        "image": null,
        "quote": null,
        "table": {
          "caption": "Hai báo cáo về vốn đầu tư mạo hiểm tại Việt Nam năm 2025",
          "headers": [
            "",
            "NIC, VPCA và Do Ventures",
            "VinVentures"
          ],
          "rows": [
            {
              "cells": [
                "Tổng vốn đầu tư mạo hiểm",
                "Khoảng 509 triệu USD",
                "Khoảng 215 triệu USD"
              ]
            },
            {
              "cells": [
                "Số thương vụ",
                "104",
                "Khoảng 41"
              ]
            },
            {
              "cells": [
                "So với năm 2024",
                "Tăng 28%",
                "Giảm khoảng 30%"
              ]
            },
            {
              "cells": [
                "Điểm nhấn",
                "Vốn vào startup AI khoảng 130 triệu USD, 23 thương vụ",
                "Khoảng 60% vốn dành cho vòng tiếp theo và vòng bắc cầu của công ty đã có trong danh mục"
              ]
            }
          ]
        },
        "notes": [
          "Ý nghĩa với founder gọi vốn lần đầu: các quỹ đang ưu tiên rót thêm cho công ty cũ và cho công ty có doanh thu. Nếu bạn chưa có doanh thu, cửa vào quỹ đầu tư mạo hiểm hẹp hơn mấy năm trước, và tầng vốn sớm là nơi nên bắt đầu."
        ]
      },
      {
        "heading": "Tầng 1: vốn sớm, khi bạn chủ yếu bán niềm tin",
        "paragraphs": [
          "Đây là tầng của ý tưởng, sản phẩm thử và những khách hàng đầu tiên. Bạn chưa có đủ số liệu để ai định giá bằng doanh thu, nên người bỏ tiền chủ yếu đánh giá đội ngũ, độ lớn của vấn đề và tốc độ bạn học được từ thị trường.",
          "Người cầm tiền ở tầng này thường là: tiền của chính founder, gia đình và người quen; nhà đầu tư thiên thần (cá nhân bỏ tiền túi) và các mạng lưới thiên thần; chương trình tăng tốc khởi nghiệp (accelerator); chương trình của doanh nghiệp lớn dành cho startup; và các khoản tài trợ không hoàn lại của nhà nước hoặc tổ chức quốc tế.",
          "Cỡ khoản nhỏ. Theo báo cáo của VPCA, NIC và BCG, vòng Pre-A (vòng ngay trước Series A) năm 2024 có trung vị khoảng 0,3 triệu USD, tức khoảng 7,5 tỷ đồng. Vòng thiên thần và pre-seed thường còn nhỏ hơn. Hình thức phổ biến là SAFE hoặc trái phiếu chuyển đổi, vì cả hai bên đều chưa có cơ sở để chốt một mức định giá chính xác."
        ],
        "bullets": [
          "Họ cần thấy: đội ngũ hiểu sâu vấn đề, khách hàng thật đang gặp vấn đề đó, và tốc độ làm ra sản phẩm.",
          "Bạn nên chuẩn bị: deck ngắn, một con số chứng minh nhu cầu (người dùng thử, đơn đặt trước, thư cam kết), kế hoạch dùng tiền cho 12 đến 18 tháng.",
          "Rủi ro hay gặp: nhận tiền từ quá nhiều cá nhân nhỏ lẻ khiến cap table rối, hoặc ký điều khoản bất lợi vì sốt ruột."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Accelerator không chỉ là nơi nhận tiền",
        "paragraphs": [
          "Nhiều founder coi accelerator như một quỹ nhỏ, rồi thất vọng vì số tiền không lớn. Thực chất accelerator đổi một phần cổ phần lấy ba thứ: một khoản tiền nhỏ, vài tháng huấn luyện cường độ cao, và quan trọng nhất là mạng lưới nhà đầu tư cho vòng kế tiếp.",
          "Ví dụ, chương trình Accelerator của VSV Capital công bố đầu tư tối đa 50.000 USD cho mỗi đội, đổi lấy 7 đến 10% cổ phần, kèm 4 tháng bootcamp tại Hà Nội, mỗi khoá 10 đến 15 đội. Nếu chỉ tính tiền, 50.000 USD cho 10% tương đương định giá sau vòng khoảng 500.000 USD, thấp hơn nhiều so với một vòng thiên thần thông thường. Bạn đang trả phần chênh lệch đó cho huấn luyện và mạng lưới. Đáng hay không tuỳ bạn cần hai thứ đó đến mức nào.",
          "Cũng có chương trình không lấy cổ phần mà tập trung vào tín dụng công nghệ, cố vấn và kết nối quỹ, như VietLeap AI Accelerator do NIC, JICA và BCG khởi động tháng 10/2025 cho 10 đến 15 startup AI. Đọc kỹ điều khoản trước khi nộp: chương trình lấy bao nhiêu cổ phần, bằng hình thức gì, và có ràng buộc gì với vòng sau."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": [
          "Kiểm tra trước khi nộp: một số tên accelerator vẫn được nhắc trong các bài tổng hợp trên mạng nhưng đã ngừng tuyển khoá mới nhiều năm. Ví dụ website VIISA không có cập nhật nào sau năm 2019. Hãy xem khoá gần nhất và ngày cập nhật trên trang chính thức trước khi dành thời gian chuẩn bị hồ sơ."
        ]
      },
      {
        "heading": "Đừng quên quỹ của các tập đoàn",
        "paragraphs": [
          "Quỹ đầu tư của doanh nghiệp (corporate venture capital, CVC) thường bị founder bỏ qua vì nghĩ họ chỉ quan tâm tới startup lớn. Thực tế CVC có thể là cửa vào tốt cho startup giai đoạn sớm có sản phẩm khớp với hệ sinh thái của tập đoàn: ngoài tiền, bạn có thể có khách hàng lớn đầu tiên, kênh phân phối và dữ liệu để thử sản phẩm.",
          "Ví dụ VinVentures, quỹ của Vingroup, có chương trình B.O.U.N.D 2026 đầu tư tối thiểu 500.000 USD cho mỗi startup được chọn, nhắm vào công ty đã có giải pháp chạy được, bằng chứng thương mại hoá ban đầu và tín hiệu tăng trưởng, kết nối với các công ty trong tập đoàn.",
          "Đổi lại, cần cân nhắc: CVC có mục tiêu chiến lược của tập đoàn, không chỉ lợi nhuận tài chính. Điều đó có thể hạn chế bạn bán hàng cho đối thủ của tập đoàn, hoặc khiến các quỹ khác ngần ngại vì nghĩ công ty sớm muộn sẽ bị chính tập đoàn đó mua lại. Hãy hỏi thẳng về quyền ưu tiên mua lại và các ràng buộc độc quyền trước khi ký."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Tầng 2: vốn tăng trưởng, khi con số phải tự nói",
        "paragraphs": [
          "Đây là tầng của các quỹ đầu tư mạo hiểm (VC), từ vòng Seed tới Series A, B. Ở tầng này, niềm tin không còn đủ. Quỹ muốn thấy mô hình kinh doanh đã chạy: khách trả tiền đều đặn, chi phí có một khách hàng hợp lý so với giá trị khách mang lại, và công ty biết rõ tiền mới sẽ đổ vào đâu để tăng trưởng nhanh hơn.",
          "Theo báo cáo của VPCA, NIC và BCG, năm 2024 vòng Series A có trung vị khoảng 2 triệu USD và Series B khoảng 10 triệu USD (giảm từ mức đỉnh 26 triệu USD năm 2021). Như đã thấy ở trên, năm 2025 phần lớn vốn rơi vào các thương vụ từ 1 đến 5 triệu USD và vào công ty đã có doanh thu."
        ],
        "bullets": [
          "Họ cần thấy: doanh thu tăng đều qua nhiều tháng, tỷ lệ giữ chân khách hàng, giá trị vòng đời khách hàng so với chi phí có khách (LTV:CAC), và biên lợi nhuận gộp.",
          "Bạn nên chuẩn bị: mô hình tài chính 3 năm có giả định rõ ràng, cap table sạch, bộ hồ sơ thẩm định (data room) sẵn sàng.",
          "Rủi ro hay gặp: dự phóng tăng trưởng quá dốc so với số thực tế, hoặc định giá đòi cao hơn mặt bằng khiến vòng sau khó gọi."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Tầng 3: thoái vốn, câu hỏi quỹ đặt ra ngay từ ngày đầu",
        "paragraphs": [
          "Quỹ đầu tư chỉ kiếm được tiền khi bán lại cổ phần. Vì vậy ngay cả ở vòng đầu, họ đã tự hỏi: công ty này sau 5 đến 8 năm sẽ được ai mua, hoặc niêm yết ở đâu.",
          "Ở Việt Nam, con đường phổ biến nhất vẫn là mua bán và sáp nhập (M&A): công ty được một tập đoàn trong nước, một công ty cùng ngành trong khu vực hoặc một quỹ đầu tư lớn hơn mua lại. Niêm yết trên sàn chứng khoán còn hiếm với startup công nghệ vì tiêu chí niêm yết hiện tại dựa nhiều vào lợi nhuận. Theo báo cáo của NIC, VPCA và Do Ventures, cơ quan quản lý đang xây dựng một sàn giao dịch riêng cho doanh nghiệp đổi mới sáng tạo với tiêu chí niêm yết linh hoạt hơn, dự kiến ra mắt năm 2027. Ngoài ra còn hình thức bán cổ phần thứ cấp: nhà đầu tư cũ bán lại phần của mình cho nhà đầu tư mới trong một vòng sau.",
          "Founder không cần một kế hoạch thoái vốn chi tiết ở vòng đầu, nhưng nên trả lời được ba câu: ai có lý do chiến lược để mua công ty bạn, đã có thương vụ tương tự nào trong khu vực gần đây, và quy mô bạn cần đạt để trở thành mục tiêu đáng mua."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Bạn đang ở tầng nào",
        "paragraphs": [
          "Dùng bảng dưới đây để tự xác định. Nếu bạn khớp với hai hàng, hãy chọn hàng thấp hơn: gõ cửa tầng dưới với số liệu tốt dễ hơn nhiều so với gõ cửa tầng trên khi số liệu còn mỏng."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": {
          "caption": "Tự xác định tầng gọi vốn",
          "headers": [
            "Bạn đang có",
            "Tầng phù hợp",
            "Nên gõ cửa",
            "Chưa nên gõ cửa"
          ],
          "rows": [
            {
              "cells": [
                "Ý tưởng, đội ngũ, chưa có sản phẩm",
                "Tầng 1, rất sớm",
                "Tiền tự có, gia đình, tài trợ không hoàn lại, cuộc thi khởi nghiệp",
                "Quỹ VC, kể cả quỹ tự nhận đầu tư sớm"
              ]
            },
            {
              "cells": [
                "Sản phẩm thử, người dùng thử, chưa có doanh thu đều",
                "Tầng 1",
                "Nhà đầu tư thiên thần, mạng lưới thiên thần, accelerator",
                "Quỹ đầu tư từ Series A trở lên"
              ]
            },
            {
              "cells": [
                "Có khách trả tiền, doanh thu tăng vài tháng liên tiếp",
                "Giữa tầng 1 và 2",
                "Quỹ pre-seed và seed, CVC có chương trình cho startup",
                "Quỹ tăng trưởng, quỹ PE"
              ]
            },
            {
              "cells": [
                "Doanh thu tăng đều trên một năm, có số liệu giữ chân khách",
                "Tầng 2",
                "Quỹ VC đầu tư Seed và Series A",
                "Accelerator, vì cái giá cổ phần không còn đáng"
              ]
            }
          ]
        },
        "notes": []
      },
      {
        "heading": "Đừng gặp ai cũng pitch: chọn 15 đến 20 nhà đầu tư",
        "paragraphs": [
          "Cộng đồng nhà đầu tư ở Việt Nam nhỏ. Các quỹ và nhà đầu tư thiên thần thường đồng đầu tư và nói chuyện với nhau. Một deck bị gửi đi khắp nơi, hay một founder đã bị nhiều quỹ từ chối, sẽ được biết tới nhanh hơn bạn nghĩ. Gửi tràn lan không làm tăng cơ hội; nó làm giảm giá trị của bạn trong mắt người nhận.",
          "Cách làm hiệu quả hơn là chọn một danh sách ngắn, khoảng 15 đến 20 nhà đầu tư, lọc theo ba điều kiện: họ đầu tư đúng giai đoạn của bạn, đúng ngành hoặc mô hình kinh doanh của bạn, và cỡ khoản của họ khớp với số tiền bạn cần. Sau đó tiếp cận theo đợt: bắt đầu với vài nhà đầu tư ít ưu tiên để luyện câu chuyện và nghe phản hồi, sửa deck, rồi mới gặp những nhà đầu tư bạn muốn nhất."
        ],
        "bullets": [
          "Bước 1: dùng công cụ Quỹ nào phù hợp với bạn trên fundraising.vn, lọc theo giai đoạn và ngành để có danh sách đầu tiên.",
          "Bước 2: với mỗi tên, kiểm tra trên trang chính thức xem họ còn đầu tư không, khoản đầu tư gần nhất là khi nào, và đã đầu tư công ty nào giống bạn.",
          "Bước 3: tìm người giới thiệu. Một lời giới thiệu từ founder họ đã đầu tư hiệu quả hơn nhiều so với email gửi tới hộp thư chung.",
          "Bước 4: ghi lại mọi lần tiếp cận, phản hồi và bước tiếp theo trong mẫu Theo dõi tiếp cận nhà đầu tư, để biết lúc nào cần nhắc lại và ai đã nói không."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Tóm lại",
        "paragraphs": [
          "Gọi vốn không phải là đi tìm thật nhiều nhà đầu tư, mà là tìm đúng người cầm loại tiền bạn cần ở đúng thời điểm. Xác định tầng của mình trước, chọn một danh sách ngắn có chủ đích, và chuẩn bị đúng thứ mà người ở tầng đó cần thấy.",
          "Thị trường năm 2025 khắt khe hơn với công ty chưa có doanh thu, nhưng tầng vốn sớm vẫn mở với những đội ngũ chứng minh được mình học nhanh từ khách hàng. Nếu bạn chưa chắc mình đã sẵn sàng, hãy chấm điểm sẵn sàng gọi vốn trước, rồi quay lại bảng tự xác định tầng ở trên."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      }
    ],
    "relatedTools": [
      {
        "slug": "quy-phu-hop",
        "label": "Lọc nhà đầu tư theo đúng tầng của bạn"
      },
      {
        "slug": "diem-san-sang-goi-von",
        "label": "Chấm xem bạn đã sẵn sàng cho tầng nào"
      },
      {
        "slug": "safe-va-trai-phieu-chuyen-doi",
        "label": "Hiểu SAFE và trái phiếu chuyển đổi trước khi ký"
      },
      {
        "slug": "goi-bao-nhieu",
        "label": "Tính số vốn cần gọi cho vòng này"
      },
      {
        "slug": "mo-phong-vong-goi-von",
        "label": "Xem mỗi vòng lấy đi bao nhiêu cổ phần"
      }
    ],
    "sources": [
      {
        "label": "NIC, VPCA và Do Ventures: Vietnam Innovation and Private Capital Report (số liệu 2025, đưa tin trên Việt Nam News)",
        "url": "https://vietnamnews.vn/economy/1782451/"
      },
      {
        "label": "VPCA, NIC và BCG: Vietnam Innovation and Private Capital Report 2025 (số liệu 2024, phát hành 05/02/2026)",
        "url": "https://investgame.net/news/pdf/2026-02-05-vietnam_innovation_private_capital_report_2025/"
      },
      {
        "label": "VinVentures: Vietnam Tech & Venture Capital Outlook 2025 (phát hành 01/2026)",
        "url": "https://www.vinventures.net/post/vietnam-tech-venture-capital-outlook-2025-report-released"
      },
      {
        "label": "Việt Nam News: Venture capital falls for fifth straight year in 2025",
        "url": "https://vietnamnews.vn/economy/1763677/venture-capital-falls-for-fifth-straight-year-in-2025.html"
      },
      {
        "label": "Việt Nam News: Việt Nam's start-up market enters restructuring phase (29/01/2026)",
        "url": "https://vietnamnews.vn/economy/1764735/viet-nam-s-start-up-market-enters-restructuring-phase.html"
      },
      {
        "label": "VSV Capital: chương trình Accelerator",
        "url": "https://vsvcapital.com.vn/accelerator"
      },
      {
        "label": "VinVentures (Vingroup): chương trình B.O.U.N.D 2026",
        "url": "https://www.vinventures.net/"
      },
      {
        "label": "VnEconomy: Khởi động VietLeap AI Accelerator (10/2025)",
        "url": "https://vneconomy.vn/khoi-dong-vietleap-ai-accelerator-tao-be-phong-cho-startup-ai-viet-nam.htm"
      }
    ],
    "seoTitle": "Bản đồ gọi vốn startup Việt Nam: ba tầng nhà đầu tư, cỡ vòng và nên gõ cửa ai",
    "seoDescription": "Thị trường vốn khởi nghiệp Việt Nam chia ba tầng: accelerator và nhà đầu tư thiên thần, quỹ VC, và thoái vốn qua M&A. Số liệu 2025, cỡ vòng trung vị, bảng tự xác định tầng và cách chọn 15 đến 20 nhà đầu tư phù hợp.",
    "publishedAt": "2026-10-07",
    "updatedAt": "2026-10-07",
    "track": "cam-nang",
    "readingMinutes": 11
  },
  {
    "slug": "cap-table-pha-loang-vong-dau",
    "title": "Cap table cho vòng đầu: vì sao bạn pha loãng nhiều hơn mình tưởng",
    "excerpt": "Một startup gọi 10 tỷ ở định giá 40 tỷ tưởng chỉ nhường 20%. Thực tế sáng lập còn 60,4%. Bài này bóc tách từng phần pha loãng bằng số cụ thể.",
    "category": "Cổ phần & cap table",
    "stages": [
      "Pre-seed",
      "Idea"
    ],
    "storyType": "huong-dan",
    "templates": [
      "cap-table-pha-loang-safe"
    ],
    "consentConfirmed": false,
    "coverImage": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Fcap-table-pha-loang-vong-dau%2F1790080551203-cover.webp?alt=media&token=b92d55d5-5ed7-4676-923b-2ad2ace5c26f",
    "coverAlt": "Cap table cho vòng đầu: vì sao bạn pha loãng nhiều hơn mình tưởng",
    "coverCaption": "",
    "ogImage": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Fcap-table-pha-loang-vong-dau%2F1790080551711-cover.jpg?alt=media&token=47d2ffa6-6fee-40c5-9014-49d520ecb3fb",
    "author": "Fundraising Vietnam",
    "authorRole": "",
    "status": "PUBLISHED",
    "featured": false,
    "sections": [
      {
        "heading": "Tóm tắt nhanh",
        "paragraphs": [
          "Cap table không phải bảng chia phần trăm. Nó là bản ghi trả lời bốn câu hỏi mà nhà đầu tư hỏi theo đúng thứ tự: ai đang sở hữu công ty, những cam kết nào chưa hiện lên bảng, sau vòng này ai còn bao nhiêu, và nếu bán công ty thì tiền chảy về đâu trước.",
          "Founder gọi vốn lần đầu thường chỉ tính được câu thứ nhất. Ba câu còn lại là chỗ tỷ lệ tụt đi mà không ai báo trước."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Bài này dành cho ai",
        "paragraphs": [
          "Dành cho bạn nếu đang ở vòng angel hoặc pre-seed, đã ký ít nhất một SAFE hoặc sắp ký, và nhà đầu tư vừa yêu cầu gửi cap table.",
          "Không dành cho bạn nếu công ty đã qua Series A với nhiều lớp cổ phần ưu đãi xếp hạng khác nhau. Lúc đó bạn cần luật sư dựng bảng, không phải một mẫu Excel."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Bốn mốc bạn phải dựng được",
        "paragraphs": [
          "Một cap table gửi nhà đầu tư nên hiển thị bốn cột, không phải một. Nhà đầu tư muốn thấy đường đi, không chỉ điểm hiện tại.",
          "Ví dụ xuyên suốt bài: công ty có 200.000 cổ phần, ba sáng lập chia 50/30/20, ESOP 10%, hai SAFE đã ký, và đang gọi 10 tỷ ở định giá pre-money 40 tỷ."
        ],
        "bullets": [
          "Khi thành lập. Chỉ có cổ phần phổ thông của sáng lập, đúng như điều lệ và sổ đăng ký cổ đông.",
          "Sau khi lập ESOP. Quỹ cổ phần nhân sự là cổ phần chưa phát hành nhưng vẫn phải nằm trên bảng, ở dạng pha loãng hoàn toàn.",
          "Sau vòng đang gọi. Đây là cột quan trọng nhất, và là cột duy nhất mà mọi SAFE đã ký sẽ hiện thành số cổ phần thật.",
          "Sau vòng tiếp theo (giả định). Nhà đầu tư vòng này muốn biết họ sẽ bị pha loãng ra sao ở vòng sau, và bạn còn đủ cổ phần để tiếp tục hay không."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Phần 1. SAFE: định giá trần mới là con số quyết định",
        "paragraphs": [
          "Nhiều founder ký SAFE với suy nghĩ \"chưa định giá thì chưa pha loãng\". Sai. Bạn đã bán một tỷ lệ cố định, chỉ là chưa ghi vào sổ.",
          "Với SAFE bản post-money, tỷ lệ nhà đầu tư nhận được tính thẳng bằng số tiền chia cho định giá trần. Nhà đầu tư bỏ 1,5 tỷ với trần 20 tỷ đã mua 7,5% công ty ngay tại thời điểm ký, dù lúc đó chưa ai định giá gì cả.",
          "Chiết khấu chỉ có tác dụng khi định giá vòng sau thấp hơn trần chia cho tỷ lệ chiết khấu. Trong ví dụ trên, giá vòng Seed là 151.000 đồng một cổ phần. Chiết khấu 20% cho ra 120.800 đồng. Nhưng định giá trần cho ra 75.500 đồng, thấp hơn nhiều, nên trần thắng. Nhà đầu tư SAFE mua cổ phần rẻ hơn nhà đầu tư Seed tới 50%.",
          "Đây là điều bình thường và đúng tinh thần của SAFE: họ vào sớm hơn, chịu rủi ro lớn hơn. Vấn đề chỉ phát sinh khi founder ký ba, bốn SAFE với các mức trần khác nhau trong mười tám tháng, rồi tới vòng Seed mới cộng lại lần đầu."
        ],
        "bullets": [
          "Quy tắc thực dụng: trước khi ký thêm một SAFE, cộng tất cả tỷ lệ số-tiền-chia-cho-trần của những SAFE đã ký. Nếu tổng vượt 20%, bạn đang đi vào vùng mà nhà đầu tư Seed sẽ khó chịu, vì phần pha loãng của họ sẽ lớn hơn số tiền họ bỏ ra."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Phần 2. ESOP: phần mở rộng luôn rơi vào túi sáng lập",
        "paragraphs": [
          "Nhà đầu tư Seed gần như luôn yêu cầu quỹ ESOP đạt một tỷ lệ nhất định sau khi họ rót tiền, thường 10% đến 15%. Câu chữ trong term sheet nghe rất vô hại. Hệ quả thì không.",
          "Trong ví dụ, ESOP đang là 10% trước vòng và phải lên 12% sau vòng. Số cổ phần phải phát hành thêm cho quỹ là 17.513. Toàn bộ phần này được tạo ra trước khi tiền mới vào, nghĩa là nó pha loãng sáng lập và các nhà đầu tư SAFE, nhưng không chạm tới nhà đầu tư Seed. Nhà đầu tư Seed vẫn giữ đúng 20% như thoả thuận.",
          "Nói cách khác, bạn đang trả tiền tuyển dụng cho những năm tới bằng cổ phần của chính mình, và định giá pre-money của bạn thực tế thấp hơn con số ghi trên term sheet."
        ],
        "bullets": [
          "Cách xử lý: đừng tranh cãi về nguyên tắc, hãy tranh cãi về con số. Mang kế hoạch tuyển dụng 18 tháng ra bàn. Nếu bạn chỉ cần tuyển một CTO và hai kỹ sư, 10% thường đủ, và bạn có căn cứ để từ chối mức 15%. Không có kế hoạch tuyển dụng thì bạn không có gì để nói, và mức nhà đầu tư đề xuất sẽ thắng."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Phần 3. Kết quả cộng lại",
        "paragraphs": [
          "Founder ban đầu nghĩ mình chỉ nhường 20%. Con số thật là 39,6%, gần gấp đôi. Không ai lừa ai cả: 20% cho tiền mới, 12% cho nhân sự tương lai, 7,6% cho những người đã tin bạn trước khi có định giá."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": {
          "caption": "Bảng cổ phần sau vòng Seed",
          "headers": [
            "Cổ đông",
            "Sau thành lập",
            "Sau vòng Seed"
          ],
          "rows": [
            {
              "cells": [
                "Ba sáng lập",
                "100,0%",
                "60,4%"
              ]
            },
            {
              "cells": [
                "Quỹ ESOP",
                "0,0%",
                "12,0%"
              ]
            },
            {
              "cells": [
                "Hai nhà đầu tư SAFE",
                "0,0%",
                "7,6%"
              ]
            },
            {
              "cells": [
                "Nhà đầu tư Seed",
                "0,0%",
                "20,0%"
              ]
            }
          ]
        },
        "notes": [
          "Thêm một vòng Series A gọi 50 tỷ ở định giá pre-money 150 tỷ, tỷ lệ sáng lập còn 43,2%. Đây vẫn là con số lành mạnh. Nhà đầu tư vòng sau bắt đầu lo khi nhóm sáng lập xuống dưới 50% trước Series A, hoặc dưới 30% sau Series A."
        ]
      },
      {
        "heading": "Phần 4. Ưu đãi thanh toán: 43% cổ phần không có nghĩa là 43% tiền",
        "paragraphs": [
          "Đây là phần hầu như không xuất hiện trong cap table mà founder tự làm, và là phần quyết định bạn nhận bao nhiêu khi công ty được mua lại.",
          "Cổ phần ưu đãi thường kèm điều khoản 1x không tham gia chia tiếp. Khi bán công ty, nhà đầu tư chọn phương án có lợi hơn cho họ: lấy lại đúng số tiền đã bỏ ra, hoặc chuyển sang cổ phần phổ thông và chia theo tỷ lệ. Họ chọn, không phải bạn.",
          "Vẫn ví dụ trên, sau Series A nhóm sáng lập nắm 43,2%. Hai kịch bản bán công ty:"
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": {
          "caption": "Hai kịch bản bán công ty, sau Series A nhóm sáng lập nắm 43,2%",
          "headers": [
            "Giá bán",
            "Nhà đầu tư Series A nhận",
            "Nhóm sáng lập nhận",
            "Tỷ lệ tiền của sáng lập"
          ],
          "rows": [
            {
              "cells": [
                "100 tỷ",
                "50,0 tỷ (lấy ưu đãi)",
                "28,8 tỷ",
                "28,8%"
              ]
            },
            {
              "cells": [
                "250 tỷ",
                "62,5 tỷ (chuyển đổi)",
                "108,1 tỷ",
                "43,2%"
              ]
            }
          ]
        },
        "notes": [
          "Ở mức 100 tỷ, Series A không chuyển đổi vì 25% của 100 tỷ chỉ là 25 tỷ, ít hơn 50 tỷ họ đã bỏ ra. Họ lấy ưu đãi trước, phần còn lại 50 tỷ mới chia cho những người khác. Nhóm sáng lập nắm 43,2% cổ phần nhưng chỉ nhận 28,8% tiền.",
          "Ở mức 250 tỷ, chuyển đổi có lợi hơn nên mọi người chia theo tỷ lệ và con số 43,2% mới đúng nghĩa.",
          "Bài học: mọi đồng ưu đãi đều là một tầng nước phải đầy trước khi tới lượt bạn. Một công ty gọi 62 tỷ qua các vòng thì bán dưới 62 tỷ đồng nghĩa sáng lập gần như không nhận gì."
        ]
      },
      {
        "heading": "Checklist trước khi gửi cap table cho nhà đầu tư",
        "paragraphs": [],
        "bullets": [
          "Số cổ phần khớp với điều lệ và sổ đăng ký cổ đông, không phải con số bạn nhớ.",
          "Mọi SAFE, trái phiếu chuyển đổi, thư cam kết đã ký đều có mặt trên bảng, kể cả cái ký hai năm trước.",
          "ESOP hiển thị ở dạng pha loãng hoàn toàn, tách riêng phần đã cấp và phần chưa cấp.",
          "Có cột \"sau vòng này\", tính theo đúng số tiền và định giá đang đàm phán.",
          "Lịch vesting của sáng lập được nêu rõ, kèm số tháng đã vest.",
          "Nếu có cổ đông đã rời công ty mà vẫn giữ cổ phần, ghi rõ. Giấu chỗ này là lý do thẩm định thất bại phổ biến.",
          "Tổng mỗi cột đúng 100%.",
          "Gửi file Excel còn công thức, không gửi ảnh chụp màn hình. Nhà đầu tư sẽ sửa giả định để tự thử."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Năm lỗi làm mất điểm",
        "paragraphs": [],
        "bullets": [
          "Gửi bảng chỉ có phần trăm, không có số cổ phần. Nhà đầu tư không tính được giá mỗi cổ phần, và sẽ nghĩ bạn chưa từng làm việc này nghiêm túc.",
          "Quên SAFE cũ. Một SAFE 200 triệu ký lúc mới khởi nghiệp với trần 5 tỷ tương đương 4% công ty. Phát hiện ở giai đoạn thẩm định thì mất niềm tin nhiều hơn mất 4%.",
          "Cộng tỷ lệ SAFE vào cột hiện tại. SAFE chưa phải cổ phần. Để chúng ở dòng riêng cho tới cột \"sau vòng này\".",
          "Không có vesting cho sáng lập. Nhà đầu tư đọc cap table không có vesting là đọc thấy rủi ro: một người rời đi năm sau vẫn giữ 30% và không làm gì cả.",
          "Làm tròn cho đẹp. 33,33% mỗi người nghe hợp lý nhưng không khớp với số cổ phần thật. Bảng phải cộng đúng tới từng cổ phần."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Dùng mẫu Excel kèm bài",
        "paragraphs": [
          "Mẫu Cap table cho vòng gọi vốn đầu tiên dựng lại đúng toàn bộ logic trong bài. Bạn chỉ nhập ở sheet Dau_vao: cổ phần sáng lập, tỷ lệ ESOP, từng SAFE đã ký, số tiền và định giá vòng đang gọi.",
          "File tự tính giá chuyển đổi của mỗi SAFE và cho biết định giá trần hay chiết khấu đang thắng, số cổ phần ESOP phải phát hành thêm, tỷ lệ của từng người qua bốn mốc, và số tiền mỗi bên nhận ở năm mức giá bán công ty. Sheet Tong_hop có bốn cảnh báo tự động, sheet Kiem_tra có mười mục phải đạt trước khi bạn gửi file ra ngoài.",
          "Mẹo dùng khi đàm phán: mở sheet Dau_vao, đổi tỷ lệ ESOP mục tiêu từ 15% xuống 10% và xem tỷ lệ sáng lập thay đổi bao nhiêu. Đó chính là giá trị của cuộc trao đổi mà bạn sắp có, tính bằng con số thay vì cảm tính."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      }
    ],
    "relatedTools": [
      {
        "slug": "bang-co-phan-va-pha-loang",
        "label": "Bảng cổ phần và pha loãng"
      },
      {
        "slug": "safe-va-trai-phieu-chuyen-doi",
        "label": "SAFE và trái phiếu chuyển đổi"
      }
    ],
    "sources": [],
    "seoTitle": "Cap table startup: SAFE, ESOP và pha loãng vòng đầu",
    "seoDescription": "Ba thứ làm tỷ lệ sáng lập tụt nhanh hơn dự tính: SAFE chuyển đổi theo định giá trần, ESOP mở rộng pre-money, và ưu đãi thanh toán khi bán công ty. Có ví dụ số và mẫu Excel tải về.",
    "publishedAt": "2026-09-21",
    "updatedAt": "2026-10-20",
    "track": "cam-nang",
    "readingMinutes": 8
  },
  {
    "slug": "dinh-gia-startup-dcf-va-cac-phuong-phap",
    "title": "Định giá startup trước vòng seed: DCF và bốn phương pháp nhà đầu tư dùng để đối chiếu",
    "excerpt": "Năm phương pháp định giá startup (DCF, so sánh bội số, phương pháp VC, Scorecard, Berkus): khi nào dùng, tính thế nào, qua một ví dụ SaaS có số cụ thể và mẫu Excel tải miễn phí.",
    "category": "Định giá",
    "stages": [
      "Pre-seed"
    ],
    "storyType": "huong-dan",
    "templates": [
      "dinh-gia-startup-dcf"
    ],
    "consentConfirmed": false,
    "coverImage": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Fdinh-gia-startup-dcf-va-cac-phuong-phap%2F1790191348152-cover.webp?alt=media&token=709d494a-7169-4116-a3c3-6c60d82bb85c",
    "coverAlt": "Định giá startup trước vòng seed: DCF và bốn phương pháp nhà đầu tư dùng để đối chiếu",
    "coverCaption": "",
    "ogImage": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Fdinh-gia-startup-dcf-va-cac-phuong-phap%2F1790191354565-cover.jpg?alt=media&token=f3806cb9-019d-4d6b-9257-f13a3b737114",
    "author": "Fundraising Vietnam",
    "authorRole": "",
    "status": "PUBLISHED",
    "featured": false,
    "sections": [
      {
        "heading": "Định giá ở vòng đầu là thương lượng, nhưng cần có điểm tựa",
        "paragraphs": [
          "Câu hỏi \"công ty em đáng giá bao nhiêu?\" ở vòng seed không có đáp án đúng duy nhất. Tuy vậy, nhà đầu tư sẽ hỏi con số đó dựa trên cơ sở nào. Nếu founder chỉ trả lời \"em thấy bên kia gọi được chừng đó\", cuộc thương lượng thường kết thúc ở mức giá của nhà đầu tư.",
          "Có hai khái niệm cần nắm trước. Pre-money là giá trị công ty trước khi nhận tiền. Post-money bằng pre-money cộng số vốn gọi. Tỷ lệ sở hữu của nhà đầu tư mới bằng số vốn họ bỏ vào chia cho post-money. Ví dụ, gọi 4 tỷ ở mức pre-money 16,9 tỷ thì post-money là 20,9 tỷ và nhà đầu tư nhận khoảng 19%. Mỗi tỷ pre-money bạn thương lượng được sẽ quyết định founder còn giữ bao nhiêu phần trăm công ty sau vòng này."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Vì sao ở Việt Nam hai bên hay nói hai ngôn ngữ khác nhau",
        "paragraphs": [
          "Phần lớn thương vụ tại Việt Nam chỉ công bố số tiền, không công bố định giá. Không có dữ liệu định giá công khai thì founder neo vào kỳ vọng, còn quỹ neo vào bội số khu vực đã chiết khấu sẵn trong đầu họ. Hai bên đưa ra hai con số, không ai nêu cách tính, nên không ai phản biện được con số của bên kia — cuộc trao đổi dừng lại ở chỗ «anh thấy cao quá».",
          "Cách thoát ra không phải là tìm cho ra một mức định giá đúng, vì mức đó không tồn tại. Cách thoát ra là đặt con số của bạn lên một mỏ neo mà bên kia kiểm chứng được. Việt Nam có ít mỏ neo hơn Mỹ, nhưng không phải không có. Dưới đây là ba mỏ neo dùng được ngay, xếp theo mức độ dễ kiểm chứng."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Mỏ neo 1: thương vụ có công bố cả số tiền lẫn tỷ lệ",
        "paragraphs": [
          "Khi một thương vụ công bố «mua X% với Y tiền», bạn suy ra được định giá: Y chia cho X. Số thương vụ như vậy ở Việt Nam không nhiều, nhưng có, và chúng là dữ liệu cứng nhất mà cả hai bên đều đọc được.",
          "Thương vụ Masan mua Phúc Long là ví dụ đáng học nhất, vì cùng một doanh nghiệp được định giá hai lần cách nhau tám tháng."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": {
          "caption": "Phúc Long: một doanh nghiệp, hai mức định giá cách nhau tám tháng",
          "headers": [
            "Thời điểm",
            "Tỷ lệ mua",
            "Số tiền",
            "Định giá doanh nghiệp"
          ],
          "rows": [
            {
              "cells": [
                "Tháng 5/2021",
                "20%",
                "15 triệu USD",
                "75 triệu USD"
              ]
            },
            {
              "cells": [
                "Tháng 1/2022",
                "Thêm 31%, nâng lên 51%",
                "110 triệu USD",
                "355 triệu USD"
              ]
            }
          ]
        },
        "notes": [
          "Định giá tăng khoảng 4,7 lần trong tám tháng, trong khi thị trường trà sữa không hề thay đổi 4,7 lần. Thứ thay đổi là bằng chứng: sau khi vào hệ thống WinMart, quý 1/2022 chuỗi đạt biên lợi nhuận gộp 68,6% và biên EBITDA 18,3%. Định giá là hàm của bằng chứng, không phải hàm của thời gian chờ.",
          "Mặt còn lại của câu chuyện cũng đáng kể: sau đó Masan phải đóng bớt các kiosk trong siêu thị vì hoạt động kém. Ngay cả người mua có kỷ luật tài chính cũng trả tiền cho một kỳ vọng, và kỳ vọng đó có thể không thành. Đây là lý do nhà đầu tư chiết khấu mạnh những con số dựa vào mở rộng chưa xảy ra.",
          "Nguồn: tổng hợp từ công bố của Masan, dẫn theo VietnamBiz và VnExpress."
        ]
      },
      {
        "heading": "Mỏ neo 2: doanh nghiệp niêm yết cùng ngành",
        "paragraphs": [
          "Đây là mỏ neo bị bỏ quên nhiều nhất, dù nó công khai và cập nhật mỗi ngày. Doanh nghiệp niêm yết trên HOSE công bố báo cáo tài chính theo quý và có vốn hoá thị trường đọc được bất cứ lúc nào. Từ hai thứ đó bạn tự tính được bội số của ngành mình tại thị trường Việt Nam — không phải bội số của Mỹ hay của khu vực.",
          "Cách làm mất khoảng một giờ: chọn hai tới ba doanh nghiệp niêm yết gần ngành nhất, lấy vốn hoá cộng nợ vay trừ tiền mặt để ra giá trị doanh nghiệp, chia cho EBITDA hoặc doanh thu bốn quý gần nhất, rồi ghi rõ ngày lấy số. Bạn sẽ có một khoảng bội số, không phải một con số.",
          "Sau đó là phần thành thật: startup của bạn nhỏ hơn, chưa có lịch sử lợi nhuận, cổ phần khó bán lại. Nhà đầu tư sẽ chiết khấu cho từng điều đó. Nếu bạn tự nêu mức chiết khấu trước và giải thích vì sao, cuộc trao đổi chuyển từ tranh cãi con số sang thảo luận mức chiết khấu — dễ gặp nhau hơn nhiều."
        ],
        "bullets": [
          "Bán lẻ và chuỗi: MWG, FRT, PNJ, DGW đều niêm yết và công bố doanh thu theo chuỗi cửa hàng.",
          "Hàng tiêu dùng và F&B: VNM, MSN, SAB, KDC.",
          "Công nghệ và dịch vụ số: FPT, CMG, ELC.",
          "Ghi ngày lấy số liệu ngay cạnh bội số. Vốn hoá thay đổi mỗi phiên, và một bội số không có ngày là một bội số không kiểm chứng được."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Mỏ neo 3: quy mô vòng gọi vốn và mức pha loãng phổ biến",
        "paragraphs": [
          "Khi không có bội số nào hợp lý — startup chưa có doanh thu chẳng hạn — vẫn còn một cách suy ngược. Thị trường có mức pha loãng quen thuộc cho từng vòng, thường 15% đến 25%. Biết số tiền định gọi và mức pha loãng mình chấp nhận, bạn ra được khoảng định giá mà mình đang ngầm đề xuất. Làm phép tính này trước khi vào phòng họp giúp bạn không rơi vào tình huống đòi một mức định giá mà chính mình chưa từng tính thử.",
          "Bối cảnh để đặt kỳ vọng đúng cỡ: vốn đầu tư mạo hiểm vào startup Việt Nam năm 2025 đạt khoảng 509 triệu USD qua 103 thương vụ, tăng 28% về giá trị nhưng giảm 13% về số thương vụ. Thị trường đang ít deal hơn và mỗi deal lớn hơn — nghĩa là chuẩn để được chọn cao hơn, chứ không phải tiền dễ hơn."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": {
          "caption": "Từ số tiền gọi và mức pha loãng ra khoảng định giá ngầm định",
          "headers": [
            "Số tiền gọi",
            "Pha loãng 15%",
            "Pha loãng 20%",
            "Pha loãng 25%"
          ],
          "rows": [
            {
              "cells": [
                "5 tỷ đồng",
                "Định giá sau vòng 33,3 tỷ",
                "25,0 tỷ",
                "20,0 tỷ"
              ]
            },
            {
              "cells": [
                "12 tỷ đồng",
                "80,0 tỷ",
                "60,0 tỷ",
                "48,0 tỷ"
              ]
            },
            {
              "cells": [
                "25 tỷ đồng",
                "166,7 tỷ",
                "125,0 tỷ",
                "100,0 tỷ"
              ]
            },
            {
              "cells": [
                "50 tỷ đồng",
                "333,3 tỷ",
                "250,0 tỷ",
                "200,0 tỷ"
              ]
            }
          ]
        },
        "notes": [
          "Định giá sau vòng bằng số tiền gọi chia cho tỷ lệ pha loãng. Định giá trước vòng bằng định giá sau vòng trừ số tiền gọi. Nhớ trừ tiếp phần ESOP phải mở rộng, vì phần đó thường lấy từ cổ phần của sáng lập.",
          "Đọc bảng theo chiều ngược lại cũng hữu ích: nếu bạn muốn định giá 100 tỷ mà chỉ gọi 5 tỷ, bạn đang đề nghị nhà đầu tư nhận 5% — nhỏ hơn mức phần lớn quỹ chấp nhận cho một vòng có dẫn dắt.",
          "Nguồn bối cảnh thị trường: Báo cáo Đổi mới sáng tạo và Vốn tư nhân Việt Nam 2026 (VPCA, NIC, BCG), dẫn theo VnEconomy và Người Quan Sát."
        ]
      },
      {
        "heading": "Bốn việc giúp hai bên chạm được vào nhau",
        "paragraphs": [],
        "bullets": [
          "Đưa một khoảng, không đưa một con số. «60 đến 80 tỷ, tuỳ điều khoản» mời người ta thương lượng; «80 tỷ» mời người ta từ chối.",
          "Luôn nói kèm phương pháp và mỏ neo: bạn tính bằng cách nào, dựa vào thương vụ nào hoặc doanh nghiệp niêm yết nào, lấy số ngày nào. Con số không có phương pháp là kỳ vọng; con số có phương pháp là một đề xuất phản biện được.",
          "Tách định giá khỏi số tiền cần gọi. Số tiền đến từ kế hoạch 18 tháng cộng một khoảng đệm, không đến từ mong muốn giữ tỷ lệ. Trộn hai thứ này là nguồn gốc của phần lớn bế tắc.",
          "Khi vẫn lệch, hãy đổi sang cấu trúc thay vì cố thắng con số: SAFE có trần định giá và chiết khấu, hoặc điều khoản điều chỉnh tỷ lệ theo cột mốc. Cách này hoãn việc định giá tới lúc có thêm bằng chứng — đúng thứ mà cả hai bên đang thiếu."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": [
          "Một câu đáng dùng trong phòng họp: «Con số này em tính từ bội số của hai doanh nghiệp niêm yết cùng ngành, chiết khấu 40% cho quy mô và thanh khoản. Nếu anh chị dùng mỏ neo khác, em muốn nghe mỏ neo đó.» Câu này chuyển cuộc trao đổi từ cảm tính sang phương pháp."
        ]
      },
      {
        "heading": "Năm phương pháp và lúc nào nên dùng",
        "paragraphs": [
          "Không phương pháp nào đủ tin cậy nếu đứng một mình. Cách làm thực tế là tính bằng vài phương pháp, xem các khoảng giá chồng lên nhau ở đâu, rồi gán trọng số theo giai đoạn của công ty:",
          "(Công ty ví dụ trong bài là một startup SaaS có doanh thu 12 tháng gần nhất 6 tỷ, 2 tỷ tiền mặt, đang gọi vòng seed 4 tỷ.)"
        ],
        "bullets": [
          "Chưa có sản phẩm: Berkus và Scorecard. DCF gần như vô nghĩa vì chưa có cơ sở để dự phóng dòng tiền.",
          "Pre-seed, có sản phẩm, doanh thu nhỏ: Scorecard và phương pháp VC, đối chiếu với các thương vụ cùng giai đoạn.",
          "Seed, doanh thu tăng đều: phương pháp VC và so sánh bội số là chính. DCF dùng để kiểm tra kế hoạch có logic hay không.",
          "Series A trở đi: so sánh bội số và DCF được trọng số lớn hơn."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "DCF: giá trị hôm nay của dòng tiền tương lai",
        "paragraphs": [
          "DCF trả lời câu hỏi: toàn bộ tiền mặt công ty sẽ tạo ra, quy về hôm nay, đáng bao nhiêu. Có bốn bước.",
          "Bước một là dự phóng doanh thu và biên EBITDA 5 năm. Trong ví dụ, doanh thu tăng từ 6 tỷ lên 69,2 tỷ ở năm 5, với tốc độ tăng trưởng giảm dần từ 120% xuống 30%. Biên EBITDA đi từ âm 40% lên 25%.",
          "Bước hai là tính dòng tiền tự do: lợi nhuận hoạt động sau thuế, cộng lại khấu hao, trừ đầu tư tài sản và phần vốn lưu động tăng thêm. Dòng tiền của công ty ví dụ lần lượt là âm 6,7 tỷ, âm 5,8 tỷ, âm 1,6 tỷ, rồi dương 2,5 tỷ và 9,2 tỷ.",
          "Bước ba là chiết khấu các dòng tiền đó về hiện tại. Doanh nghiệp niêm yết thường dùng tỷ lệ chiết khấu khoảng 10–15%. Startup giai đoạn sớm dùng 30–60%, vì rủi ro thất bại cao hơn nhiều. Mẫu dùng 45%. Ở mức này, tổng giá trị hiện tại của 5 năm dòng tiền là âm 5,9 tỷ.",
          "Bước bốn là tính giá trị cuối, tức giá trị của công ty sau năm 5. Đây là chỗ nhiều founder làm sai. Có hai cách tính:",
          "Công thức Gordon giả định công ty tăng trưởng đều mãi mãi. Cách này cho giá trị cuối 24,1 tỷ, tương đương chỉ 1,4 lần EBITDA năm 5. Mức đó quá thấp, vì ở năm 5 công ty vẫn đang tăng trưởng 30%, chưa ở trạng thái ổn định mà Gordon giả định.",
          "- Bội số thoát lấy EBITDA năm 5 nhân 12 lần, ra 207,6 tỷ. Con số này tương đương 3 lần doanh thu, gần với mức thị trường thường trả cho một công ty SaaS đang tăng trưởng.",
          "- Theo cách bội số thoát, giá trị doanh nghiệp là 26,5 tỷ. Cộng 2 tỷ tiền mặt, giá trị vốn chủ theo DCF là 28,5 tỷ. Bảng độ nhạy trong mẫu cho khoảng từ 23,4 đến 34,4 tỷ.",
          "Có một điểm cần nói thẳng với nhà đầu tư: toàn bộ giá trị trong DCF của startup đến từ giá trị cuối, vì các năm đầu dòng tiền âm. Mẫu hiển thị tỷ lệ này là 122%. DCF ở giai đoạn seed thực chất là phép thử xem giả định năm 5 có hợp lý không. Nó không phải con số để chốt giá."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "So sánh bội số và phương pháp VC: góc nhìn của nhà đầu tư",
        "paragraphs": [
          "So sánh bội số lấy mức giá thị trường đang trả cho công ty tương tự. Mẫu có năm công ty minh hoạ với bội số giá trị trên doanh thu từ 1,8 đến 5,5 lần. Nên dùng trung vị (3,2 lần) thay vì trung bình, để một thương vụ cá biệt không kéo lệch kết quả. Sau đó trừ khoảng 30% chiết khấu thanh khoản, vì cổ phần công ty chưa niêm yết khó bán lại. Kết quả là pre-money 15,4 tỷ, trong khoảng 12,5–18,8 tỷ. Khi dùng mẫu, bạn cần thay năm dòng minh hoạ bằng công ty hoặc thương vụ thật và ghi rõ nguồn. Nhà đầu tư sẽ hỏi nguồn.",
          "Phương pháp VC đi ngược từ lúc thoát vốn. Nếu năm 5 công ty bán được với giá 3 lần doanh thu, giá trị lúc thoát là 207,6 tỷ. Qua các vòng sau, cổ phần của nhà đầu tư hôm nay bị pha loãng còn khoảng 70%. Nếu nhà đầu tư cần thu về gấp 10 lần, post-money hôm nay tối đa là 207,6 × 70% ÷ 10, tức 14,5 tỷ. Trừ 4 tỷ vốn gọi, pre-money còn 10,5 tỷ.",
          "Phương pháp VC cho kết quả thấp nhất vì mục tiêu gấp 10 lần trong 5 năm tương đương lợi nhuận khoảng 58% mỗi năm. Mức này cao hơn tỷ lệ 45% dùng ở DCF. Lý do là quỹ phải bù cho những khoản đầu tư khác thất bại. Hiểu điều này giúp founder bớt bất ngờ khi nhận term sheet thấp hơn kỳ vọng."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Scorecard và Berkus cho startup chưa có doanh thu",
        "paragraphs": [
          "Scorecard (của Bill Payne) bắt đầu từ định giá trung bình của các thương vụ cùng giai đoạn trong khu vực, rồi điều chỉnh theo bảy tiêu chí có trọng số. Đội ngũ chiếm 30%, quy mô thị trường 25%, sản phẩm 15%, cạnh tranh 10%, kênh bán 10%, còn lại chia cho nhu cầu vốn bổ sung và yếu tố khác. Công ty ví dụ có đội ngũ mạnh hơn trung bình (125%), thị trường lớn (150%) và cạnh tranh gay gắt (75%). Tổng điểm là 117,5%, nên từ mức trung bình 20 tỷ ra 23,5 tỷ.",
          "Berkus cộng giá trị cho năm yếu tố, mỗi yếu tố giúp giảm một loại rủi ro: ý tưởng, nguyên mẫu, đội ngũ, quan hệ chiến lược và doanh số đầu tiên. Mỗi yếu tố có một mức trần. Bản gốc dùng 500.000 USD; mẫu đặt 4 tỷ cho phù hợp với thị trường Việt Nam. Vì công ty ví dụ đã có doanh thu, Berkus được đặt trọng số 0%. Mẫu vẫn tính để bạn thấy cách làm."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Ghép lại thành một con số để đàm phán",
        "paragraphs": [
          "Tab Tổng hợp đặt năm khoảng giá lên cùng một biểu đồ, gọi là football field. Với trọng số DCF 20%, so sánh 30%, VC 40% và Scorecard 10%, pre-money có trọng số là 16,9 tỷ. Gọi 4 tỷ, nhà đầu tư nhận 19,1%, founder và cổ đông hiện hữu giữ 80,9%.",
          "Mẫu có sẵn mục Kiểm tra với ba cảnh báo. Thứ nhất, nếu phương pháp cao nhất gấp hơn khoảng 3 lần phương pháp thấp nhất, cần xem lại giả định của phương pháp lệch nhất. Ví dụ này đang ở mức 2,7 lần. Thứ hai, tỷ lệ nhà đầu tư nhận nằm ngoài khoảng 10–30% thường gặp ở vòng seed. Thứ ba, tỷ lệ chiết khấu thấp hơn tăng trưởng dài hạn, khiến công thức Gordon không dùng được.",
          "Khi trình bày với nhà đầu tư, bạn nên đưa khoảng giá kèm lập luận cho từng phương pháp. Một con số đơn lẻ dễ bị bác. Khi nhà đầu tư phản biện một giả định, bạn chỉ cần sửa ô đó và cả bảng tự tính lại ngay trong buổi họp."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Cách dùng mẫu",
        "paragraphs": [
          "Tải mẫu ở cuối bài. Bạn chỉ sửa các ô chữ xanh nền vàng. Đầu tiên, điền tab Đầu vào: số vốn gọi, tiền mặt, nợ, doanh thu 12 tháng gần nhất, tăng trưởng và biên EBITDA 5 năm. Nếu đã có mô hình tài chính 36 tháng, hãy lấy số từ đó. Tiếp theo, thay dữ liệu so sánh bằng số thật, chấm điểm Scorecard, rồi đặt trọng số ở tab Tổng hợp theo giai đoạn của công ty. Kết quả là điểm tựa để trao đổi với nhà đầu tư, không phải mức giá bắt buộc, và không phải tư vấn đầu tư."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      }
    ],
    "relatedTools": [
      {
        "slug": "goi-bao-nhieu",
        "label": "Lập kế hoạch số vốn"
      }
    ],
    "sources": [
      {
        "label": "VietnamBiz — nhìn lại thương vụ Masan mua Phúc Long, định giá qua hai lần mua",
        "url": "https://vietnambiz.vn/ma-mat-tay-nhu-masan-tron-mot-nam-thau-tom-phuc-long-dua-dinh-gia-tang-gap-5-lan-nang-bien-loi-nhuan-gan-70-quy-mo-top-dau-thi-truong-202268114546955.htm"
      },
      {
        "label": "VnExpress — Masan chi thêm tiền thâu tóm Phúc Long",
        "url": "https://vnexpress.net/masan-chi-them-tien-thau-tom-phuc-long-4425675.html"
      },
      {
        "label": "VnEconomy — vốn đầu tư mạo hiểm vào startup Việt 2025 (báo cáo VPCA, NIC, BCG)",
        "url": "https://vneconomy.vn/techconnect/von-dau-tu-mao-hiem-vao-startup-viet-tang-manh-ai-tro-thanh-tam-diem.htm"
      },
      {
        "label": "CafeF — Phúc Long quý 3/2025 theo báo cáo Masan",
        "url": "https://cafef.vn/sau-tai-cau-truc-trung-binh-moi-cua-hang-phuc-long-thu-235-trieu-dong-ngay-188251028062048988.chn"
      }
    ],
    "seoTitle": "Mẫu Excel định giá startup DCF miễn phí | fundraising.vn",
    "seoDescription": "Mẫu Excel định giá startup gồm DCF, so sánh bội số, phương pháp VC, Scorecard, Berkus và biểu đồ tổng hợp. Có ví dụ điền sẵn, bản tiếng Việt và Anh.",
    "publishedAt": "2026-09-19",
    "updatedAt": "2026-09-23",
    "track": "cam-nang",
    "readingMinutes": 12
  },
  {
    "slug": "dinh-gia-tren-giay-va-dinh-gia-that",
    "title": "Định giá trên giấy và định giá thật: term sheet lấy lại phần chênh bằng cách nào",
    "excerpt": "Hai term sheet cùng ghi định giá cao, nhưng số tiền founder nhận khi bán công ty có thể chênh nhau hàng chục tỷ. Bài này chỉ ra năm điều khoản nhà đầu tư dùng để lấy lại phần chênh định giá, ví dụ bằng số cho từng mức giá bán, và cách quy mọi term sheet về hai con số để so sánh.",
    "category": "Định giá",
    "stages": [
      "Pre-seed",
      "Seed",
      "Series A"
    ],
    "storyType": "huong-dan",
    "templates": [
      "so-sanh-term-sheet",
      "term-sheet-vong-seed"
    ],
    "consentConfirmed": false,
    "coverImage": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Fdinh-gia-tren-giay-va-dinh-gia-that%2F1792407839684-cover.webp?alt=media&token=6abd8b71-24ee-4678-8f3c-e42392ddd0a8",
    "coverAlt": "Hai term sheet: B định giá 50 tỷ cao hơn A 40 tỷ, nhưng khi bán công ty 80 tỷ founder chỉ nhận 45 tỷ so với 54 tỷ ở A",
    "coverCaption": "Con số định giá chỉ là một dòng trong term sheet. Các dòng còn lại quyết định founder thực nhận bao nhiêu.",
    "ogImage": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Fdinh-gia-tren-giay-va-dinh-gia-that%2F1792407842759-cover.jpg?alt=media&token=859b5252-f73b-48f1-8de3-c232dfdfa054",
    "author": "Fundraising Vietnam",
    "authorRole": "",
    "status": "PUBLISHED",
    "featured": false,
    "sections": [
      {
        "heading": "Hai lời mời, một cái bẫy",
        "paragraphs": [
          "Startup của bạn nhận hai term sheet cho vòng 10 tỷ đồng. Quỹ A định giá pre-money 40 tỷ. Quỹ B định giá 50 tỷ. Phần lớn founder lần đầu sẽ chọn B mà không cần đọc tiếp.",
          "Nhà đầu tư thiên thần Luis Villalobos ví đàm phán định giá ở vòng sớm như một ván poker: mỗi bên giấu bài và cố làm như tay mình mạnh hơn. Một trong những nước đi quen thuộc là chấp nhận con số định giá founder muốn, rồi lấy lại phần chênh ở những dòng khác của term sheet. Ông gọi đó là khoảng cách giữa định giá danh nghĩa (con số ghi trên giấy) và định giá ngầm (giá trị thật sau khi tính mọi điều khoản)."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Năm điều khoản kéo định giá thật xuống",
        "paragraphs": [],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": {
          "caption": "Mỗi điều khoản lấy lại phần chênh định giá theo một cách khác nhau",
          "headers": [
            "Điều khoản",
            "Cách nó lấy lại phần chênh",
            "Mức thông lệ ở vòng sớm"
          ],
          "rows": [
            {
              "cells": [
                "Quỹ ESOP tạo trước vòng",
                "Cổ phần thưởng cho nhân viên được tính vào định giá pre-money, nên chỉ founder và cổ đông cũ gánh phần pha loãng",
                "10% đến 15%, đủ cho kế hoạch tuyển 18 tháng"
              ]
            },
            {
              "cells": [
                "Ưu tiên thanh toán có tham gia",
                "Khi bán công ty, nhà đầu tư lấy lại vốn trước rồi vẫn chia tiếp phần còn lại theo tỷ lệ sở hữu",
                "1 lần, không tham gia"
              ]
            },
            {
              "cells": [
                "Cổ tức tích luỹ",
                "Cộng dồn mỗi năm, thường 8%, trả một lần khi bán công ty, trước cổ đông phổ thông",
                "Không có, hoặc chỉ trả khi được công bố"
              ]
            },
            {
              "cells": [
                "Chứng quyền",
                "Quyền mua thêm cổ phần với giá vòng này trong nhiều năm, kể cả khi công ty đã lên giá",
                "Không có ở vòng cổ phần ưu đãi"
              ]
            },
            {
              "cells": [
                "Chống pha loãng toàn phần",
                "Nếu vòng sau giảm giá, toàn bộ cổ phần của nhà đầu tư được tính lại theo giá mới, founder gánh phần chênh",
                "Bình quân gia quyền diện rộng"
              ]
            }
          ]
        },
        "notes": [
          "Ba điều khoản đầu tác động tới mọi kịch bản bán công ty. Chống pha loãng chỉ có tác dụng khi có vòng giảm giá, nhưng khi đó tác động rất lớn."
        ]
      },
      {
        "heading": "Ví dụ bằng số: định giá cao hơn, founder nhận ít hơn",
        "paragraphs": [
          "Quỹ A: định giá pre-money 40 tỷ, rót 10 tỷ, ưu tiên thanh toán 1 lần không tham gia. Sau vòng, công ty lập quỹ ESOP 15% và mọi cổ đông cùng gánh. Kết quả: nhà đầu tư 17%, founder 68%, ESOP 15%.",
          "Quỹ B: định giá pre-money 50 tỷ, rót 10 tỷ, nhưng yêu cầu quỹ ESOP 15% sau vòng phải tạo trước vòng (nằm trong 50 tỷ), ưu tiên thanh toán 1 lần có tham gia, cổ tức tích luỹ 8% một năm. Kết quả: nhà đầu tư 16,7%, founder 68,3%, ESOP 15%. Phần quỹ ESOP chiếm 9 tỷ trong định giá pre-money, nên định giá thật cho phần của founder chỉ khoảng 41 tỷ, gần bằng quỹ A.",
          "Khác biệt lớn nằm ở lúc bán công ty, giả sử sau 5 năm (cổ tức tích luỹ của B lúc đó là 4 tỷ):"
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": {
          "caption": "Tiền founder nhận được ở từng mức giá bán công ty (tỷ đồng)",
          "headers": [
            "Giá bán công ty",
            "Quỹ A định giá 40 tỷ",
            "Quỹ B định giá 50 tỷ",
            "Founder thiệt ở B"
          ],
          "rows": [
            {
              "cells": [
                "30 tỷ",
                "16,4",
                "10,9",
                "5,5"
              ]
            },
            {
              "cells": [
                "80 tỷ",
                "54,4",
                "45,1",
                "9,3"
              ]
            },
            {
              "cells": [
                "200 tỷ",
                "136,0",
                "127,1",
                "8,9"
              ]
            }
          ]
        },
        "notes": [
          "Cách tính ở mức 80 tỷ. Quỹ A: chuyển sang cổ phần phổ thông có lợi hơn (17% của 80 tỷ là 13,6 tỷ, lớn hơn 10 tỷ ưu tiên), founder nhận 68% của 80 tỷ là 54,4 tỷ. Quỹ B: nhận trước 10 tỷ vốn cộng 4 tỷ cổ tức, rồi chia tiếp 16,7% của 66 tỷ còn lại, tổng khoảng 25 tỷ; founder nhận 68,3% của 66 tỷ là 45,1 tỷ.",
          "Ở mọi mức giá bán, term sheet định giá cao hơn lại để founder nhận ít hơn. Ở mức bán thấp, phần thiệt gần một phần ba số tiền founder có thể nhận."
        ]
      },
      {
        "heading": "Những điều khoản không quy ra tiền được",
        "paragraphs": [
          "Villalobos lưu ý: gần như mọi điều khoản đều ảnh hưởng tới định giá, kể cả những thứ không ai đặt giá rõ ràng. Một quỹ muốn hai ghế hội đồng quản trị sẽ không đổi lấy một ghế chỉ để giảm định giá một đồng, nhưng có thể đồng ý nếu định giá giảm một nửa.",
          "Nên đọc các điều khoản dưới đây như một phần của định giá, không phải phần phụ lục."
        ],
        "bullets": [
          "Số ghế hội đồng quản trị và ai nắm đa số.",
          "Danh sách quyền phủ quyết: ngắn và chỉ bảo vệ quyền của nhà đầu tư, hay chạm vào cả ngân sách và tuyển dụng.",
          "Vesting của founder: theo ông, đây là điều khoản gây tranh cãi nhiều thứ hai sau định giá, nhất là khi nhà đầu tư muốn bắt đầu tính lại từ đầu.",
          "Quyền yêu cầu mua lại cổ phần sau 5 năm: hiếm khi thực thi được, nhưng là đòn bẩy đàm phán khi công ty chậm lớn.",
          "Thời hạn no-shop: càng dài, bạn càng mất thế khi thẩm định kéo dài."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Khi hai bên không thống nhất được định giá",
        "paragraphs": [
          "Một cách gỡ bế tắc phổ biến là hoãn định giá sang vòng sau: nhà đầu tư rót tiền hôm nay, được mua với chiết khấu so với giá vòng sau. Đây chính là logic của SAFE và trái phiếu chuyển đổi.",
          "Cách này cần cả trần lẫn sàn. Ví dụ founder muốn 50 tỷ, angel chỉ muốn 30 tỷ, hai bên chốt chiết khấu 30% ở vòng sau mà không có trần. Nếu vòng sau định giá 500 tỷ, angel mua ở 350 tỷ, gấp 7 lần mức founder từng đòi, dù họ là người chịu rủi ro sớm nhất. Ngược lại, không có sàn thì founder gánh hết thiệt hại khi vòng sau định giá thấp. Villalobos đề xuất một khoảng như 30 đến 50 tỷ trong ví dụ này. Trong SAFE, mức trần chính là valuation cap; mẫu SAFE thông dụng không có sàn."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Quy mọi term sheet về hai con số",
        "paragraphs": [
          "Trước khi so sánh hai lời mời, quy từng term sheet về hai con số. Con số thứ nhất là định giá thật: định giá pre-money trừ đi phần quỹ ESOP bắt buộc tạo trước vòng. Con số thứ hai là số tiền founder nhận ở ba mức giá bán công ty: bán thấp (gần tổng vốn đã gọi), bán trung bình, bán cao.",
          "Mẫu Excel So sánh term sheet của fundraising.vn tính sẵn cả hai con số cho ba term sheet đặt cạnh nhau, và công cụ Đọc term sheet bằng con số làm việc đó cho từng lời mời. Nếu bạn cần một bản term sheet tham chiếu để đối chiếu, mẫu term sheet vòng seed bằng tiếng Việt và tiếng Anh có bảng mười điều khoản thông lệ và cờ đỏ."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Tóm lại",
        "paragraphs": [
          "Định giá trên term sheet là con số dễ thấy nhất và cũng dễ bị lấy lại nhất. Quỹ ESOP tạo trước vòng, ưu tiên thanh toán có tham gia, cổ tức tích luỹ, chứng quyền và chống pha loãng toàn phần đều chuyển tiền từ founder sang nhà đầu tư mà không đổi con số định giá. Hãy so sánh các lời mời bằng số tiền bạn thực nhận ở nhiều mức giá bán, và dùng con số định giá cao như một lý do để hỏi kỹ hơn, không phải để ký nhanh hơn."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      }
    ],
    "relatedTools": [
      {
        "slug": "doc-term-sheet",
        "label": "Đọc từng term sheet bằng con số"
      },
      {
        "slug": "safe-va-trai-phieu-chuyen-doi",
        "label": "Thử trần định giá và chiết khấu của SAFE"
      },
      {
        "slug": "bang-co-phan-va-pha-loang",
        "label": "Xem quỹ ESOP lấy từ phần của ai"
      }
    ],
    "sources": [
      {
        "label": "Angel Capital Education Foundation, Kauffman Foundation: Valuing Pre-revenue Companies (Villalobos, Investment Valuations of Seed- and Early-Stage Ventures)",
        "url": "https://www.angelcapitalassociation.org/data/Documents/Resources/AngelCapitalEducation/ACEF_-_Valuing_Pre-revenue_Companies.pdf?rev=FD23"
      }
    ],
    "seoTitle": "Định giá danh nghĩa và định giá thật trong term sheet: ESOP, ưu tiên thanh toán, chứng quyền, cổ tức tích luỹ",
    "seoDescription": "Vì sao định giá cao hơn chưa chắc tốt hơn: năm điều khoản làm giảm định giá thật (quỹ ESOP trước vòng, ưu tiên thanh toán có tham gia, chứng quyền, cổ tức tích luỹ, chống pha loãng toàn phần), ví dụ hai term sheet bằng VNĐ và cách gỡ bế tắc định giá bằng trần và sàn.",
    "publishedAt": "2026-10-20",
    "updatedAt": "2026-10-20",
    "track": "cam-nang",
    "readingMinutes": 6
  },
  {
    "slug": "email-tiep-can-quy-kem-vi-du",
    "title": "Cách viết email tiếp cận quỹ kèm ví dụ",
    "excerpt": "Một email ngắn cần đủ bối cảnh, bằng chứng, mức gọi và lý do quỹ này phù hợp.",
    "category": "Tiếp cận nhà đầu tư",
    "stages": [
      "Pre-seed",
      "Seed"
    ],
    "storyType": "huong-dan",
    "templates": [],
    "consentConfirmed": false,
    "coverImage": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Femail-tiep-can-quy-kem-vi-du%2F1790080554272-cover.webp?alt=media&token=32749061-c1c1-4b6a-afbc-0130aa49b303",
    "coverAlt": "Cách viết email tiếp cận quỹ kèm ví dụ",
    "coverCaption": "",
    "ogImage": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Femail-tiep-can-quy-kem-vi-du%2F1790080554572-cover.jpg?alt=media&token=6c04e9e1-89da-4502-bcc0-88213137a8e2",
    "author": "Fundraising Vietnam",
    "authorRole": "",
    "status": "PUBLISHED",
    "featured": false,
    "sections": [
      {
        "heading": "Ưu tiên lời giới thiệu, nhưng vẫn cần email tốt",
        "paragraphs": [
          "Email được một người quen chung giới thiệu — founder quỹ đã đầu tư, luật sư, người trong hệ sinh thái — thường được đọc kỹ hơn email gửi thẳng. Nhưng dù đi đường nào, bạn vẫn cần một email ngắn, đọc là hiểu, vì người giới thiệu sẽ chuyển tiếp chính email đó.",
          "Nếu không có người giới thiệu, email trực tiếp vẫn có tác dụng khi nó đúng người, đúng quỹ và có một bằng chứng đủ làm người đọc tò mò."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Cấu trúc năm dòng",
        "paragraphs": [],
        "bullets": [
          "Bạn là ai và startup làm gì — một câu.",
          "Một bằng chứng đáng chú ý nhất: khách trả tiền, tăng trưởng, tỷ lệ giữ chân.",
          "Đang gọi bao nhiêu và để đạt cột mốc gì.",
          "Vì sao quỹ này có liên quan: khẩu vị ngành, giai đoạn, một khoản đầu tư cụ thể của họ.",
          "Một lời đề nghị cụ thể cho cuộc trao đổi ngắn."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Tiêu đề email",
        "paragraphs": [
          "Tiêu đề quyết định email có được mở hay không. Hãy đưa thông tin quan trọng nhất lên tiêu đề thay vì viết chung chung."
        ],
        "bullets": [
          "Chưa tốt: “Cơ hội đầu tư hấp dẫn” hoặc “Xin gặp anh/chị”.",
          "Tốt hơn: “B2B SaaS quản lý tồn kho — 60 khách trả tiền, gọi Seed 12 tỷ”.",
          "Khi có người giới thiệu: “Giới thiệu: [tên founder] (quản lý tồn kho) ↔ [tên người ở quỹ]”."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Ví dụ email gửi trực tiếp",
        "paragraphs": [
          "Chào anh/chị, chúng tôi xây nền tảng quản lý tồn kho cho nhà bán lẻ vừa và nhỏ. Trong sáu tháng, sản phẩm đạt 60 khách trả tiền và doanh thu định kỳ 300 triệu đồng/tháng. Công ty đang gọi 12 tỷ đồng để mở rộng lên 250 khách trong 18 tháng. Tôi liên hệ vì quỹ tập trung vào B2B SaaS giai đoạn Seed tại Đông Nam Á. Anh/chị có phù hợp để trao đổi 25 phút trong tuần tới không?",
          "Email này dài chưa tới 100 chữ, nhưng người đọc biết ngay công ty làm gì, đã chứng minh được gì, cần gì và vì sao họ nhận được email này."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Ví dụ email nhờ giới thiệu",
        "paragraphs": [
          "Khi nhờ người quen giới thiệu, hãy gửi họ hai thứ: một lời nhờ ngắn, và một đoạn email viết sẵn mà họ có thể chuyển tiếp nguyên văn. Đừng bắt người giúp bạn phải tự viết lại.",
          "Ví dụ đoạn chuyển tiếp: “Anh/chị [tên], em là [tên], founder [công ty] — nền tảng quản lý tồn kho cho nhà bán lẻ vừa và nhỏ. Sau sáu tháng bọn em có 60 khách trả tiền, doanh thu định kỳ 300 triệu/tháng, và đang gọi Seed 12 tỷ. Em mong được anh/chị [người giới thiệu] kết nối vì quỹ mình từng đầu tư vào [công ty cùng lĩnh vực]. Deck đính kèm qua đường link.”"
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Sau khi gửi",
        "paragraphs": [
          "Nếu chưa có phản hồi sau khoảng một tuần làm việc, nhắc lại một lần — và nhắc bằng một thông tin mới, như khách hàng mới ký hoặc số liệu tháng vừa rồi, thay vì chỉ hỏi “anh/chị đã xem email chưa”. Sau hai lần không phản hồi, chuyển sang quỹ khác và gửi bản cập nhật định kỳ cho quỹ đó vài tháng sau.",
          "Nhiều khoản đầu tư đến từ nhà đầu tư đã theo dõi startup qua vài bản cập nhật. Một lần im lặng chưa phải là lời từ chối."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Trước khi gửi",
        "paragraphs": [
          "Kiểm tra quy mô vé, giai đoạn, địa bàn và kênh nộp hồ sơ chính thức của quỹ. Cá nhân hoá một lý do có thật; không mở đầu bằng lời khen chung chung."
        ],
        "bullets": [
          "Gửi đúng một người ở quỹ, ưu tiên người phụ trách ngành của bạn.",
          "Đính kèm deck dạng đường link có thể theo dõi lượt xem, không gửi tệp nặng.",
          "Không đính kèm quá nhiều tệp: mô hình tài chính và data room để dành cho vòng sau.",
          "Không gửi cùng một email cho nhiều quỹ trong ô người nhận.",
          "Đọc lại số liệu: con số trong email phải khớp với con số trong deck."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      }
    ],
    "relatedTools": [
      {
        "slug": "quy-phu-hop",
        "label": "Tìm quỹ phù hợp"
      },
      {
        "slug": "pitch-deck-10-slide",
        "label": "Kiểm tra pitch deck 10 slide"
      }
    ],
    "sources": [
      {
        "label": "Paul Graham — How to Raise Money",
        "url": "https://www.paulgraham.com/fr.html"
      }
    ],
    "seoTitle": "Cách viết email tiếp cận quỹ đầu tư: cấu trúc 5 dòng và ví dụ mẫu",
    "seoDescription": "Cấu trúc email năm dòng gửi nhà đầu tư, ví dụ email trực tiếp và email xin giới thiệu, cách đặt tiêu đề, khi nào nhắc lại và các lỗi khiến email bị bỏ qua.",
    "publishedAt": "2026-09-16",
    "updatedAt": "2026-09-22",
    "track": "cam-nang",
    "readingMinutes": 3
  },
  {
    "slug": "founder-con-4-thang-runway-nen-goi-von-the-nao",
    "title": "Founder còn 4 tháng runway nên gọi vốn thế nào?",
    "excerpt": "Khi thời gian ngắn, mục tiêu đầu tiên là giành lại quyền lựa chọn thay vì gửi hồ sơ hàng loạt trong thế bị động.",
    "category": "Tình huống gọi vốn",
    "stages": [
      "Pre-seed",
      "Seed"
    ],
    "storyType": "tong-hop",
    "templates": [],
    "consentConfirmed": false,
    "coverImage": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Ffounder-con-4-thang-runway-nen-goi-von-the-nao%2F1790080556204-cover.webp?alt=media&token=59601836-9561-4593-9065-753b57fcc0f3",
    "coverAlt": "Founder còn 4 tháng runway nên gọi vốn thế nào?",
    "coverCaption": "",
    "ogImage": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Ffounder-con-4-thang-runway-nen-goi-von-the-nao%2F1790080556474-cover.jpg?alt=media&token=47c25f6e-7fe4-4e99-84d1-89b87bb828e6",
    "author": "Fundraising Vietnam",
    "authorRole": "",
    "status": "PUBLISHED",
    "featured": false,
    "sections": [
      {
        "heading": "Tình huống",
        "paragraphs": [
          "Một startup EdTech bán phần mềm cho trung tâm ngoại ngữ có 1,6 tỷ đồng tiền mặt, đốt ròng 400 triệu mỗi tháng. Vòng Seed dự kiến chốt từ quý trước nhưng quỹ dẫn vòng rút lui ở bước thẩm định. Founder còn đúng bốn tháng.",
          "Phản xạ đầu tiên của founder là gửi deck cho mọi quỹ trong danh sách. Đây thường là phản xạ sai."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Vì sao bốn tháng là rất ngắn",
        "paragraphs": [
          "Bốn tháng runway thường ngắn hơn thời gian cần để tiếp cận, thẩm định và hoàn tất một vòng vốn tổ chức. Từ cuộc gặp đầu tiên đến khi tiền về thường mất 3–6 tháng, chưa kể thời gian hoàn tất hồ sơ pháp lý và chuyển tiền.",
          "Nguy hiểm hơn, nhà đầu tư nhận ra khi founder hết thời gian. Founder dễ chấp nhận điều khoản bất lợi hoặc mất tập trung vì vừa vận hành vừa gọi vốn — và chính việc vận hành sa sút lại làm hồ sơ yếu đi."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Tuần đầu tiên: kéo dài runway",
        "paragraphs": [
          "Việc đầu tiên không phải gọi vốn mà là mua thêm thời gian. Mục tiêu là đưa runway từ bốn tháng lên sáu đến tám tháng mà không làm hỏng động cơ tạo doanh thu."
        ],
        "bullets": [
          "Hoãn mọi kế hoạch tuyển dụng chưa ký hợp đồng.",
          "Cắt chi phí không trực tiếp tạo doanh thu: công cụ ít dùng, quảng cáo thương hiệu, sự kiện.",
          "Đề nghị khách hàng hiện tại trả trước theo năm, đổi lại một mức giảm giá hợp lý.",
          "Thu các khoản công nợ đến hạn, đàm phán giãn thời hạn thanh toán với nhà cung cấp.",
          "Founder cân nhắc giảm lương tạm thời — và nói rõ điều này với nhà đầu tư, vì đó là tín hiệu cam kết."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Ba đường chạy song song",
        "paragraphs": [
          "Ba đường này chạy cùng lúc, không tuần tự. Đường thứ nhất mua thời gian cho đường thứ ba; đường thứ hai là tấm lưới an toàn nếu đường thứ ba không kịp."
        ],
        "bullets": [
          "Giảm đốt tiền nhưng bảo vệ hoạt động tạo doanh thu: đội bán hàng và chăm sóc khách hàng là những người cuối cùng bị cắt.",
          "Tìm nguồn có quy trình ngắn: nhà đầu tư hiện hữu góp thêm vòng cầu nối, angel đã biết công ty, SAFE hoặc trái phiếu chuyển đổi, doanh thu trả trước từ khách hàng lớn.",
          "Chuẩn bị data room và danh sách 15–20 quỹ có điều kiện thực sự phù hợp — đúng giai đoạn, đúng ngành, đúng quy mô vé — thay vì gửi đại trà."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Thông điệp với nhà đầu tư",
        "paragraphs": [
          "Không che giấu runway. Nhà đầu tư sẽ biết trong buổi thẩm định đầu tiên, và phát hiện muộn làm mất niềm tin nhiều hơn là biết sớm.",
          "Hãy trình bày rõ tiền mặt, kế hoạch kiểm soát chi đã thực hiện, bằng chứng gần nhất và cột mốc mà khoản vốn cầu nối sẽ mở khoá. Ví dụ: “Chúng tôi còn 1,6 tỷ; sau khi cắt giảm, runway là 7 tháng. Khoản cầu nối 3 tỷ đưa chúng tôi tới 120 trung tâm trả tiền, đủ để quay lại vòng Seed với số liệu tốt hơn.” Sự rõ ràng đáng tin hơn một dự báo quá lạc quan."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Điều khoản cần cẩn trọng khi ở thế bị động",
        "paragraphs": [
          "Khi cần tiền gấp, founder dễ ký những điều khoản ảnh hưởng tới mọi vòng sau. Trước khi ký, hãy nhờ luật sư hoặc cố vấn có kinh nghiệm đọc kỹ các điểm sau:"
        ],
        "bullets": [
          "Quyền ưu tiên thanh lý nhiều lần giá trị đầu tư, hoặc có tham gia chia phần còn lại.",
          "Mức định giá trần quá thấp trên SAFE hoặc trái phiếu chuyển đổi.",
          "Quyền phủ quyết quá rộng với các quyết định vận hành thường ngày.",
          "Điều khoản chống pha loãng toàn phần.",
          "Cam kết mua lại cổ phần có thời hạn mà công ty khó thực hiện."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Nếu vẫn không gọi được",
        "paragraphs": [
          "Kế hoạch tốt luôn có phương án cuối: đưa công ty về trạng thái tự nuôi được bằng doanh thu, dù tăng trưởng chậm lại. Nếu không thể, các lựa chọn còn lại là sáp nhập, bán lại cho một công ty cùng ngành, hoặc đóng cửa có trật tự để bảo vệ nhân viên, khách hàng và uy tín của founder cho lần khởi nghiệp sau.",
          "Nghĩ về phương án này từ tuần đầu không phải là bi quan. Nó giúp founder biết chính xác lằn ranh nào không được vượt qua khi đàm phán."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      }
    ],
    "relatedTools": [
      {
        "slug": "tinh-runway",
        "label": "Kiểm tra runway"
      },
      {
        "slug": "quy-phu-hop",
        "label": "Tìm nguồn vốn phù hợp"
      },
      {
        "slug": "safe-va-trai-phieu-chuyen-doi",
        "label": "SAFE và trái phiếu chuyển đổi"
      }
    ],
    "sources": [
      {
        "label": "Paul Graham — Default Alive or Default Dead?",
        "url": "https://www.paulgraham.com/aord.html"
      }
    ],
    "seoTitle": "Còn 4 tháng runway: founder nên gọi vốn thế nào để không bị ép điều khoản",
    "seoDescription": "Tình huống founder còn 4 tháng tiền mặt: kéo dài runway trong tuần đầu, ba đường chạy song song, cách nói chuyện với nhà đầu tư và những điều khoản cần cẩn trọng khi ở thế bị động.",
    "publishedAt": "2026-09-16",
    "updatedAt": "2026-09-22",
    "track": "cau-chuyen",
    "readingMinutes": 4
  },
  {
    "slug": "goi-von-qua-som-bon-cai-gia",
    "title": "Gọi vốn quá sớm: bốn cái giá founder ít khi tính trước",
    "excerpt": "Tiền đầu tư không miễn phí. Bài này đặt cạnh nhau cái được và cái mất khi gọi vốn lúc công ty chưa chứng minh được gì: cổ phần bán rẻ, quyền quyết định bị chia, áp lực tăng trưởng và kỷ luật chi tiêu. Cuối bài có bảy câu hỏi để tự kiểm tra mình đã thật sự cần gọi vốn chưa.",
    "category": "Tình huống gọi vốn",
    "stages": [
      "Idea",
      "Pre-seed"
    ],
    "storyType": "huong-dan",
    "templates": [],
    "consentConfirmed": false,
    "coverImage": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Fgoi-von-qua-som-bon-cai-gia%2F1791000285151-cover.webp?alt=media&token=3f4f3ed5-a904-4a99-a727-9a6b923e0221",
    "coverAlt": "So sánh phần sở hữu của founder khi gọi vốn ngay và khi chờ thêm 9 tháng để có khách trả tiền",
    "coverCaption": "Cùng 3 tỷ đồng, gọi sớm 9 tháng có thể khiến founder nhượng gấp đôi phần công ty.",
    "ogImage": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Fgoi-von-qua-som-bon-cai-gia%2F1791000292779-cover.jpg?alt=media&token=80b3a35b-7daa-4eca-8112-355296aba0a9",
    "author": "Fundraising Vietnam",
    "authorRole": "",
    "status": "PUBLISHED",
    "featured": false,
    "sections": [
      {
        "heading": "Gọi vốn là một giao dịch, không phải một cột mốc",
        "paragraphs": [
          "Trong cộng đồng khởi nghiệp, gọi được vốn thường được ăn mừng như một thành tích. Nhưng về bản chất, đó là một giao dịch: bạn đổi một phần công ty, một phần quyền quyết định và một phần tự do lựa chọn tốc độ phát triển để lấy tiền mặt. Giao dịch nào cũng có giá, và giá đắt nhất khi bạn bán lúc chưa có gì để chứng minh.",
          "Bài này không nói rằng đừng gọi vốn. Nhiều công ty cần vốn sớm và nên gọi sớm. Mục tiêu là giúp bạn nhìn thấy rõ bốn cái giá đi kèm, bằng con số cụ thể, để tự trả lời câu hỏi: ở thời điểm này, lợi ích của tiền có lớn hơn cái giá phải trả không."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Cái giá thứ nhất: bán cổ phần với giá rẻ",
        "paragraphs": [
          "Khi công ty chưa có khách trả tiền, nhà đầu tư không có gì để định giá ngoài đội ngũ và ý tưởng. Rủi ro cao nên định giá thấp. Định giá thấp nghĩa là cùng một số tiền, bạn phải nhượng nhiều cổ phần hơn.",
          "Ví dụ minh họa: một startup phần mềm cần 3 tỷ đồng. Nếu gọi ngay khi mới có sản phẩm thử, nhà đầu tư thiên thần định giá trước vòng khoảng 9 tỷ. Nếu tự nuôi công ty thêm 9 tháng để có 30 khách trả tiền, cùng nhà đầu tư đó có thể chấp nhận định giá 21 tỷ. Các mức định giá ở đây chỉ để minh họa cơ chế, không phải mặt bằng thị trường.",
          "Phần chênh lệch không dừng ở vòng đầu. Mỗi vòng sau tiếp tục pha loãng từ con số còn lại, nên phần mất ở vòng đầu đi theo bạn tới tận lúc bán công ty."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": {
          "caption": "Cùng gọi 3 tỷ, gọi ngay và gọi sau 9 tháng (giả định mỗi vòng sau nhượng 20%)",
          "headers": [
            "",
            "Gọi ngay",
            "Chờ 9 tháng, có 30 khách trả tiền"
          ],
          "rows": [
            {
              "cells": [
                "Định giá trước vòng",
                "9 tỷ",
                "21 tỷ"
              ]
            },
            {
              "cells": [
                "Phần nhượng cho nhà đầu tư",
                "25%",
                "12,5%"
              ]
            },
            {
              "cells": [
                "Founder còn sau vòng đầu",
                "75%",
                "87,5%"
              ]
            },
            {
              "cells": [
                "Sau vòng Seed",
                "60%",
                "70%"
              ]
            },
            {
              "cells": [
                "Sau vòng Series A",
                "48%",
                "56%"
              ]
            },
            {
              "cells": [
                "Nếu công ty được bán 300 tỷ",
                "144 tỷ",
                "168 tỷ"
              ]
            }
          ]
        },
        "notes": [
          "Chênh 8 điểm phần trăm sở hữu, tương đương 24 tỷ đồng ở mức bán 300 tỷ, chỉ vì gọi sớm hơn 9 tháng. Bảng đã lược bỏ quỹ cổ phiếu thưởng và điều khoản ưu tiên thanh toán để dễ theo dõi; thực tế hai yếu tố này còn làm khoảng cách lớn hơn.",
          "Mặt còn lại của phép tính: chờ 9 tháng cũng tốn tiền. Nếu công ty đốt 120 triệu mỗi tháng, bạn cần khoảng 1,1 tỷ từ doanh thu, tiền túi hoặc nguồn khác để đi hết quãng đó. Và nếu 9 tháng trôi qua mà không có khách trả tiền, định giá còn tệ hơn hôm nay. Chờ chỉ có lợi khi bạn tin mình biến được thời gian thành bằng chứng."
        ]
      },
      {
        "heading": "Cái giá thứ hai: chia quyền quyết định",
        "paragraphs": [
          "Nhà đầu tư không chỉ mua cổ phần. Họ mua kèm những quyền để bảo vệ khoản tiền của mình, và các quyền đó thay đổi cách bạn điều hành công ty mỗi ngày. Dưới đây là năm yêu cầu hay gặp, kèm ý nghĩa thực tế của từng yêu cầu."
        ],
        "bullets": [
          "Quyền phủ quyết: một số quyết định phải có nhà đầu tư đồng ý mới được làm, thường là gọi vòng mới, bán công ty, phát hành thêm cổ phần, vay vượt hạn mức. Ví dụ: bạn muốn mở quỹ cổ phiếu thưởng 5% để mời một CTO giỏi, nhưng phải chờ nhà đầu tư duyệt, và họ có thể muốn quỹ nhỏ hơn. Phạm vi hẹp là bình thường; phạm vi lan tới ngân sách và tuyển dụng thường ngày là dấu hiệu cần đàm phán lại.",
          "Ghế trong hội đồng quản trị: ở vòng sớm, cách chia hay gặp là nhà sáng lập giữ đa số, nhà đầu tư dẫn dắt có một ghế. Điều cần để ý là ai giữ đa số sau hai, ba vòng nữa, vì hội đồng quản trị có quyền thay giám đốc điều hành, kể cả khi người đó là nhà sáng lập.",
          "KPI tăng trưởng: tiền có thể được giải ngân theo đợt, đợt sau chỉ về khi đạt chỉ tiêu. Ví dụ: 2 tỷ giải ngân ngay, 3 tỷ còn lại khi doanh thu đạt 500 triệu mỗi tháng. Nếu thị trường chậm hơn dự tính, bạn vừa thiếu tiền vừa phải đàm phán lại trong thế yếu.",
          "Báo cáo tài chính định kỳ: báo cáo hàng tháng hoặc hàng quý, sổ sách theo chuẩn, có khi cả kiểm toán. Đây là kỷ luật tốt, nhưng tốn thời gian và tiền, và với đội 5 người thì mỗi ngày làm báo cáo là một ngày không làm sản phẩm.",
          "Định hướng phát triển: khi muốn đổi hướng sản phẩm, đổi tệp khách hàng hay mở thị trường mới, bạn cần thuyết phục thêm người. Nhà đầu tư thường đẩy về phía thị trường lớn hơn và tăng nhanh hơn, kể cả khi bạn thấy một thị trường ngách có lãi phù hợp với công ty hơn."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": [
          "Không có quyền nào ở trên là xấu tự thân. Chúng tồn tại vì nhà đầu tư cũng đang chịu rủi ro. Câu hỏi thực tế là: bạn có sẵn sàng làm việc cùng người này trong năm đến bảy năm, với họ ngồi trong phòng họp ở mọi quyết định lớn không. Nếu câu trả lời còn lưỡng lự, khoản tiền đó đắt hơn con số trên giấy."
        ]
      },
      {
        "heading": "Cái giá thứ ba: đồng hồ tăng trưởng bắt đầu chạy",
        "paragraphs": [
          "Quỹ đầu tư mạo hiểm thường có vòng đời khoảng mười năm. Trong khoảng đó họ phải gọi tiền, đầu tư, rồi bán lại cổ phần để trả tiền cho người góp vốn vào quỹ. Vì phần lớn khoản đầu tư sẽ không hoàn vốn, mỗi khoản phải có khả năng tăng giá trị rất nhiều lần để bù cho những khoản thất bại. Đây là lý do nhà đầu tư mạo hiểm muốn công ty tăng nhanh, kể cả phải chấp nhận rủi ro cao hơn.",
          "Mục tiêu đó không sai, nhưng có thể không phải mục tiêu của bạn. Một công ty tăng 20% mỗi năm, có lãi đều và nuôi được 30 người là một doanh nghiệp tốt. Với quỹ đầu tư mạo hiểm, đó lại là một khoản đầu tư không đạt.",
          "Ví dụ minh họa: một chuỗi đồ uống có 5 cửa hàng đều có lãi. Nhà đầu tư rót vốn với kỳ vọng 30 cửa hàng trong ba năm. Để kịp tiến độ, công ty mở ở những mặt bằng chưa kiểm chứng, tuyển quản lý chưa kịp đào tạo, và biên lợi nhuận của các cửa hàng mới thấp hơn hẳn 5 cửa hàng đầu. Nếu tự đi bằng lợi nhuận, công ty có thể chỉ mở 12 cửa hàng trong ba năm, nhưng cửa hàng nào cũng có lãi.",
          "Thêm một điểm ít người để ý: sau khi nhận vốn mạo hiểm, việc bán công ty ở mức giá vừa phải không còn là lựa chọn dễ dàng. Điều khoản ưu tiên thanh toán và kỳ vọng của nhà đầu tư khiến một thương vụ bán mà trước đây bạn thấy rất tốt có thể không còn đáng để làm."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Cái giá thứ tư: tiền dễ làm mất kỷ luật",
        "paragraphs": [
          "Khi tài khoản đột nhiên có vài tỷ, mọi kế hoạch đều trông khả thi. Tuyển thêm người, chạy quảng cáo mạnh, thuê văn phòng đẹp hơn, xây thêm tính năng. Vấn đề là phần lớn các khoản chi đó làm tăng mức đốt tiền ngay lập tức, còn kết quả thì chưa chắc.",
          "Startup Genome, trong báo cáo năm 2011 phân tích hơn 3.200 startup công nghệ, ghi nhận khoảng 74% startup internet thất bại vì mở rộng quy mô quá sớm: tuyển người, chi tiền, mở rộng thị trường trước khi sản phẩm thực sự được khách hàng cần. Gọi vốn quá sớm làm điều này dễ xảy ra hơn, vì tiền về trước khi bạn biết nên tiêu vào đâu."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": {
          "caption": "Cùng nhận 5 tỷ, hai cách tiêu (công ty có sẵn 1 tỷ, đang đốt 150 triệu mỗi tháng)",
          "headers": [
            "",
            "Tiêu theo cột mốc",
            "Tiêu theo kế hoạch lớn"
          ],
          "rows": [
            {
              "cells": [
                "Tuyển thêm",
                "3 người, khi đạt từng cột mốc",
                "12 người trong quý đầu"
              ]
            },
            {
              "cells": [
                "Marketing mỗi tháng",
                "30 triệu, đo được hiệu quả",
                "150 triệu, chưa rõ kênh nào hiệu quả"
              ]
            },
            {
              "cells": [
                "Mức đốt mỗi tháng",
                "khoảng 300 triệu",
                "khoảng 650 triệu"
              ]
            },
            {
              "cells": [
                "Runway với 6 tỷ",
                "khoảng 20 tháng",
                "khoảng 9 tháng"
              ]
            },
            {
              "cells": [
                "Phải bắt đầu gọi vòng tiếp",
                "tháng thứ 12 đến 14",
                "tháng thứ 3 đến 4"
              ]
            }
          ]
        },
        "notes": [
          "Một vòng gọi vốn thường mất nhiều tháng từ buổi gặp đầu tiên tới khi tiền về. Với 9 tháng runway, công ty ở cột phải gần như vừa nhận tiền đã phải đi gọi tiếp, khi chưa kịp tạo ra kết quả nào để kể. Đó là lúc định giá vòng sau thấp hơn vòng trước.",
          "Paul Graham (Y Combinator) gợi ý một câu hỏi đơn giản để giữ kỷ luật: nếu chi phí giữ nguyên và doanh thu tăng như vài tháng qua, công ty có đạt hoà vốn trước khi hết tiền không. Ông gọi đó là trạng thái tự sống được (default alive) hay tự chết dần (default dead). Hỏi câu này mỗi tháng, trước và sau khi nhận vốn."
        ]
      },
      {
        "heading": "Khi nào gọi vốn sớm lại là lựa chọn đúng",
        "paragraphs": [
          "Để công bằng, có những trường hợp chờ đợi đắt hơn bốn cái giá ở trên:"
        ],
        "bullets": [
          "Sản phẩm cần đầu tư lớn trước khi bán được, như phần cứng, công nghệ sâu, y sinh. Không có vốn thì không có sản phẩm để chứng minh.",
          "Thị trường mà người dẫn đầu chiếm phần lớn giá trị, và đối thủ đang có vốn. Chậm sáu tháng có thể là mất thị trường.",
          "Bạn biết rõ mỗi đồng vốn sẽ biến thành cột mốc nào, và cột mốc đó làm định giá vòng sau tăng nhiều hơn phần cổ phần bạn nhượng hôm nay.",
          "Nhà đầu tư mang lại nhiều hơn tiền: khách hàng đầu tiên, giấy phép, kênh phân phối mà bạn không tự mở được.",
          "Founder không thể tự nuôi mình và đội thêm vài tháng, và không có nguồn vốn nào khác rẻ hơn."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Bảy câu hỏi trước khi quyết định gọi vốn",
        "paragraphs": [
          "Trả lời thật cho từng câu. Nếu có từ ba câu trở lên bạn trả lời không, nhiều khả năng đây chưa phải lúc, hoặc chưa phải loại vốn phù hợp."
        ],
        "bullets": [
          "Tôi nói được chính xác số tiền này sẽ mua được cột mốc nào, đo bằng con số và có thời hạn không?",
          "Nếu không gọi được vốn trong sáu tháng tới, công ty có sống được không? (Tính bằng công cụ runway trước khi trả lời.)",
          "Tôi đã thử các nguồn rẻ hơn chưa: doanh thu, khách trả trước, chương trình tài trợ không hoàn lại, vay?",
          "Mô hình kinh doanh có thể tăng gấp nhiều lần trong ba đến năm năm không, hay hợp hơn với tăng trưởng đều và có lãi?",
          "Tôi có sẵn sàng báo cáo định kỳ và chia quyền quyết định lớn với người khác trong nhiều năm không?",
          "Tôi đã biết mỗi khách hàng mang về bao nhiêu và tốn bao nhiêu để có được chưa?",
          "Nếu chờ thêm sáu đến chín tháng để có bằng chứng, định giá sẽ khác bao nhiêu, và tôi có đủ tiền để chờ không?"
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Nếu chưa nên gọi vốn, làm gì thay thế",
        "paragraphs": [],
        "bullets": [
          "Tự nuôi bằng doanh thu: bán sớm, kể cả bản sản phẩm chưa hoàn chỉnh. Khách trả tiền là bằng chứng mạnh nhất cho vòng gọi vốn sau này.",
          "Xin khách trả trước hoặc ký hợp đồng thử nghiệm có thu phí: vừa có tiền, vừa có bằng chứng nhu cầu.",
          "Tìm tài trợ không hoàn lại và chương trình hỗ trợ khởi nghiệp: không mất cổ phần. Xem danh sách tại mục Chương trình và tài trợ trên fundraising.vn.",
          "Gọi một khoản nhỏ từ nhà đầu tư thiên thần bằng SAFE hoặc trái phiếu chuyển đổi: hoãn việc định giá tới khi có thêm bằng chứng, nhưng nhớ tính trước SAFE sẽ quy đổi thành bao nhiêu phần trăm.",
          "Giảm mức đốt tiền để kéo dài runway: mỗi tháng sống thêm là một tháng tạo thêm bằng chứng."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Tóm lại",
        "paragraphs": [
          "Gọi vốn sớm không sai. Gọi vốn mà không biết mình đang trả giá gì mới là sai. Trước khi bắt đầu gửi hồ sơ, hãy tính ba con số: công ty tự sống được bao lâu, cần bao nhiêu tiền để đạt cột mốc tiếp theo, và cổ phần bạn nhượng hôm nay sẽ đáng bao nhiêu nếu đợi thêm vài tháng. Nếu tiền giúp bạn đi tới cột mốc nhanh hơn mức pha loãng bạn chấp nhận, đó là lúc gọi vốn."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      }
    ],
    "relatedTools": [
      {
        "slug": "tinh-runway",
        "label": "Tính xem công ty tự sống được bao lâu"
      },
      {
        "slug": "mo-phong-vong-goi-von",
        "label": "Thử xem mỗi mức định giá lấy đi bao nhiêu cổ phần"
      },
      {
        "slug": "doc-term-sheet",
        "label": "Đọc các điều khoản đi kèm tiền đầu tư"
      },
      {
        "slug": "chi-so-tang-truong",
        "label": "Đo tốc độ tăng trưởng từ doanh thu thật"
      },
      {
        "slug": "diem-san-sang-goi-von",
        "label": "Chấm mức sẵn sàng gọi vốn"
      }
    ],
    "sources": [
      {
        "label": "Paul Graham: Default Alive or Default Dead? (2015)",
        "url": "https://www.paulgraham.com/aord.html"
      },
      {
        "label": "GeekWire: Startup Genome Report về mở rộng quy mô quá sớm (2011)",
        "url": "https://www.geekwire.com/2011/number-reason-startups-fail-premature-scaling/"
      },
      {
        "label": "Y Combinator: A guide to seed fundraising",
        "url": "https://www.ycombinator.com/library/4A-a-guide-to-seed-fundraising"
      }
    ],
    "seoTitle": "Gọi vốn quá sớm: rủi ro, đánh đổi và 7 câu hỏi trước khi quyết định",
    "seoDescription": "Gọi vốn khi chưa chứng minh được giá trị khiến founder bán cổ phần rẻ, mất một phần quyền quyết định, chịu áp lực tăng trưởng và dễ chi tiêu thiếu kỷ luật. Ví dụ bằng số và bài tự kiểm tra trước khi gọi vốn.",
    "publishedAt": "2026-10-03",
    "updatedAt": "2026-10-03",
    "track": "cau-chuyen",
    "readingMinutes": 10
  },
  {
    "slug": "mo-hinh-doanh-thu-startup-chon-va-kiem-chung",
    "title": "Chọn mô hình doanh thu cho startup: 10 cách kiếm tiền và ai thực sự giúp bạn kiểm chứng",
    "excerpt": "Nhiều startup chết không vì thiếu doanh thu mà vì logic kiếm tiền sai: khách càng dùng càng lỗ. Bài này rút 7 bài học từ MoviePass, WeFit, Leflair, Baemin, Spotify, Airbnb, Arm, đi qua 10 mô hình doanh thu kèm chỉ số phải theo dõi, 6 câu hỏi để chọn mô hình, và phép thử rẻ để kiểm chứng bằng tiền thật.",
    "category": "Hồ sơ & pitch deck",
    "stages": [
      "Idea",
      "Pre-seed",
      "Seed"
    ],
    "storyType": "huong-dan",
    "templates": [],
    "consentConfirmed": false,
    "coverImage": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Fmo-hinh-doanh-thu-startup-chon-va-kiem-chung%2F1792332084149-cover.webp?alt=media&token=9b561a23-50c2-4810-9b53-514c7e62784e",
    "coverAlt": "Mười mô hình doanh thu của startup và câu hỏi ai trả tiền, kèm ví dụ MoviePass: hơn 3 triệu thuê bao nhưng càng dùng càng lỗ",
    "coverCaption": "Doanh thu cao chưa chứng minh được gì. Mô hình đúng là mô hình mà mỗi khách mới làm bạn khỏe hơn.",
    "ogImage": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Fmo-hinh-doanh-thu-startup-chon-va-kiem-chung%2F1792332094513-cover.jpg?alt=media&token=b23ce492-af71-449c-af79-dc24ffc0ccca",
    "author": "Fundraising Vietnam",
    "authorRole": "",
    "status": "PUBLISHED",
    "featured": false,
    "sections": [
      {
        "heading": "Doanh thu không phải là bằng chứng",
        "paragraphs": [
          "Mô hình doanh thu đúng là mô hình mà mỗi khách hàng mới làm bạn khỏe hơn, không phải yếu đi. Doanh thu cao chưa chứng minh được điều đó.",
          "MoviePass là ví dụ rõ nhất. Năm 2017 họ hạ giá gói xem phim không giới hạn xuống 9,95 USD/tháng, và đến giữa năm 2018 đã có hơn 3 triệu thuê bao. Nhưng mỗi vé họ vẫn trả rạp giá đầy đủ, nên người dùng càng chăm thì công ty càng lỗ: khoảng 40 triệu USD chỉ riêng tháng 5/2018. Tháng 9/2019 dịch vụ đóng cửa.",
          "MoviePass không thiếu khách, không thiếu doanh thu, không thiếu vốn. Thứ họ thiếu là một logic kiếm tiền mà quy mô làm cho tốt hơn. Bài này giúp bạn kiểm tra logic đó trước khi đổ tiền vào tăng trưởng: 7 bài học từ startup thật, 10 mô hình doanh thu kèm chỉ số phải theo dõi, 6 câu hỏi để chọn mô hình, và ai thực sự giúp bạn kiểm chứng.",
          "Một lưu ý về danh sách 10 mô hình hay được chia sẻ trên mạng: quyên góp (donations) là tiền tặng, người cho không nhận lại cổ phần hay sản phẩm. Nó khác gọi vốn cộng đồng và khác gọi vốn từ nhà đầu tư. Bài này dùng đúng nghĩa đó."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Bài học 1: Nhiều người dùng không có nghĩa là nhiều tiền",
        "paragraphs": [
          "Quý 2/2026, Spotify có 777 triệu người dùng hằng tháng, trong đó 494 triệu (khoảng 64%) dùng bản miễn phí có quảng cáo. Nhóm này chỉ mang về 446 triệu EUR, khoảng 9% tổng doanh thu 4,78 tỷ EUR. Phần còn lại đến từ 300 triệu người trả phí Premium.",
          "Quảng cáo chỉ nuôi được doanh nghiệp ở quy mô hàng trăm triệu người. Với startup Việt vài chục nghìn người dùng, doanh thu quảng cáo hiếm khi đủ trả lương một kỹ sư."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Bài học 2: Gói \"không giới hạn\" nguy hiểm khi chi phí tăng theo mức dùng",
        "paragraphs": [
          "WeFit (Việt Nam, hoạt động từ 9/2016) bán gói tập không giới hạn tại khoảng 1.000 phòng tập ở Hà Nội và TP.HCM. Tháng 1/2019 họ gọi được 1 triệu USD vòng pre-Series A từ CyberAgent Capital, khi đó xử lý khoảng 150.000 lượt đặt mỗi tháng. Từ cuối 2019 nhiều phòng tập báo bị chậm thanh toán; ngày 11/5/2020 công ty nộp đơn phá sản.",
          "Đây là bài toán MoviePass ở quy mô Việt Nam. Thuê bao chỉ an toàn khi chi phí phục vụ thêm một lượt dùng gần bằng 0 (phần mềm, nội dung số) hoặc có trần (giới hạn số buổi mỗi tháng)."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Bài học 3: Tiền về trước hay về sau quyết định bạn sống bao lâu",
        "paragraphs": [
          "Leflair (flash sale hàng hiệu) đóng cửa tháng 2/2020, để lại khoản công nợ khoảng 2 triệu USD với khoảng 500 nhà cung cấp. Khi biên lợi nhuận mỗi đơn mỏng và chi phí vận hành lớn, dòng tiền chỉ trụ được bằng vốn mới và tiền còn nợ nhà cung cấp.",
          "Câu cần hỏi: khách trả tiền cho bạn trước hay sau khi bạn phải trả tiền cho đối tác? Thu trước (gói năm, đặt cọc, đơn đặt trước) cho bạn thêm thời gian. Phải trả đối tác trước lấy bớt thời gian của bạn."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Bài học 4: Với sàn, người đứng thứ ba rất khó sống",
        "paragraphs": [
          "Năm 2022 thị trường giao đồ ăn Việt Nam có Grab 45%, ShopeeFood 41%, Baemin 12% (theo Momentum Works). Baemin dừng hoạt động tại Việt Nam từ 8/12/2023. Gojek Việt Nam đóng góp chưa tới 0,5% tổng giá trị giao dịch của tập đoàn GoTo trong quý 2/2024 và rút lui từ 16/9/2024.",
          "Hiệu ứng mạng lưới vừa là lợi thế, vừa là luật được ăn cả: bên dẫn đầu có nhiều người mua hơn, nên kéo được nhiều người bán hơn, và ngược lại. Nếu bạn làm sàn, hãy chọn một thị trường ngách đủ nhỏ để dẫn đầu."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Bài học 5: Mức phí của sàn là đòn bẩy, và cũng là rủi ro",
        "paragraphs": [
          "Năm 2025 Airbnb ghi nhận 12,2 tỷ USD doanh thu trên 91,3 tỷ USD giá trị đặt phòng, tức giữ lại khoảng 13,4% (tính từ hai con số công bố). Tại Việt Nam, từ 1/4/2025 Shopee nâng phí cố định trung bình từ khoảng 4% lên khoảng 9,5%; cộng phí thanh toán 5%, tổng phí người bán chịu tăng từ khoảng 9% lên 14,5%, và cộng đồng người bán phản ứng mạnh.",
          "Tăng phí chỉ bền khi người bán vẫn lời hơn so với các kênh khác. Trước khi định mức phí, hãy tính lợi nhuận của chính người bán trên nền tảng của bạn."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Bài học 6: Với freemium, phần lớn người dùng sẽ không bao giờ trả tiền",
        "paragraphs": [
          "Báo cáo chuyển đổi SaaS của ChartMogul cho thấy với sản phẩm freemium tự phục vụ, 3% đến 5% người dùng miễn phí chuyển sang trả phí là tốt, 8% đến 12% là rất tốt; khoảng một phần tư sản phẩm freemium dưới 2,5%. Nghĩa là khoảng 95 trên 100 người dùng sẽ tốn máy chủ và chăm sóc khách hàng mà không trả gì.",
          "Freemium kéo người dùng vào rất tốt, nhưng chỉ sống được khi chi phí phục vụ người dùng miễn phí thấp. Tiền lớn thường đến từ nhóm có ngân sách: đội nhóm, doanh nghiệp, trường học, không phải từ người dùng lẻ."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Bài học 7: Mô hình mạnh thường là hai dòng tiền xếp chồng",
        "paragraphs": [
          "Arm không bán chip. Năm tài chính 2026 (kết thúc 31/3/2026) họ thu 4,92 tỷ USD: khoảng 2,31 tỷ từ phí cấp phép trả một lần và 2,61 tỷ từ phí bản quyền tính trên mỗi con chip khách hàng xuất xưởng. Phí cấp phép trả chi phí nghiên cứu hôm nay; phí bản quyền tạo dòng tiền nhiều năm sau.",
          "Coolmate khởi đầu bằng bán thẳng online, đạt gần 290 tỷ đồng doanh thu và 530.000 khách hàng năm 2022, rồi mới tính tới kênh cửa hàng. Mô hình đầu tiên giúp bạn sống; mô hình thứ hai giúp bạn lớn. Chỉ thêm mô hình thứ hai khi mô hình thứ nhất đã được kiểm chứng."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "10 mô hình doanh thu: khi nào hợp, đo bằng gì",
        "paragraphs": [
          "Mỗi mô hình là một lời hứa về cách dòng tiền chạy. Cột \"Dấu hiệu chọn sai\" là thứ nhà đầu tư thường hỏi đầu tiên."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": {
          "caption": "10 mô hình doanh thu phổ biến",
          "headers": [
            "Mô hình",
            "Hợp khi",
            "Chỉ số phải theo dõi",
            "Dấu hiệu chọn sai"
          ],
          "rows": [
            {
              "cells": [
                "1. Bán trực tiếp",
                "Giá trị lớn, mua không thường xuyên: dự án, thiết bị, dịch vụ triển khai",
                "Biên gộp mỗi đơn, chi phí có một khách, tỷ lệ mua lại",
                "Mỗi tháng lại bắt đầu từ 0, doanh thu không dự báo được"
              ]
            },
            {
              "cells": [
                "2. Thuê bao",
                "Nhu cầu lặp lại, chi phí phục vụ thêm một lượt gần bằng 0",
                "Churn hằng tháng, LTV/CAC, số tháng hoàn vốn CAC",
                "Người dùng càng chăm bạn càng lỗ (MoviePass, WeFit)"
              ]
            },
            {
              "cells": [
                "3. Quảng cáo",
                "Hàng chục triệu người dùng, thời gian dùng cao",
                "Người dùng hoạt động hằng ngày, thời gian dùng, doanh thu quảng cáo mỗi người",
                "Vài chục nghìn người dùng mà hy vọng sống bằng quảng cáo"
              ]
            },
            {
              "cells": [
                "4. Tiếp thị liên kết",
                "Bạn sở hữu lưu lượng hoặc niềm tin của một cộng đồng",
                "Tỷ lệ click thành đơn, hoa hồng mỗi đơn, tỷ lệ huỷ đơn",
                "Phụ thuộc chính sách hoa hồng của một sàn duy nhất"
              ]
            },
            {
              "cells": [
                "5. Bán qua kênh",
                "Khách khó tiếp cận trực tiếp, đã có người họ tin (đại lý, kế toán)",
                "Doanh số mỗi đối tác, mức chiết khấu, tỷ lệ gia hạn qua kênh",
                "Chiết khấu ăn hết biên, đối tác không chịu bán sản phẩm của bạn"
              ]
            },
            {
              "cells": [
                "6. Sàn thu phí giao dịch",
                "Hai phía phân tán, giao dịch lặp lại, bạn kiểm soát được thanh toán",
                "GMV, take rate, tỷ lệ quay lại của cả hai phía",
                "Đứng thứ ba trong thị trường, hai bên giao dịch riêng ngoài sàn"
              ]
            },
            {
              "cells": [
                "7. Cấp phép",
                "Có công nghệ, dữ liệu hoặc thương hiệu khó sao chép",
                "Số giấy phép, phí bản quyền mỗi đơn vị, thời hạn hợp đồng",
                "Không có bằng sáng chế, bí quyết hay thương hiệu đủ mạnh"
              ]
            },
            {
              "cells": [
                "8. Bán lẻ hàng hoá",
                "Bạn kiểm soát sản phẩm, chuỗi cung ứng và thương hiệu",
                "Biên gộp, vòng quay tồn kho, giá trị đơn trung bình, tỷ lệ hoàn",
                "Tồn kho chôn hết tiền mặt, cạnh tranh chỉ bằng giá"
              ]
            },
            {
              "cells": [
                "9. Quyên góp",
                "Tổ chức phi lợi nhuận, sứ mệnh rõ, cộng đồng rất lớn",
                "Số người tặng định kỳ, giá trị tặng trung bình",
                "Startup cần tăng trưởng và cần hoàn vốn cho nhà đầu tư"
              ]
            },
            {
              "cells": [
                "10. Miễn phí cơ bản (freemium)",
                "Chi phí phục vụ người dùng miễn phí thấp, sản phẩm tự lan truyền",
                "Tỷ lệ kích hoạt, tỷ lệ chuyển sang trả phí, chi phí phục vụ người miễn phí",
                "Dưới 2,5% chuyển đổi trong khi chi phí máy chủ tăng theo người dùng"
              ]
            }
          ]
        },
        "notes": [
          "Ví dụ ở Việt Nam: KiotViet bán phần mềm quản lý bán hàng theo thuê bao và phục vụ hơn 110.000 SME khi gọi vòng Series B 45 triệu USD. MISA phân phối phần mềm qua mạng lưới đại lý và đại lý thuế hưởng chiết khấu. ACCESSTRADE vận hành mạng tiếp thị liên kết lớn nối doanh nghiệp với người làm nội dung.",
          "Hai mô hình hay bị nhầm: sàn (6) thu phí trên giao dịch giữa người khác với nhau, còn bán lẻ (8) tự mua hàng, chịu tồn kho và hưởng toàn bộ biên. Sàn nhẹ vốn hơn nhưng phải giải bài toán con gà quả trứng; bán lẻ có tiền ngay từ đơn đầu nhưng nặng vốn lưu động."
        ]
      },
      {
        "heading": "6 câu hỏi cốt lõi để chọn mô hình",
        "paragraphs": [
          "Đừng chọn mô hình vì một công ty nổi tiếng đang dùng. Trả lời 6 câu dưới đây bằng dữ liệu của chính bạn; mô hình phù hợp thường tự lộ ra."
        ],
        "bullets": [
          "Ai trả tiền, và họ có phải người dùng không? Người dùng tự trả thì đi bán trực tiếp hoặc thuê bao. Người khác trả (nhà quảng cáo, người bán, thương hiệu) thì đi quảng cáo, tiếp thị liên kết hoặc sàn, và phải phục vụ cả hai phía.",
          "Giá trị đến một lần hay lặp lại? Nhu cầu hằng tuần, hằng tháng hợp thuê bao. Nhu cầu vài năm một lần, giá trị lớn hợp bán trực tiếp hoặc cấp phép. Đừng ép thuê bao lên thứ khách chỉ cần một lần.",
          "Phục vụ thêm một khách, một lượt dùng tốn bao nhiêu? Gần bằng 0 thì thuê bao và freemium an toàn. Tăng theo từng lượt (suất chiếu, buổi tập, chuyến xe) thì tính phí theo lượt hoặc đặt trần cho gói.",
          "Tiền về trước hay về sau? Thu trước kéo dài thời gian sống. Phải trả đối tác trước khi khách trả mình là rủi ro dòng tiền cần tính từ ngày đầu.",
          "Bạn có gì khó sao chép? Cấp phép cần công nghệ hoặc thương hiệu không ai làm lại được. Sàn cần vị trí dẫn đầu một thị trường. Bán lẻ cần thương hiệu và chuỗi cung ứng. Không có lợi thế này thì giá là vũ khí duy nhất.",
          "Cần bao nhiêu khách để hoà vốn, và con số đó có thực tế không? Lấy chi phí cố định hằng tháng chia cho biên đóng góp của mỗi khách."
        ],
        "image": null,
        "quote": null,
        "table": {
          "caption": "Câu trả lời của bạn thường dẫn tới mô hình nào",
          "headers": [
            "Nếu câu trả lời là",
            "Thường hợp với"
          ],
          "rows": [
            {
              "cells": [
                "Người dùng tự trả, dùng lặp lại, chi phí phục vụ thêm gần 0",
                "Thuê bao, có thể mở đầu bằng freemium"
              ]
            },
            {
              "cells": [
                "Người dùng tự trả, mua hiếm, giá trị lớn",
                "Bán trực tiếp, sau đó thêm hợp đồng bảo trì"
              ]
            },
            {
              "cells": [
                "Hai nhóm cần tìm nhau, giao dịch lặp lại",
                "Sàn thu phí giao dịch"
              ]
            },
            {
              "cells": [
                "Khách tin một bên trung gian hơn tin bạn",
                "Bán qua kênh"
              ]
            },
            {
              "cells": [
                "Có công nghệ, thương hiệu khó sao chép",
                "Cấp phép, phí bản quyền"
              ]
            },
            {
              "cells": [
                "Có lưu lượng lớn nhưng chưa có sản phẩm riêng",
                "Tiếp thị liên kết, rồi quảng cáo khi đủ lớn"
              ]
            }
          ]
        },
        "notes": [
          "Ví dụ cho câu 6: phần mềm giá 199.000 đồng/tháng, biên đóng góp 80% (khoảng 159.000 đồng mỗi khách), chi phí cố định 150 triệu đồng/tháng thì cần khoảng 943 khách trả phí để hoà vốn. Nếu là freemium với tỷ lệ chuyển đổi 3%, bạn cần khoảng 31.400 người dùng miễn phí đang hoạt động. Câu hỏi thật là: kênh nào mang về 31.400 người đó, và tốn bao nhiêu?"
        ]
      },
      {
        "heading": "Ai thực sự giúp bạn kiểm chứng?",
        "paragraphs": [
          "Câu trả lời ngắn: chỉ người trả tiền mới kiểm chứng được mô hình doanh thu. Mentor, vườn ươm, nhà đầu tư giúp bạn thiết kế phép thử và chỉ ra lỗ hổng, nhưng không ai trong số họ thay được hành động móc ví của khách.",
          "Lời khen, lượt đăng ký, phiếu khảo sát \"sẽ mua\" đều rẻ. Tín hiệu thật là tiền: một khoản đặt cọc, một hợp đồng thử nghiệm có phí, một lần gia hạn."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": {
          "caption": "Mỗi bên kiểm chứng được điều gì",
          "headers": [
            "Ai",
            "Kiểm chứng được",
            "Không kiểm chứng được",
            "Cách nhờ hiệu quả"
          ],
          "rows": [
            {
              "cells": [
                "Khách hàng trả tiền",
                "Mức giá chấp nhận, tần suất dùng, có gia hạn hay không",
                "Quy mô thị trường tổng",
                "Báo giá thật, xin đặt cọc, đề nghị trả trước gói năm"
              ]
            },
            {
              "cells": [
                "Đối tác kênh, người bán trên sàn",
                "Biên lợi nhuận của họ có đủ để họ ở lại",
                "Người dùng cuối có thích sản phẩm không",
                "Hỏi họ lời bao nhiêu mỗi đơn qua bạn so với kênh khác"
              ]
            },
            {
              "cells": [
                "Founder đã chạy cùng mô hình",
                "Chi phí ẩn, điểm gãy dòng tiền, cách định giá",
                "Thị trường của bạn có giống của họ",
                "Hỏi: tháng nào anh chị suýt hết tiền, và vì sao?"
              ]
            },
            {
              "cells": [
                "Vườn ươm, chương trình tăng tốc",
                "Kỷ luật thử nghiệm, kết nối khách hàng thử và chuyên gia",
                "Thay khách ra quyết định mua",
                "Đặt mục tiêu khoá học bằng số khách trả phí, không bằng số buổi học"
              ]
            },
            {
              "cells": [
                "Nhà đầu tư",
                "So sánh với hàng trăm startup cùng loại, soi kinh tế đơn vị",
                "Sản phẩm có ai mua (họ không phải khách)",
                "Mang số liệu theo nhóm khách (cohort), không mang dự phóng"
              ]
            },
            {
              "cells": [
                "Dữ liệu của chính bạn",
                "Hành vi thật theo thời gian",
                "Lý do đằng sau hành vi",
                "Theo dõi theo nhóm khách bắt đầu cùng tháng"
              ]
            }
          ]
        },
        "notes": []
      },
      {
        "heading": "Phép thử rẻ cho từng mô hình",
        "paragraphs": [
          "Mục tiêu là có tín hiệu trả tiền trong vài tuần, trước khi viết nhiều code hay đổ tiền quảng cáo. Ngưỡng dưới đây là gợi ý để bắt đầu, không phải chuẩn ngành, trừ dòng freemium lấy theo số liệu ChartMogul."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": {
          "caption": "Phép thử và tín hiệu đủ tốt để đi tiếp",
          "headers": [
            "Mô hình",
            "Phép thử rẻ",
            "Tín hiệu đủ tốt"
          ],
          "rows": [
            {
              "cells": [
                "Bán trực tiếp",
                "Gửi báo giá thật cho 10 khách tiềm năng",
                "Có khách ký hoặc đặt cọc mà không cần giảm giá sâu"
              ]
            },
            {
              "cells": [
                "Thuê bao",
                "Bán gói trả trước cho 10 khách đầu tiên, phục vụ thủ công nếu cần",
                "Khách trả trước và vẫn dùng sang tháng thứ hai"
              ]
            },
            {
              "cells": [
                "Quảng cáo",
                "Đo tần suất và thời gian dùng trước, chưa bán quảng cáo",
                "Người dùng quay lại đều mà không cần nhắc"
              ]
            },
            {
              "cells": [
                "Tiếp thị liên kết",
                "Chạy một tháng với một hoặc hai chương trình liên kết",
                "Hoa hồng trên mỗi lượt truy cập trả được chi phí làm nội dung"
              ]
            },
            {
              "cells": [
                "Bán qua kênh",
                "Ký thử với 3 đối tác, đào tạo họ một buổi",
                "Đối tác tự bán được đơn mà không cần bạn đi cùng"
              ]
            },
            {
              "cells": [
                "Sàn thu phí",
                "Tự làm thủ công phía cung cho một ngách hẹp",
                "Hai bên giao dịch lặp lại qua bạn khi đã bỏ trợ giá"
              ]
            },
            {
              "cells": [
                "Cấp phép",
                "Đàm phán hợp đồng thử nghiệm có phí với 1 đến 2 khách",
                "Khách trả phí thử nghiệm và hỏi về điều khoản dài hạn"
              ]
            },
            {
              "cells": [
                "Bán lẻ",
                "Mở bán đặt trước hoặc một lô nhỏ",
                "Biên gộp sau hoàn trả vẫn dương, có khách mua lần hai"
              ]
            },
            {
              "cells": [
                "Freemium",
                "Ra bản miễn phí, khoá một tính năng người dùng nhiều nhất cần",
                "Từ 3% đến 5% người dùng hoạt động chuyển sang trả phí"
              ]
            }
          ]
        },
        "notes": [
          "Điểm chung: phép thử nào cũng kết thúc bằng một hành động trả tiền đo được. Nếu phép thử kết thúc bằng câu \"khách nói họ thích\", đó chưa phải kiểm chứng."
        ]
      },
      {
        "heading": "Checklist trước khi gặp nhà đầu tư",
        "paragraphs": [
          "Nhà đầu tư giai đoạn sớm không đòi doanh thu lớn. Họ cần thấy bạn hiểu logic kiếm tiền của mình và đã thử nó bằng tiền thật."
        ],
        "bullets": [
          "Viết mô hình doanh thu trong một câu: ai trả, trả cho cái gì, bao nhiêu, bao lâu một lần.",
          "Có ít nhất một tín hiệu bằng tiền: đặt cọc, hợp đồng thử nghiệm có phí, hoặc một lần gia hạn.",
          "Tính biên đóng góp mỗi khách và số khách cần để hoà vốn.",
          "Trả lời được: khi khách dùng nhiều hơn, chi phí của bạn tăng thế nào?",
          "Vẽ được dòng tiền của một giao dịch: tiền khách vào ngày nào, tiền trả đối tác ra ngày nào.",
          "Chọn 2 đến 3 chỉ số theo bảng 10 mô hình ở trên, có số liệu theo từng tháng.",
          "Biết đối thủ thu tiền bằng cách nào, và vì sao cách của bạn tốt hơn cho khách.",
          "Nếu định thêm mô hình thứ hai, nêu rõ điều kiện để bật nó, ví dụ sau 500 khách trả phí."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": [
          "Muốn có người đọc lại logic doanh thu trong pitch deck? Gửi deck lên mục Nhận xét pitch deck của fundraising.vn, miễn phí."
        ]
      }
    ],
    "relatedTools": [
      {
        "slug": "kiem-tra-gia-dinh-kinh-te-don-vi",
        "label": "Kiểm tra kinh tế đơn vị của mô hình"
      },
      {
        "slug": "tinh-runway",
        "label": "Tính runway khi tiền về chậm"
      },
      {
        "slug": "chi-so-tang-truong",
        "label": "Soát chỉ số tăng trưởng"
      },
      {
        "slug": "pitch-deck-10-slide",
        "label": "Kiểm tra pitch deck 10 slide"
      }
    ],
    "sources": [
      {
        "label": "Fortune: MoviePass shuts down for good (13/9/2019)",
        "url": "https://fortune.com/2019/09/13/moviepass-shuts-down-for-good"
      },
      {
        "label": "Spotify: báo cáo quý 2/2026 gửi SEC (4/8/2026)",
        "url": "https://www.sec.gov/Archives/edgar/data/0001639920/000114036126031044/ef20078867_ex99-1.htm"
      },
      {
        "label": "Tuổi Trẻ News: WeWow (WeFit) nộp đơn phá sản (13/5/2020)",
        "url": "https://tuoitrenews.vn/news/business/20200513/vietnamese-fitness-beauty-startup-wewow-files-for-bankruptcy/54549.html"
      },
      {
        "label": "Znews: Leflair bị tố nợ nhà cung cấp sau khi đóng cửa",
        "url": "https://znews.vn/website-hang-hieu-leflair-bi-to-no-hang-chuc-ty-dong-sau-khi-dong-cua-post1054943.html"
      },
      {
        "label": "Mekong ASEAN: Baemin dừng hoạt động tại Việt Nam (thị phần 2022 theo Momentum Works)",
        "url": "https://mekongasean.vn/dich-vu-dat-do-an-baemin-dung-hoat-dong-tai-viet-nam-4903.html"
      },
      {
        "label": "Diễn đàn Doanh nghiệp: Gojek dừng cuộc chơi tại Việt Nam (5/9/2024)",
        "url": "https://diendandoanhnghiep.vn/gojek-dung-cuoc-choi-tai-viet-nam-don-suc-vao-que-nha-10141483.html"
      },
      {
        "label": "Airbnb: báo cáo thường niên 10-K năm 2025",
        "url": "https://www.sec.gov/Archives/edgar/data/1559720/000155972026000004/abnb-20251231.htm"
      },
      {
        "label": "Báo Pháp luật Việt Nam: Shopee thay đổi phí người bán từ 1/4/2025",
        "url": "https://doanhnhan.baophapluat.vn/shopee-ra-loat-chinh-sach-tinh-phi-moi-tang-toi-6-tuy-nganh-hang-nha-ban-hang-khoc-than-thi-ganh-nang-chi-phi-81201.html"
      },
      {
        "label": "ChartMogul: The SaaS Conversion Report",
        "url": "https://chartmogul.com/reports/saas-conversion-report/"
      },
      {
        "label": "Arm Holdings: báo cáo 20-F năm tài chính 2026",
        "url": "https://www.sec.gov/Archives/edgar/data/0001973239/000197323926000097/arm-20260331.htm"
      },
      {
        "label": "Đại biểu Nhân dân: Coolmate, từ con số 0 đến doanh thu trăm tỷ (28/4/2023)",
        "url": "https://daibieunhandan.vn/coolmate-hanh-trinh-tu-con-so-0-den-doanh-thu-tram-ty-10308212.html"
      },
      {
        "label": "Brands Vietnam: KiotViet gọi vốn Series B 45 triệu USD",
        "url": "https://www.brandsvietnam.com/21890-Phan-mem-quan-ly-ban-hang-KiotViet-goi-von-thanh-cong-45-trieu-USD-vong-Series"
      }
    ],
    "seoTitle": "Mô hình doanh thu startup: 10 mô hình, bài học từ startup Việt Nam và thế giới, cách kiểm chứng",
    "seoDescription": "So sánh 10 mô hình doanh thu (thuê bao, sàn, freemium, quảng cáo, cấp phép...) cho startup giai đoạn sớm: khi nào hợp, chỉ số cần theo dõi, bài học từ MoviePass, WeFit, Leflair, Baemin, Spotify, Arm, 6 câu hỏi chọn mô hình và phép thử rẻ để kiểm chứng.",
    "publishedAt": "2026-10-18",
    "updatedAt": "2026-10-18",
    "track": "cam-nang",
    "readingMinutes": 13
  },
  {
    "slug": "mo-hinh-tai-chinh-cho-chuoi-fnb",
    "title": "Mô hình tài chính cho chuỗi F&B: câu hỏi đầu tiên là hoàn vốn một điểm bán",
    "excerpt": "Với mô hình chuỗi, nhà đầu tư không mua kế hoạch mở 50 cửa hàng. Họ mua bằng chứng rằng một cửa hàng đã hoàn vốn được.",
    "category": "Mô hình tài chính",
    "stages": [
      "Pre-seed",
      "Seed"
    ],
    "storyType": "huong-dan",
    "templates": [
      "mo-hinh-tai-chinh-chuoi-fnb"
    ],
    "consentConfirmed": false,
    "coverImage": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Fmo-hinh-tai-chinh-cho-chuoi-fnb%2F1790190211858-cover.webp?alt=media&token=90d8cfde-873b-49cb-9450-58c9176caf66",
    "coverAlt": "Mô hình tài chính cho chuỗi F&B: câu hỏi đầu tiên là hoàn vốn một điểm bán",
    "coverCaption": "",
    "ogImage": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Fmo-hinh-tai-chinh-cho-chuoi-fnb%2F1790190214830-cover.jpg?alt=media&token=f1b108d5-5c21-460e-b157-5140224ca98e",
    "author": "Fundraising Vietnam",
    "authorRole": "",
    "status": "PUBLISHED",
    "featured": false,
    "sections": [
      {
        "heading": "Đơn vị phân tích là một điểm bán",
        "paragraphs": [
          "Kế hoạch mở năm mươi cửa hàng trong ba năm không nói được điều gì nếu chưa có một cửa hàng chứng minh được mô hình. Vì vậy bảng số của chuỗi nên bắt đầu từ một điểm bán: doanh thu mỗi tháng, chi phí tại điểm, lợi nhuận gộp còn lại, và bao nhiêu tháng để hoàn lại vốn đầu tư ban đầu.",
          "Khi một điểm đã hoàn vốn trong khoảng thời gian chấp nhận được, kế hoạch mở rộng trở thành phép nhân có cơ sở. Khi chưa, mọi phép nhân chỉ nhân lên phần lỗ."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Biến số điều khiển",
        "paragraphs": [],
        "bullets": [
          "Số điểm bán và tốc độ mở mới — nên để dạng thập phân, ví dụ 0,25 nếu bốn tháng mở một điểm.",
          "Số hoá đơn mỗi ngày mỗi điểm và số ngày mở cửa mỗi tháng.",
          "Giá trị bình quân mỗi hoá đơn.",
          "Biên lợi nhuận gộp sau giá vốn nguyên liệu.",
          "Chi phí cố định tại điểm: thuê mặt bằng và nhân sự.",
          "Vốn đầu tư mở một điểm bán — thi công, thiết bị, tiền cọc mặt bằng, hàng ban đầu."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Ví dụ có thật: Phúc Long sau khi đóng bớt điểm bán",
        "paragraphs": [
          "Phúc Long thuộc tập đoàn Masan nên số liệu được công bố theo quý — hiếm có trong ngành F&B Việt Nam, và vì vậy rất đáng để đối chiếu. Quý 3/2025, chuỗi đạt doanh thu 516 tỷ đồng, tăng 21,2% so với cùng kỳ, với khoảng 242 cửa hàng. Doanh thu bình quân mỗi cửa hàng mỗi ngày là 23,5 triệu đồng, tăng 8,8% trên nhóm cửa hàng so sánh tương đương.",
          "Điều đáng học không nằm ở mức tăng, mà ở cách chuỗi đạt được nó: Masan đóng các kiosk đặt trong siêu thị WinMart hoạt động kém và dồn về cửa hàng độc lập. Nói cách khác, giả định quen thuộc «mở thêm điểm thì doanh thu thêm» đã bị chính họ bác bỏ bằng số liệu. Bảng tài chính nào cộng dồn doanh thu theo số điểm mở mới mà không tách riêng doanh thu mỗi điểm đều sẽ gặp đúng vấn đề này."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": {
          "caption": "Phúc Long, quý 3/2025 — và dòng tương ứng trong bảng của bạn",
          "headers": [
            "Chỉ số công bố",
            "Giá trị",
            "Dòng tương ứng bạn phải có"
          ],
          "rows": [
            {
              "cells": [
                "Doanh thu quý",
                "516 tỷ đồng, tăng 21,2%",
                "Doanh thu theo quý, tách theo nhóm điểm bán"
              ]
            },
            {
              "cells": [
                "Số cửa hàng",
                "Khoảng 242",
                "Số điểm đang hoạt động, không tính điểm đã đóng"
              ]
            },
            {
              "cells": [
                "Doanh thu mỗi cửa hàng mỗi ngày",
                "23,5 triệu đồng, tăng 8,8%",
                "Đây là biến số điều khiển của cả bảng"
              ]
            },
            {
              "cells": [
                "Biên EBITDA",
                "18,1%",
                "Biên sau chi phí vận hành điểm bán, trước khấu hao"
              ]
            },
            {
              "cells": [
                "Tỷ trọng kênh giao hàng",
                "32,9% doanh thu, tăng 5,4 điểm phần trăm",
                "Doanh thu tách theo kênh, vì phí sàn giao hàng ăn vào biên"
              ]
            },
            {
              "cells": [
                "Nhóm đồ ăn kèm",
                "6,2% doanh thu, tăng 45,3%",
                "Doanh thu theo nhóm sản phẩm, không gộp một dòng"
              ]
            }
          ]
        },
        "notes": [
          "Nguồn: số liệu Masan quý 3/2025 do CafeF tổng hợp (28/10/2025). Luỹ kế 9 tháng 2025, Phúc Long đạt 1.373 tỷ đồng doanh thu và 141 tỷ đồng lợi nhuận sau thuế.",
          "Phúc Long là chuỗi đã vận hành nhiều năm, không phải chuẩn để một chuỗi mới ba điểm so bằng. Hãy dùng cấu trúc các dòng, đừng mượn con số."
        ]
      },
      {
        "heading": "Quy mô ngành, để biết giả định tăng trưởng của bạn nằm ở đâu",
        "paragraphs": [
          "Báo cáo thị trường kinh doanh ẩm thực của iPOS.vn cho thấy một bức tranh ít nhiều trái với cảm giác thường thấy: ngành đông cửa hàng nhưng tăng trưởng đã chậm lại, và áp lực chi phí đầu vào mới là thứ quyết định biên lợi nhuận."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": {
          "caption": "Ngành F&B Việt Nam theo báo cáo iPOS.vn",
          "headers": [
            "Chỉ tiêu",
            "2025",
            "2026 (dự báo)"
          ],
          "rows": [
            {
              "cells": [
                "Số cửa hàng ăn uống",
                "Khoảng 329.500",
                "Khoảng 333.600"
              ]
            },
            {
              "cells": [
                "Doanh thu toàn ngành",
                "Khoảng 726.500 tỷ đồng",
                "Khoảng 760.000 tỷ đồng"
              ]
            },
            {
              "cells": [
                "Tăng trưởng so với năm trước",
                "5,5%",
                "4,6%"
              ]
            },
            {
              "cells": [
                "Doanh nghiệp chịu ảnh hưởng rõ từ giá nguyên liệu",
                "69,38%",
                "—"
              ]
            },
            {
              "cells": [
                "Tỷ trọng đồ uống từ 35.000 đồng trở lên",
                "57,58% thị phần",
                "—"
              ]
            }
          ]
        },
        "notes": [
          "Nguồn: iPOS.vn, Báo cáo thị trường kinh doanh ẩm thực Việt Nam, số liệu 2025 và dự báo 2026.",
          "Cách dùng: nếu bảng của bạn giả định doanh thu mỗi điểm tăng 25% một năm trong khi toàn ngành tăng khoảng 5%, bạn đang ngầm giả định giành khách của người khác. Điều đó không sai, nhưng phải nói rõ giành từ ai và bằng cách nào — nhà đầu tư sẽ hỏi đúng câu đó.",
          "Gần 70% doanh nghiệp chịu áp lực giá nguyên liệu nghĩa là giá vốn trong bảng phải là ô nhập có thể thay đổi, kèm một kịch bản giá vốn tăng 10%."
        ]
      },
      {
        "heading": "Bốn con số nên hiện trong deck",
        "paragraphs": [],
        "bullets": [
          "Doanh thu bình quân mỗi điểm mỗi tháng.",
          "Lợi nhuận gộp mỗi điểm mỗi tháng sau khi trừ thuê và nhân sự tại điểm.",
          "Thời gian hoàn vốn một điểm bán, tính bằng tháng.",
          "Chi phí quản lý cấp công ty, tách riêng khỏi chi phí tại điểm — nhà đầu tư luôn muốn thấy hai khối này rời nhau."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Cái bẫy của tiền cọc và chi phí đầu tư",
        "paragraphs": [
          "Vốn đầu tư mở điểm không phải chi phí hàng tháng, nhưng nó rút tiền mặt ngay. Rất nhiều bảng F&B trông có lãi mà vẫn hết tiền, vì phần đầu tư mở điểm bị để ngoài bảng dòng tiền.",
          "Cách xử lý là đưa khoản này vào dòng tiền theo đúng tiến độ mở điểm, và kiểm tra tiền mặt cuối mỗi tháng. Nếu tốc độ mở nhanh hơn tốc độ hoàn vốn, tiền mặt sẽ cạn kể cả khi từng điểm đều lãi."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      }
    ],
    "relatedTools": [
      {
        "slug": "tinh-runway",
        "label": "Tính runway"
      },
      {
        "slug": "goi-bao-nhieu",
        "label": "Lập kế hoạch số vốn"
      }
    ],
    "sources": [
      {
        "label": "CafeF — số liệu Phúc Long quý 3/2025 theo báo cáo Masan",
        "url": "https://cafef.vn/sau-tai-cau-truc-trung-binh-moi-cua-hang-phuc-long-thu-235-trieu-dong-ngay-188251028062048988.chn"
      },
      {
        "label": "Báo Đầu tư — iPOS.vn: thị trường F&B 2025 và dự báo 2026",
        "url": "https://baodautu.vn/thi-truong-fb-viet-nam-2026-huong-toi-doanh-thu-760000-ty-dong-quy-mo-333600-cua-hang-d564321.html"
      },
      {
        "label": "iPOS.vn — Báo cáo thị trường kinh doanh ẩm thực Việt Nam",
        "url": "https://ipos.vn/bao-cao-thi-truong-kinh-doanh-am-thuc-viet-nam-2025/"
      }
    ],
    "seoTitle": "Mô hình tài chính cho chuỗi F&B: câu hỏi đầu tiên là hoàn vốn một điểm bán",
    "seoDescription": "Với mô hình chuỗi, nhà đầu tư không mua kế hoạch mở 50 cửa hàng. Họ mua bằng chứng rằng một cửa hàng đã hoàn vốn được.",
    "publishedAt": "2026-09-18",
    "updatedAt": "2026-09-23",
    "track": "cam-nang",
    "readingMinutes": 4
  },
  {
    "slug": "mo-hinh-tai-chinh-cho-startup-saas",
    "title": "Mô hình tài chính cho startup SaaS: 7 biến số quỹ luôn kiểm tra",
    "excerpt": "Với SaaS, tỷ lệ khách rời đi quan trọng hơn doanh thu. Đây là cách dựng bảng số quanh bảy biến số mà nhà đầu tư sẽ kiểm tra từng cái một.",
    "category": "Mô hình tài chính",
    "stages": [
      "Pre-seed",
      "Seed"
    ],
    "storyType": "huong-dan",
    "templates": [
      "mo-hinh-tai-chinh-saas"
    ],
    "consentConfirmed": false,
    "coverImage": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Fmo-hinh-tai-chinh-cho-startup-saas%2F1790190199525-cover.webp?alt=media&token=983a360f-8724-43f9-850f-a63ea7998ff0",
    "coverAlt": "Mô hình tài chính cho startup SaaS: 7 biến số quỹ luôn kiểm tra",
    "coverCaption": "",
    "ogImage": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Fmo-hinh-tai-chinh-cho-startup-saas%2F1790190209051-cover.jpg?alt=media&token=69e02e00-6fda-403f-b193-8de6d6038db1",
    "author": "Fundraising Vietnam",
    "authorRole": "",
    "status": "PUBLISHED",
    "featured": false,
    "sections": [
      {
        "heading": "Vì sao SaaS tính khác",
        "paragraphs": [
          "Mô hình SaaS có một đặc điểm quyết định toàn bộ cấu trúc bảng: doanh thu tháng này là doanh thu tháng trước cộng khách mới trừ khách rời đi. Doanh thu không được tạo lại từ đầu mỗi tháng như bán lẻ, nên nó tích luỹ — và cũng bị rò rỉ liên tục.",
          "Vì vậy nhà đầu tư đọc bảng SaaS theo thứ tự hơi khác với founder: họ xem tỷ lệ rời đi trước, rồi mới xem doanh thu. Một startup tăng trưởng nhanh với tỷ lệ rời đi 8% mỗi tháng là một cái xô bị đục lỗ, và mọi đồng marketing chỉ để bù phần chảy ra."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Bảy biến số",
        "paragraphs": [
          "Bảy biến này đủ để dựng một mô hình 12 tháng đáng tin. Thêm biến nữa thường làm bảng phức tạp mà không tăng độ tin cậy, vì mỗi biến thêm vào là một con số bạn phải bảo vệ."
        ],
        "bullets": [
          "Số khách trả tiền đầu kỳ — số thực tế, không tính khách dùng thử.",
          "Khách mới mỗi tháng — lấy trung bình ba tháng gần nhất, đây phải là số đã làm được chứ không phải mục tiêu.",
          "Tốc độ tăng của lượng khách mới — để số này giảm dần theo quy mô.",
          "Tỷ lệ khách rời đi mỗi tháng — đo theo doanh thu mất đi, không chỉ theo số lượng khách.",
          "Doanh thu bình quân mỗi khách mỗi tháng.",
          "Biên lợi nhuận gộp — sau chi phí hạ tầng, phí cổng thanh toán và chi phí hỗ trợ khách hàng.",
          "Chi phí thu hút một khách — toàn bộ chi phí bán hàng và marketing chia cho số khách mới, gồm cả lương nhân sự bán hàng."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Ba chỉ số phái sinh cần hiện rõ",
        "paragraphs": [],
        "bullets": [
          "Thời gian hoàn vốn chi phí thu hút khách: chi phí thu hút một khách chia cho lợi nhuận gộp mỗi khách mỗi tháng. Dưới 12 tháng là dấu hiệu tốt ở giai đoạn đầu.",
          "Tỷ lệ giá trị vòng đời trên chi phí thu hút: từ 3 trở lên là mức nhà đầu tư thường mong đợi. Cao trên 10 thường là dấu hiệu tỷ lệ rời đi bị ước quá thấp, chứ không phải tin tốt.",
          "Burn multiple: tổng đốt ròng chia cho phần doanh thu tháng tăng thêm. Dưới 2 là hiệu quả, trên 5 nghĩa là bạn đang mua tăng trưởng quá đắt."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Ví dụ có thật: KiotViet, từ 110.000 lên hơn 300.000 nhà kinh doanh",
        "paragraphs": [
          "Tháng 9/2021, KiotViet công bố gọi 45 triệu USD vòng Series B do KKR dẫn dắt cùng Kasikornbank. Con số được nhắc trong thông báo là hơn 110.000 doanh nghiệp nhỏ và vừa đang dùng phần mềm. Hiện trang chủ KiotViet công bố hơn 300.000 nhà kinh doanh và khoảng 10.000 nhà kinh doanh mới mỗi tháng.",
          "Đây là ví dụ tốt để hiểu vì sao bảng của bạn cần nhiều hơn một con số. Hai mốc trên chỉ cho biết quy mô người dùng; chúng không nói doanh thu bình quân mỗi khách, tỷ lệ khách rời bỏ, hay chi phí để có một khách mới. Nhà đầu tư đọc xong sẽ tự ước lượng ba thứ đó — và nếu bạn không đưa ra trước, họ ước lượng theo hướng thận trọng nhất."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": {
          "caption": "Từ con số công khai tới con số bảng tài chính phải trả lời",
          "headers": [
            "Con số công khai",
            "Nói lên điều gì",
            "Bảng của bạn phải trả lời thêm"
          ],
          "rows": [
            {
              "cells": [
                "Hơn 300.000 nhà kinh doanh sử dụng",
                "Quy mô và độ phủ thị trường",
                "Bao nhiêu trong số đó đang trả tiền, ở gói nào"
              ]
            },
            {
              "cells": [
                "Khoảng 10.000 khách mới mỗi tháng",
                "Tốc độ có khách mới",
                "Chi phí để có một khách mới, và ai trả chi phí đó"
              ]
            },
            {
              "cells": [
                "110.000 khách tại thời điểm gọi 45 triệu USD",
                "Quy mô lúc quỹ lớn vào vòng",
                "Doanh thu định kỳ mỗi tháng tại cùng thời điểm"
              ]
            },
            {
              "cells": [
                "Không công bố tỷ lệ rời bỏ",
                "—",
                "Bao nhiêu phần trăm khách rời mỗi tháng, và họ rời ở tháng thứ mấy"
              ]
            }
          ]
        },
        "notes": [
          "Nguồn: thông báo vòng Series B của KiotViet (9/2021) và trang chủ kiotviet.vn. Số trên trang chủ do doanh nghiệp tự công bố và thay đổi theo thời gian."
        ]
      },
      {
        "heading": "Mốc tham chiếu để đối chiếu bảng của bạn",
        "paragraphs": [
          "Việt Nam chưa có báo cáo chuẩn hoá về chỉ số SaaS. Cách thực tế là đối chiếu với mốc quốc tế, nhưng đối chiếu xu hướng chứ không sao chép con số: phần lớn SaaS Việt Nam bán cho doanh nghiệp nhỏ với giá trị hợp đồng thấp hơn nhiều, nên tỷ lệ rời bỏ tự nhiên cao hơn và thời gian hoàn vốn cũng khác."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": {
          "caption": "Trung vị của B2B SaaS quốc tế, báo cáo 2025 trên dữ liệu 2024",
          "headers": [
            "Chỉ số",
            "Trung vị",
            "Đọc thế nào cho bảng của bạn"
          ],
          "rows": [
            {
              "cells": [
                "Giữ chân doanh thu ròng (NRR)",
                "101%",
                "Dưới 100% nghĩa là khách cũ co lại; tăng trưởng phải mua hoàn toàn bằng khách mới"
              ]
            },
            {
              "cells": [
                "Giữ chân doanh thu gộp (GRR)",
                "88%",
                "Mỗi năm mất khoảng 12% doanh thu nền, bảng phải trừ phần này trước khi cộng khách mới"
              ]
            },
            {
              "cells": [
                "Thời gian hoàn vốn chi phí có khách",
                "Khoảng 12 tháng",
                "Dài hơn 18 tháng thì mỗi đồng marketing khoá vốn quá lâu"
              ]
            },
            {
              "cells": [
                "Chi phí có một đô-la doanh thu mới",
                "2,00 USD",
                "Tăng 14% so với năm trước — chi phí có khách đang đắt lên trên toàn thị trường"
              ]
            },
            {
              "cells": [
                "Tăng trưởng theo quy mô doanh thu định kỳ",
                "13% (dưới 5 triệu USD) · 10% (5–20) · 9% (20–50)",
                "Bảng dự phóng tăng 200%/năm cần một lý do rất cụ thể"
              ]
            }
          ]
        },
        "notes": [
          "Nguồn: Benchmarkit, 2025 SaaS Performance Metrics. Đây là mẫu doanh nghiệp quốc tế, dùng để đặt câu hỏi cho bảng của bạn chứ không phải mục tiêu phải đạt."
        ]
      },
      {
        "heading": "Một ví dụ bằng tiền Việt, để thấy các con số nối nhau ra sao",
        "paragraphs": [
          "Giả sử một SaaS bán cho cửa hàng nhỏ: 1.200 khách trả tiền, giá trung bình 350.000 đồng/tháng, biên lợi nhuận gộp 80%, mỗi tháng mất 2,5% số khách, chi 2,4 triệu đồng để có một khách mới. Toàn bộ số dưới đây là ví dụ minh hoạ, không phải số của doanh nghiệp nào."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": {
          "caption": "VÍ DỤ MINH HOẠ · cách sáu con số nối thành bốn kết luận",
          "headers": [
            "Phép tính",
            "Kết quả",
            "Nhà đầu tư kết luận gì"
          ],
          "rows": [
            {
              "cells": [
                "1.200 khách × 350.000 đ",
                "Doanh thu định kỳ 420 triệu đồng/tháng",
                "Quy mô hiện tại, quy năm khoảng 5 tỷ đồng"
              ]
            },
            {
              "cells": [
                "2,5% rời bỏ mỗi tháng",
                "Mất 30 khách/tháng, tương đương 10,5 triệu doanh thu",
                "Phải có hơn 30 khách mới mỗi tháng thì mới nhích lên"
              ]
            },
            {
              "cells": [
                "2,4 triệu ÷ (350.000 × 80%)",
                "Hoàn vốn sau 8,6 tháng",
                "Nằm trong vùng chấp nhận được, dưới mốc 12 tháng"
              ]
            },
            {
              "cells": [
                "1 ÷ 2,5% × 350.000 × 80%",
                "Giá trị vòng đời khoảng 11,2 triệu đồng",
                "Gấp 4,7 lần chi phí có khách — đủ để mở rộng chi marketing"
              ]
            }
          ]
        },
        "notes": [
          "Đổi 2,5% rời bỏ thành 5% thì giá trị vòng đời rơi một nửa và tỷ lệ trên còn 2,3 lần. Đây là lý do ô tỷ lệ rời bỏ phải là ô nhập riêng trong bảng, không phải con số gõ cứng giữa công thức."
        ]
      },
      {
        "heading": "Ba câu hỏi bạn sẽ bị hỏi về bảng này",
        "paragraphs": [
          "Ba câu này quyết định phần lớn niềm tin vào bảng. Nên trả lời sẵn trong cột ghi chú của tab Giả định thay vì đợi được hỏi."
        ],
        "bullets": [
          "Tỷ lệ rời đi đo theo cách nào — theo số khách hay theo doanh thu, và trong khoảng thời gian nào?",
          "Chi phí thu hút khách có tính lương nhân sự bán hàng chưa, hay chỉ tính tiền quảng cáo?",
          "Nếu lượng khách mới đi ngang trong sáu tháng thì bảng này ra sao?"
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      }
    ],
    "relatedTools": [
      {
        "slug": "kiem-tra-gia-dinh-kinh-te-don-vi",
        "label": "Kiểm tra kinh tế đơn vị"
      },
      {
        "slug": "tinh-runway",
        "label": "Tính runway"
      }
    ],
    "sources": [
      {
        "label": "KiotViet — thông báo gọi vốn 45 triệu USD vòng Series B (9/2021)",
        "url": "https://www.kiotviet.vn/phan-mem-quan-ly-ban-hang-kiotviet-goi-von-thanh-cong-45-trieu-usd/"
      },
      {
        "label": "KiotViet — trang chủ, số nhà kinh doanh đang sử dụng",
        "url": "https://www.kiotviet.vn/"
      },
      {
        "label": "Benchmarkit — 2025 SaaS Performance Metrics",
        "url": "https://www.benchmarkit.ai/2025benchmarks"
      }
    ],
    "seoTitle": "Mô hình tài chính cho startup SaaS: 7 biến số quỹ luôn kiểm tra",
    "seoDescription": "Với SaaS, tỷ lệ khách rời đi quan trọng hơn doanh thu. Đây là cách dựng bảng số quanh bảy biến số mà nhà đầu tư sẽ kiểm tra từng cái một.",
    "publishedAt": "2026-09-18",
    "updatedAt": "2026-09-23",
    "track": "cam-nang",
    "readingMinutes": 6
  },
  {
    "slug": "mo-hinh-tai-chinh-cho-thuong-mai-dien-tu",
    "title": "Mô hình tài chính cho thương mại điện tử: đừng bỏ quên tỷ lệ hoàn hàng",
    "excerpt": "Lưu lượng, chuyển đổi, giá trị đơn và mua lại quyết định doanh thu. Nhưng tỷ lệ hoàn hàng và chi phí quảng cáo mới quyết định bạn sống được bao lâu.",
    "category": "Mô hình tài chính",
    "stages": [
      "Pre-seed",
      "Seed"
    ],
    "storyType": "huong-dan",
    "templates": [
      "mo-hinh-tai-chinh-thuong-mai-dien-tu"
    ],
    "consentConfirmed": false,
    "coverImage": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Fmo-hinh-tai-chinh-cho-thuong-mai-dien-tu%2F1790190217493-cover.webp?alt=media&token=a15532df-934b-49ca-a2d9-ca3b1b7d819b",
    "coverAlt": "Mô hình tài chính cho thương mại điện tử: đừng bỏ quên tỷ lệ hoàn hàng",
    "coverCaption": "",
    "ogImage": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Fmo-hinh-tai-chinh-cho-thuong-mai-dien-tu%2F1790190220437-cover.jpg?alt=media&token=93e97d9f-16f5-43d2-9555-b33318bd1dc0",
    "author": "Fundraising Vietnam",
    "authorRole": "",
    "status": "PUBLISHED",
    "featured": false,
    "sections": [
      {
        "heading": "Chuỗi biến số",
        "paragraphs": [
          "Doanh thu thương mại điện tử là một chuỗi nhân: lưu lượng nhân tỷ lệ chuyển đổi ra số đơn, số đơn nhân giá trị bình quân ra doanh thu. Vì là phép nhân, một sai số nhỏ ở tỷ lệ chuyển đổi tạo ra sai số rất lớn ở cuối chuỗi.",
          "Tỷ lệ chuyển đổi của phần lớn cửa hàng trực tuyến tại Việt Nam nằm trong khoảng một đến ba phần trăm. Nếu bảng của bạn dùng năm phần trăm, hãy chuẩn bị bằng chứng, vì đó sẽ là ô đầu tiên bị hỏi."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Ví dụ có thật: Coolmate và đường từ biên gộp tới lợi nhuận",
        "paragraphs": [
          "Tháng 10/2024, Coolmate công bố gọi 6 triệu USD vòng Series B do Vertex Ventures SEA & India dẫn dắt, có Kairous Capital tham gia. Điều đáng chú ý với người đang dựng bảng tài chính không phải con số vốn, mà là bộ chỉ số công ty đưa ra kèm theo: doanh thu mục tiêu 26 triệu USD năm 2024 và 45 triệu USD năm 2025, biên lợi nhuận gộp 43% rồi 45%, biên EBITDA 6% rồi 12%.",
          "Đó chính là hình dạng một bảng tài chính thương mại điện tử thuyết phục: không dừng ở doanh thu, mà cho thấy quãng đường từ biên gộp xuống lợi nhuận hoạt động, và cho thấy quãng đường đó đang ngắn lại theo thời gian. Một bảng chỉ có doanh thu tăng gấp đôi mỗi năm, còn dòng lợi nhuận thì để trống, sẽ bị hỏi đúng chỗ đó."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": {
          "caption": "Chỉ số Coolmate công bố khi gọi vốn — và điều nhà đầu tư đọc được",
          "headers": [
            "Chỉ số",
            "2024",
            "2025 (mục tiêu công bố)",
            "Nhà đầu tư đọc gì"
          ],
          "rows": [
            {
              "cells": [
                "Doanh thu",
                "26 triệu USD",
                "45 triệu USD",
                "Tốc độ tăng trưởng có nhất quán với chi phí marketing không"
              ]
            },
            {
              "cells": [
                "Biên lợi nhuận gộp",
                "43%",
                "45%",
                "Giá vốn và chi phí giao vận có đang cải thiện theo quy mô"
              ]
            },
            {
              "cells": [
                "Biên EBITDA",
                "6%",
                "12%",
                "Doanh nghiệp đã qua giai đoạn mua tăng trưởng bằng lỗ hay chưa"
              ]
            }
          ]
        },
        "notes": [
          "Nguồn: Báo Đầu tư, bản tin vòng Series B của Coolmate (10/2024). Đây là mục tiêu công ty công bố tại thời điểm gọi vốn, không phải kết quả đã kiểm toán.",
          "Trong bảng của bạn, ba dòng này phải nằm cạnh nhau trên cùng một màn hình: biên gộp, tỷ lệ chi phí marketing trên doanh thu, và biên EBITDA."
        ]
      },
      {
        "heading": "Mặt bằng sàn thương mại điện tử, để kiểm tra giả định của bạn",
        "paragraphs": [
          "Số liệu Metric cho năm 2025 cho thấy hai chiều ngược nhau: doanh số toàn sàn tăng mạnh, nhưng số gian hàng có đơn lại giảm. Thị trường đang sàng lọc chứ không còn mở rộng đều cho mọi người bán."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": {
          "caption": "Sàn thương mại điện tử Việt Nam năm 2025 (Metric)",
          "headers": [
            "Chỉ tiêu",
            "Giá trị 2025",
            "So với 2024"
          ],
          "rows": [
            {
              "cells": [
                "Tổng doanh số các sàn",
                "429,7 nghìn tỷ đồng",
                "Tăng 34,75%"
              ]
            },
            {
              "cells": [
                "Số sản phẩm bán ra",
                "3.941,6 triệu sản phẩm",
                "Tăng 15,23%"
              ]
            },
            {
              "cells": [
                "Số gian hàng có phát sinh đơn",
                "601.800 shop",
                "Giảm 7,43%"
              ]
            },
            {
              "cells": [
                "Thị phần Shopee",
                "56,04%",
                "Giảm từ khoảng 64%"
              ]
            },
            {
              "cells": [
                "Thị phần TikTok Shop",
                "41,31%",
                "Tăng từ khoảng 29%"
              ]
            }
          ]
        },
        "notes": [
          "Nguồn: Metric, số liệu thị trường sàn thương mại điện tử Việt Nam năm 2025, dẫn theo VnEconomy.",
          "Một phép chia đáng làm: 429,7 nghìn tỷ đồng chia cho 3.941,6 triệu sản phẩm ra khoảng 109.000 đồng mỗi sản phẩm bán ra. Nếu giá trị đơn hàng trung bình trong bảng của bạn là 450.000 đồng, bạn đang bán ở phân khúc cao hơn mặt bằng sàn — điều đó hoàn toàn được, nhưng phải giải thích bằng sản phẩm chứ không bằng kỳ vọng.",
          "Doanh số tăng 34,75% trong khi số shop giảm 7,43% nghĩa là phần tăng đang dồn về người bán đã có chỗ đứng. Giả định «mở gian hàng là có đơn» không còn đúng; chi phí quảng cáo trong bảng phải phản ánh điều đó."
        ]
      },
      {
        "heading": "Hai dòng hay bị bỏ quên",
        "paragraphs": [],
        "bullets": [
          "Tỷ lệ hoàn hàng: với hàng thời trang và giao hàng thu tiền hộ, con số này đủ lớn để thay đổi kết luận của cả bảng. Bỏ dòng này là cách nhanh nhất để mất niềm tin khi nhà đầu tư đối chiếu với số liệu vận hành.",
          "Doanh thu từ khách mua lại: nếu chỉ tính khách mới, bạn đang mô tả một doanh nghiệp phải mua lại toàn bộ doanh thu mỗi tháng. Tách riêng đơn mới và đơn mua lại cho thấy bạn hiểu mình đang xây thói quen hay chỉ đang chạy quảng cáo."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Chi phí quảng cáo là chi phí biến đổi thật",
        "paragraphs": [
          "Trong mô hình này, chi phí quảng cáo tăng gần như tuyến tính với lưu lượng, và giá mỗi lượt truy cập thường tăng theo quy mô chứ không giảm. Đặt chi phí quảng cáo cố định mỗi tháng trong khi doanh thu tăng gấp ba là giả định không ai tin.",
          "Hãy để chi phí quảng cáo gắn với lưu lượng, và kiểm tra lợi nhuận gộp mỗi đơn sau khi trừ chi phí thu hút. Nếu con số đó âm, tăng trưởng chỉ làm bạn hết tiền nhanh hơn."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      }
    ],
    "relatedTools": [
      {
        "slug": "kiem-tra-gia-dinh-kinh-te-don-vi",
        "label": "Kiểm tra kinh tế đơn vị"
      }
    ],
    "sources": [
      {
        "label": "Báo Đầu tư — Coolmate huy động 6 triệu USD vòng Series B",
        "url": "https://baodautu.vn/huy-dong-them-6-trieu-usd-tai-vong-goi-von-series-b-coolmate-du-luc-go-global-d228696.html"
      },
      {
        "label": "VnEconomy — số liệu Metric về thị trường sàn thương mại điện tử 2025",
        "url": "https://vneconomy.vn/thi-truong-thuong-mai-dien-tu-viet-nam-buoc-vao-giai-doan-sang-loc-manh-me.htm"
      },
      {
        "label": "Metric — báo cáo thị trường thương mại điện tử Việt Nam",
        "url": "https://metric.vn/insights/cong-bo-bao-cao-thuong-mai-dien-tu-viet-nam-2025/"
      }
    ],
    "seoTitle": "Mô hình tài chính cho thương mại điện tử: đừng bỏ quên tỷ lệ hoàn hàng",
    "seoDescription": "Lưu lượng, chuyển đổi, giá trị đơn và mua lại quyết định doanh thu. Nhưng tỷ lệ hoàn hàng và chi phí quảng cáo mới quyết định bạn sống được bao lâu.",
    "publishedAt": "2026-09-18",
    "updatedAt": "2026-09-23",
    "track": "cam-nang",
    "readingMinutes": 4
  },
  {
    "slug": "mo-xe-slide-use-of-funds",
    "title": "Mổ xẻ một slide Use of Funds tốt và chưa tốt",
    "excerpt": "Nhà đầu tư cần thấy tiền tạo ra cột mốc, không chỉ thấy một biểu đồ chia tỷ lệ chi tiêu.",
    "category": "Hồ sơ & pitch deck",
    "stages": [
      "Pre-seed",
      "Seed"
    ],
    "storyType": "huong-dan",
    "templates": [],
    "consentConfirmed": false,
    "coverImage": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Fmo-xe-slide-use-of-funds%2F1790080563171-cover.webp?alt=media&token=558cf6a8-4b7a-4a90-8963-15caadb62b99",
    "coverAlt": "Mổ xẻ một slide Use of Funds tốt và chưa tốt",
    "coverCaption": "",
    "ogImage": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Fmo-xe-slide-use-of-funds%2F1790080563447-cover.jpg?alt=media&token=8fef22a6-452c-4330-a611-d71eb73bd32b",
    "author": "Fundraising Vietnam",
    "authorRole": "",
    "status": "PUBLISHED",
    "featured": false,
    "sections": [
      {
        "heading": "Slide này thật ra trả lời câu hỏi gì",
        "paragraphs": [
          "Bề ngoài, slide sử dụng vốn trả lời câu hỏi “tiền sẽ đi đâu”. Nhưng câu nhà đầu tư thật sự muốn biết là: số tiền này mua được cột mốc gì, và cột mốc đó có đủ để công ty gọi được vòng tiếp theo hay tự đứng được không.",
          "Nếu slide chỉ trả lời câu hỏi thứ nhất, nó là một bảng ngân sách. Nếu trả lời được câu thứ hai, nó là một kế hoạch."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Bản chưa tốt",
        "paragraphs": [
          "“50% sản phẩm, 30% marketing, 20% vận hành”, trình bày bằng một biểu đồ tròn. Slide này mới cho biết tiền đi đâu. Nó chưa cho biết startup mua được năng lực gì và năng lực đó tạo ra kết quả nào."
        ],
        "bullets": [
          "Không có thời hạn: 18 tháng hay 36 tháng?",
          "Không có đầu ra: “sản phẩm” nghĩa là tuyển ai, làm xong cái gì?",
          "Không có dự phòng: kế hoạch chậm một quý thì lấy tiền ở đâu?",
          "Không nối với con số gọi vốn và runway ở các slide khác."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Bản tốt hơn",
        "paragraphs": [
          "Ví dụ một startup phần mềm gọi 8 tỷ đồng cho 18 tháng. Mỗi khoản chi đi cùng thời hạn và đầu ra đo được:"
        ],
        "bullets": [
          "Sản phẩm — 3,4 tỷ: tuyển 3 kỹ sư và 1 quản lý sản phẩm; hoàn thành tích hợp với phần mềm bán hàng và ứng dụng di động trước tháng 6.",
          "Bán hàng và marketing — 2,6 tỷ: tuyển 2 nhân sự bán hàng, thử ba kênh trong 6 tháng đầu rồi dồn ngân sách vào kênh hiệu quả nhất; tăng từ 20 lên 80 khách trả tiền.",
          "Vận hành — 1,0 tỷ: kế toán, pháp lý, hạ tầng máy chủ, văn phòng.",
          "Dự phòng — 1,0 tỷ (khoảng 12%): bảo vệ kế hoạch nếu doanh thu chậm hơn dự kiến hoặc tuyển dụng kéo dài."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Nối với runway và vòng tiếp theo",
        "paragraphs": [
          "Slide sử dụng vốn phải khớp với các con số còn lại trong deck. Với mức đốt trung bình khoảng 420 triệu đồng mỗi tháng, 8 tỷ cho khoảng 19 tháng — tức 18 tháng thực thi cộng một tháng đệm cho vòng gọi vốn tiếp theo.",
          "Dòng cuối slide nên là kết quả: “Sau 18 tháng: 80 khách trả tiền, doanh thu định kỳ đủ để gọi vòng Seed.” Đây là câu nhà đầu tư sẽ nhớ, không phải các tỷ lệ phần trăm."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Ba câu hỏi kiểm tra",
        "paragraphs": [],
        "bullets": [
          "Khoản chi này có cần thiết để đạt cột mốc không? Nếu bỏ nó, cột mốc có bị ảnh hưởng không?",
          "Cột mốc có đo được và có thời hạn không?",
          "Nếu doanh thu chậm hơn 20%, kế hoạch thay đổi thế nào và khoản nào sẽ cắt trước?"
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Những lỗi hay gặp",
        "paragraphs": [],
        "bullets": [
          "Tổng các khoản không khớp với số vốn đang gọi.",
          "Ghi “marketing” mà không nói kênh nào, thử bao lâu, đo bằng gì.",
          "Không có dòng dự phòng, hoặc dự phòng được giấu vào các khoản khác.",
          "Chi cho những thứ không liên quan tới cột mốc, như văn phòng lớn hay xe công ty.",
          "Số vốn tròn trịa không có phép tính nào đằng sau."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      }
    ],
    "relatedTools": [
      {
        "slug": "goi-bao-nhieu",
        "label": "Lập kế hoạch vòng gọi vốn"
      },
      {
        "slug": "tinh-runway",
        "label": "Tính runway"
      },
      {
        "slug": "pitch-deck-10-slide",
        "label": "Kiểm tra pitch deck 10 slide"
      }
    ],
    "sources": [
      {
        "label": "Y Combinator — A guide to seed fundraising",
        "url": "https://www.ycombinator.com/library/4A-a-guide-to-seed-fundraising"
      }
    ],
    "seoTitle": "Slide Use of Funds: ví dụ tốt và chưa tốt, cách nối số vốn với cột mốc",
    "seoDescription": "Mổ xẻ hai phiên bản slide sử dụng vốn trong pitch deck: vì sao biểu đồ tròn chưa đủ, ví dụ phân bổ 8 tỷ đồng theo cột mốc, cách nối với runway và các lỗi thường gặp.",
    "publishedAt": "2026-09-16",
    "updatedAt": "2026-09-22",
    "track": "cam-nang",
    "readingMinutes": 3
  },
  {
    "slug": "nam-hieu-nham-khi-goi-von-quy-de-mo-rong",
    "title": "Năm hiểu nhầm khi gọi vốn quỹ đầu tư để mở rộng doanh nghiệp",
    "excerpt": "Doanh nghiệp đã có doanh thu lớn thường bước vào phòng họp với quỹ bằng năm niềm tin sai: quỹ sẽ cùng gánh khó khăn, quỹ sẽ trả tiền nghiên cứu, cứ tăng nhanh là được định giá cao, chia đều cổ phần là đoàn kết, và thương hiệu nội có thể đấu tay đôi với thương hiệu toàn cầu. Bài này đặt mỗi niềm tin cạnh góc nhìn của nhà đầu tư, kèm ví dụ bằng số.",
    "category": "Góc nhìn quỹ",
    "stages": [
      "Seed",
      "Series A"
    ],
    "storyType": "goc-nhin",
    "templates": [],
    "consentConfirmed": false,
    "coverImage": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Fnam-hieu-nham-khi-goi-von-quy-de-mo-rong%2F1791001111790-cover.webp?alt=media&token=c5c831e8-b126-497b-8e0e-64ed8301853a",
    "coverAlt": "Năm hiểu nhầm của founder khi gọi vốn quỹ đầu tư, đặt cạnh góc nhìn của nhà đầu tư",
    "coverCaption": "Quỹ tài chính không mua lời hứa. Họ mua một cỗ máy đã chạy, chỉ còn thiếu nhiên liệu.",
    "ogImage": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Fnam-hieu-nham-khi-goi-von-quy-de-mo-rong%2F1791001118458-cover.jpg?alt=media&token=e2822c2d-80c4-4943-af22-024ff907d65c",
    "author": "Fundraising Vietnam",
    "authorRole": "",
    "status": "PUBLISHED",
    "featured": false,
    "sections": [
      {
        "heading": "Bài này dành cho ai",
        "paragraphs": [
          "Bài được tổng hợp và viết lại từ chia sẻ của một founder chuỗi nhà hàng gần 200 điểm bán, người đã huy động vốn từ quỹ đầu tư nước ngoài, trong một buổi trao đổi với founder một thương hiệu giày Việt. Fundraising.vn bổ sung ví dụ bằng số và phần đối chiếu với startup giai đoạn sớm.",
          "Đối tượng chính là doanh nghiệp đã có doanh thu đáng kể, cỡ hàng trăm tỷ đồng mỗi năm, muốn gọi vốn từ quỹ tài chính (quỹ đầu tư tư nhân, quỹ tăng trưởng) để tăng tốc. Nếu bạn đang ở giai đoạn sớm, đừng bỏ qua: phần lớn ý vẫn đúng, nhưng có vài điểm khác, được nói rõ ở cuối bài."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Trước hết: bạn đang nói chuyện với loại nhà đầu tư nào",
        "paragraphs": [
          "Nhiều hiểu nhầm bắt đầu từ việc gộp mọi nhà đầu tư làm một. Nhà đầu tư tài chính và cổ đông chiến lược muốn những thứ rất khác nhau, và cách bạn trình bày phải khác theo."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": {
          "caption": "Nhà đầu tư tài chính và cổ đông chiến lược",
          "headers": [
            "",
            "Nhà đầu tư tài chính",
            "Cổ đông chiến lược"
          ],
          "rows": [
            {
              "cells": [
                "Ví dụ",
                "Quỹ đầu tư tư nhân, quỹ tăng trưởng, quỹ mạo hiểm",
                "Doanh nghiệp cùng ngành, nhà cung cấp, nhà phân phối lớn"
              ]
            },
            {
              "cells": [
                "Muốn gì",
                "Lợi nhuận khi bán lại cổ phần sau vài năm",
                "Lợi ích kinh doanh: thị phần, nguồn hàng, kênh bán, công nghệ"
              ]
            },
            {
              "cells": [
                "Mang lại ngoài tiền",
                "Kỷ luật quản trị, mạng lưới, kinh nghiệm gọi vòng sau",
                "Khách hàng, chuỗi cung ứng, hạ tầng, đôi khi cả nhân sự"
              ]
            },
            {
              "cells": [
                "Kiên nhẫn với rủi ro vận hành",
                "Thấp: muốn thấy cỗ máy đã chạy",
                "Cao hơn nếu phục vụ chiến lược của họ"
              ]
            },
            {
              "cells": [
                "Rủi ro cho founder",
                "Áp lực tăng trưởng và thời hạn thoái vốn",
                "Bị kéo theo hướng có lợi cho họ, khó bán cho đối thủ của họ sau này"
              ]
            }
          ]
        },
        "notes": []
      },
      {
        "heading": "Hiểu nhầm 1: \"Quỹ vào để cùng mình giải quyết khó khăn\"",
        "paragraphs": [
          "Sự thật: quỹ tài chính không vào để chia gánh nặng vận hành. Họ không thay bạn sửa quy trình, không thay bạn tìm nhà cung cấp, và không bỏ tiền để bạn tiếp tục vừa làm vừa sửa.",
          "Góc nhìn nhà đầu tư: dự án lý tưởng là dự án mà sản phẩm, quy trình và chuỗi cung ứng đều đã sẵn sàng, và rào cản duy nhất còn lại là thiếu tiền để nhân rộng. Tiền vào là cỗ máy tăng tốc ngay. Muốn được nhìn như vậy, kế hoạch tăng trưởng phải được lượng hoá tới từng nguồn.",
          "Ví dụ: một doanh nghiệp doanh thu 200 tỷ đồng muốn lên 1.000 tỷ trong năm năm, tức tăng khoảng 38% mỗi năm. Câu \"thị trường còn rất lớn\" không thuyết phục được ai. Thứ quỹ muốn thấy là bảng dưới đây, mỗi dòng có giả định và bằng chứng đi kèm."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": {
          "caption": "Lộ trình từ 200 lên 1.000 tỷ, tách theo nguồn tăng trưởng (số minh họa)",
          "headers": [
            "Nguồn tăng trưởng",
            "Thêm doanh thu năm thứ 5",
            "Giả định cần chứng minh"
          ],
          "rows": [
            {
              "cells": [
                "Khách cũ mua lại khi sản phẩm hao mòn",
                "+120 tỷ",
                "Chu kỳ mua lại, tỷ lệ quay lại theo từng nhóm khách các năm qua"
              ]
            },
            {
              "cells": [
                "Bán thêm sản phẩm cho khách cũ",
                "+130 tỷ",
                "Tỷ lệ khách mua từ hai dòng sản phẩm trở lên đang tăng"
              ]
            },
            {
              "cells": [
                "Điểm bán mới trong nước",
                "+350 tỷ",
                "Doanh thu và thời gian hoà vốn của các điểm mở trong 2 năm gần nhất"
              ]
            },
            {
              "cells": [
                "Kênh online và đại lý",
                "+150 tỷ",
                "Biên lợi nhuận theo kênh sau phí sàn và vận chuyển"
              ]
            },
            {
              "cells": [
                "Thị trường nước ngoài chọn lọc",
                "+50 tỷ",
                "Đơn hàng thử, đối tác phân phối đã ký"
              ]
            },
            {
              "cells": [
                "Tổng",
                "1.000 tỷ",
                ""
              ]
            }
          ]
        },
        "notes": [
          "Nhà đầu tư sẽ hỏi tiếp: nếu đối thủ hạ giá hoặc mở ngay cạnh điểm bán của bạn thì sao. Chuẩn bị sẵn kịch bản phòng thủ, đừng để câu đó là lần đầu bạn nghĩ tới.",
          "Một dòng có giả định nhưng chưa có bằng chứng không vô dụng, nhưng phải được ghi là giả định. Lẫn kỳ vọng với số liệu là cách nhanh nhất mất lòng tin trong buổi thẩm định."
        ]
      },
      {
        "heading": "Hiểu nhầm 2: \"Quỹ sẽ sẵn lòng trả tiền nghiên cứu sản phẩm\"",
        "paragraphs": [
          "Sự thật: trừ các quỹ mạo hiểm giai đoạn hạt giống chuyên về công nghệ, phần lớn quỹ tài chính và đối tác chiến lược không kiên nhẫn với các dự án nghiên cứu dài hạn, kết quả chưa chắc chắn.",
          "Góc nhìn nhà đầu tư: vốn phải dồn vào đưa sản phẩm ra thị trường, hệ thống phân phối và giành thị phần. Doanh nghiệp cần có sẵn ít nhất một sản phẩm chủ lực đủ mạnh để thắng đối thủ trực tiếp, trước khi tính chuyện đốt tiền làm cái mới.",
          "Ví dụ: một thương hiệu giày có một dòng sản phẩm chiếm 60% doanh thu, gọi 100 tỷ đồng. Hai cách viết phần sử dụng vốn cho ra hai phản ứng rất khác từ quỹ."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": {
          "caption": "Cùng 100 tỷ, hai cách phân bổ",
          "headers": [
            "Hạng mục",
            "Bản dễ bị từ chối",
            "Bản quỹ muốn đọc"
          ],
          "rows": [
            {
              "cells": [
                "Nghiên cứu dòng sản phẩm mới",
                "40 tỷ",
                "10 tỷ, cải tiến dòng chủ lực"
              ]
            },
            {
              "cells": [
                "Mở điểm bán, đại lý",
                "25 tỷ",
                "45 tỷ"
              ]
            },
            {
              "cells": [
                "Marketing và kênh bán",
                "20 tỷ",
                "30 tỷ"
              ]
            },
            {
              "cells": [
                "Hàng tồn kho, vốn lưu động",
                "15 tỷ",
                "15 tỷ"
              ]
            }
          ]
        },
        "notes": [
          "Nếu sản phẩm của bạn thật sự cần nghiên cứu dài hạn, hãy tìm đúng nguồn: quỹ mạo hiểm chuyên công nghệ, chương trình tài trợ đổi mới sáng tạo của nhà nước, hoặc đối tác chiến lược cần chính công nghệ đó. Xem các chương trình đang mở ở mục Chương trình và tài trợ trên fundraising.vn."
        ]
      },
      {
        "heading": "Hiểu nhầm 3: \"Tăng nóng, mở chuỗi thật nhanh, chạy quảng cáo đẩy doanh thu là được định giá cao\"",
        "paragraphs": [
          "Sự thật: to và nhanh không đồng nghĩa với sống sót. Với bán lẻ, mở rộng hệ thống cửa hàng mà không kiểm soát được dòng tiền hoạt động thì càng mở càng nhanh chết. Với thương mại điện tử, nếu lợi thế duy nhất là giá rẻ, rất dễ rơi vào cảnh càng bán càng lỗ.",
          "Góc nhìn nhà đầu tư: quỹ thẩm định song song hai thứ. Mô hình có rào cản phòng thủ hay không, tức lý do khách không dễ bỏ sang đối thủ. Và founder có đủ kỷ luật tài chính để điều hành một bộ máy lớn gấp năm đến mười lần mà không vỡ dòng tiền hay không.",
          "Ví dụ chuỗi cửa hàng (số minh họa): mỗi cửa hàng mới tốn 1,5 tỷ để mở và lỗ khoảng 80 triệu mỗi tháng trong 6 tháng đầu trước khi có lãi. Mở 30 cửa hàng trong một năm nghĩa là cần 45 tỷ đầu tư cộng 14,4 tỷ bù lỗ giai đoạn đầu, gần 60 tỷ đồng trước khi cửa hàng mới nào trả lại đồng nào. Nếu cửa hàng mới ở mặt bằng chưa kiểm chứng và chậm hoà vốn gấp đôi, nhu cầu tiền tăng thêm khoảng 14 tỷ, đúng lúc doanh nghiệp đã tiêu gần hết vốn mới gọi.",
          "Ví dụ thương mại điện tử: một đôi giày bán 300 nghìn đồng, giá vốn 190 nghìn, phí sàn 30 nghìn, vận chuyển và đóng gói 35 nghìn, quảng cáo 55 nghìn cho mỗi đơn. Mỗi đơn lỗ 10 nghìn trước cả chi phí văn phòng. Doanh thu tăng gấp ba thì lỗ cũng tăng gấp ba."
        ],
        "bullets": [
          "Thời gian hoà vốn của từng điểm bán, tách theo năm mở và theo loại mặt bằng.",
          "Lãi lỗ trên mỗi đơn hàng sau mọi chi phí biến đổi, tách theo kênh.",
          "Dòng tiền hoạt động theo tháng, không chỉ lợi nhuận trên sổ.",
          "Điều gì khiến khách quay lại bạn thay vì đối thủ rẻ hơn: thương hiệu, vị trí, công thức, dịch vụ, hay chỉ là giá."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": [
          "Bốn thứ trên là những gì quỹ sẽ đòi xem. Có sẵn chúng trước buổi gặp đầu tiên đã là một tín hiệu về kỷ luật tài chính."
        ]
      },
      {
        "heading": "Hiểu nhầm 4: \"Chia đều cổ phần cho anh em cùng làm là đoàn kết\"",
        "paragraphs": [
          "Sự thật: theo góc nhìn của người đã gọi vốn thành công, bảng cổ phần dàn hàng ngang kiểu 33%, 33%, 34% là một trong những tín hiệu đỏ khiến quỹ tài chính dừng lại sớm nhất.",
          "Góc nhìn nhà đầu tư: khi doanh nghiệp tăng tốc, bất đồng về chiến lược xảy ra liên tục: mở thêm thị trường nào, cắt dòng sản phẩm nào, tuyển ai làm giám đốc vận hành. Phải có một người có thẩm quyền ra quyết định cuối cùng, nếu không bộ máy tê liệt đúng lúc cần chạy nhanh nhất. Nhiều quỹ ở giai đoạn này muốn người đứng đầu nắm quyền chi phối, thường là trên 50%.",
          "Ví dụ: ba nhà sáng lập mỗi người một phần ba. Người phụ trách vận hành muốn mở 10 điểm bán ở Hà Nội, người phụ trách tài chính muốn tập trung lấp đầy TP.HCM trước, người còn lại lưỡng lự. Không ai đủ phiếu để quyết, cuộc tranh luận kéo dài ba tháng, và nhà đầu tư đang thẩm định nhìn thấy đúng điều họ sợ."
        ],
        "bullets": [
          "Nếu tỷ lệ đã chia đều và khó thay đổi: ghi rõ trong điều lệ hoặc thoả thuận cổ đông ai là người quyết định cuối cùng với từng nhóm việc, và cơ chế xử lý khi bế tắc.",
          "Nếu còn kịp: thảo luận lại tỷ lệ theo vai trò và mức cam kết, kèm vesting để phần cổ phần gắn với thời gian thực sự gắn bó.",
          "Dù chia thế nào: đừng đợi tới lúc nhà đầu tư hỏi mới bàn chuyện này lần đầu."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Hiểu nhầm 5: \"Mang thương hiệu nội đi đấu tay đôi với thương hiệu toàn cầu\"",
        "paragraphs": [
          "Sự thật: người tiêu dùng có một định kiến lâu năm gọi là hiệu ứng xuất xứ quốc gia: giày thể thao gắn với Mỹ, thời trang gắn với châu Âu, mỹ phẩm gắn với Hàn Quốc, điện tử gắn với Nhật. Đam mê và niềm tự hào không làm định kiến đó biến mất.",
          "Góc nhìn nhà đầu tư: đốt tiền để đảo ngược nhận thức của người tiêu dùng toàn cầu là chiến lược rất rủi ro với doanh nghiệp vừa và nhỏ. Cách khôn ngoan hơn là chọn chiến trường mình có lợi thế.",
          "Ví dụ với một thương hiệu giày Việt: thay vì đối đầu trực diện với các hãng giày thể thao toàn cầu ở phân khúc chạy bộ, có thể chọn một ngách mà thương hiệu lớn không phục vụ kỹ, như giày cho dáng chân người Việt đi làm cả ngày, hoặc giày đồng phục cho trường học và doanh nghiệp. Việt Nam là một trong những nơi sản xuất giày lớn của thế giới, nên lợi thế chuỗi cung ứng ngay tại chỗ (mẫu mới nhanh, đơn nhỏ vẫn làm được) là thứ đối thủ toàn cầu khó sao chép ở thị trường này."
        ],
        "bullets": [
          "Chọn ngách: một nhóm khách cụ thể mà bạn phục vụ tốt hơn bất kỳ ai.",
          "Khai thác lợi thế bản địa: tốc độ ra mẫu, chi phí, hiểu khách hàng trong nước.",
          "Mở rộng có chọn lọc: đi tới thị trường gần, có cộng đồng hiểu sản phẩm, trước khi nghĩ tới thị trường lớn nhất."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Nếu bạn là startup giai đoạn sớm, đọc bài này thế nào",
        "paragraphs": [
          "Năm điểm trên được nói từ góc nhìn quỹ tài chính đầu tư vào doanh nghiệp đã lớn. Với startup chưa có hoặc mới có ít doanh thu, nhà đầu tư thiên thần và quỹ mạo hiểm giai đoạn sớm nhìn hơi khác."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": {
          "caption": "Cùng một câu hỏi, hai giai đoạn",
          "headers": [
            "Điểm",
            "Quỹ tài chính, giai đoạn mở rộng",
            "Quỹ mạo hiểm, giai đoạn sớm"
          ],
          "rows": [
            {
              "cells": [
                "Mức sẵn sàng",
                "Cỗ máy đã chạy, chỉ thiếu tiền",
                "Chấp nhận còn nhiều thứ chưa xong, nhưng cần bằng chứng có người cần"
              ]
            },
            {
              "cells": [
                "Nghiên cứu sản phẩm",
                "Hầu như không trả tiền cho việc này",
                "Trả tiền cho việc làm ra sản phẩm đầu tiên, nhất là quỹ chuyên công nghệ"
              ]
            },
            {
              "cells": [
                "Tăng trưởng",
                "Phải đi cùng dòng tiền hoạt động lành mạnh",
                "Ưu tiên tốc độ học và tăng trưởng, nhưng vẫn hỏi lãi lỗ trên từng khách"
              ]
            },
            {
              "cells": [
                "Cổ phần nhà sáng lập",
                "Thường muốn một người nắm quyền chi phối",
                "Chia gần đều vẫn gặp, nhưng phải rõ ai quyết định cuối và có vesting"
              ]
            },
            {
              "cells": [
                "Thị trường",
                "Ngách có lãi, mở rộng chọn lọc",
                "Ngách để bắt đầu, nhưng phải có đường đi tới thị trường lớn"
              ]
            }
          ]
        },
        "notes": []
      },
      {
        "heading": "Tự kiểm tra trước khi gặp quỹ tài chính",
        "paragraphs": [],
        "bullets": [
          "Tôi tách được kế hoạch tăng trưởng thành từng nguồn, mỗi nguồn có số liệu quá khứ làm bằng chứng.",
          "Tôi nói được tiền vào sẽ biến thành gì trong 90 ngày đầu, không chỉ trong năm năm.",
          "Phần lớn vốn gọi được dành cho bán hàng, phân phối và thị phần, không phải cho nghiên cứu cái mới.",
          "Tôi biết thời gian hoà vốn của từng điểm bán hoặc lãi lỗ trên từng đơn, tách theo kênh.",
          "Dòng tiền hoạt động theo tháng đã được theo dõi ít nhất 12 tháng gần nhất.",
          "Trong nhóm sáng lập, ai quyết định cuối cùng đã được ghi thành văn bản.",
          "Tôi giải thích được vì sao khách không bỏ mình sang đối thủ rẻ hơn.",
          "Chiến lược thị trường dựa trên lợi thế mình đang có, không chỉ dựa trên đam mê."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      }
    ],
    "relatedTools": [
      {
        "slug": "chi-so-tang-truong",
        "label": "Đo tốc độ và độ đều của tăng trưởng"
      },
      {
        "slug": "kiem-tra-gia-dinh-kinh-te-don-vi",
        "label": "Soát lãi lỗ trên từng đơn, từng cửa hàng"
      },
      {
        "slug": "chia-co-phan-dong-sang-lap",
        "label": "Soát cách chia cổ phần giữa các nhà sáng lập"
      },
      {
        "slug": "dinh-gia-co-doanh-thu",
        "label": "Ước khoảng định giá khi đã có doanh thu"
      },
      {
        "slug": "goi-bao-nhieu",
        "label": "Lập kế hoạch số vốn và cách dùng"
      },
      {
        "slug": "quy-phu-hop",
        "label": "Tìm quỹ đúng giai đoạn và ngành"
      }
    ],
    "sources": [],
    "seoTitle": "5 hiểu nhầm khi gọi vốn quỹ đầu tư để mở rộng doanh nghiệp, và quỹ thực sự nhìn gì",
    "seoDescription": "Quỹ tài chính không vào để gánh khó khăn hay trả tiền R&D. Họ nhìn kế hoạch tăng trưởng được lượng hoá, sản phẩm chủ lực, dòng tiền hoạt động, cơ cấu sở hữu và chiến lược thị trường. Ví dụ bằng số cho từng điểm.",
    "publishedAt": "2026-10-03",
    "updatedAt": "2026-10-03",
    "track": "kinh-nghiem",
    "readingMinutes": 10
  },
  {
    "slug": "nhin-lai-tuan-43-2026",
    "title": "Nhìn lại tuần 43/2026: vòng seed 200 triệu USD, một thương vụ mua đội ngũ 15 người và khoản vay chuyển đổi được trả lại",
    "excerpt": "Bốn thương vụ và một nghị quyết đáng chú ý trong tuần 19 đến 25/10/2026, kèm bài học cụ thể cho founder Việt: đừng lấy vòng seed khổng lồ làm chuẩn, chứng minh giá trị bằng số liệu vận hành của khách hàng, nghĩ sớm về người mua chiến lược, đọc kỹ điều khoản đáo hạn của khoản vay chuyển đổi, và chuẩn bị hồ sơ để hưởng miễn thuế ở TP.HCM từ năm 2027.",
    "category": "Nhìn lại tuần",
    "stages": [
      "Pre-seed",
      "Seed",
      "Series A"
    ],
    "storyType": "huong-dan",
    "templates": [],
    "consentConfirmed": false,
    "coverImage": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Fnhin-lai-tuan-43-2026%2F1793243596334-cover.webp?alt=media&token=48658a46-a478-4452-a10e-acee6c44bbb1",
    "coverAlt": "Nhìn lại tuần 43/2026: vòng seed 200 triệu USD, một thương vụ mua đội ngũ 15 người và khoản vay chuyển đổi được trả lại",
    "coverCaption": "",
    "ogImage": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Fnhin-lai-tuan-43-2026%2F1793243604481-cover.jpg?alt=media&token=2961c472-f319-462b-95bc-d74393c3c669",
    "author": "Fundraising Vietnam",
    "authorRole": "",
    "status": "PUBLISHED",
    "featured": false,
    "sections": [
      {
        "heading": "Tuần này có gì",
        "paragraphs": [
          "Số liệu trong bài chốt ngày 25/10/2026, lấy từ thông cáo và báo chí có ngày đăng. Số tiền là tổng vòng công bố, không phải séc của riêng một quỹ.",
          "Tuần 43 có hai vòng gọi vốn rất lớn ở giai đoạn sớm, hai vòng Series D vào AI công nghiệp và hạ tầng vệ tinh, một thương vụ mua lại nhỏ nhưng đáng học, và một tin Việt Nam về cách một khoản vay chuyển đổi kết thúc. Ở trong nước, TP.HCM có nghị quyết miễn thuế mới cho khởi nghiệp sáng tạo đã có hiệu lực từ 01/10."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Vòng seed 200 triệu USD không phải thước đo cho bạn",
        "paragraphs": [
          "Warhound, công ty công nghệ sinh học quốc phòng ở Dallas, ra mắt với vòng seed 200 triệu USD ở mức định giá 1,2 tỷ USD. Danh sách nhà đầu tư gồm Sequoia Capital, In-Q-Tel, ARK Invest, Franklin Templeton, 8VC và Lux Capital. Công ty muốn cung cấp chó nghiệp vụ cho quân đội và lực lượng cứu hộ bằng cách kết hợp chọn giống, nhân bản và huấn luyện, và theo bài báo thì chưa có sản phẩm để bán.",
          "Cùng tuần, Enact Intelligence (Zurich, thành lập tháng 3/2026) gọi 30 triệu USD ngay ở vòng pre-seed để làm robot cảm nhận được lực và xúc giác, chưa công bố doanh thu hay khách hàng.",
          "Hai vòng này có điểm chung: lĩnh vực đang được ưu tiên (quốc phòng, robot), đội ngũ và nhà đầu tư hàng đầu thế giới, và cần rất nhiều vốn trước khi có sản phẩm. Đó là ngoại lệ, không phải mặt bằng. Founder Việt gọi vòng đầu nên so mình với trung vị của thị trường Việt Nam và Đông Nam Á, và gắn số vốn cần gọi với một cột mốc cụ thể."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Vốn lớn chảy vào AI có số liệu vận hành thật",
        "paragraphs": [
          "Xona Space Systems, công ty xây chòm vệ tinh định vị, gọi 250 triệu USD Series D ở mức định giá 2,45 tỷ USD. Tractian, công ty dùng cảm biến và AI để dự báo hỏng hóc máy móc trong nhà máy, gọi 130 triệu USD Series D ở mức định giá 1,4 tỷ USD, do Sapphire Ventures dẫn dắt. Tractian cho biết sản phẩm đang chạy ở hơn 2.000 cơ sở (số liệu công ty tự công bố).",
          "Điều nhà đầu tư trả tiền ở đây không phải chữ AI, mà là một bài toán vận hành đo được: giảm số lần dừng máy ngoài kế hoạch, thay thế một hạ tầng đang có rủi ro. Nếu bạn làm AI cho sản xuất, logistics hay năng lượng, hãy đưa số liệu tiết kiệm của khách hàng thật lên những slide đầu tiên, kèm cách đo."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Rivian mua một đội ngũ 15 người: thoái vốn không chỉ có IPO",
        "paragraphs": [
          "Hãng xe điện Rivian mua Third Dimension, startup ở Anh dùng AI biến ảnh và video thành thế giới 3D, ban đầu làm cho ngành game. Công ty mới gọi 7 triệu USD vốn seed; giá mua không công bố. Đội ngũ 15 người sẽ nhập vào nhóm AI tự hành của Rivian để dựng môi trường mô phỏng cho xe tự lái.",
          "Đây là kiểu thoái vốn ngày càng phổ biến: doanh nghiệp lớn mua công nghệ và con người để đi nhanh hơn tự xây. Bài học cho founder là một công nghệ hẹp nhưng sâu, giải đúng nút thắt của một tập đoàn, có thể được mua sớm. Khi gọi vốn, phần lộ trình thoái vốn nên kể tên vài bên mua chiến lược có thật và lý do họ cần bạn."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Dat Bike: khoản vay chuyển đổi có thể kết thúc bằng tiền, không phải cổ phần",
        "paragraphs": [
          "PIDG, quỹ hạ tầng do sáu chính phủ hậu thuẫn, đã hoàn tất rút khỏi startup xe máy điện Dat Bike sau khi khoản vay chuyển đổi 4 triệu USD mà đơn vị InfraCo cấp năm 2024 được hoàn trả. Vòng Series B của Dat Bike đạt 22 triệu USD vào tháng 9/2025 và lên 26 triệu USD sau lần đóng thứ hai tháng 3/2026, do F.C.C. (Nhật Bản) và Rebright Partners đồng dẫn dắt, có Jungle Ventures, AiViet Venture, Chứng khoán Thiên Việt và Cathay Venture tham gia.",
          "Khoản vay chuyển đổi (convertible note) không tự động biến thành cổ phần. Tuỳ điều khoản, nó có thể được trả lại bằng tiền khi đến hạn hoặc khi công ty gọi được vòng mới. Trước khi nhận một khoản như vậy, hãy đọc kỹ ngày đáo hạn, lãi suất, mức chiết khấu, trần định giá và ai được quyền chọn giữa chuyển đổi và hoàn trả, rồi đưa kịch bản hoàn trả vào kế hoạch dòng tiền."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Chính sách: Nghị quyết 59/2026 của TP.HCM miễn thuế từ năm 2027",
        "paragraphs": [
          "HĐND TP.HCM ban hành Nghị quyết 59/2026/NQ-HĐND ngày 22/9/2026, có hiệu lực từ 01/10/2026, thay cho Nghị quyết 31/2024/NQ-HĐND. Doanh nghiệp khởi nghiệp sáng tạo được miễn thuế thu nhập doanh nghiệp 5 năm đối với thu nhập từ hoạt động khởi nghiệp (sản phẩm, dịch vụ, quy trình hoặc mô hình mới hay cải tiến đáng kể). Chuyên gia, nhà khoa học và cá nhân khởi nghiệp đủ điều kiện được miễn thuế thu nhập cá nhân 5 năm liên tục trên tiền lương, tiền công. Ưu đãi áp dụng từ kỳ tính thuế 2027.",
          "Điều kiện chính: trụ sở ở TP.HCM và có giấy chứng nhận hoặc công nhận còn hiệu lực theo chính sách của thành phố; cá nhân khởi nghiệp phải là thành viên sáng lập hoặc đồng sáng lập của doanh nghiệp khởi nghiệp sáng tạo được công nhận. Thu nhập từ hoạt động kinh doanh khác không được miễn. Hãy đối chiếu văn bản gốc và hỏi cơ quan thuế hoặc luật sư trước khi tính ưu đãi này vào mô hình tài chính."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Bảng tóm tắt tuần",
        "paragraphs": [],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": {
          "caption": "Số liệu chốt ngày 25/10/2026",
          "headers": [
            "Công ty",
            "Sự kiện",
            "Số tiền",
            "Định giá",
            "Điều đáng học"
          ],
          "rows": [
            {
              "cells": [
                "Warhound (Mỹ)",
                "Seed",
                "200 triệu USD",
                "1,2 tỷ USD",
                "Ngoại lệ, không phải chuẩn để đặt mục tiêu"
              ]
            },
            {
              "cells": [
                "Enact Intelligence (Thụy Sĩ)",
                "Pre-seed",
                "30 triệu USD",
                "Không công bố",
                "Robot, đội ngũ và nhà đầu tư hàng đầu"
              ]
            },
            {
              "cells": [
                "Xona Space Systems (Mỹ)",
                "Series D",
                "250 triệu USD",
                "2,45 tỷ USD",
                "Hạ tầng thay thế một hệ thống đang có rủi ro"
              ]
            },
            {
              "cells": [
                "Tractian (Mỹ)",
                "Series D",
                "130 triệu USD",
                "1,4 tỷ USD",
                "AI gắn với số liệu vận hành của khách hàng"
              ]
            },
            {
              "cells": [
                "Third Dimension (Anh)",
                "Được Rivian mua",
                "Không công bố",
                "Không công bố",
                "Công nghệ hẹp, đúng nút thắt của người mua"
              ]
            },
            {
              "cells": [
                "Dat Bike (Việt Nam)",
                "PIDG rút sau khi được trả khoản vay",
                "4 triệu USD",
                "Không công bố",
                "Đọc kỹ kịch bản hoàn trả của khoản vay chuyển đổi"
              ]
            }
          ]
        },
        "notes": []
      },
      {
        "heading": "Ba việc founder có thể làm ngay tuần này",
        "paragraphs": [],
        "bullets": [
          "Đặt lại mục tiêu số vốn theo cột mốc 12 đến 18 tháng tới, không theo các vòng gây chú ý trên báo.",
          "Thêm vào pitch deck một slide số liệu vận hành của khách hàng: họ tiết kiệm được gì, đo bằng cách nào, trong bao lâu.",
          "Nếu công ty có trụ sở ở TP.HCM, kiểm tra xem đã có giấy công nhận doanh nghiệp khởi nghiệp sáng tạo chưa, để kịp hưởng miễn thuế từ năm 2027."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      }
    ],
    "relatedTools": [],
    "sources": [
      {
        "label": "Tech Startups: Startup funding news, 23/10/2026 (Warhound, Enact, Xona, Tractian)",
        "url": "https://techstartups.com/2026/10/23/startup-funding-news-today-october-23-2026-helion-slingshot-xona-warhound-tractian-more/"
      },
      {
        "label": "SatNews: Xona Space Systems Series D 250 triệu USD (22/10/2026)",
        "url": "https://satnews.com/2026/10/22/xona-space-systems-secures-250m-series-d-at-2-45b-valuation-to-scale-pulsar-pnt-fleet/"
      },
      {
        "label": "TechCrunch: Rivian buys world model startup (22/10/2026)",
        "url": "https://techcrunch.com/2026/10/22/rivian-buys-world-model-startup-to-accelerate-self-driving-ambitions/"
      },
      {
        "label": "Bloomberg Businessweek Việt Nam: PIDG thoái vốn Dat Bike (20/10/2026)",
        "url": "https://bbw.vn/pidg-thoai-von-dat-bike-sau-vong-von-series-b-26-trieu-usd-61063.html"
      },
      {
        "label": "PIDG: First e-mobility transaction in Southeast Asia (27/8/2024)",
        "url": "https://pidg.org/pidg-announces-first-e-mobility-transaction-in-southeast-asia/"
      },
      {
        "label": "Nghị quyết 59/2026/NQ-HĐND TP.HCM (tóm tắt)",
        "url": "https://thue.man.net.vn/nghi-quyet-59-2026/"
      }
    ],
    "seoTitle": "Nhìn lại tuần 43/2026: thương vụ gọi vốn, thoái vốn và chính sách khởi nghiệp đáng chú ý",
    "seoDescription": "Warhound gọi 200 triệu USD vòng seed, Xona và Tractian gọi Series D, Rivian mua Third Dimension, PIDG rời Dat Bike sau khi khoản vay chuyển đổi 4 triệu USD được trả, và Nghị quyết 59/2026 của TP.HCM miễn thuế cho khởi nghiệp sáng tạo.",
    "publishedAt": "2026-10-26",
    "updatedAt": "2026-10-29",
    "track": "nhin-lai",
    "readingMinutes": 6
  },
  {
    "slug": "pitch-deck-tot-va-chua-tot",
    "title": "Pitch deck tốt và chưa tốt: so sánh từng slide kèm ví dụ cụ thể",
    "excerpt": "Nhà đầu tư lướt một deck trong khoảng 2 phút 30 giây. Bài này đặt bản chưa tốt cạnh bản tốt cho từng slide trong 10 slide cốt lõi, kèm 10 lỗi hay gặp và bảng tự chấm trước khi gửi.",
    "category": "Hồ sơ & pitch deck",
    "stages": [
      "Pre-seed",
      "Seed"
    ],
    "storyType": "huong-dan",
    "templates": [],
    "consentConfirmed": false,
    "coverImage": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Fpitch-deck-tot-va-chua-tot%2F1790081610452-cover.webp?alt=media&token=502910f4-1266-4dcb-adcb-36354230970e",
    "coverAlt": "Bìa bài Pitch Deck tốt và chưa tốt: một slide dày chữ đặt cạnh một slide có tiêu đề là kết luận và biểu đồ tăng trưởng",
    "coverCaption": "",
    "ogImage": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Fpitch-deck-tot-va-chua-tot%2F1790081620040-cover.jpg?alt=media&token=153d154a-fd2e-470f-9e0c-20278071cb83",
    "author": "Fundraising Vietnam",
    "authorRole": "",
    "status": "PUBLISHED",
    "featured": false,
    "sections": [
      {
        "heading": "Vì sao deck không tạo được ấn tượng",
        "paragraphs": [
          "Nhà đầu tư đọc một deck gọi vốn trong khoảng 2 phút 30 giây. Với deck vòng seed là khoảng 3 phút 44 giây, và chỉ 58% deck được đọc đến hết (số liệu DocSend). Nghĩa là deck không được \"đọc\" — nó được lướt để tìm lý do dừng lại hoặc đi tiếp.",
          "Trong khoảng 150 giây đó, nhà đầu tư cố trả lời bốn câu hỏi:"
        ],
        "bullets": [
          "Vấn đề này có thật và có đau không — ai đang mất tiền, mất thời gian vì nó?",
          "Thị trường có đủ lớn để ra một công ty lớn không?",
          "Có bằng chứng gì cho thấy đội này đang thắng — số liệu, khách hàng, tốc độ tăng trưởng?",
          "Vì sao là đội này, và vì sao là bây giờ?"
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Deck chưa tốt thường không sai, mà bắt người đọc tự đi tìm",
        "paragraphs": [
          "Deck chưa tốt hiếm khi sai thông tin. Vấn đề là nó bắt nhà đầu tư tự đi tìm câu trả lời: chữ dày, tính từ thay cho con số, slide nào cũng \"quan trọng\" như nhau.",
          "Theo DocSend, nhà đầu tư dừng lâu nhất ở Mô hình kinh doanh (khoảng 64 giây), Sản phẩm (59 giây), Traction (40 giây), Đội ngũ (38 giây) và Tài chính (37 giây). Đây là những slide cần đầu tư công sức nhiều nhất."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "6 nguyên tắc phân biệt deck tốt và chưa tốt",
        "paragraphs": [
          "Deck tốt không nằm ở thiết kế đẹp, mà ở chỗ mỗi slide trả lời đúng một câu hỏi bằng bằng chứng."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": {
          "caption": "",
          "headers": [
            "Nguyên tắc",
            "Deck chưa tốt",
            "Deck tốt"
          ],
          "rows": [
            {
              "cells": [
                "Tiêu đề là kết luận",
                "\"Thị trường\"",
                "\"120.000 nhà hàng tại HCM & HN chi 1.800 tỷ/năm cho nhập hàng thủ công\""
              ]
            },
            {
              "cells": [
                "Con số thay tính từ",
                "\"Tăng trưởng mạnh, khách hàng rất hài lòng\"",
                "\"MRR tăng 18%/tháng trong 6 tháng; tỷ lệ rời bỏ 2,1%/tháng\""
              ]
            },
            {
              "cells": [
                "Một slide – một ý",
                "3 biểu đồ, 8 gạch đầu dòng trên một slide",
                "1 biểu đồ + 1 câu kết luận"
              ]
            },
            {
              "cells": [
                "Cụ thể về khách hàng",
                "\"Mọi doanh nghiệp vừa và nhỏ\"",
                "\"Chủ chuỗi 3–10 quán cà phê, tự nhập hàng qua Zalo\""
              ]
            },
            {
              "cells": [
                "Tự đọc hiểu được",
                "Cần founder thuyết trình mới hiểu",
                "Gửi email, người đọc vẫn nắm được câu chuyện trong 3 phút"
              ]
            },
            {
              "cells": [
                "Nhất quán số liệu",
                "Slide 5 ghi 2.000 khách, slide 12 ghi 1.500",
                "Một nguồn số liệu, có ghi thời điểm \"tính đến 08/2026\""
              ]
            }
          ]
        },
        "notes": [
          "Mẹo kiểm tra nhanh: chỉ đọc tiêu đề của tất cả slide theo thứ tự. Nếu chuỗi tiêu đề đó kể được trọn câu chuyện gọi vốn, deck đã đi đúng hướng.",
          "Các ví dụ bên dưới dùng chung một startup giả định: BếpSỉ — nền tảng đặt hàng nguyên liệu B2B cho quán cà phê, nhà hàng nhỏ. Số liệu là minh họa, không phải số thật."
        ]
      },
      {
        "heading": "Slide 1. Vấn đề (Problem)",
        "paragraphs": [
          "Nhà đầu tư muốn biết: ai đau, đau bao nhiêu, và họ đang chắp vá thế nào."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": {
          "caption": "",
          "headers": [
            "Chưa tốt",
            "Tốt"
          ],
          "rows": [
            {
              "cells": [
                "\"Ngành F&B Việt Nam đang gặp nhiều khó khăn trong khâu cung ứng, thiếu minh bạch và hiệu quả.\"",
                "\"Chủ quán nhỏ mất khoảng 6 giờ/tuần gọi 5–7 nhà cung cấp qua Zalo, và trả giá cao hơn chuỗi lớn 12–15% vì mua lẻ.\""
              ]
            },
            {
              "cells": [
                "Nói về cả ngành, không có người cụ thể",
                "Một chân dung khách hàng + 2 con số đo được nỗi đau"
              ]
            },
            {
              "cells": [
                "Không có bằng chứng",
                "\"Phỏng vấn 85 chủ quán; 71 người nêu nhập hàng là việc mất thời gian nhất\""
              ]
            }
          ]
        },
        "notes": []
      },
      {
        "heading": "Slide 2. Giải pháp (Solution)",
        "paragraphs": [
          "Nhà đầu tư muốn biết: giải pháp khớp với nỗi đau vừa nêu thế nào, và tốt hơn cách cũ bao nhiêu lần."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": {
          "caption": "",
          "headers": [
            "Chưa tốt",
            "Tốt"
          ],
          "rows": [
            {
              "cells": [
                "\"Nền tảng hệ sinh thái ứng dụng AI, blockchain, IoT toàn diện cho chuỗi cung ứng F&B.\"",
                "\"Một app đặt hàng từ 40+ nhà cung cấp, giao trong 24h, giá sỉ gộp đơn: giảm 6 giờ còn 30 phút/tuần, rẻ hơn 9%.\""
              ]
            },
            {
              "cells": [
                "Liệt kê công nghệ và 10 tính năng",
                "1 câu giá trị + so sánh trước/sau bằng số"
              ]
            }
          ]
        },
        "notes": []
      },
      {
        "heading": "Slide 3. Thị trường (Market size)",
        "paragraphs": [
          "Nhà đầu tư muốn biết: nếu thành công, công ty có thể lớn đến đâu — và founder có hiểu thị trường của mình không."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": {
          "caption": "",
          "headers": [
            "Chưa tốt",
            "Tốt"
          ],
          "rows": [
            {
              "cells": [
                "\"Thị trường F&B Việt Nam trị giá hàng chục tỷ USD. Chỉ cần chiếm 1% là đã có hàng trăm triệu USD.\" (lấy số tổng ngành từ trên xuống)",
                "Tính từ dưới lên: số khách hàng mục tiêu × chi tiêu/năm × phần doanh thu công ty giữ lại"
              ]
            },
            {
              "cells": [
                "Không phân biệt TAM/SAM/SOM",
                "TAM: 300.000 quán cả nước × 180 triệu/năm tiền nguyên liệu. SAM: 120.000 quán tại HCM & HN. SOM 5 năm: 8.000 quán × 180 triệu × 8% hoa hồng ≈ 115 tỷ doanh thu/năm"
              ]
            }
          ]
        },
        "notes": [
          "\"Chiếm 1% thị trường\" là cụm từ khiến nhiều nhà đầu tư mất niềm tin ngay: nó cho thấy founder chưa tính từ khách hàng thật."
        ]
      },
      {
        "heading": "Slide 4. Sản phẩm (Product)",
        "paragraphs": [
          "Nhà đầu tư muốn biết: sản phẩm có thật, đang được dùng, và trải nghiệm cốt lõi là gì."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": {
          "caption": "",
          "headers": [
            "Chưa tốt",
            "Tốt"
          ],
          "rows": [
            {
              "cells": [
                "Sơ đồ kiến trúc hệ thống, danh sách 15 module",
                "2–3 ảnh chụp màn hình thật theo luồng: tìm hàng → đặt → nhận hàng"
              ]
            },
            {
              "cells": [
                "Mockup đẹp nhưng chưa có ai dùng",
                "Chú thích số liệu ngay trên ảnh: \"Đơn trung bình 2,4 triệu; 64% đơn là đặt lại\""
              ]
            },
            {
              "cells": [
                "\"Sắp ra mắt AI gợi ý đơn hàng\" đặt ngang hàng với tính năng đã có",
                "Tách rõ \"đã có\" và \"lộ trình 12 tháng\""
              ]
            }
          ]
        },
        "notes": []
      },
      {
        "heading": "Slide 5. Traction (sức kéo)",
        "paragraphs": [
          "Nhà đầu tư muốn biết: khách hàng có thật sự muốn sản phẩm không — và xu hướng đang đi lên nhanh cỡ nào. Đây là slide quyết định nhiều nhất nếu đã có doanh thu."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": {
          "caption": "",
          "headers": [
            "Chưa tốt",
            "Tốt"
          ],
          "rows": [
            {
              "cells": [
                "\"10.000+ lượt tải app, 50.000 follower Facebook\" (số liệu phù phiếm)",
                "\"420 quán đặt hàng đều mỗi tháng; GMV 4 tỷ/tháng, tăng 18%/tháng trong 6 tháng\""
              ]
            },
            {
              "cells": [
                "Số cộng dồn từ trước đến nay — luôn đi lên nên không nói lên điều gì",
                "Biểu đồ theo tháng, có trục và đơn vị rõ ràng"
              ]
            },
            {
              "cells": [
                "Logo \"đối tác\" mới ký MOU",
                "Chỉ số giữ chân: \"78% quán vẫn đặt hàng sau 6 tháng\""
              ]
            }
          ]
        },
        "notes": [
          "Chưa có doanh thu? Dùng bằng chứng thay thế: danh sách chờ, thư cam kết mua (LOI), kết quả thí điểm có trả tiền. Không dùng lượt thích hay lượt tải."
        ]
      },
      {
        "heading": "Slide 6. Mô hình kinh doanh (Business model)",
        "paragraphs": [
          "Nhà đầu tư muốn biết: kiếm tiền từ đâu, mỗi khách hàng lãi hay lỗ. Đây là slide được đọc lâu nhất."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": {
          "caption": "",
          "headers": [
            "Chưa tốt",
            "Tốt"
          ],
          "rows": [
            {
              "cells": [
                "\"Doanh thu từ quảng cáo, hoa hồng, gói premium, bán dữ liệu, tư vấn…\" (5 nguồn, chưa nguồn nào chạy)",
                "1 nguồn chính: hoa hồng 8% trên mỗi đơn từ nhà cung cấp"
              ]
            },
            {
              "cells": [
                "Không có kinh tế đơn vị",
                "Chi phí có 1 quán (CAC) 1,5 triệu; doanh thu gộp/quán/tháng 0,6 triệu → hoàn vốn sau khoảng 3 tháng"
              ]
            }
          ]
        },
        "notes": []
      },
      {
        "heading": "Slide 7. Cạnh tranh (Competition)",
        "paragraphs": [
          "Nhà đầu tư muốn biết: founder có hiểu đối thủ không, và lợi thế nào khó bị sao chép."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": {
          "caption": "",
          "headers": [
            "Chưa tốt",
            "Tốt"
          ],
          "rows": [
            {
              "cells": [
                "\"Chúng tôi không có đối thủ cạnh tranh.\"",
                "Nhắc cả đối thủ trực tiếp và cách làm cũ (Zalo + chợ đầu mối + đại lý)"
              ]
            },
            {
              "cells": [
                "Bảng tick mà cột mình ✔ hết, đối thủ ✘ hết",
                "Ma trận 2 trục với tiêu chí khách hàng thật sự quan tâm (tốc độ giao, giá) + 1 câu về lợi thế bền vững: \"mạng lưới 40 nhà cung cấp độc quyền giá sỉ tại 2 thành phố\""
              ]
            }
          ]
        },
        "notes": [
          "\"Không có đối thủ\" thường được hiểu là: hoặc chưa tìm hiểu, hoặc không có thị trường."
        ]
      },
      {
        "heading": "Slide 8. Đội ngũ (Team)",
        "paragraphs": [
          "Nhà đầu tư muốn biết: vì sao đúng là những người này sẽ thắng bài toán này."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": {
          "caption": "",
          "headers": [
            "Chưa tốt",
            "Tốt"
          ],
          "rows": [
            {
              "cells": [
                "8 ảnh chân dung, kèm chức danh \"CEO – Nhiệt huyết, sáng tạo\"",
                "2–3 founder, mỗi người 1 dòng thành tích liên quan trực tiếp"
              ]
            },
            {
              "cells": [
                "Liệt kê cố vấn nổi tiếng chỉ gặp 1 lần",
                "\"CEO: 6 năm quản lý thu mua cho chuỗi 80 nhà hàng. CTO: từng dẫn đội 12 kỹ sư xây hệ thống đặt hàng cho sàn TMĐT.\""
              ]
            }
          ]
        },
        "notes": []
      },
      {
        "heading": "Slide 9. Tài chính (Financials)",
        "paragraphs": [
          "Nhà đầu tư muốn biết: founder có hiểu các đòn bẩy tăng trưởng và chi phí của mình không — không ai tin con số năm thứ 5."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": {
          "caption": "",
          "headers": [
            "Chưa tốt",
            "Tốt"
          ],
          "rows": [
            {
              "cells": [
                "Đường \"cây gậy khúc côn cầu\": 0 → 1.000 tỷ trong 3 năm, không giả định",
                "Dự phóng 3 năm, nêu 3 giả định then chốt: số quán mới/tháng, giá trị đơn, tỷ lệ giữ chân"
              ]
            },
            {
              "cells": [
                "Bảng P&L 40 dòng chữ nhỏ",
                "1 biểu đồ doanh thu – chi phí – dòng tiền; bản Excel chi tiết để trong phụ lục hoặc data room"
              ]
            }
          ]
        },
        "notes": []
      },
      {
        "heading": "Slide 10. Gọi vốn (The Ask)",
        "paragraphs": [
          "Nhà đầu tư muốn biết: cần bao nhiêu, dùng vào đâu, và số tiền đó đưa công ty đến cột mốc nào."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": {
          "caption": "",
          "headers": [
            "Chưa tốt",
            "Tốt"
          ],
          "rows": [
            {
              "cells": [
                "\"Chúng tôi đang tìm kiếm nhà đầu tư chiến lược đồng hành.\"",
                "\"Gọi 1,5 triệu USD vòng seed, đủ hoạt động 18 tháng\""
              ]
            },
            {
              "cells": [
                "Biểu đồ tròn phân bổ vốn chung chung (Marketing 40%, Tech 30%…)",
                "Phân bổ gắn với cột mốc: \"Đạt 2.500 quán và GMV 20 tỷ/tháng — đủ điều kiện gọi Series A\""
              ]
            }
          ]
        },
        "notes": []
      },
      {
        "heading": "Ví dụ xuyên suốt: deck BếpSỉ trước và sau khi sửa",
        "paragraphs": [
          "Cùng một công ty, cùng dữ liệu — chỉ đổi cách viết tiêu đề. Đọc cột bên phải từ trên xuống, bạn đã có toàn bộ câu chuyện gọi vốn trong 12 câu."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": {
          "caption": "",
          "headers": [
            "#",
            "Tiêu đề bản cũ",
            "Tiêu đề bản sửa"
          ],
          "rows": [
            {
              "cells": [
                "1",
                "BếpSỉ – Giải pháp công nghệ cho ngành F&B",
                "BếpSỉ giúp quán nhỏ nhập nguyên liệu giá sỉ, giao trong 24h"
              ]
            },
            {
              "cells": [
                "2",
                "Thực trạng ngành",
                "Chủ quán mất 6 giờ/tuần và trả đắt hơn 12–15% vì tự nhập hàng lẻ"
              ]
            },
            {
              "cells": [
                "3",
                "Giải pháp của chúng tôi",
                "Một app, 40+ nhà cung cấp, gộp đơn để có giá sỉ"
              ]
            },
            {
              "cells": [
                "4",
                "Vì sao là bây giờ?",
                "80% chủ quán đã quen thanh toán QR — rào cản đặt hàng online đã biến mất"
              ]
            },
            {
              "cells": [
                "5",
                "Thị trường",
                "120.000 quán tại HCM & HN; mục tiêu 115 tỷ doanh thu/năm sau 5 năm"
              ]
            },
            {
              "cells": [
                "6",
                "Sản phẩm",
                "Đặt hàng trong 3 bước; 64% đơn là đặt lại"
              ]
            },
            {
              "cells": [
                "7",
                "Kết quả đạt được",
                "420 quán, GMV 4 tỷ/tháng, tăng 18%/tháng"
              ]
            },
            {
              "cells": [
                "8",
                "Mô hình kinh doanh",
                "Hoa hồng 8%/đơn; hoàn vốn chi phí có khách sau khoảng 3 tháng"
              ]
            },
            {
              "cells": [
                "9",
                "Đối thủ cạnh tranh",
                "Đối thủ lớn nhất là Zalo + chợ đầu mối; chúng tôi thắng về giá và tốc độ"
              ]
            },
            {
              "cells": [
                "10",
                "Đội ngũ",
                "Founder từng làm thu mua cho chuỗi 80 nhà hàng"
              ]
            },
            {
              "cells": [
                "11",
                "Kế hoạch tài chính",
                "Hòa vốn tháng 20 nếu giữ tốc độ thêm 60 quán/tháng"
              ]
            },
            {
              "cells": [
                "12",
                "Kêu gọi đầu tư",
                "Gọi 1,5 triệu USD để đạt 2.500 quán trong 18 tháng"
              ]
            }
          ]
        },
        "notes": [
          "Những gì đã thay đổi: mỗi tiêu đề có ít nhất một con số hoặc một đối tượng cụ thể, và slide sau nối tiếp slide trước (nỗi đau → cách giải → quy mô → bằng chứng → kiếm tiền → ai làm → cần gì)."
        ]
      },
      {
        "heading": "10 lỗi hay gặp và cách sửa nhanh",
        "paragraphs": [],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": {
          "caption": "",
          "headers": [
            "Lỗi",
            "Vì sao gây hại",
            "Sửa thế nào"
          ],
          "rows": [
            {
              "cells": [
                "Mở đầu bằng tầm nhìn, sứ mệnh dài",
                "Nhà đầu tư chưa biết công ty làm gì đã phải đọc triết lý",
                "Slide 1: một câu \"Chúng tôi giúp [ai] làm [việc gì] [tốt hơn bao nhiêu]\""
              ]
            },
            {
              "cells": [
                "Quá nhiều chữ",
                "Deck bị lướt, không được đọc",
                "Tối đa khoảng 30 chữ phần thân mỗi slide; chi tiết chuyển vào phụ lục"
              ]
            },
            {
              "cells": [
                "Deck quá dài (30–40 slide)",
                "Chỉ khoảng 58% deck được xem hết",
                "Deck gửi email 12–20 slide; phần còn lại để data room"
              ]
            },
            {
              "cells": [
                "Thị trường \"1% của thị trường tỷ đô\"",
                "Cho thấy chưa tính từ khách hàng thật",
                "Tính từ dưới lên: số khách × chi tiêu × phần giữ lại"
              ]
            },
            {
              "cells": [
                "Số liệu phù phiếm (lượt tải, follower)",
                "Không chứng minh khách hàng trả tiền hay quay lại",
                "Dùng doanh thu, khách hoạt động, tỷ lệ giữ chân theo tháng"
              ]
            },
            {
              "cells": [
                "\"Không có đối thủ\"",
                "Mất uy tín ngay",
                "Nhắc cả đối thủ trực tiếp và cách làm cũ khách đang dùng"
              ]
            },
            {
              "cells": [
                "Biểu đồ không có trục, đơn vị, thời điểm",
                "Người đọc nghi ngờ số liệu bị \"làm đẹp\"",
                "Ghi rõ đơn vị, kỳ, nguồn, \"tính đến tháng/năm\""
              ]
            },
            {
              "cells": [
                "Dự phóng tài chính không có giả định",
                "Không ai kiểm chứng được",
                "Nêu 3 giả định then chốt trên cùng slide"
              ]
            },
            {
              "cells": [
                "Không nói rõ số tiền gọi",
                "Nhà đầu tư không biết mình có phù hợp không",
                "Ghi số tiền, vòng, số tháng runway, cột mốc sẽ đạt"
              ]
            },
            {
              "cells": [
                "Một deck cho mọi mục đích",
                "Deck để thuyết trình và deck gửi đọc cần khác nhau",
                "Làm 2 bản: bản thuyết trình (ít chữ, nhiều hình) và bản gửi email (tự đọc hiểu được)"
              ]
            }
          ]
        },
        "notes": []
      },
      {
        "heading": "Bảng tự chấm điểm trước khi gửi nhà đầu tư",
        "paragraphs": [
          "Chấm mỗi tiêu chí 0 (chưa có), 1 (có nhưng mơ hồ), 2 (rõ, có số). Dưới 14/20: chưa nên gửi. Từ 14 đến 17: sửa các mục 0–1 điểm. Từ 18 đến 20: sẵn sàng."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": {
          "caption": "",
          "headers": [
            "Tiêu chí",
            "Câu hỏi kiểm tra"
          ],
          "rows": [
            {
              "cells": [
                "Mở đầu",
                "Người lạ đọc slide 1 có nói lại được công ty làm gì, cho ai không?"
              ]
            },
            {
              "cells": [
                "Vấn đề",
                "Có chân dung khách hàng cụ thể và con số đo nỗi đau?"
              ]
            },
            {
              "cells": [
                "Giải pháp",
                "Có so sánh trước/sau bằng số?"
              ]
            },
            {
              "cells": [
                "Thị trường",
                "Có phép tính từ dưới lên, tách TAM/SAM/SOM?"
              ]
            },
            {
              "cells": [
                "Traction",
                "Có biểu đồ theo tháng và chỉ số giữ chân (hoặc LOI, thí điểm trả tiền)?"
              ]
            },
            {
              "cells": [
                "Mô hình kinh doanh",
                "Có kinh tế đơn vị: CAC, doanh thu/khách, thời gian hoàn vốn?"
              ]
            },
            {
              "cells": [
                "Cạnh tranh",
                "Có nhắc đối thủ thật và một lợi thế khó sao chép?"
              ]
            },
            {
              "cells": [
                "Đội ngũ",
                "Mỗi founder có một dòng thành tích liên quan trực tiếp?"
              ]
            },
            {
              "cells": [
                "Tài chính & gọi vốn",
                "Có số tiền, runway, cột mốc và giả định dự phóng?"
              ]
            },
            {
              "cells": [
                "Tổng thể",
                "Đọc riêng các tiêu đề có kể được câu chuyện; số liệu có nhất quán giữa các slide?"
              ]
            }
          ]
        },
        "notes": [
          "Cách dùng hiệu quả nhất: nhờ một người ngoài ngành đọc deck trong 3 phút rồi chấm bảng này — không phải founder tự chấm."
        ]
      }
    ],
    "relatedTools": [
      {
        "slug": "pitch-deck-10-slide",
        "label": "Kiểm tra pitch deck 10 slide"
      },
      {
        "slug": "quy-mo-thi-truong",
        "label": "Tính quy mô thị trường"
      },
      {
        "slug": "diem-san-sang-goi-von",
        "label": "Điểm sẵn sàng gọi vốn"
      }
    ],
    "sources": [
      {
        "label": "DocSend Startup Index – Pitch Deck Metrics",
        "url": "https://www.docsend.com/pitch-deck-metrics/"
      },
      {
        "label": "DocSend – What VCs really want to see inside your seed deck",
        "url": "https://www.docsend.com/blog/what-vcs-really-want-to-see-inside-your-seed-deck/"
      },
      {
        "label": "Sequoia Capital – Writing a Business Plan",
        "url": "https://www.sequoiacap.com/article/writing-a-business-plan/"
      },
      {
        "label": "Y Combinator – How to build your seed round pitch deck",
        "url": "https://www.ycombinator.com/library/2u-how-to-build-your-seed-round-pitch-deck"
      }
    ],
    "seoTitle": "Pitch deck tốt và chưa tốt: so sánh từng slide, kèm ví dụ",
    "seoDescription": "So sánh bản chưa tốt và bản tốt cho 10 slide cốt lõi của pitch deck gọi vốn: vấn đề, thị trường, traction, mô hình kinh doanh, đội ngũ, gọi vốn. Kèm 10 lỗi hay gặp và bảng tự chấm 20 điểm.",
    "publishedAt": "2026-09-22",
    "updatedAt": "2026-09-22",
    "track": "cam-nang",
    "readingMinutes": 11
  },
  {
    "slug": "quy-nhin-gi-trong-5-phut-dau-pitch-deck",
    "title": "Quỹ nhìn gì trong 5 phút đầu của pitch deck?",
    "excerpt": "Bối cảnh, vấn đề, bằng chứng và “ask” phải giúp investor định vị startup trước khi đi vào chi tiết.",
    "category": "Góc nhìn quỹ",
    "stages": [
      "Pre-seed",
      "Seed"
    ],
    "storyType": "huong-dan",
    "templates": [],
    "consentConfirmed": false,
    "coverImage": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Fquy-nhin-gi-trong-5-phut-dau-pitch-deck%2F1790080565127-cover.webp?alt=media&token=f77339f9-1318-419e-aeaa-e511f822c108",
    "coverAlt": "Quỹ nhìn gì trong 5 phút đầu của pitch deck?",
    "coverCaption": "",
    "ogImage": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Fquy-nhin-gi-trong-5-phut-dau-pitch-deck%2F1790080565403-cover.jpg?alt=media&token=4991151c-8354-49a4-94b5-bb69fc9c9c65",
    "author": "Fundraising Vietnam",
    "authorRole": "",
    "status": "PUBLISHED",
    "featured": false,
    "sections": [
      {
        "heading": "Vài phút quyết định cách đọc phần còn lại",
        "paragraphs": [
          "Theo số liệu DocSend công bố, nhà đầu tư thường chỉ dành khoảng hai đến ba phút cho một pitch deck được gửi qua đường link. Trong buổi pitch trực tiếp, thời gian dài hơn, nhưng cơ chế tương tự: sau vài phút đầu, người nghe đã hình thành một giả thuyết về công ty, và phần còn lại của deck chỉ còn nhiệm vụ xác nhận hoặc bác bỏ giả thuyết đó.",
          "Vì vậy năm phút đầu không phải là phần “khởi động”. Đó là lúc investor quyết định đọc tiếp với sự tò mò hay với sự hoài nghi."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Investor cần định vị nhanh năm điều",
        "paragraphs": [
          "Trong những phút đầu, người nghe cần trả lời được năm câu hỏi. Nếu năm thông tin này nằm rải rác, phần còn lại của deck phải làm việc vất vả hơn."
        ],
        "bullets": [
          "Công ty làm gì, cho ai — gói gọn trong một câu.",
          "Vấn đề có đủ đau và đủ phổ biến để khách hàng trả tiền không.",
          "Vì sao giải pháp này, và vì sao là bây giờ.",
          "Đã có bằng chứng gì: khách trả tiền, người dùng quay lại, thí điểm, thư cam kết.",
          "Đang gọi bao nhiêu vốn, và số vốn đó đưa công ty tới cột mốc nào."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Một trật tự dễ theo dõi",
        "paragraphs": [
          "Không có trật tự duy nhất đúng, nhưng trật tự dưới đây đi theo đúng thứ tự câu hỏi trong đầu người nghe, nên ít khi làm họ lạc."
        ],
        "bullets": [
          "Slide mở đầu: tên công ty kèm một câu mô tả theo khung “Chúng tôi giúp [ai] làm [việc gì] bằng [cách nào]”.",
          "Vấn đề: nỗi đau cụ thể, có con số, và cách khách hàng đang tự xử lý hiện nay.",
          "Giải pháp: sản phẩm làm gì khác đi và vì sao khách hàng đổi sang.",
          "Traction: bằng chứng tốt nhất bạn có, ghi rõ mốc thời gian.",
          "Ask: số vốn cần gọi và cột mốc sẽ đạt. Nhiều quỹ muốn biết con số này sớm để biết vòng của bạn có nằm trong khẩu vị đầu tư của họ không."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Tiêu đề slide nên mang kết luận",
        "paragraphs": [
          "Mỗi slide nên trả lời một câu hỏi, và tiêu đề slide nên là câu trả lời, không chỉ là tên chủ đề. Nhà đầu tư lướt nhanh thường chỉ đọc tiêu đề; nếu tiêu đề là kết luận, họ vẫn nắm được câu chuyện."
        ],
        "bullets": [
          "“Thị trường” → “Nhà bán lẻ vừa và nhỏ mất khoảng 10% doanh thu vì hết hàng mà không biết”.",
          "“Traction” → “60 khách trả tiền sau 6 tháng, chưa chi đồng quảng cáo nào”.",
          "“Đội ngũ” → “Hai founder từng vận hành chuỗi 40 cửa hàng”."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Traction ở giai đoạn sớm trông như thế nào",
        "paragraphs": [
          "Startup pre-seed chưa có doanh thu vẫn có thể có bằng chứng. Điều quan trọng là nói rõ đó là loại bằng chứng gì và đo trong khoảng thời gian nào."
        ],
        "bullets": [
          "Khách hàng thí điểm đang dùng thật, kèm tần suất sử dụng.",
          "Thư cam kết hoặc hợp đồng nguyên tắc có điều kiện rõ ràng.",
          "Danh sách chờ kèm tỷ lệ chuyển thành người dùng, không chỉ số đăng ký.",
          "Tỷ lệ người dùng bản thử nghiệm quay lại sau 4 tuần.",
          "Số cuộc phỏng vấn khách hàng và điều bạn đã thay đổi sau khi nghe họ."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Sai lầm thường gặp",
        "paragraphs": [
          "Founder dành quá nhiều thời gian cho lịch sử ngành, tính năng hoặc TAM trước khi người nghe hiểu công ty đang làm gì. Đến lúc câu chuyện chính bắt đầu, sự chú ý đã giảm đi một nửa."
        ],
        "bullets": [
          "Mở đầu bằng quy mô thị trường hàng tỷ đô trước khi nói mình bán gì.",
          "Slide liệt kê tính năng thay vì kết quả khách hàng nhận được.",
          "Số liệu không có mốc thời gian, hoặc trộn người dùng miễn phí với khách trả tiền.",
          "Đặt logo đối tác chưa ký hợp đồng như khách hàng.",
          "Ask mơ hồ như “gọi vốn để mở rộng thị trường”, không có số tiền và cột mốc.",
          "Slide dày chữ, phải có người thuyết minh mới hiểu."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Tự kiểm tra trước khi gửi",
        "paragraphs": [
          "Đưa deck cho một người ngoài ngành đọc trong hai phút, sau đó hỏi họ năm câu ở phần đầu bài. Câu nào họ không trả lời được là chỗ deck của bạn cần sửa trước khi đến tay nhà đầu tư."
        ],
        "bullets": [
          "Đọc riêng các tiêu đề slide có hiểu được câu chuyện không?",
          "Con số traction có ghi mốc thời gian và định nghĩa rõ ràng không?",
          "Số vốn gọi có khớp với slide sử dụng vốn và cột mốc không?",
          "Deck mở tốt trên điện thoại không, vì nhiều nhà đầu tư đọc deck trên điện thoại?"
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      }
    ],
    "relatedTools": [
      {
        "slug": "pitch-deck-10-slide",
        "label": "Kiểm tra pitch deck 10 slide"
      },
      {
        "slug": "diem-san-sang-goi-von",
        "label": "Điểm sẵn sàng gọi vốn"
      }
    ],
    "sources": [
      {
        "label": "DocSend — Pitch deck metrics (thời gian nhà đầu tư xem deck)",
        "url": "https://www.docsend.com/pitch-deck-metrics/"
      },
      {
        "label": "TechCrunch — VCs spend an average of 3 minutes, 44 seconds on a pitch deck (2015)",
        "url": "https://techcrunch.com/?p=1167693"
      },
      {
        "label": "Y Combinator — How to build your seed round pitch deck",
        "url": "https://www.ycombinator.com/library/2u-how-to-build-your-seed-round-pitch-deck"
      }
    ],
    "seoTitle": "Quỹ nhìn gì trong 5 phút đầu của pitch deck? Trật tự slide và sai lầm cần tránh",
    "seoDescription": "Nhà đầu tư chỉ dành vài phút cho một pitch deck. Năm câu hỏi họ cần trả lời được, trật tự slide dễ theo dõi, cách viết tiêu đề slide và checklist trước khi gửi.",
    "publishedAt": "2026-09-16",
    "updatedAt": "2026-09-22",
    "track": "kinh-nghiem",
    "readingMinutes": 4
  },
  {
    "slug": "quy-tiep-nhan-ho-so-den-giai-ngan",
    "title": "Từ nộp hồ sơ đến tiền về tài khoản: quỹ mất bao lâu, và đang làm gì trong lúc bạn chờ",
    "excerpt": "Bản đồ đầy đủ tám bước của một quỹ đầu tư, kèm khoảng thời gian điển hình cho từng bước, thủ tục pháp lý phải làm tại Việt Nam trước khi giải ngân, và cách đọc sự im lặng của quỹ.",
    "category": "Góc nhìn quỹ",
    "stages": [
      "Pre-seed",
      "Seed"
    ],
    "storyType": "huong-dan",
    "templates": [
      "bo-ho-so-tham-dinh-data-room",
      "theo-doi-tiep-can-nha-dau-tu"
    ],
    "consentConfirmed": false,
    "coverImage": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Fquy-tiep-nhan-ho-so-den-giai-ngan%2F1790164888117-cover.webp?alt=media&token=af46b4ef-890d-4f69-9522-574b7ad1686d",
    "coverAlt": "Biểu đồ các bước và số tuần từ lúc nộp hồ sơ tới khi quỹ giải ngân",
    "coverCaption": "Kịch bản điển hình: khoảng 25 tuần từ lúc gửi hồ sơ đến khi tiền về tài khoản.",
    "ogImage": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Fquy-tiep-nhan-ho-so-den-giai-ngan%2F1790164894535-cover.jpg?alt=media&token=6cbaa290-cb15-47a8-96ca-c81ac0c22d6e",
    "author": "Fundraising Vietnam",
    "authorRole": "",
    "status": "PUBLISHED",
    "featured": false,
    "sections": [
      {
        "heading": "Vì sao founder sốt ruột",
        "paragraphs": [
          "Founder đếm thời gian bằng runway: mỗi tuần trôi qua là một tuần tiền trong tài khoản ít đi. Quỹ đếm thời gian bằng lịch họp: cuộc họp pipeline hàng tuần, cuộc họp hội đồng đầu tư mỗi tháng hoặc mỗi quý. Hai cách đếm này không khớp nhau, và phần lớn cảm giác «quỹ bỏ rơi mình» sinh ra từ đó chứ không phải từ việc quỹ mất hứng thú.",
          "Con số để bạn hiệu chỉnh kỳ vọng: một vòng gọi vốn thường mất 6–8 tháng tính từ buổi pitch đầu tiên đến lúc đóng vòng. Riêng đoạn từ lúc ký term sheet đến lúc tiền về, khoảng 30 ngày đã là kịch bản đẹp nhất — và đó là ở thị trường Mỹ, nơi không có thủ tục đăng ký góp vốn cho nhà đầu tư nước ngoài như Việt Nam.",
          "Bài này mô tả chuyện gì đang diễn ra bên trong quỹ ở từng bước, mất bao lâu, bạn cần chuẩn bị gì, và lúc nào thì im lặng nên được hiểu là lời từ chối."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Bản đồ tám bước",
        "paragraphs": [
          "Quỹ Đầu tư mạo hiểm TP.HCM (HCM VIF) công bố quy trình tiếp nhận gồm tám bước, và ghi rõ rằng vì quỹ chưa vận hành nên chưa cam kết thời gian cụ thể cho từng bước. Cấu trúc tám bước này giống với cách phần lớn quỹ tư nhân làm việc, nên dùng được làm khung chung.",
          "Cột thời gian dưới đây là khoảng điển hình tổng hợp từ thực tiễn quốc tế, không phải cam kết của bất kỳ quỹ nào. Hãy hỏi thẳng quỹ bạn đang làm việc cùng về lịch của họ."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": {
          "caption": "Tám bước từ lúc gửi hồ sơ đến lúc giải ngân",
          "headers": [
            "Bước",
            "Ai chủ động",
            "Kết quả cần đạt",
            "Khoảng thời gian điển hình"
          ],
          "rows": [
            {
              "cells": [
                "1. Tiếp nhận hồ sơ",
                "Hệ thống của quỹ",
                "Hồ sơ được ghi nhận, có mã theo dõi",
                "Ngay khi gửi"
              ]
            },
            {
              "cells": [
                "2. Sàng lọc ban đầu",
                "Quỹ",
                "Hồ sơ có hợp lĩnh vực, giai đoạn, quy mô séc không",
                "1–3 tuần"
              ]
            },
            {
              "cells": [
                "3. Trao đổi đầu tiên",
                "Hai bên",
                "Quỹ hiểu bài toán; bạn hiểu khẩu vị của quỹ",
                "1–4 tuần cho 2–4 buổi"
              ]
            },
            {
              "cells": [
                "4. Thẩm định công nghệ / sản phẩm",
                "Quỹ",
                "Kiểm chứng chiều sâu công nghệ và năng lực triển khai",
                "2–6 tuần, chạy song song bước 5"
              ]
            },
            {
              "cells": [
                "5. Thẩm định tài chính và pháp lý",
                "Quỹ và luật sư",
                "Rà pháp nhân, sổ sách, hợp đồng, sở hữu trí tuệ",
                "3–7 tuần"
              ]
            },
            {
              "cells": [
                "6. Đàm phán điều khoản",
                "Hai bên",
                "Term sheet: định giá, tỷ lệ, quyền của nhà đầu tư",
                "1 ngày đến vài tuần"
              ]
            },
            {
              "cells": [
                "7. Phê duyệt đầu tư",
                "Hội đồng đầu tư của quỹ",
                "Quyết định chính thức",
                "Theo lịch họp: 2–8 tuần"
              ]
            },
            {
              "cells": [
                "8. Ký kết và giải ngân",
                "Hai bên",
                "Hợp đồng, thủ tục pháp lý, tiền vào tài khoản",
                "3–10 tuần tại Việt Nam"
              ]
            }
          ]
        },
        "notes": [
          "Thứ tự trên là lý thuyết. Thực tế các bước gối lên nhau: quỹ vẫn thẩm định trong lúc đàm phán, và luật sư soạn hợp đồng song song với thẩm định."
        ]
      },
      {
        "heading": "Bước 1–2: hồ sơ của bạn nằm ở đâu trong tuần đầu",
        "paragraphs": [
          "Hồ sơ gửi qua form hoặc email rơi vào pipeline của quỹ. Người đọc đầu tiên thường là analyst hoặc associate, không phải partner. Họ đọc rất nhanh — phần lớn hồ sơ bị loại trong vài phút vì những lý do cơ học: sai giai đoạn, sai ngành, sai địa bàn, quy mô vốn cần gọi nằm ngoài khoảng séc của quỹ.",
          "Những hồ sơ qua được vòng này được đưa vào cuộc họp pipeline hàng tuần của quỹ. Đó là lý do phản hồi hiếm khi đến trong 24 giờ: hồ sơ của bạn đang chờ tới thứ Hai.",
          "Giới thiệu từ người quỹ đã tin (founder trong danh mục, luật sư, quỹ khác) rút ngắn bước này nhiều nhất — không phải vì quỹ thiên vị, mà vì nó thay thế phần kiểm chứng mà quỹ chưa có thời gian làm."
        ],
        "bullets": [
          "Việc của bạn ở bước này: gửi đúng nơi, đúng giai đoạn, kèm một câu tóm tắt đọc hết trong 5 giây.",
          "Không nên: gửi hàng loạt cho 50 quỹ cùng lúc bằng một email giống hệt nhau — quỹ nhận ra ngay, và các quỹ nói chuyện với nhau.",
          "Nên: ghi lại ngày gửi cho từng quỹ để biết khi nào đến lượt nhắc lại."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Bước 3: các buổi trao đổi, và ai ngồi trong phòng",
        "paragraphs": [
          "Từ buổi gặp đầu tiên đến quyết định, một quỹ thường tiếp xúc 3–6 lần và số người tham gia tăng dần: analyst → partner phụ trách ngành → cả nhóm đầu tư. Mỗi lần thêm người là một lần bạn phải kể lại câu chuyện, và câu chuyện phải khớp nhau qua các lần kể.",
          "Trong nội bộ, một partner sẽ nhận vai «người bảo vệ thương vụ» — người đứng ra thuyết phục hội đồng. Nếu sau vài buổi mà chưa ai nhận vai đó, hồ sơ sẽ trôi dần chứ hiếm khi bị từ chối dứt khoát. Đây là lúc nên hỏi thẳng: «Ai ở quỹ đang theo hồ sơ của tôi, và bước kế tiếp là gì?»",
          "HCM VIF gợi ý bốn câu hỏi founder nên trả lời được trước khi gửi hồ sơ: bạn giải quyết bài toán gì của thị trường, vì sao là đội ngũ này, ai sẽ trả tiền cho giải pháp, và bạn sẵn sàng minh bạch tới đâu. Câu cuối cùng quan trọng hơn vẻ ngoài của nó: nó quyết định bước thẩm định sẽ kéo dài hai tuần hay hai tháng."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Bước 4–5: thẩm định, và vì sao nó chậm",
        "paragraphs": [
          "Thẩm định (due diligence) là giai đoạn dài nhất mà founder ít kiểm soát nhất. Với vòng hạt giống, phần thẩm định cộng soạn hợp đồng thường mất 3–4 tuần nếu mọi thứ sẵn sàng, và 6–7 tuần trong lịch trình dài hơn. Với doanh nghiệp có yếu tố phần cứng, giấy phép ngành, hoặc danh mục sở hữu trí tuệ phức tạp, mốc này dài hơn nữa.",
          "Nguyên nhân chậm phổ biến nhất không nằm ở quỹ, mà ở chỗ founder bắt đầu đi tìm giấy tờ sau khi quỹ hỏi. Mỗi lần quỹ hỏi một tài liệu bạn chưa có, đồng hồ dừng lại cho đến khi bạn gửi — và mỗi vòng hỏi đáp qua email mất trung bình vài ngày.",
          "Cách rút ngắn duy nhất thật sự hiệu quả: chuẩn bị sẵn data room trước khi gửi hồ sơ."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": {
          "caption": "Tài liệu quỹ sẽ hỏi, và hỏi ở bước nào",
          "headers": [
            "Tài liệu",
            "Hỏi ở bước nào",
            "Mức chi tiết được kỳ vọng"
          ],
          "rows": [
            {
              "cells": [
                "Pitch deck 10–15 slide",
                "Lúc gửi hồ sơ",
                "Đủ để hiểu bài toán, giải pháp, đội ngũ, số vốn cần gọi"
              ]
            },
            {
              "cells": [
                "Tóm tắt một câu",
                "Lúc gửi hồ sơ",
                "Một dòng, không thuật ngữ"
              ]
            },
            {
              "cells": [
                "Số liệu traction",
                "Buổi trao đổi đầu",
                "Bản gốc từ hệ thống, không phải bảng tự gõ lại"
              ]
            },
            {
              "cells": [
                "Hồ sơ đội ngũ sáng lập",
                "Buổi trao đổi đầu",
                "Vai trò, thời gian toàn thời gian, tỷ lệ sở hữu"
              ]
            },
            {
              "cells": [
                "Bằng chứng công nghệ",
                "Thẩm định công nghệ",
                "Bản demo, kiến trúc hệ thống, bằng sáng chế nếu có"
              ]
            },
            {
              "cells": [
                "Mô hình tài chính",
                "Thẩm định tài chính",
                "File tính được, có giả định tách riêng, 18–36 tháng"
              ]
            },
            {
              "cells": [
                "Hồ sơ pháp nhân",
                "Thẩm định pháp lý",
                "ĐKKD, điều lệ, biên bản họp, hợp đồng lao động chủ chốt"
              ]
            },
            {
              "cells": [
                "Cap table",
                "Thẩm định và đàm phán",
                "Bảng cổ phần đầy đủ, kể cả ESOP, SAFE, khoản vay chuyển đổi"
              ]
            },
            {
              "cells": [
                "Kế hoạch sử dụng vốn",
                "Đàm phán",
                "Chia theo hạng mục và mốc thời gian, gắn với cột mốc"
              ]
            }
          ]
        },
        "notes": [
          "Danh sách tài liệu theo công bố của HCM VIF, bổ sung phần mức chi tiết theo thực tiễn thẩm định.",
          "Một cách kiểm tra nhanh mức sẵn sàng: nếu quỹ hỏi bất kỳ dòng nào ở trên mà bạn cần quá 48 giờ để gửi, bạn chưa sẵn sàng gọi vốn."
        ]
      },
      {
        "heading": "Bước 6: term sheet không phải là tiền",
        "paragraphs": [
          "Term sheet là bản ghi nhớ các điều khoản chính: định giá, số tiền, tỷ lệ sở hữu, quyền của nhà đầu tư. Nếu các điều khoản đã được bàn miệng từ trước, term sheet có thể chốt trong một hai ngày; nếu còn nhiều điểm tranh chấp, quá trình này kéo dài vài tuần.",
          "Điều founder hay hiểu nhầm: phần lớn nội dung term sheet không ràng buộc pháp lý. Hai điều khoản thường có ràng buộc là bảo mật và điều khoản độc quyền đàm phán (no-shop / exclusivity) — bạn cam kết không đi nói chuyện với quỹ khác trong 30–60 ngày. Ký term sheet với một quỹ chậm chạp có nghĩa là bạn tự khoá mình lại trong hai tháng.",
          "Trước khi ký, hãy hỏi đúng hai câu: điều khoản độc quyền kéo dài bao lâu, và còn những phê duyệt nội bộ nào chưa xong."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Bước 7: phê duyệt đầu tư chạy theo lịch, không theo nhu cầu của bạn",
        "paragraphs": [
          "Quyết định cuối cùng do hội đồng đầu tư đưa ra. Quỹ tư nhân nhỏ có thể họp hàng tuần; quỹ lớn họp hai tuần hoặc mỗi tháng một lần. Quỹ có vốn nhà nước hoặc vốn từ tổ chức thường có thêm lớp phê duyệt của cơ quan chủ quản, và lịch họp thưa hơn.",
          "Hệ quả thực tế: lỡ một cuộc họp có thể đẩy lịch của bạn đi ba đến sáu tuần, dù không ai phản đối thương vụ. Vì vậy câu hỏi «hội đồng đầu tư của anh chị họp vào ngày nào» có giá trị hơn câu «khi nào có kết quả».",
          "Tháng 12 và tháng Tết là hai quãng chết của lịch phê duyệt tại Việt Nam. Nếu hồ sơ rơi vào đó, hãy cộng thêm 3–4 tuần vào kế hoạch."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Bước 8: những việc phải làm trước khi tiền được phép chuyển",
        "paragraphs": [
          "Đây là phần bị bỏ sót nhiều nhất trong các bài viết nước ngoài, và cũng là phần khiến vòng vốn tại Việt Nam dài hơn. Sau khi ký hợp đồng, còn một chuỗi thủ tục hành chính và ngân hàng phải hoàn tất thì tiền mới được phép về.",
          "Với nhà đầu tư nước ngoài, tùy trường hợp mà phải đăng ký góp vốn, mua cổ phần tại cơ quan đăng ký đầu tư trước khi chuyển tiền. Ba nhóm trường hợp bắt buộc: doanh nghiệp hoạt động trong ngành nghề tiếp cận thị trường có điều kiện; giao dịch làm tỷ lệ sở hữu nước ngoài vượt quá 50% vốn điều lệ; doanh nghiệp có quyền sử dụng đất tại khu vực nhạy cảm về quốc phòng, an ninh."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": {
          "caption": "Chuỗi thủ tục sau khi ký, tại Việt Nam",
          "headers": [
            "Việc phải làm",
            "Ai làm",
            "Thời hạn",
            "Lưu ý"
          ],
          "rows": [
            {
              "cells": [
                "Đăng ký góp vốn, mua cổ phần (nếu thuộc diện bắt buộc)",
                "Doanh nghiệp nộp cho cơ quan đăng ký đầu tư nơi đặt trụ sở",
                "10 ngày làm việc kể từ ngày nhận hồ sơ hợp lệ, theo hướng dẫn hiện hành",
                "Tuyệt đối không chuyển tiền trước khi có văn bản chấp thuận"
              ]
            },
            {
              "cells": [
                "Mở tài khoản vốn tại ngân hàng",
                "Doanh nghiệp",
                "Vài ngày làm việc",
                "Tài khoản vốn đầu tư trực tiếp hoặc gián tiếp tùy cấu trúc thương vụ"
              ]
            },
            {
              "cells": [
                "Nhà đầu tư chuyển tiền",
                "Nhà đầu tư nước ngoài",
                "Theo hợp đồng",
                "Tiền phải đi qua đúng tài khoản vốn, không chuyển vào tài khoản thanh toán thường"
              ]
            },
            {
              "cells": [
                "Thay đổi đăng ký doanh nghiệp, cập nhật sổ cổ đông",
                "Doanh nghiệp",
                "Trong vòng 10 ngày làm việc sau khi hoàn tất giao dịch",
                "Chậm khâu này gây rắc rối cho chính vòng gọi vốn sau"
              ]
            },
            {
              "cells": [
                "Hoàn tất điều kiện tiên quyết trong hợp đồng",
                "Doanh nghiệp và sáng lập",
                "Trước hoặc cùng lúc giải ngân",
                "Ví dụ: ký lại hợp đồng lao động, chuyển sở hữu trí tuệ về công ty, lập ESOP"
              ]
            }
          ]
        },
        "notes": [
          "Quy định về thời hạn và hồ sơ thay đổi theo văn bản hướng dẫn từng thời kỳ. Hãy xác nhận lại với cơ quan đăng ký đầu tư nơi doanh nghiệp đặt trụ sở, hoặc với luật sư của vòng gọi vốn, trước khi ấn định ngày giải ngân trong hợp đồng.",
          "Chuyển tiền trước khi có chấp thuận là lỗi bị vi phạm nhiều nhất và xử lý rất mất thời gian. Đừng để áp lực runway đẩy bạn vào lỗi này."
        ]
      },
      {
        "heading": "Giải ngân một lần hay nhiều đợt",
        "paragraphs": [
          "Không phải vòng nào tiền cũng về một lần. Quỹ thường chia thành các đợt gắn với cột mốc: đợt đầu khi hoàn tất thủ tục, các đợt sau khi đạt chỉ tiêu doanh thu, ra mắt sản phẩm, hoặc tuyển đủ nhân sự chủ chốt.",
          "Chia đợt không phải dấu hiệu quỹ không tin bạn — nó là cách quỹ quản trị rủi ro và cũng là cách bạn giữ định giá cho vòng sau. Nhưng nó thay đổi hoàn toàn cách bạn tính runway: runway của bạn chỉ được tính trên số tiền đã về, cộng với cam kết mà bạn chắc chắn đạt điều kiện.",
          "Hãy đưa cột mốc giải ngân vào bảng runway của mình, và đặt cảnh báo sớm 60 ngày cho mỗi đợt."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Ba kịch bản thời gian, tính từ ngày gửi hồ sơ",
        "paragraphs": [
          "Bảng dưới đây cộng dồn các khoảng ở trên thành ba kịch bản. Dùng nó để đặt lịch lùi, không dùng để đòi hỏi quỹ."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": {
          "caption": "Số tuần cho mỗi giai đoạn theo ba kịch bản",
          "headers": [
            "Giai đoạn",
            "Nhanh",
            "Điển hình",
            "Chậm"
          ],
          "rows": [
            {
              "cells": [
                "Sàng lọc và phản hồi đầu tiên",
                "1 tuần",
                "3 tuần",
                "6 tuần hoặc im lặng"
              ]
            },
            {
              "cells": [
                "Các buổi trao đổi",
                "2 tuần",
                "4 tuần",
                "8 tuần"
              ]
            },
            {
              "cells": [
                "Đàm phán term sheet",
                "1 tuần",
                "2 tuần",
                "4 tuần"
              ]
            },
            {
              "cells": [
                "Thẩm định công nghệ, tài chính, pháp lý",
                "3 tuần",
                "6 tuần",
                "12 tuần"
              ]
            },
            {
              "cells": [
                "Phê duyệt của hội đồng đầu tư",
                "1 tuần",
                "4 tuần",
                "8 tuần"
              ]
            },
            {
              "cells": [
                "Ký kết và thủ tục pháp lý",
                "3 tuần",
                "6 tuần",
                "10 tuần"
              ]
            },
            {
              "cells": [
                "Tổng cộng",
                "11 tuần (khoảng 3 tháng)",
                "25 tuần (khoảng 6 tháng)",
                "48 tuần (khoảng 11 tháng)"
              ]
            }
          ]
        },
        "notes": [
          "Cột «điển hình» khớp với quan sát chung rằng một vòng gọi vốn mất 6–8 tháng từ buổi pitch đầu tiên đến khi đóng vòng.",
          "Kịch bản «nhanh» hầu như chỉ xảy ra khi có giới thiệu mạnh, data room sẵn sàng, và cấu trúc đơn giản như SAFE hoặc trái phiếu chuyển đổi."
        ]
      },
      {
        "heading": "Lịch lùi từ runway của bạn",
        "paragraphs": [
          "Hãy làm ngược lại: lấy ngày tiền cần về, trừ đi thời gian của kịch bản điển hình, ra ngày bạn phải bắt đầu.",
          "Khuyến nghị phổ biến ở thị trường Mỹ là bắt đầu khi còn 10 tháng runway: 8 tháng cho quy trình, 2 tháng dự phòng. Với vòng có nhà đầu tư nước ngoài tại Việt Nam, cộng thêm thời gian cho chuỗi thủ tục sau khi ký — nghĩa là nên bắt đầu khi còn khoảng 12 tháng.",
          "Nếu bạn còn dưới 6 tháng runway, quy trình quỹ truyền thống hiếm khi kịp. Lúc đó các lựa chọn thực tế hơn là vòng cầu từ nhà đầu tư hiện hữu, SAFE với nhà đầu tư thiên thần, doanh thu, hoặc cắt chi phí để kéo dài runway trước khi gọi vốn."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Vì sao chậm, và phần nào bạn xử lý được",
        "paragraphs": [],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": {
          "caption": "Nguyên nhân chậm thường gặp",
          "headers": [
            "Nguyên nhân",
            "Dấu hiệu bạn nhận ra",
            "Cách rút ngắn"
          ],
          "rows": [
            {
              "cells": [
                "Chưa ai ở quỹ nhận bảo vệ thương vụ",
                "Trao đổi lịch sự nhưng không có bước kế tiếp cụ thể",
                "Hỏi thẳng ai đang theo hồ sơ và mốc tiếp theo là gì"
              ]
            },
            {
              "cells": [
                "Data room chưa sẵn",
                "Mỗi câu hỏi của quỹ mất vài ngày mới trả lời được",
                "Chuẩn bị đủ 9 nhóm tài liệu trước khi gửi hồ sơ"
              ]
            },
            {
              "cells": [
                "Cap table rối",
                "Quỹ hỏi đi hỏi lại về các khoản SAFE, khoản vay, cam kết miệng",
                "Dựng lại cap table đầy đủ, ghi rõ mọi cam kết đã hứa"
              ]
            },
            {
              "cells": [
                "Pháp nhân chưa gọn",
                "Sở hữu trí tuệ đứng tên cá nhân, thiếu biên bản họp",
                "Chuyển sở hữu trí tuệ về công ty, hoàn thiện hồ sơ nội bộ trước"
              ]
            },
            {
              "cells": [
                "Lịch hội đồng đầu tư",
                "Mọi thứ xong nhưng vẫn chờ",
                "Hỏi lịch họp từ sớm và nộp tài liệu trước hạn chốt"
              ]
            },
            {
              "cells": [
                "Nhiều nhà đầu tư trong một vòng",
                "Thời gian kéo dài khi thêm mỗi bên mới",
                "Chốt nhà đầu tư dẫn dắt trước, các bên còn lại theo điều khoản đã có"
              ]
            },
            {
              "cells": [
                "Thủ tục sau khi ký",
                "Hợp đồng đã ký mà tiền chưa về",
                "Khởi động hồ sơ đăng ký và mở tài khoản vốn ngay khi ký, không chờ"
              ]
            }
          ]
        },
        "notes": []
      },
      {
        "heading": "Đọc sự im lặng",
        "paragraphs": [
          "Quỹ nói «không» rất nhanh và nói «có» rất chậm. Nhưng nhiều quỹ ngại nói «không» thẳng, nên im lặng trở thành câu trả lời. Bảng dưới đây là cách quy đổi im lặng thành hành động, để bạn không treo hy vọng vào một hồ sơ đã chết."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": {
          "caption": "Im lặng bao lâu thì nên hiểu là gì",
          "headers": [
            "Tình huống",
            "Sau bao lâu",
            "Việc nên làm"
          ],
          "rows": [
            {
              "cells": [
                "Gửi hồ sơ, chưa có hồi âm",
                "2 tuần",
                "Nhắc lại một lần, kèm một cập nhật mới có giá trị"
              ]
            },
            {
              "cells": [
                "Gửi hồ sơ, đã nhắc một lần",
                "4 tuần",
                "Coi như không phù hợp lúc này, chuyển năng lượng sang quỹ khác"
              ]
            },
            {
              "cells": [
                "Đã gặp một buổi, chưa có bước kế tiếp",
                "2 tuần",
                "Hỏi thẳng: hồ sơ đang ở bước nào, cần gì để đi tiếp"
              ]
            },
            {
              "cells": [
                "Đang thẩm định, quỹ ngừng hỏi",
                "2 tuần",
                "Gửi cập nhật tiến độ kinh doanh và hỏi còn vướng điểm nào"
              ]
            },
            {
              "cells": [
                "Đã ký term sheet, quỹ chậm",
                "Quá mốc trong term sheet",
                "Yêu cầu lịch cụ thể; nhắc điều khoản độc quyền đang chặn bạn"
              ]
            }
          ]
        },
        "notes": [
          "Cập nhật định kỳ hàng tháng cho các quỹ đã gặp là cách rẻ nhất để giữ cửa mở: ngắn, có số liệu, không xin gì cả. Nhiều vòng vốn được chốt ở lần cập nhật thứ tư chứ không phải ở buổi pitch đầu.",
          "Đừng giữ lịch nhắc lại trong đầu. Mẫu «Bảng theo dõi tiếp cận nhà đầu tư» ở cuối bài tự tính ngày cần liên hệ lại cho từng quỹ theo nhịp bạn đặt, đánh dấu quỹ quá hạn, và cho biết tỷ lệ đi từ gửi hồ sơ tới gặp mặt của bạn đang là bao nhiêu."
        ]
      },
      {
        "heading": "Việc cần làm trước khi gửi hồ sơ đầu tiên",
        "paragraphs": [
          "Mẫu Excel đi kèm bài này — «Bộ hồ sơ thẩm định (data room)» — đã có sẵn 52 tài liệu theo tám nhóm, kèm cột trạng thái và sheet tiến độ. Tải ở cuối bài rồi điền dần, đừng đợi tới lúc quỹ hỏi."
        ],
        "bullets": [
          "Dựng data room đủ 9 nhóm tài liệu, mỗi tài liệu mở được trong 1 phút.",
          "Kiểm tra cap table khớp với mọi cam kết đã hứa bằng miệng.",
          "Tính runway theo tiền thực có, và đặt ngày bắt đầu gọi vốn lùi 12 tháng trước ngày hết tiền.",
          "Chuẩn bị câu trả lời cho bốn câu hỏi sàng lọc: bài toán, đội ngũ, người trả tiền, mức sẵn sàng minh bạch.",
          "Lập bảng theo dõi từng quỹ: ngày gửi, người liên hệ, bước hiện tại, ngày nhắc lại tiếp theo.",
          "Hỏi mỗi quỹ ngay buổi đầu: quy trình của anh chị gồm mấy bước, hội đồng đầu tư họp khi nào."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      }
    ],
    "relatedTools": [
      {
        "slug": "tinh-runway",
        "label": "Tính runway trước khi bắt đầu gọi vốn"
      },
      {
        "slug": "diem-san-sang-goi-von",
        "label": "Rà mức sẵn sàng gọi vốn"
      },
      {
        "slug": "ho-so-phap-ly-khoi-nghiep",
        "label": "Soát hồ sơ pháp lý"
      },
      {
        "slug": "quy-phu-hop",
        "label": "Tìm quỹ phù hợp"
      }
    ],
    "sources": [
      {
        "label": "HCM VIF — Dành cho startup: quy trình tiếp nhận và tài liệu cần chuẩn bị",
        "url": "https://hcmc.vc/danh-cho-startup"
      },
      {
        "label": "Gunderson Dettmer — Venture Financing Process: Timeline",
        "url": "https://catalyze.gunder.com/en/knowledge-articles/resource/gc-primer-venture-financing-process-part-vii-timeline"
      },
      {
        "label": "The Venture Alley — How Long Should it Take to Close my Venture Financing?",
        "url": "https://www.theventurealley.com/2019/09/venture-financing-timeline/"
      },
      {
        "label": "Angel Investors Network — How Long Does a Funding Round Take",
        "url": "https://angelinvestorsnetwork.com/capital-raising/how-long-does-a-funding-round-take-6-8-months-is-reality"
      },
      {
        "label": "Thư viện pháp luật — Thủ tục đầu tư hình thức góp vốn, mua cổ phần đối với nhà đầu tư nước ngoài",
        "url": "https://thuvienphapluat.vn/chinh-sach-phap-luat-moi/vn/ho-tro-phap-luat/chinh-sach-moi/110061/thu-tuc-dau-tu-hinh-thuc-gop-von-mua-co-phan-doi-voi-nha-dau-tu-nuoc-ngoai-theo-nghi-dinh-96-2026"
      }
    ],
    "seoTitle": "Quy trình và thời gian của quỹ: từ nhận hồ sơ đến giải ngân",
    "seoDescription": "Tám bước của một quỹ đầu tư, thời gian điển hình mỗi bước, thủ tục pháp lý tại Việt Nam trước khi giải ngân, và cách founder theo dõi tiến độ mà không sốt ruột.",
    "publishedAt": "2026-09-23",
    "updatedAt": "2026-09-23",
    "track": "kinh-nghiem",
    "readingMinutes": 14
  },
  {
    "slug": "slide-thoai-von-tinh-loi-nhuan-nha-dau-tu",
    "title": "Slide thoái vốn trong pitch deck: tính lợi nhuận cho nhà đầu tư sao cho các con số không tự mâu thuẫn",
    "excerpt": "Trong các deck chúng tôi nhận xét, slide thoái vốn là nơi sai số nhiều nhất: tỷ lệ sở hữu không khớp vòng gọi vốn, lợi nhuận không khớp định giá, ROI không khớp số tiền đầu tư. Nhà đầu tư luôn tự tính lại, và một phép tính sai làm mất niềm tin vào cả mô hình tài chính. Bài này hướng dẫn bốn bước tính đúng, cách chọn định giá thoái vốn có cơ sở, ba kịch bản n",
    "category": "Hồ sơ & pitch deck",
    "stages": [
      "Seed",
      "Series A"
    ],
    "storyType": "huong-dan",
    "templates": [],
    "consentConfirmed": false,
    "coverImage": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Fslide-thoai-von-tinh-loi-nhuan-nha-dau-tu%2F1791381642987-cover.webp?alt=media&token=3229411c-2db1-4003-b1ad-3830930252c7",
    "coverAlt": "Bốn bước tính lợi nhuận nhà đầu tư trên slide thoái vốn, từ tỷ lệ sau vòng tới ROI và IRR",
    "coverCaption": "Nhà đầu tư luôn tự tính lại slide thoái vốn. Bốn phép tính đơn giản giúp các con số của bạn khớp nhau.",
    "ogImage": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Fslide-thoai-von-tinh-loi-nhuan-nha-dau-tu%2F1791381645899-cover.jpg?alt=media&token=a531252f-738a-4f7c-85c3-7d7767f29773",
    "author": "Fundraising Vietnam",
    "authorRole": "",
    "status": "PUBLISHED",
    "featured": false,
    "sections": [
      {
        "heading": "Slide sai số nhiều nhất trong pitch deck",
        "paragraphs": [
          "Slide thoái vốn thường được làm sau cùng, vội vàng, với mong muốn đưa ra một con số lợi nhuận thật ấn tượng cho nhà đầu tư. Kết quả là nhiều con số trên slide không khớp với nhau, hoặc không khớp với slide gọi vốn ngay trước đó.",
          "Đây là một tình huống minh họa, tổng hợp từ các lỗi chúng tôi hay gặp khi nhận xét deck (số đã được thay đổi). Startup gọi 1,5 triệu USD với định giá trước vòng 4,5 triệu USD. Slide thoái vốn ghi: định giá thoái vốn 100 triệu USD, nhà đầu tư sở hữu 12%, lợi nhuận 10 triệu USD, ROI 7 lần."
        ],
        "bullets": [
          "Gọi 1,5 triệu ở định giá trước vòng 4,5 triệu nghĩa là định giá sau vòng 6 triệu, nhà đầu tư nhận 25%. Slide thoái vốn lại ghi 12% mà không giải thích phần chênh lệch đi đâu.",
          "12% của 100 triệu là 12 triệu, không phải 10 triệu như slide ghi.",
          "10 triệu chia 1,5 triệu là khoảng 6,7 lần, không phải 7 lần."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": [
          "Mỗi lỗi riêng lẻ đều nhỏ. Nhưng nhà đầu tư đọc slide này với máy tính trong tay, và ba con số không khớp khiến họ nghi ngờ luôn mô hình tài chính phía trước. Công cụ nhận xét deck của fundraising.vn tự kiểm các phép tính này bằng code trước khi nhận xét."
        ]
      },
      {
        "heading": "Bốn bước tính lợi nhuận cho nhà đầu tư",
        "paragraphs": [
          "Mọi con số trên slide thoái vốn đều đi ra từ bốn phép tính nối tiếp nhau. Làm đúng thứ tự thì các con số tự khớp."
        ],
        "bullets": [
          "Bước 1, tỷ lệ sau vòng: tiền nhà đầu tư rót chia định giá sau vòng. Ví dụ 1,5 triệu chia 6 triệu bằng 25%.",
          "Bước 2, pha loãng qua các vòng sau: mỗi vòng mới phát hành thêm cổ phần nên tỷ lệ của nhà đầu tư cũ giảm. Nhân tỷ lệ hiện tại với (1 trừ phần nhượng ở mỗi vòng sau), kể cả phần mở rộng quỹ cổ phần cho nhân viên (ESOP).",
          "Bước 3, giá trị lúc thoái vốn: tỷ lệ còn lại nhân định giá thoái vốn.",
          "Bước 4, ROI và IRR: ROI là giá trị lúc thoái vốn chia số tiền đã đầu tư. IRR là tỷ suất lợi nhuận mỗi năm, tính bằng ROI mũ (1 chia số năm), trừ 1."
        ],
        "image": null,
        "quote": null,
        "table": {
          "caption": "Ví dụ: nhà đầu tư rót 1,5 triệu USD, nhận 25%, giả định ba vòng pha loãng sau đó",
          "headers": [
            "Thời điểm",
            "Phần nhượng mới",
            "Tỷ lệ của nhà đầu tư"
          ],
          "rows": [
            {
              "cells": [
                "Sau vòng hiện tại",
                "25% cho nhà đầu tư này",
                "25%"
              ]
            },
            {
              "cells": [
                "Sau Series A",
                "20%",
                "20%"
              ]
            },
            {
              "cells": [
                "Sau Series B",
                "15%",
                "17%"
              ]
            },
            {
              "cells": [
                "Mở rộng ESOP trước khi bán",
                "5%",
                "16,15%"
              ]
            }
          ]
        },
        "notes": [
          "Với định giá thoái vốn 100 triệu USD, phần của nhà đầu tư là khoảng 16,15 triệu USD, tức ROI khoảng 10,8 lần. Nếu thoái vốn sau 6 năm, IRR khoảng 48,6% mỗi năm. Phần pha loãng ở các vòng sau là giả định; hãy ghi giả định đó ngay trên slide để nhà đầu tư thấy bạn đã tính tới."
        ]
      },
      {
        "heading": "Định giá thoái vốn lấy từ đâu",
        "paragraphs": [
          "Con số định giá thoái vốn là giả định quan trọng nhất trên slide, và cũng là chỗ dễ bị hỏi vặn nhất. Cách phổ biến là lấy doanh thu dự kiến ở năm thoái vốn nhân với hệ số định giá trên doanh thu của các thương vụ tương đương.",
          "Ba lỗi hay gặp khi chọn thương vụ tương đương: chọn những tên quá lớn và quá xa (một sàn việc làm niêm yết ở Úc không phải thương vụ tương đương của một startup Việt Nam giai đoạn seed); chỉ ghi giá trị thương vụ mà không ghi hệ số, nên người đọc không so được; và trộn các thương vụ cách nhau nhiều năm, khi điều kiện thị trường đã khác hẳn."
        ],
        "bullets": [
          "Chọn 4 đến 6 thương vụ trong khoảng 3 đến 5 năm gần nhất, ưu tiên Đông Nam Á, cùng mô hình kinh doanh.",
          "Với mỗi thương vụ, ghi giá trị và hệ số định giá trên doanh thu. Không tìm được hệ số thì nói rõ là không có, đừng tự ước.",
          "Nếu doanh nghiệp là sàn giao dịch, định giá trên doanh thu thuần (giá trị giao dịch nhân tỷ lệ phí bạn thu), không phải trên tổng giá trị giao dịch (GMV). GMV không phải doanh thu của bạn."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Trình bày ba kịch bản thay vì một con số",
        "paragraphs": [
          "Một con số lợi nhuận duy nhất, lại là con số đẹp nhất, khiến slide trông như một lời hứa. Ba kịch bản cho thấy bạn hiểu rủi ro và đã nghĩ tới trường hợp mọi thứ không như kế hoạch. Dưới đây vẫn là ví dụ nhà đầu tư rót 1,5 triệu USD, còn 16,15% lúc thoái vốn, sau 6 năm."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": {
          "caption": "Ba kịch bản thoái vốn (USD)",
          "headers": [
            "Kịch bản",
            "Định giá thoái vốn",
            "Phần của nhà đầu tư",
            "ROI",
            "IRR mỗi năm"
          ],
          "rows": [
            {
              "cells": [
                "Thận trọng",
                "50 triệu",
                "8,1 triệu",
                "5,4 lần",
                "khoảng 32%"
              ]
            },
            {
              "cells": [
                "Cơ sở",
                "100 triệu",
                "16,15 triệu",
                "10,8 lần",
                "khoảng 49%"
              ]
            },
            {
              "cells": [
                "Lạc quan",
                "200 triệu",
                "32,3 triệu",
                "21,5 lần",
                "khoảng 67%"
              ]
            }
          ]
        },
        "notes": [
          "Bảng bỏ qua ưu đãi thanh lý và các điều khoản ưu tiên khác cho dễ theo dõi. Ở kịch bản thận trọng với giá bán thấp, các điều khoản đó có thể thay đổi đáng kể cách chia tiền. Xem ví dụ bằng số trong bài Thoái vốn ở Việt Nam."
        ]
      },
      {
        "heading": "Nhà đầu tư thật sự đọc slide này thế nào",
        "paragraphs": [
          "Phần lớn nhà đầu tư không tin con số ROI bạn đưa ra, và cũng không kỳ vọng bạn đoán trúng. Họ dùng slide này để kiểm ba điều.",
          "Thứ nhất, bạn có hiểu cơ chế không: pha loãng, ưu đãi thanh lý, khác biệt giữa doanh thu và GMV. Thứ hai, quy mô có đủ lớn không: với một quỹ giai đoạn sớm, công ty cần có khả năng trở nên đủ lớn để một khoản đầu tư thành công bù được nhiều khoản thất bại. Thứ ba, có người mua thật không: những cái tên bạn liệt kê là người mua tiềm năng có lý do chiến lược để mua, và đã từng mua công ty tương tự chưa.",
          "Vì vậy, một slide khiêm tốn mà tính đúng, có giả định rõ và có danh sách người mua hợp lý thuyết phục hơn nhiều so với một con số ROI 20 lần không có căn cứ."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Tám điểm kiểm trước khi gửi deck",
        "paragraphs": [
          "Chạy qua danh sách này với slide thoái vốn và slide gọi vốn đặt cạnh nhau."
        ],
        "bullets": [
          "Tỷ lệ nhà đầu tư nhận ở vòng này bằng số tiền gọi chia định giá sau vòng.",
          "Nếu tỷ lệ lúc thoái vốn khác tỷ lệ vòng này, có bảng hoặc dòng giải thích pha loãng.",
          "Phần của nhà đầu tư lúc thoái vốn bằng tỷ lệ nhân định giá thoái vốn.",
          "ROI bằng phần đó chia số tiền đầu tư; IRR khớp với số năm ghi trên slide.",
          "Định giá thoái vốn dựa trên doanh thu (hoặc lợi nhuận), có ghi hệ số và nguồn.",
          "Năm thoái vốn khớp với năm trong mô hình tài chính, và doanh thu năm đó khớp với slide dự phóng.",
          "Thương vụ tương đương gần đây, cùng khu vực, có hệ số.",
          "Có ít nhất một kịch bản thận trọng."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Tóm lại",
        "paragraphs": [
          "Slide thoái vốn không cần con số lớn. Nó cần những con số khớp nhau và có căn cứ. Tính theo đúng bốn bước, ghi rõ giả định pha loãng, định giá trên doanh thu thay vì GMV, và trình bày ba kịch bản. Nếu bạn gửi deck cho fundraising.vn nhận xét, phần kiểm tra số liệu tự động sẽ chỉ ra ngay chỗ nào chưa khớp."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      }
    ],
    "relatedTools": [
      {
        "slug": "mo-phong-vong-goi-von",
        "label": "Mô phỏng tỷ lệ sở hữu qua từng vòng"
      },
      {
        "slug": "bang-co-phan-va-pha-loang",
        "label": "Dựng bảng cổ phần và pha loãng"
      },
      {
        "slug": "dinh-gia-co-doanh-thu",
        "label": "Ước định giá theo hệ số doanh thu"
      },
      {
        "slug": "pitch-deck-10-slide",
        "label": "Rà cả deck theo checklist 10 slide"
      }
    ],
    "sources": [
      {
        "label": "VPCA, NIC và BCG: Vietnam Innovation and Private Capital Report 2025 (cỡ vòng trung vị 2024)",
        "url": "https://investgame.net/news/pdf/2026-02-05-vietnam_innovation_private_capital_report_2025/"
      },
      {
        "label": "Y Combinator: A guide to seed fundraising",
        "url": "https://www.ycombinator.com/library/4A-a-guide-to-seed-fundraising"
      }
    ],
    "seoTitle": "Slide thoái vốn (exit) trong pitch deck: cách tính ROI, IRR và pha loãng cho nhà đầu tư",
    "seoDescription": "Cách tính lợi nhuận nhà đầu tư trên slide thoái vốn: tỷ lệ sau vòng, pha loãng qua các vòng sau, giá trị lúc thoái vốn, ROI và IRR. Ví dụ bằng số, ba kịch bản, cách chọn thương vụ tương đương và checklist 8 điểm.",
    "publishedAt": "2026-10-07",
    "updatedAt": "2026-10-07",
    "track": "cam-nang",
    "readingMinutes": 6
  },
  {
    "slug": "startup-nen-goi-bao-nhieu-von-cho-18-thang",
    "title": "Startup nên gọi bao nhiêu vốn cho 18 tháng?",
    "excerpt": "Một tình huống thực tế để nối runway, mức đốt tiền, dự phòng và cột mốc thành số vốn có thể bảo vệ trước nhà đầu tư.",
    "category": "Tình huống gọi vốn",
    "stages": [
      "Pre-seed",
      "Seed"
    ],
    "storyType": "tong-hop",
    "templates": [],
    "consentConfirmed": false,
    "coverImage": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Fstartup-nen-goi-bao-nhieu-von-cho-18-thang%2F1790080566268-cover.webp?alt=media&token=6e7f6161-a493-4276-8445-a5d2338fcae2",
    "coverAlt": "Startup nên gọi bao nhiêu vốn cho 18 tháng?",
    "coverCaption": "",
    "ogImage": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Fstartup-nen-goi-bao-nhieu-von-cho-18-thang%2F1790080566566-cover.jpg?alt=media&token=dc02746d-adae-44fb-8381-1966956acb93",
    "author": "Fundraising Vietnam",
    "authorRole": "",
    "status": "PUBLISHED",
    "featured": false,
    "sections": [
      {
        "heading": "Tình huống",
        "paragraphs": [
          "Một startup phần mềm B2B vòng pre-seed có 1,2 tỷ đồng tiền mặt, đang đốt ròng 300 triệu đồng mỗi tháng và có 22 khách trả tiền. Mục tiêu của founder: trong 18 tháng tới đạt 100 khách trả tiền, đủ bằng chứng để gọi vòng Seed.",
          "Founder tính rất nhanh: 300 triệu nhân 18 tháng là 5,4 tỷ, trừ 1,2 tỷ đang có, vậy cần gọi khoảng 4,2 tỷ đồng. Con số này được đưa thẳng vào slide cuối của pitch deck."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Ba điều phép tính đơn giản bỏ qua",
        "paragraphs": [
          "Phép nhân trên trả lời câu hỏi “với chi phí hôm nay, công ty sống được bao lâu”. Nhưng kế hoạch 18 tháng không vận hành với chi phí hôm nay, và nó không bắt đầu từ hôm nay."
        ],
        "bullets": [
          "Thời gian gọi vốn: từ cuộc gặp đầu tiên đến khi tiền về tài khoản thường mất 3–6 tháng. Trong thời gian đó công ty vẫn đốt tiền. Với 1,2 tỷ và mức đốt 300 triệu, số tiền mặt hiện có chỉ vừa đủ nuôi công ty trong bốn tháng đi gọi vốn — tức là 18 tháng phải được tính từ ngày tiền mới về, không phải từ hôm nay.",
          "Chi phí tăng theo kế hoạch: muốn đi từ 22 lên 100 khách, công ty cần thêm người bán hàng và kỹ sư. Mức đốt 300 triệu là của đội hình hiện tại, không phải của đội hình sẽ đạt cột mốc.",
          "Kế hoạch luôn chậm hơn dự kiến: tuyển người mất thời gian hơn, khách ký hợp đồng chậm hơn. Không có dự phòng nghĩa là chỉ một quý chậm trễ là công ty hết tiền đúng lúc sắp đạt cột mốc."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Tính lại từng bước",
        "paragraphs": [
          "Dưới đây là cách tính lại với cùng dữ liệu. Các giả định được ghi rõ để nhà đầu tư có thể thay số của họ vào và kiểm tra."
        ],
        "bullets": [
          "Chi phí vận hành cơ sở trong 18 tháng: 300 triệu × 18 = 5,4 tỷ đồng.",
          "Phần tăng thêm theo kế hoạch tuyển: thêm 2 nhân sự bán hàng và 1 kỹ sư từ tháng thứ 3 sau khi nhận vốn, khoảng 120 triệu mỗi tháng trong 16 tháng = 1,92 tỷ đồng.",
          "Phần doanh thu tăng thêm bù lại: giả định doanh thu mới giúp giảm đốt ròng trung bình 50 triệu mỗi tháng trong 12 tháng cuối = trừ 0,6 tỷ đồng.",
          "Cộng lại: 5,4 + 1,92 − 0,6 = 6,72 tỷ đồng.",
          "Dự phòng 15% cho kế hoạch chậm hơn: khoảng 1 tỷ đồng. Tổng nhu cầu vào khoảng 7,7 tỷ, làm tròn thành mục tiêu gọi 7,5–8 tỷ đồng."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Nếu vẫn gọi 4,2 tỷ thì sao",
        "paragraphs": [
          "Với đội hình mở rộng, mức đốt trung bình khoảng 380–420 triệu mỗi tháng. 4,2 tỷ chỉ đủ khoảng 10–11 tháng — công ty sẽ phải quay lại gọi vốn khi mới có khoảng 50–60 khách, chưa đạt cột mốc đã hứa, và đàm phán trong thế yếu.",
          "Đây là lý do nhà đầu tư có kinh nghiệm thường lo khi founder gọi quá ít, không chỉ khi gọi quá nhiều. Gọi ít hơn nhu cầu thật không giúp định giá tốt hơn; nó chỉ dời bài toán sang một thời điểm tệ hơn."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Nối số vốn với cột mốc",
        "paragraphs": [
          "Nhà đầu tư không chỉ hỏi startup sống được bao lâu; họ hỏi số vốn đó tạo ra bằng chứng gì cho vòng tiếp theo. Vì vậy con số 7,5–8 tỷ phải đi cùng các cột mốc đo được, có thời hạn, và đủ để một quỹ Seed muốn đầu tư."
        ],
        "bullets": [
          "Tháng 6: hoàn tất tuyển đội bán hàng, 40 khách trả tiền.",
          "Tháng 12: 70 khách trả tiền, tỷ lệ khách rời đi dưới 3% mỗi tháng.",
          "Tháng 18: 100 khách trả tiền, doanh thu định kỳ đủ để chứng minh kênh bán hàng lặp lại được."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Cách trình bày có thể bảo vệ",
        "paragraphs": [
          "Trên slide, tách nhu cầu vốn thành ba khối: chi phí vận hành cơ sở, phần tăng thêm theo kế hoạch tuyển dụng, và dự phòng. Mỗi khối nối với một cột mốc. Trong buổi gặp, một câu trình bày gọn có thể là: “Chúng tôi gọi 8 tỷ để có 18 tháng kể từ khi nhận vốn, đủ tuyển đội bán hàng và đưa số khách trả tiền từ 22 lên 100. Kịch bản chậm hơn 20% vẫn nằm trong khoản dự phòng.”",
          "Câu này cho nhà đầu tư ba thông tin cùng lúc: bạn hiểu dòng tiền, bạn biết tiền mua được gì, và bạn đã nghĩ đến trường hợp xấu."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Checklist trước khi chốt con số",
        "paragraphs": [],
        "bullets": [
          "Dùng đốt ròng (chi phí trừ lợi nhuận gộp) thay vì chỉ dùng tổng chi phí.",
          "Tính 18 tháng từ ngày tiền về, cộng thêm 3–6 tháng hoàn tất vòng gọi vốn.",
          "Đưa kế hoạch tuyển dụng vào dòng tiền theo đúng tháng tuyển.",
          "Thêm 10–20% dự phòng và ghi rõ nó bảo vệ trường hợp nào.",
          "Viết cột mốc 12–18 tháng bằng số đo kiểm chứng được.",
          "Mô phỏng trường hợp doanh thu thấp hơn và chi phí cao hơn kế hoạch, xem tháng nào hết tiền."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      }
    ],
    "relatedTools": [
      {
        "slug": "goi-bao-nhieu",
        "label": "Lập kế hoạch số vốn"
      },
      {
        "slug": "tinh-runway",
        "label": "Tính runway"
      },
      {
        "slug": "mo-phong-vong-goi-von",
        "label": "Mô phỏng vòng gọi vốn"
      }
    ],
    "sources": [
      {
        "label": "Y Combinator — A guide to seed fundraising",
        "url": "https://www.ycombinator.com/library/4A-a-guide-to-seed-fundraising"
      }
    ],
    "seoTitle": "Startup nên gọi bao nhiêu vốn cho 18 tháng? Cách tính từng bước kèm ví dụ",
    "seoDescription": "Vì sao lấy mức đốt tiền nhân 18 tháng gần như luôn ra số vốn quá thấp, và cách tính lại có thời gian gọi vốn, kế hoạch tuyển dụng, dự phòng và cột mốc.",
    "publishedAt": "2026-09-16",
    "updatedAt": "2026-09-22",
    "track": "cau-chuyen",
    "readingMinutes": 4
  },
  {
    "slug": "tai-tro-ung-dung-ai-natif-2026",
    "title": "NATIF tài trợ tới 3 tỷ đồng cho dự án ứng dụng AI: ai nộp được, tiền chia thế nào, cần chuẩn bị gì?",
    "excerpt": "Quỹ Đổi mới công nghệ quốc gia tài trợ tối đa 50% kinh phí, không quá 3 tỷ đồng mỗi nhiệm vụ ứng dụng AI; doanh nghiệp đối ứng tối thiểu 50% bằng tiền. Bài này tóm tắt điều kiện, cách chia dự toán, điểm dễ trượt và quy trình xét duyệt, kèm mẫu Excel để chuẩn bị hồ sơ.",
    "category": "Chương trình hỗ trợ nhà nước",
    "stages": [
      "Series A",
      "Seed",
      "Pre-seed"
    ],
    "storyType": "huong-dan",
    "templates": [
      "du-toan-nhiem-vu-tai-tro-natif"
    ],
    "consentConfirmed": false,
    "coverImage": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Ftai-tro-ung-dung-ai-natif-2026%2F1790080567660-cover.webp?alt=media&token=b83a9750-a996-4f38-816d-2736f25bbe12",
    "coverAlt": "Thông báo kế hoạch tài trợ nhiệm vụ đổi mới công nghệ ứng dụng trí tuệ nhân tạo năm 2026",
    "coverCaption": "",
    "ogImage": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Ftai-tro-ung-dung-ai-natif-2026%2F1790080567952-cover.jpg?alt=media&token=ebe1d8e0-221f-408a-b43c-eb92928ab1ec",
    "author": "Fundraising Vietnam",
    "authorRole": "",
    "status": "PUBLISHED",
    "featured": false,
    "sections": [
      {
        "heading": "Tóm tắt nhanh",
        "paragraphs": [],
        "bullets": [
          "Đơn vị tài trợ: Quỹ Đổi mới công nghệ quốc gia (NATIF), Bộ Khoa học và Công nghệ",
          "Mức tài trợ: Quỹ chi tối đa 50% tổng kinh phí nhiệm vụ và không quá 3 tỷ đồng; doanh nghiệp đối ứng tối thiểu 50% bằng tiền",
          "Hạn nộp đợt 2026: 17h00 ngày 10/10/2026",
          "Quy mô: 15 nhiệm vụ trong năm 2026, ký hợp đồng trước 31/12; từ 2027 dự kiến khoảng 50 nhiệm vụ mỗi năm",
          "Thời gian thực hiện: tối đa 12 tháng",
          "Nộp qua: cổng OMS (oms.natif.vn), bưu điện hoặc trực tiếp tại Hà Nội",
          "Điểm quan trọng: khi hồ sơ đạt chuẩn vượt ngân sách, Quỹ xét theo thứ tự nộp hồ sơ hợp lệ, nên nộp sớm là lợi thế",
          "Có mẫu Excel đi kèm bài: tự kiểm tra điều kiện, chia dự toán và lập kế hoạch 12 tháng"
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Bài này dành cho ai",
        "paragraphs": [
          "Chương trình dành cho doanh nghiệp hoặc tổ chức muốn dùng AI để tạo sản phẩm, dịch vụ, quy trình hay mô hình kinh doanh mới, hoặc cải tiến rõ rệt cái đang có. Đây là tài trợ theo nhiệm vụ đổi mới công nghệ, không phải vốn đầu tư: bạn không phải đổi cổ phần, nhưng phải thực hiện đúng cam kết và quyết toán kinh phí theo quy định.",
          "Có hai cách để startup tham gia. Cách thứ nhất là tự đứng tên chủ trì, nếu bạn đã có pháp nhân, có bài toán AI của chính mình và đủ tiền đối ứng. Cách thứ hai, thường hợp hơn với startup làm giải pháp AI, là làm đơn vị phát triển giải pháp cho một doanh nghiệp đứng ra chủ trì (nhà máy, chuỗi bán lẻ, bệnh viện, doanh nghiệp logistics). NATIF gọi đây là mô hình ba bên: Nhà nước, doanh nghiệp có bài toán, và đơn vị công nghệ (doanh nghiệp AI, viện, trường).",
          "Cách thứ hai còn có lợi về sở hữu trí tuệ. Theo cách chia NATIF trình bày tại hội thảo hướng dẫn, phần lõi AI thuộc bên phát triển giải pháp, còn phần ứng dụng tích hợp và dữ liệu thuộc doanh nghiệp được tài trợ. Nghĩa là startup vẫn giữ công nghệ của mình để bán tiếp cho khách hàng khác."
        ],
        "bullets": [
          "Phù hợp: startup làm giải pháp AI, đi cùng một khách hàng doanh nghiệp có sẵn dữ liệu và bài toán",
          "Phù hợp: startup đã có pháp nhân, có bài toán AI rõ ràng làm xong trong 12 tháng và có tiền đối ứng",
          "Chưa phù hợp: nhóm chưa thành lập công ty",
          "Chưa phù hợp: dự án chỉ cài đặt một phần mềm có sẵn, không có yếu tố đổi mới công nghệ"
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Tiền được chia thế nào",
        "paragraphs": [
          "Quỹ không tài trợ toàn bộ. Phần tiền từ ngân sách tối đa bằng một nửa tổng kinh phí nhiệm vụ và không vượt 3 tỷ đồng. Phần còn lại doanh nghiệp tự đối ứng, và phần đối ứng tối thiểu 50% tổng kinh phí phải bằng tiền. Vì vậy câu hỏi đầu tiên không phải \"xin được bao nhiêu\" mà là \"dự án tổng cộng tốn bao nhiêu và doanh nghiệp tự bỏ ra được bao nhiêu\"."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": {
          "caption": "Mức xin tối đa theo tổng kinh phí",
          "headers": [
            "Tổng kinh phí nhiệm vụ",
            "Tối đa xin NATIF",
            "Doanh nghiệp đối ứng tối thiểu"
          ],
          "rows": [
            {
              "cells": [
                "2 tỷ đồng",
                "1 tỷ đồng",
                "1 tỷ đồng"
              ]
            },
            {
              "cells": [
                "4 tỷ đồng",
                "2 tỷ đồng",
                "2 tỷ đồng"
              ]
            },
            {
              "cells": [
                "6 tỷ đồng",
                "3 tỷ đồng",
                "3 tỷ đồng"
              ]
            },
            {
              "cells": [
                "8 tỷ đồng",
                "3 tỷ đồng",
                "5 tỷ đồng"
              ]
            }
          ]
        },
        "notes": [
          "Muốn xin đủ 3 tỷ đồng thì tổng kinh phí nhiệm vụ phải từ 6 tỷ đồng trở lên. Sheet «Dự toán» trong mẫu Excel đi kèm tự tính mức tối đa và báo khi phần xin vượt 50%, vượt 3 tỷ đồng hoặc khi đối ứng bằng tiền chưa đủ."
        ]
      },
      {
        "heading": "Tự kiểm tra: bạn có đủ điều kiện không?",
        "paragraphs": [
          "Nếu bạn trả lời \"có\" cho cả 8 câu dưới đây thì nên bắt tay chuẩn bị ngay. Nếu có câu trả lời \"chưa\", hãy xử lý câu đó trước khi viết thuyết minh. Sheet «Tự kiểm tra» trong mẫu Excel có sẵn các câu này kèm việc cần làm cho từng câu."
        ],
        "bullets": [
          "Đơn vị chủ trì đã có tư cách pháp nhân và ngành nghề kinh doanh phù hợp với nội dung nhiệm vụ?",
          "Có bài toán AI cụ thể, đo được bằng năng suất, chất lượng, chi phí hoặc doanh thu?",
          "Nói rõ được dữ liệu dùng cho AI lấy từ đâu, có quyền sử dụng không, chất lượng ra sao và kế hoạch chuẩn bị thế nào?",
          "Nhiệm vụ thuộc ít nhất một trong ba hướng đổi mới công nghệ (xem phần dưới)?",
          "Đơn vị chủ trì đối ứng được tối thiểu 50% tổng kinh phí bằng tiền và có giấy tờ chứng minh?",
          "Dự án hoàn thành và đưa MVP vào vận hành trong tối đa 12 tháng?",
          "Không còn khoản kinh phí ngân sách nào chưa quyết toán hoặc chưa hoàn trả?",
          "Không bị đình chỉ nhiệm vụ khoa học công nghệ trong 01 năm gần nhất, không bị đình chỉ hoạt động hay bị khởi tố?"
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Bốn điểm startup dễ trượt nhất",
        "paragraphs": [
          "Thứ nhất là tiền đối ứng. Đơn vị chủ trì phải tự bỏ tối thiểu một nửa tổng kinh phí bằng tiền và có giấy tờ chứng minh (báo cáo tài chính, sao kê, cam kết góp vốn của nhà đầu tư, hợp đồng với khách hàng). Với startup pre-seed, đây thường là rào cản lớn nhất, và cũng là lý do đi cùng một doanh nghiệp chủ trì thường dễ hơn tự đứng tên.",
          "Thứ hai là không chứng minh được tính đổi mới công nghệ. NATIF nêu ba hướng để một nhiệm vụ đủ điều kiện: thay thế công nghệ nhập khẩu bằng công nghệ tiên tiến hơn; làm chủ, nội địa hóa công nghệ thay vì phụ thuộc bên ngoài; hoặc chuyển giao công nghệ có hợp đồng làm căn cứ. Đây là ranh giới giữa một nhiệm vụ đổi mới công nghệ thật và một dự án mua phần mềm thông thường. Hãy chọn một hướng và chứng minh bằng so sánh với công nghệ đang dùng.",
          "Thứ ba là phần dữ liệu. Ngoài các tiêu chí chung, dự án AI phải nêu rõ nguồn dữ liệu, khả năng tiếp cận, quyền sử dụng, chất lượng và kế hoạch chuẩn bị dữ liệu. Nhiều hồ sơ chỉ viết về mô hình AI mà bỏ qua dữ liệu. NATIF nói rõ chỉ tài trợ khi doanh nghiệp có sẵn dữ liệu và bài toán rõ ràng.",
          "Thứ tư là tính khả thi. Hội đồng xem mục tiêu, nội dung, phương pháp, tiến độ và kinh phí có ăn khớp với nhau không, và kết quả đầu ra có đo được không. Một kế hoạch 12 tháng với các mốc cụ thể và chỉ số đo trước, đo sau thuyết phục hơn nhiều so với lời hứa chung chung. Sheet «Kế hoạch 12 tháng» trong mẫu Excel có sẵn một bộ mốc ví dụ để bạn sửa theo dự án."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Nên kê khoản nào vào phần xin ngân sách",
        "paragraphs": [
          "Nội dung chi theo khoản 1 và khoản 4 Điều 6 Nghị định 265/2025/NĐ-CP. Nguyên tắc là phần xin ngân sách nên là chi phí phát sinh mới, phục vụ trực tiếp nhiệm vụ, và không được trùng với phần doanh nghiệp tự chi hoặc đã tính khấu trừ thuế (Điều 9 Nghị định 268/2025/NĐ-CP). Bảng dưới tóm tắt hướng dẫn kê khai NATIF trình bày tại hội thảo ngày 29/09/2026."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": {
          "caption": "Gợi ý chia khoản chi",
          "headers": [
            "Khoản chi",
            "Nên đặt vào",
            "Ví dụ trong dự án AI"
          ],
          "rows": [
            {
              "cells": [
                "Thuê chuyên gia, kỹ sư AI bên ngoài",
                "Phần xin ngân sách",
                "Huấn luyện, tinh chỉnh mô hình"
              ]
            },
            {
              "cells": [
                "Mua, thuê dữ liệu và quyền truy cập",
                "Phần xin ngân sách",
                "Tập dữ liệu gán nhãn, API bên thứ ba"
              ]
            },
            {
              "cells": [
                "Thuê hạ tầng GPU, điện toán đám mây, thiết bị đo",
                "Phần xin ngân sách",
                "GPU trong thời gian huấn luyện, cảm biến thu dữ liệu"
              ]
            },
            {
              "cells": [
                "Thử nghiệm, hiệu chỉnh, tích hợp vào vận hành",
                "Phần xin ngân sách",
                "Chạy thử trên dây chuyền thật"
              ]
            },
            {
              "cells": [
                "Kiểm thử, kiểm định, chứng nhận chất lượng",
                "Phần xin ngân sách",
                "Đánh giá độc lập độ chính xác mô hình"
              ]
            },
            {
              "cells": [
                "Phí chuyển giao công nghệ, đào tạo làm chủ công nghệ",
                "Phần xin ngân sách",
                "License mô hình, đào tạo kỹ sư vận hành"
              ]
            },
            {
              "cells": [
                "Lương nhân sự nội bộ đã có sẵn",
                "Phần đối ứng",
                "Đội kỹ thuật hiện có tham gia nhiệm vụ"
              ]
            },
            {
              "cells": [
                "Hạ tầng, phần mềm nền đã đầu tư từ trước",
                "Phần đối ứng",
                "Máy chủ, ERP đang khai thác"
              ]
            },
            {
              "cells": [
                "Chi phí quản lý, vận hành chung",
                "Phần đối ứng",
                "Văn phòng, hành chính chung"
              ]
            },
            {
              "cells": [
                "R&D nội bộ ngoài phạm vi nhiệm vụ",
                "Không đưa vào nhiệm vụ",
                "Tính năng khác của sản phẩm"
              ]
            }
          ]
        },
        "notes": [
          "Đây là gợi ý, không phải quy định bắt buộc. Sheet «Dự toán» trong mẫu Excel liệt kê sẵn các khoản theo khoản 1 và 4 Điều 6, có cột gợi ý nguồn và tự cảnh báo khi một khoản nên để đối ứng lại đang đặt vào phần xin ngân sách."
        ]
      },
      {
        "heading": "Lĩnh vực, địa bàn và tiêu chí ưu tiên",
        "paragraphs": [
          "Ngoài các tiêu chí chung (khả thi, hồ sơ rõ ràng, ứng dụng trực tiếp, tuân thủ quy định về sở hữu trí tuệ và tiêu chuẩn, đủ năng lực thực hiện), Kế hoạch tài trợ ưu tiên nhiệm vụ giải quyết bài toán thực tiễn của doanh nghiệp bằng AI, đưa MVP vào vận hành trong thời gian thí điểm, có hiệu quả đo được và có khả năng nhân rộng trong ngành."
        ],
        "bullets": [
          "Công nghiệp chế biến, chế tạo",
          "Nông nghiệp và chế biến nông sản",
          "Y tế và dược phẩm",
          "Logistics và chuỗi cung ứng",
          "Thương mại, dịch vụ và quản trị doanh nghiệp",
          "Cơ quan hành chính nhà nước",
          "Địa bàn: Hà Nội, TP.HCM, Đà Nẵng, Tây Ninh và các địa phương có nhu cầu"
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Hồ sơ cần nộp",
        "paragraphs": [
          "Mỗi đơn vị nộp 1 bộ hồ sơ. Các mẫu biểu được đăng trên trang Văn bản và biểu mẫu của NATIF (link ở phần Nguồn tham khảo)."
        ],
        "bullets": [
          "Đơn đăng ký thực hiện nhiệm vụ: Mẫu I.1",
          "Thuyết minh nhiệm vụ: Mẫu I.2 (phần quan trọng nhất, nên dành nhiều thời gian nhất), kèm Phụ lục dự toán",
          "Văn bản pháp lý: quyết định thành lập hoặc điều lệ",
          "Văn bản cam kết chỉ nhận một nguồn kinh phí ngân sách cho cùng một nội dung: Mẫu I.6",
          "Hồ sơ dự án đầu tư, chuẩn bị theo tình hình thực tế của doanh nghiệp",
          "Các tài liệu khác theo thông báo kêu gọi và Điều 11 Nghị định 268/2025/NĐ-CP",
          "Nên chuẩn bị thêm: minh chứng tiền đối ứng, hợp đồng hoặc cam kết với đối tác AI (ghi rõ cách chia sở hữu trí tuệ), tài liệu về nguồn và quyền sử dụng dữ liệu"
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Sau khi nộp: quy trình và thời gian",
        "paragraphs": [
          "Quy trình theo Điều 10 đến 18 Nghị định 268/2025/NĐ-CP. Từ khi hồ sơ hợp lệ đến khi ký hợp đồng mất khoảng 60 ngày. Sau khi có thông báo xét duyệt, doanh nghiệp có 15 ngày để hoàn thiện hồ sơ, nên chuẩn bị sẵn bản dự toán chi tiết để không bị động."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": {
          "caption": "Bảy bước từ kêu gọi đến quyết toán",
          "headers": [
            "Bước",
            "Nội dung",
            "Thời gian"
          ],
          "rows": [
            {
              "cells": [
                "1. Kêu gọi đề xuất",
                "Thông báo trên cổng thông tin của Quỹ",
                "Đã đăng 09/09/2026"
              ]
            },
            {
              "cells": [
                "2. Nộp hồ sơ",
                "01 bộ, qua cổng OMS, bưu điện hoặc trực tiếp",
                "Hạn 17h00 ngày 10/10/2026"
              ]
            },
            {
              "cells": [
                "3. Xét duyệt",
                "Hội đồng 7 đến 9 người, cần ít nhất 2/3 phiếu đạt",
                "Khoảng 30 ngày"
              ]
            },
            {
              "cells": [
                "4. Thẩm định",
                "Dự toán và mức hỗ trợ",
                "Khoảng 10 ngày"
              ]
            },
            {
              "cells": [
                "5. Phê duyệt",
                "Công khai trên cổng thông tin",
                "Khoảng 10 ngày"
              ]
            },
            {
              "cells": [
                "6. Ký hợp đồng",
                "Cấp kinh phí theo chứng từ",
                "Khoảng 10 ngày; dự kiến công bố kết quả 15/12/2026"
              ]
            },
            {
              "cells": [
                "7. Thực hiện, quyết toán",
                "Kiểm tra, đánh giá nội dung",
                "Tối đa 12 tháng"
              ]
            }
          ]
        },
        "notes": []
      },
      {
        "heading": "Nộp hồ sơ và liên hệ",
        "paragraphs": [
          "Cách nhanh nhất là nộp bản điện tử qua cổng OMS của Quỹ. Bạn cũng có thể gửi qua bưu điện hoặc nộp trực tiếp tại Phòng Tài trợ và Đặt hàng, Tầng 5 Tòa nhà Cục Đổi mới sáng tạo, 113 Trần Duy Hưng, Hà Nội. Ngày nhận hồ sơ được tính theo ngày ghi nhận trên cổng, theo dấu bưu điện gửi đến, hoặc theo dấu đến của cơ quan tiếp nhận.",
          "Nếu còn băn khoăn hồ sơ của mình có hợp không, hãy đăng ký nhu cầu tại khaosat.natif.gov.vn để được Quỹ liên hệ hướng dẫn trước khi nộp.",
          "Liên hệ: chuyên viên Đặng Thị Xuân Yến, 0974 694 385, ttdh@natif.vn.",
          "Nội dung trên được tóm tắt từ thông báo và tài liệu hướng dẫn của NATIF để founder tham khảo. Trước khi nộp, hãy đối chiếu với văn bản gốc."
        ],
        "bullets": [],
        "image": {
          "url": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Ftai-tro-ung-dung-ai-natif-2026%2F1791186296207-jr7ka.webp?alt=media&token=6015a47d-0c6d-4f19-984d-8ef2f32f8675",
          "alt": "Slide của Quỹ NATIF: năm câu hỏi cần tự rà trước khi bấm nộp hồ sơ, lịch gợi ý 5 ngày từ 05/10 đến 09/10, hạn nộp 17h00 ngày 10/10/2026, thông tin liên hệ và mã QR dẫn tới cổng oms.natif.vn",
          "caption": "Năm câu hỏi cuối cùng trước khi bấm nộp. NATIF khuyên nộp trước thứ Sáu 09/10, sớm hơn hạn một ngày. Quét mã QR để vào cổng nộp hồ sơ",
          "credit": "Quỹ NATIF, tài liệu hướng dẫn xây dựng hồ sơ thuyết minh nhiệm vụ AI 2026",
          "width": 774,
          "height": 441,
          "fit": "rong",
          "position": "cuoi"
        },
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Nếu lỡ đợt này",
        "paragraphs": [
          "Đợt năm 2026 là giai đoạn thí điểm. Theo kế hoạch NATIF công bố, từ năm 2027 Quỹ dự kiến nhân rộng lên khoảng 50 nhiệm vụ ứng dụng AI mỗi năm sau khi đánh giá hiệu quả giai đoạn 1, đồng thời mở thêm các hướng tài trợ ngoài AI. Chuẩn bị bài toán, dữ liệu và tiền đối ứng từ bây giờ là cách tốt nhất để kịp đợt sau."
        ],
        "bullets": [
          "Để lại nhu cầu tại khaosat.natif.gov.vn, kể cả khi bài toán của bạn không thuộc AI; dữ liệu này là căn cứ để Quỹ xây các hướng tài trợ năm 2027",
          "Theo dõi chương trình đồng tài trợ NATIF và NEDO (Nhật Bản) dự kiến thí điểm từ năm 2027, dành cho liên danh ít nhất một doanh nghiệp Việt Nam và một doanh nghiệp hoặc tổ chức Nhật Bản, ưu tiên năng lượng, môi trường, AI và tự động hóa",
          "Xem lịch các chương trình và quỹ tài trợ khác tại trang Chương trình của fundraising.vn"
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      }
    ],
    "relatedTools": [
      {
        "slug": "goi-bao-nhieu",
        "label": "Lập kế hoạch số vốn"
      }
    ],
    "sources": [
      {
        "label": "Mẫu biểu hồ sơ",
        "url": "https://www.natif.gov.vn/van-ban/pl-1"
      },
      {
        "label": "Cổng nộp hồ sơ OMS",
        "url": "https://oms.natif.vn"
      },
      {
        "label": "Trang chính thức Quỹ NATIF",
        "url": "https://www.natif.gov.vn/"
      },
      {
        "label": "Đăng ký nhu cầu, hỏi trước khi nộp",
        "url": "https://khaosat.natif.gov.vn"
      },
      {
        "label": "Tạp chí Khoa học và Công nghệ Việt Nam: mức tài trợ 50% và đối ứng",
        "url": "https://vjst.vn/mo-rong-co-hoi-tai-tro-doi-moi-cong-nghe-cho-doanh-nghiep-103333.html"
      }
    ],
    "seoTitle": "Tài trợ ứng dụng AI của NATIF: tối đa 3 tỷ, đối ứng 50%",
    "seoDescription": "Điều kiện, cách chia dự toán giữa phần xin ngân sách và phần đối ứng, quy trình xét duyệt và mẫu Excel để startup chuẩn bị hồ sơ tài trợ ứng dụng AI của NATIF.",
    "publishedAt": "2026-09-18",
    "updatedAt": "2026-10-05",
    "track": "chinh-sach",
    "readingMinutes": 11
  },
  {
    "slug": "term-sheet-o-viet-nam-rang-buoc-va-thuc-thi",
    "title": "Term sheet ở Việt Nam: điều khoản nào ràng buộc, điều khoản nào thực thi được, và cờ đỏ cần nhận ra",
    "excerpt": "Term sheet thường ghi là không ràng buộc, nhưng ký xong thì gần như không còn đường lùi, và vài điều khoản có hiệu lực ngay. Bài này tách phần ràng buộc với phần không, đi qua mười điều khoản với mức thông lệ ở vòng đầu, giải thích vì sao cam kết mua lại bằng tài sản cá nhân là cờ đỏ lớn nhất với founder Việt Nam, điều gì ghi được vào điều lệ công ty cổ phần",
    "category": "Cổ phần & cap table",
    "stages": [
      "Pre-seed",
      "Seed",
      "Series A"
    ],
    "storyType": "huong-dan",
    "templates": [
      "so-sanh-term-sheet"
    ],
    "consentConfirmed": false,
    "coverImage": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Fterm-sheet-o-viet-nam-rang-buoc-va-thuc-thi%2F1791418172614-cover.webp?alt=media&token=597f0eeb-cda0-4d1c-a961-ee2dbabc8408",
    "coverAlt": "Một term sheet chia hai phần: điều khoản ràng buộc ngay khi ký và điều khoản không ràng buộc, kèm cờ đỏ cam kết mua lại",
    "coverCaption": "Không ràng buộc không có nghĩa là không có hậu quả. Vài điều khoản có hiệu lực ngay khi bạn ký.",
    "ogImage": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Fterm-sheet-o-viet-nam-rang-buoc-va-thuc-thi%2F1791418175623-cover.jpg?alt=media&token=e574e5a3-47d9-4316-8cc8-7b5da911c5a4",
    "author": "Fundraising Vietnam",
    "authorRole": "",
    "status": "PUBLISHED",
    "featured": false,
    "sections": [
      {
        "heading": "Không ràng buộc, nhưng gần như không còn đường lùi",
        "paragraphs": [
          "Term sheet là bản tóm tắt các điều kiện chính của một khoản đầu tư: bao nhiêu tiền, ở định giá nào, nhà đầu tư nhận những quyền gì. Sau term sheet, hai bên mới thẩm định và soạn bộ hợp đồng đầy đủ: hợp đồng đầu tư, thoả thuận cổ đông, điều lệ sửa đổi.",
          "Phần lớn term sheet ghi rõ là không ràng buộc. Điều đó đúng về mặt pháp lý, nhưng dễ gây hiểu nhầm. Trên thực tế, mọi văn bản về sau đều được soạn theo term sheet, và đòi đổi một điều khoản chính sau khi đã ký thường bị coi là thiếu thiện chí. Nhà đầu tư có thể rút, còn bạn thì đã mất vài tuần không được nói chuyện với ai khác. Vì vậy, thời điểm để thương lượng là trước khi ký term sheet, không phải sau."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Phần ràng buộc ngay khi ký",
        "paragraphs": [
          "Gần như term sheet nào cũng có vài điều khoản có hiệu lực ngay, kể cả khi thương vụ không bao giờ đóng. Đọc kỹ phần này trước tiên."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": {
          "caption": "Điều khoản ràng buộc thường gặp",
          "headers": [
            "Điều khoản",
            "Mức thông lệ",
            "Khi nào cần hỏi lại"
          ],
          "rows": [
            {
              "cells": [
                "Độc quyền đàm phán",
                "30 đến 60 ngày",
                "Trên 60 ngày, hoặc không tự hết hiệu lực khi nhà đầu tư đổi điều khoản chính"
              ]
            },
            {
              "cells": [
                "Bảo mật",
                "Hai bên giữ bí mật nội dung term sheet",
                "Chỉ ràng buộc một phía founder"
              ]
            },
            {
              "cells": [
                "Chi phí",
                "Mỗi bên tự trả, hoặc công ty trả chi phí luật sư của nhà đầu tư khi thương vụ hoàn tất, có trần",
                "Công ty phải trả kể cả khi thương vụ không thành, hoặc không có trần"
              ]
            },
            {
              "cells": [
                "Luật áp dụng và nơi giải quyết tranh chấp",
                "Ghi rõ luật nước nào, toà án hay trọng tài nào",
                "Bỏ trống, hoặc chọn nơi founder không đủ điều kiện theo đuổi tranh chấp"
              ]
            },
            {
              "cells": [
                "Phí phạt nếu không ký hợp đồng chính",
                "Không có",
                "Bất kỳ khoản phạt hay bồi thường nào chỉ áp lên founder"
              ]
            }
          ]
        },
        "notes": []
      },
      {
        "heading": "Mười điều khoản và mức thông lệ ở vòng đầu",
        "paragraphs": [
          "Định giá là con số ai cũng đọc, nhưng hai term sheet cùng định giá có thể khiến founder nhận số tiền rất khác nhau khi bán công ty. Bảng dưới là mức thường được coi là hợp lý ở vòng thiên thần, pre-seed và seed. Mức thông lệ không phải luật; nó là điểm xuất phát để thương lượng."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": {
          "caption": "Mười điều khoản cần đọc kỹ",
          "headers": [
            "Điều khoản",
            "Mức thông lệ ở vòng đầu",
            "Dấu hiệu cần hỏi lại"
          ],
          "rows": [
            {
              "cells": [
                "Định giá và quỹ cổ phiếu thưởng (ESOP)",
                "Ghi rõ định giá trước hay sau vòng; quỹ ESOP vừa đủ cho kế hoạch tuyển 12 đến 18 tháng",
                "Quỹ ESOP lớn phải tạo trước vòng, làm định giá thực thấp hơn con số ghi trên giấy"
              ]
            },
            {
              "cells": [
                "Ưu đãi thanh lý",
                "1 lần, không tham gia chia tiếp",
                "Hệ số trên 1 lần, hoặc có tham gia chia tiếp"
              ]
            },
            {
              "cells": [
                "Chống pha loãng",
                "Trung bình gia quyền diện rộng, có ngoại lệ cho quỹ ESOP",
                "Điều chỉnh toàn phần (full ratchet)"
              ]
            },
            {
              "cells": [
                "Vesting của founder",
                "4 năm, cliff 1 năm, có tính thời gian đã làm",
                "Tính lại từ đầu, không tăng tốc khi công ty được bán"
              ]
            },
            {
              "cells": [
                "Hội đồng quản trị",
                "Founder giữ đa số ghế, nhà đầu tư dẫn dắt có một ghế",
                "Nhà đầu tư giữ đa số ghế ngay từ vòng đầu"
              ]
            },
            {
              "cells": [
                "Quyền phủ quyết",
                "Chỉ các việc làm thay đổi quyền của nhà đầu tư: bán công ty, phát hành thêm, sửa điều lệ",
                "Phủ quyết cả ngân sách, tuyển dụng, hợp đồng thường ngày"
              ]
            },
            {
              "cells": [
                "Quyền kéo theo",
                "Cần đa số cả cổ đông phổ thông lẫn cổ đông ưu đãi, có giá sàn",
                "Nhà đầu tư tự quyết được việc bán công ty"
              ]
            },
            {
              "cells": [
                "Ưu tiên mua và bán cùng",
                "Có, kèm ngoại lệ cho chuyển nhượng nhỏ",
                "Cấm founder bán trong thời gian dài, hoặc mỗi lần bán cần nhà đầu tư đồng ý"
              ]
            },
            {
              "cells": [
                "Quyền tham gia vòng sau",
                "Giữ tỷ lệ ở vòng kế tiếp",
                "Được mua vượt tỷ lệ, hoặc ưu tiên trước mọi nhà đầu tư mới"
              ]
            },
            {
              "cells": [
                "Quyền thông tin",
                "Báo cáo quý, báo cáo năm, ngân sách năm",
                "Truy cập toàn bộ sổ sách và hệ thống bất cứ lúc nào"
              ]
            }
          ]
        },
        "notes": [
          "Công cụ Đọc term sheet bằng con số trên fundraising.vn tính ba điều khoản đầu (ESOP, ưu đãi thanh lý, chống pha loãng) ra số tiền founder nhận ở nhiều mức giá bán, và soát các điều khoản còn lại theo đúng bảng này."
        ]
      },
      {
        "heading": "Cờ đỏ lớn nhất: founder cam kết mua lại bằng tài sản cá nhân",
        "paragraphs": [
          "Term sheet theo mẫu quốc tế hiếm khi có điều khoản này, nên các bài viết dịch từ nước ngoài thường bỏ qua. Nhưng với một số nhà đầu tư trong nước, đặc biệt là nhà đầu tư cá nhân và doanh nghiệp không chuyên đầu tư mạo hiểm, không hiếm gặp điều khoản buộc founder tự mua lại cổ phần của nhà đầu tư nếu công ty không đạt mục tiêu doanh thu, không gọi được vòng sau, hoặc không bán được sau một số năm, thường kèm một mức lãi cam kết.",
          "Ví dụ minh họa: nhà đầu tư rót 5 tỷ đồng, kèm điều khoản founder phải mua lại sau 3 năm với lãi 12% mỗi năm nếu công ty không đạt mục tiêu. Đến hạn, founder phải tự trả khoảng 7 tỷ đồng (5 tỷ nhân 1,12 mũ 3). Lúc đó công ty thường đang khó khăn, nên số tiền này gần như chắc chắn đến từ tài sản riêng của founder.",
          "Về bản chất, điều khoản này biến khoản đầu tư thành một khoản vay đứng tên founder, trong khi nhà đầu tư vẫn giữ toàn bộ quyền của cổ đông nếu công ty thành công. Rủi ro của bên góp vốn bị chuyển hết sang người sáng lập."
        ],
        "bullets": [
          "Không chấp nhận cam kết mua lại, bảo lãnh hay thế chấp bằng tài sản cá nhân của founder.",
          "Nếu nhà đầu tư cần một lối ra được bảo đảm, đề nghị để công ty (không phải founder) mua lại theo giá gốc, sau một thời gian dài, và chỉ trong phạm vi công ty còn đủ tiền theo luật.",
          "Nếu nhà đầu tư thật sự muốn lợi nhuận cố định, có thể bàn thẳng một khoản vay hoặc trái phiếu chuyển đổi của công ty, với điều khoản rõ ràng, thay vì gọi đó là đầu tư cổ phần.",
          "Cảnh giác với các tên gọi khác: cam kết hiệu quả, điều khoản bảo đảm lợi nhuận, quyền bán lại cho cổ đông sáng lập."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Ký ở công ty Việt Nam: điều gì ghi được vào điều lệ",
        "paragraphs": [
          "Term sheet theo mẫu quốc tế được viết cho luật của những nơi như Delaware hay Singapore, nơi cổ phần ưu đãi có thể mang gần như bất kỳ quyền nào hai bên thoả thuận. Luật Doanh nghiệp 2020 của Việt Nam chặt hơn, nên một số điều khoản không thể chuyển nguyên vào điều lệ.",
          "Theo Điều 114 Luật Doanh nghiệp 2020, ngoài cổ phần phổ thông, công ty cổ phần có thể có cổ phần ưu đãi cổ tức, ưu đãi hoàn lại, ưu đãi biểu quyết và các loại ưu đãi khác do điều lệ quy định. Một vài điểm ảnh hưởng trực tiếp tới term sheet:"
        ],
        "bullets": [
          "Cổ phần ưu đãi biểu quyết chỉ dành cho tổ chức được Chính phủ uỷ quyền và cổ đông sáng lập, và hiệu lực ưu đãi chỉ kéo dài 3 năm. Nhà đầu tư không thể nhận loại cổ phần này.",
          "Cổ phần ưu đãi có thể chuyển thành cổ phần phổ thông theo nghị quyết Đại hội đồng cổ đông, nhưng cổ phần phổ thông không chuyển ngược thành cổ phần ưu đãi được.",
          "Quyền ưu tiên nhận tài sản của cổ đông ưu đãi cổ tức theo luật áp dụng khi công ty giải thể hoặc phá sản. Đó không giống ưu đãi thanh lý trong term sheet, vốn áp dụng chủ yếu khi bán công ty.",
          "Vì vậy, các quyền như ưu đãi thanh lý khi bán công ty, chống pha loãng, quyền kéo theo thường nằm trong thoả thuận cổ đông (một hợp đồng giữa các cổ đông) thay vì chỉ trong điều lệ. Hợp đồng ràng buộc các bên ký, nhưng việc thực thi phụ thuộc vào cách soạn và nơi giải quyết tranh chấp.",
          "Công ty TNHH không phát hành được cổ phần, nên muốn nhận vốn theo kiểu này thường phải chuyển thành công ty cổ phần trước.",
          "Trong 3 năm đầu, cổ phần phổ thông của cổ đông sáng lập bị hạn chế chuyển nhượng cho người ngoài nhóm sáng lập, trừ khi Đại hội đồng cổ đông chấp thuận. Điều này ảnh hưởng tới các điều khoản về chuyển nhượng và quyền kéo theo.",
          "Nhà đầu tư nước ngoài trong một số trường hợp phải làm thủ tục đăng ký góp vốn, mua cổ phần theo Luật Đầu tư trước khi trở thành cổ đông, nên lịch giải ngân cần tính thêm thời gian này."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": [
          "Đây là lý do nhiều startup Việt Nam gọi vốn quỹ nước ngoài thông qua một công ty mẹ ở Singapore: term sheet và thoả thuận cổ đông áp dụng luật Singapore, nơi các quyền này đã quen thuộc với quỹ. Đổi lại, cấu trúc này tốn chi phí lập và duy trì, có thủ tục đầu tư ra nước ngoài và đặt ra câu hỏi về thuế. Quyết định này nên làm cùng luật sư, trước vòng có định giá đầu tiên, vì đổi cấu trúc về sau tốn kém hơn nhiều."
        ]
      },
      {
        "heading": "Khi bị đòi ký trong 48 giờ",
        "paragraphs": [
          "Hạn chót rất ngắn là cách tạo áp lực phổ biến. Nhà đầu tư nghiêm túc hiếm khi rút chỉ vì founder xin thêm một tuần để đọc kỹ và hỏi luật sư. Nếu họ rút vì điều đó, có lẽ bạn đã tránh được một mối quan hệ khó khăn trong 5 đến 7 năm tới."
        ],
        "bullets": [
          "Cảm ơn, xác nhận bạn rất quan tâm, và đề nghị một mốc cụ thể, ví dụ phản hồi trong 7 ngày làm việc.",
          "Trong thời gian đó, nhập các con số vào công cụ đọc term sheet để thấy founder nhận bao nhiêu ở nhiều mức giá bán.",
          "Gửi term sheet cho một luật sư có kinh nghiệm về đầu tư mạo hiểm, không chỉ luật sư doanh nghiệp chung.",
          "Gom tất cả câu hỏi và đề nghị sửa vào một lần phản hồi, sắp theo mức quan trọng, thay vì gửi rải rác.",
          "Nếu đang nói chuyện với nhà đầu tư khác, báo cho họ biết bạn đã nhận term sheet. Đây thường là lúc các cuộc trò chuyện song song tăng tốc."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Đọc một term sheet trong năm bước",
        "paragraphs": [
          "Áp dụng thứ tự này cho mọi term sheet, kể cả khi bạn tin nhà đầu tư."
        ],
        "bullets": [
          "Bước 1: tìm phần ràng buộc ngay khi ký và kiểm theo bảng ở trên.",
          "Bước 2: tìm mọi điều khoản đặt nghĩa vụ lên cá nhân founder: cam kết mua lại, bảo lãnh, phạt, hạn chế làm việc sau khi rời công ty.",
          "Bước 3: tính số tiền founder nhận ở ít nhất ba mức giá bán, có tính ESOP, ưu đãi thanh lý và chống pha loãng.",
          "Bước 4: soát các điều khoản kiểm soát: hội đồng quản trị, quyền phủ quyết, quyền kéo theo.",
          "Bước 5: hỏi luật sư điều khoản nào ghi được vào điều lệ, điều khoản nào phải nằm trong thoả thuận cổ đông, và cách thực thi khi có tranh chấp."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Tóm lại",
        "paragraphs": [
          "Term sheet quyết định ai kiểm soát công ty và ai nhận bao nhiêu tiền trong nhiều năm tới. Thương lượng trước khi ký, đọc phần ràng buộc đầu tiên, và không bao giờ đặt tài sản cá nhân để bảo đảm cho khoản đầu tư vào công ty.",
          "Ở Việt Nam, câu hỏi không chỉ là điều khoản nào hợp lý, mà còn là điều khoản nào ghi được vào điều lệ và thực thi được. Bài này không phải tư vấn pháp lý; hãy làm việc với luật sư có kinh nghiệm đầu tư mạo hiểm trước khi ký."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      }
    ],
    "relatedTools": [
      {
        "slug": "doc-term-sheet",
        "label": "Soát term sheet của bạn bằng con số"
      },
      {
        "slug": "bang-co-phan-va-pha-loang",
        "label": "Xem cap table sau vòng, có tính quỹ ESOP"
      },
      {
        "slug": "safe-va-trai-phieu-chuyen-doi",
        "label": "So sánh với SAFE và trái phiếu chuyển đổi"
      },
      {
        "slug": "ho-so-phap-ly-khoi-nghiep",
        "label": "Rà hồ sơ pháp lý trước khi ký"
      }
    ],
    "sources": [
      {
        "label": "Vietnam Law Magazine: Legal framework relating to shares, an overview (10/2022)",
        "url": "https://vietnamlawmagazine.vn/legal-framework-relating-to-shares-an-overview-49106.html"
      },
      {
        "label": "Luật Doanh nghiệp 2020, Điều 114: Cổ phần",
        "url": "https://hethongphapluat.com/luat-doanh-nghiep-2020/khoan-3-dieu-114"
      },
      {
        "label": "Bộ Tư pháp: Trường hợp hạn chế chuyển nhượng cổ phần",
        "url": "https://htpldn.moj.gov.vn/Pages/chi-tiet-pho-bien.aspx?ItemID=161"
      },
      {
        "label": "NVCA: bộ văn bản mẫu cho đầu tư mạo hiểm (Hoa Kỳ)",
        "url": "https://nvca.org/model-legal-documents/"
      }
    ],
    "seoTitle": "Term sheet startup Việt Nam: phần ràng buộc, 10 điều khoản, cam kết mua lại và Luật Doanh nghiệp 2020",
    "seoDescription": "Đọc term sheet gọi vốn ở Việt Nam: điều khoản ràng buộc ngay khi ký, mức thông lệ của 10 điều khoản ở vòng đầu, cờ đỏ cam kết mua lại bằng tài sản cá nhân, cổ phần ưu đãi theo Luật Doanh nghiệp 2020, công ty mẹ ở Singapore và cách xử lý hạn chót 48 giờ.",
    "publishedAt": "2026-10-07",
    "updatedAt": "2026-10-08",
    "track": "cam-nang",
    "readingMinutes": 10
  },
  {
    "slug": "thoai-von-o-viet-nam-ai-mua-startup",
    "title": "Thoái vốn ở Việt Nam: ai mua startup, vì sao họ mua, và founder cần chuẩn bị gì từ vòng đầu",
    "excerpt": "Quỹ chỉ kiếm được tiền khi bán lại cổ phần, nên ngay ở vòng đầu họ đã tự hỏi công ty bạn sẽ được ai mua. Bài này đi qua bốn lối ra của một startup, những thương vụ có thật ở Việt Nam để thấy người mua thường là ai, điều khoản ưu đãi thanh lý ảnh hưởng tới phần founder nhận về ra sao, và sáu việc nên làm từ sớm để công ty dễ bán khi thời điểm đến.",
    "category": "Góc nhìn quỹ",
    "stages": [
      "Pre-seed",
      "Seed",
      "Series A"
    ],
    "storyType": "huong-dan",
    "templates": [
      "bo-ho-so-tham-dinh-data-room"
    ],
    "consentConfirmed": false,
    "coverImage": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Fthoai-von-o-viet-nam-ai-mua-startup%2F1791381633854-cover.webp?alt=media&token=e50190e5-83b6-48cd-877f-972b2e5a0d28",
    "coverAlt": "Bốn lối ra của startup: bán cho doanh nghiệp chiến lược, bán cho quỹ, bán cổ phần thứ cấp và niêm yết",
    "coverCaption": "Ở Việt Nam, bán cho một doanh nghiệp chiến lược vẫn là lối ra phổ biến nhất của startup.",
    "ogImage": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Fthoai-von-o-viet-nam-ai-mua-startup%2F1791381640179-cover.jpg?alt=media&token=7f6df9fe-d07a-4372-9cc7-d7e12d3df8ee",
    "author": "Fundraising Vietnam",
    "authorRole": "",
    "status": "PUBLISHED",
    "featured": false,
    "sections": [
      {
        "heading": "Vì sao quỹ hỏi chuyện bán công ty khi bạn mới gọi vòng đầu",
        "paragraphs": [
          "Founder thường bất ngờ khi trong buổi gặp đầu tiên, nhà đầu tư hỏi: theo bạn, sau này ai sẽ mua công ty này? Câu hỏi nghe như quá xa, nhưng với quỹ thì đó là câu hỏi cốt lõi.",
          "Quỹ đầu tư mạo hiểm huy động tiền từ các nhà đầu tư góp vốn (thường gọi là LP), và phải trả lại tiền cho họ sau một khoảng thời gian định trước, thường khoảng 10 năm. Quỹ chỉ có tiền để trả khi bán được cổ phần đang nắm. Cổ phần trong một công ty tốt mà không ai mua thì vẫn chỉ là con số trên giấy.",
          "Thêm vào đó, phần lớn khoản đầu tư giai đoạn sớm sẽ không thành công. Quỹ trông vào một vài công ty bán được với giá rất cao để bù cho phần còn lại. Vì thế họ cần tin rằng công ty bạn không chỉ tăng trưởng tốt, mà còn có người mua thật ở mức giá đủ lớn."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Bốn lối ra của một startup",
        "paragraphs": [
          "Thoái vốn là lúc nhà đầu tư (và founder) đổi cổ phần thành tiền. Có bốn con đường chính, khác nhau về người mua, thời điểm và điều kiện."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": {
          "caption": "Bốn lối ra phổ biến",
          "headers": [
            "Lối ra",
            "Người mua",
            "Khi nào xảy ra",
            "Điều kiện thường cần"
          ],
          "rows": [
            {
              "cells": [
                "Bán cho doanh nghiệp chiến lược (M&A)",
                "Tập đoàn trong nước, công ty cùng ngành trong khu vực, hãng công nghệ nước ngoài",
                "Bất kỳ giai đoạn nào, phổ biến nhất khi công ty có vị thế rõ trong một mảng",
                "Sản phẩm, khách hàng hoặc đội ngũ bổ sung đúng chỗ người mua đang thiếu"
              ]
            },
            {
              "cells": [
                "Bán cho quỹ khác hoặc quỹ PE",
                "Quỹ tăng trưởng, quỹ PE mua phần lớn công ty",
                "Khi công ty đã lớn, có lợi nhuận hoặc dòng tiền ổn định",
                "Số liệu tài chính đã kiểm toán, tăng trưởng đều"
              ]
            },
            {
              "cells": [
                "Bán cổ phần thứ cấp",
                "Nhà đầu tư vòng sau mua lại phần của nhà đầu tư cũ",
                "Trong một vòng gọi vốn mới",
                "Có nhà đầu tư mới muốn tăng tỷ lệ sở hữu"
              ]
            },
            {
              "cells": [
                "Niêm yết (IPO)",
                "Nhà đầu tư trên thị trường chứng khoán",
                "Khi công ty rất lớn và đáp ứng tiêu chí niêm yết",
                "Lợi nhuận, quy mô vốn, quản trị minh bạch theo chuẩn công ty đại chúng"
              ]
            }
          ]
        },
        "notes": [
          "Bán cổ phần thứ cấp chỉ là lối ra cho một phần cổ đông, công ty vẫn tiếp tục hoạt động độc lập. Chủ đề này có bài riêng trong Playbook."
        ]
      },
      {
        "heading": "Ai đã mua startup ở Việt Nam",
        "paragraphs": [
          "Nhìn vào các thương vụ đã được công bố giúp founder hình dung người mua thật sự trông như thế nào. Dưới đây là một số thương vụ tiêu biểu, lấy theo nguồn công khai."
        ],
        "bullets": [
          "Nền tảng lớn mua để thêm một mảng mới hoặc thêm người dùng: Sea với Foody, Tiki với Ticketbox.",
          "Hợp nhất trong khu vực: các nền tảng cùng ngành ở nhiều nước gộp lại để có quy mô, như Chợ Tốt về với Carousell.",
          "Hãng công nghệ nước ngoài mua đội ngũ và năng lực nghiên cứu: Nvidia với VinBrain, Qualcomm với MovianAI. Ở dạng này, chất lượng kỹ sư và công nghệ quan trọng hơn doanh thu."
        ],
        "image": null,
        "quote": null,
        "table": {
          "caption": "Một số thương vụ mua lại startup công nghệ tại Việt Nam",
          "headers": [
            "Năm",
            "Người mua",
            "Công ty được mua",
            "Ghi chú theo nguồn công khai"
          ],
          "rows": [
            {
              "cells": [
                "2017",
                "Sea (Garena)",
                "Foody",
                "Mua khoảng 82% với giá khoảng 64 triệu USD, công bố trong hồ sơ IPO của Sea"
              ]
            },
            {
              "cells": [
                "2019",
                "Carousell (Singapore)",
                "Chợ Tốt, qua việc sáp nhập mảng rao vặt 701Search của Telenor",
                "Gộp các nền tảng rao vặt trong khu vực về một nhóm lớn hơn"
              ]
            },
            {
              "cells": [
                "2019",
                "Tiki",
                "Ticketbox",
                "Thương vụ mua lại đầu tiên của Tiki, mở rộng sang mảng giải trí"
              ]
            },
            {
              "cells": [
                "2024",
                "Nvidia",
                "VinBrain (của Vingroup)",
                "Mua công ty AI trong y tế, gắn với kế hoạch đặt trung tâm nghiên cứu AI tại Việt Nam"
              ]
            },
            {
              "cells": [
                "2025",
                "Qualcomm",
                "MovianAI (mảng AI tạo sinh của VinAI)",
                "Mua đội ngũ và năng lực nghiên cứu AI"
              ]
            }
          ]
        },
        "notes": [
          "Theo một hội thảo về M&A được VnEconomy đưa tin, 10 tháng đầu năm 2025 Việt Nam có khoảng 218 thương vụ M&A, tổng giá trị khoảng 2,3 tỷ USD, phần lớn ở các ngành truyền thống. Báo cáo của NIC, VPCA và Do Ventures ghi nhận vốn PE năm 2025 khoảng 4 tỷ USD, chủ yếu là các thương vụ mua lại quyền kiểm soát. Thương vụ mua startup công nghệ chỉ là phần nhỏ, nhưng đang tăng ở các mảng AI, bán dẫn và dữ liệu."
        ]
      },
      {
        "heading": "Còn niêm yết thì sao",
        "paragraphs": [
          "Niêm yết trên sàn chứng khoán trong nước hiện chưa phải lối ra thực tế cho phần lớn startup công nghệ, vì tiêu chí niêm yết dựa nhiều vào lợi nhuận và quy mô vốn, trong khi startup thường lỗ trong nhiều năm để tăng trưởng.",
          "Theo báo cáo của NIC, VPCA và Do Ventures, cơ quan quản lý đang xây dựng một sàn giao dịch riêng cho doanh nghiệp đổi mới sáng tạo với tiêu chí linh hoạt hơn, dự kiến ra mắt năm 2027. Đây là tín hiệu đáng theo dõi, nhưng khi trình bày với nhà đầu tư hôm nay, đừng đặt kế hoạch thoái vốn chủ yếu vào một sàn chưa vận hành. M&A vẫn nên là kịch bản chính."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Ưu đãi thanh lý: vì sao bán công ty chưa chắc founder được nhiều",
        "paragraphs": [
          "Khi công ty được bán, tiền không luôn chia đúng theo tỷ lệ sở hữu. Phần lớn nhà đầu tư vòng có định giá sẽ yêu cầu điều khoản ưu đãi thanh lý (liquidation preference): khi bán công ty, họ được nhận lại số tiền đã đầu tư trước, rồi phần còn lại mới chia.",
          "Ví dụ minh họa: nhà đầu tư rót 20 tỷ đồng để nhận 25% công ty (định giá sau vòng 80 tỷ). Bảng dưới so sánh tiền nhà đầu tư nhận ở ba mức giá bán, với ba kiểu điều khoản: không có ưu đãi; ưu đãi 1 lần không tham gia (nhận lại 20 tỷ hoặc nhận 25%, chọn bên lớn hơn); và ưu đãi 1 lần có tham gia (nhận lại 20 tỷ rồi vẫn chia 25% phần còn lại)."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": {
          "caption": "Nhà đầu tư rót 20 tỷ cho 25%. Tiền nhà đầu tư nhận / phần còn lại cho founder và cổ đông khác (tỷ đồng)",
          "headers": [
            "Giá bán công ty",
            "Không có ưu đãi",
            "Ưu đãi 1 lần, không tham gia",
            "Ưu đãi 1 lần, có tham gia"
          ],
          "rows": [
            {
              "cells": [
                "200 tỷ",
                "50 / 150",
                "50 / 150",
                "65 / 135"
              ]
            },
            {
              "cells": [
                "60 tỷ",
                "15 / 45",
                "20 / 40",
                "30 / 30"
              ]
            },
            {
              "cells": [
                "30 tỷ",
                "7,5 / 22,5",
                "20 / 10",
                "22,5 / 7,5"
              ]
            }
          ]
        },
        "notes": [
          "Khi bán với giá cao, ưu đãi không tham gia gần như không ảnh hưởng tới founder. Khi bán với giá thấp, nó quyết định founder còn được bao nhiêu. Ưu đãi có tham gia thì luôn lấy thêm phần của founder ở mọi mức giá. Ở vòng đầu, ưu đãi 1 lần không tham gia là mức phổ biến và hợp lý; hãy đọc kỹ nếu term sheet ghi hệ số lớn hơn 1 lần hoặc có chữ tham gia (participating)."
        ]
      },
      {
        "heading": "Sáu việc nên làm từ vòng đầu để công ty dễ bán",
        "paragraphs": [
          "Người mua sẽ thẩm định công ty kỹ hơn bất kỳ nhà đầu tư nào. Nhiều thương vụ đổ vỡ hoặc bị ép giá không phải vì sản phẩm, mà vì giấy tờ. Những việc dưới đây rẻ khi làm sớm và rất đắt khi làm lúc đã có người hỏi mua."
        ],
        "bullets": [
          "Giữ cap table sạch: mọi cổ phần, quyền chọn và khoản đầu tư chuyển đổi (SAFE, trái phiếu chuyển đổi) đều có văn bản và khớp với đăng ký doanh nghiệp.",
          "Đứng tên công ty cho mọi tài sản trí tuệ: mã nguồn, tên miền, nhãn hiệu, dữ liệu. Người viết mã và người thiết kế phải có hợp đồng ghi rõ sản phẩm thuộc về công ty.",
          "Đọc kỹ các điều khoản thoái vốn trong term sheet: ưu đãi thanh lý, quyền kéo theo (drag-along), quyền bán cùng (tag-along), quyền ưu tiên mua. Chúng quyết định ai được phép bán, bán thế nào và chia tiền ra sao.",
          "Làm báo cáo tài chính đúng chuẩn và kiểm toán khi đủ lớn. Người mua sẽ đối chiếu số trong deck với sổ sách.",
          "Cân nhắc cấu trúc pháp nhân sớm. Nếu dự định gọi vốn nước ngoài và bán cho người mua quốc tế, việc có công ty mẹ ở nước ngoài hay không ảnh hưởng tới thủ tục và thuế khi bán. Hỏi luật sư trước vòng có định giá.",
          "Xây quan hệ với người mua tiềm năng từ sớm qua hợp tác kinh doanh. Phần lớn thương vụ bắt đầu từ một mối hợp tác đã chứng minh được giá trị, không phải từ một cuộc gọi bất ngờ."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Nói gì về thoái vốn trong pitch deck",
        "paragraphs": [
          "Ở vòng thiên thần và pre-seed, một slide hoặc thậm chí một đoạn trong slide thị trường là đủ: kể tên vài nhóm người mua có lý do chiến lược, kèm một hai thương vụ tương tự trong khu vực. Đừng hứa một mức định giá thoái vốn cụ thể khi công ty chưa có doanh thu.",
          "Từ vòng seed trở đi, nếu bạn đưa con số lợi nhuận cho nhà đầu tư vào deck, hãy chắc chắn các con số khớp nhau. Đây là slide hay sai nhất trong các deck chúng tôi nhận xét. Bài Slide thoái vốn trong pitch deck trong Playbook hướng dẫn cách tính từng bước."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Tóm lại",
        "paragraphs": [
          "Thoái vốn không phải chuyện của 7 năm sau. Nó là lý do quỹ bỏ tiền vào hôm nay. Ở Việt Nam, bán cho doanh nghiệp chiến lược vẫn là con đường phổ biến nhất, và người mua thường tìm thứ họ đang thiếu: người dùng, một mảng sản phẩm mới, hoặc đội ngũ kỹ thuật giỏi.",
          "Founder không cần một kế hoạch bán công ty chi tiết ở vòng đầu, nhưng cần hiểu ai có thể mua, điều khoản nào quyết định phần mình nhận về, và giữ công ty sạch sẽ về giấy tờ ngay từ đầu."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      }
    ],
    "relatedTools": [
      {
        "slug": "doc-term-sheet",
        "label": "Đọc ưu đãi thanh lý và các điều khoản thoái vốn bằng con số"
      },
      {
        "slug": "bang-co-phan-va-pha-loang",
        "label": "Xem phần của bạn còn bao nhiêu sau mỗi vòng"
      },
      {
        "slug": "ho-so-phap-ly-khoi-nghiep",
        "label": "Rà hồ sơ pháp lý trước khi có người hỏi mua"
      },
      {
        "slug": "dinh-gia-co-doanh-thu",
        "label": "Ước định giá theo hệ số doanh thu"
      }
    ],
    "sources": [
      {
        "label": "Global Venturing: Foody enters Sea in $64m deal (2017)",
        "url": "https://globalventuring.com/foody-enters-sea-in-64m-deal"
      },
      {
        "label": "Telenor Group merges online classifieds assets with Carousell (2019)",
        "url": "https://telenor.com/media/newsroom/archive/telenor-group-merges-online-classifieds-assets-with-carousell"
      },
      {
        "label": "The Leader: Tiki acquires online ticketing startup Ticketbox (08/2019)",
        "url": "https://e.theleader.vn/e-commerce-platform-tiki-acquires-online-ticketing-startup-ticketbox-1566374272511.htm"
      },
      {
        "label": "Việt Nam News: NVIDIA acquires Vingroup's AI healthcare solution company (2024)",
        "url": "https://vietnamnews.vn/economy/1688629/nvidia-acquires-vingroup-s-ai-healthcare-solution-company.html"
      },
      {
        "label": "SiliconANGLE: Qualcomm acquires MovianAI to bolster AI capabilities (04/2025)",
        "url": "https://siliconangle.com/2025/04/01/qualcomm-acquires-movianai-bolster-ai-capabilities/"
      },
      {
        "label": "VnEconomy: Vietnam's M&A market remains a rare bright spot (12/2025)",
        "url": "https://en.vneconomy.vn/vietnams-ma-market-remains-a-rare-bright-spot-seminar.htm"
      },
      {
        "label": "Việt Nam News: báo cáo Vietnam Innovation and Private Capital của NIC, VPCA và Do Ventures",
        "url": "https://vietnamnews.vn/economy/1782451/"
      }
    ],
    "seoTitle": "Thoái vốn startup ở Việt Nam: M&A, người mua chiến lược, IPO và ưu đãi thanh lý",
    "seoDescription": "Bốn lối ra của startup Việt Nam (M&A, bán cho quỹ, bán cổ phần thứ cấp, IPO), các thương vụ có thật như Sea mua Foody, Nvidia mua VinBrain, Qualcomm mua MovianAI, ví dụ ưu đãi thanh lý bằng số và việc cần chuẩn bị từ vòng đầu.",
    "publishedAt": "2026-10-07",
    "updatedAt": "2026-10-07",
    "track": "kinh-nghiem",
    "readingMinutes": 8
  },
  {
    "slug": "trinh-bay-so-lieu-cho-nha-dau-tu-chon-bieu-do",
    "title": "Trình bày số liệu cho nhà đầu tư: chọn biểu đồ nào, tránh tám lỗi nào",
    "excerpt": "Nhà đầu tư lướt một bảng số trong vài chục giây. Bài này chỉ cách chọn biểu đồ bắt đầu từ câu hỏi người đọc cần trả lời, tám lỗi trình bày hay gặp và cách sửa, cách viết tiêu đề nói thẳng kết luận, và những con số đặc thù của startup Việt (COD, công nợ, mùa Tết) cần nói rõ.",
    "category": "Báo cáo tài chính",
    "stages": [
      "Pre-seed",
      "Seed"
    ],
    "storyType": "huong-dan",
    "templates": [
      "dashboard-bao-cao-nha-dau-tu",
      "dashboard-dong-tien-13-tuan"
    ],
    "consentConfirmed": false,
    "coverImage": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Ftrinh-bay-so-lieu-cho-nha-dau-tu-chon-bieu-do%2F1793244906266-cover.webp?alt=media&token=a148a48d-d61f-4cad-961f-edb40a607a4c",
    "coverAlt": "Hai biểu đồ cùng một bộ số: bên trái nhiều màu, trục bị cắt, tiêu đề chỉ là tên chỉ số; bên phải cột bắt đầu từ 0, một cột tô màu, tiêu đề nói kết luận",
    "coverCaption": "Cùng một bộ số, người đọc hiểu ngay hay phải đoán là do cách trình bày.",
    "ogImage": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Ftrinh-bay-so-lieu-cho-nha-dau-tu-chon-bieu-do%2F1793244913078-cover.jpg?alt=media&token=1bf336b7-214c-46e0-b95d-f8708cdaa031",
    "author": "Fundraising Vietnam",
    "authorRole": "",
    "status": "PUBLISHED",
    "featured": false,
    "sections": [
      {
        "heading": "Người đọc chỉ cho bạn vài chục giây",
        "paragraphs": [
          "Một nhà đầu tư thiên thần nhận hàng chục [[investor-update|báo cáo nhà đầu tư]] và pitch deck mỗi tháng. Họ không đọc từng ô số. Họ nhìn dòng tiêu đề, nhìn hướng đi của biểu đồ, rồi quyết định có đọc tiếp hay không.",
          "Vì vậy việc của bạn không phải là đưa thật nhiều số, mà là làm cho kết luận hiện ra ngay: doanh thu đang tăng hay chững, tiền còn đủ bao lâu, rủi ro nằm ở đâu. Một biểu đồ đúng giúp người đọc thấy điều đó trong một cái liếc. Một biểu đồ sai làm họ nghi ngờ cả những con số đúng."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Bắt đầu từ câu hỏi, không từ loại biểu đồ",
        "paragraphs": [
          "Trước khi chọn biểu đồ, viết nốt câu \"người đọc cần thấy...\". Câu trả lời quyết định loại biểu đồ, rồi mới tới dạng dữ liệu bạn đang có. Bảng dưới gom những câu hỏi startup giai đoạn sớm hay gặp."
        ],
        "bullets": [],
        "image": {
          "url": "https://fundraising.vn/anh/playbook/trinh-bay-so-lieu-cho-nha-dau-tu-chon-bieu-do/ban-do-chon-bieu-do.webp",
          "alt": "Chín ô, mỗi ô một câu hỏi của người đọc và biểu đồ hợp với câu hỏi đó: đường, thanh ngang đã xếp, thanh xếp chồng, phễu, biểu đồ cầu, bảng cohort, ô số lớn, dải kịch bản, cột theo tuổi nợ",
          "caption": "Chín câu hỏi hay gặp và biểu đồ hợp với từng câu. Chi tiết nên dùng, nên tránh ở bảng dưới.",
          "credit": "",
          "width": 1600,
          "height": 1108,
          "fit": "nguyen-ban",
          "position": "dau",
          "urlHep": "https://fundraising.vn/anh/playbook/trinh-bay-so-lieu-cho-nha-dau-tu-chon-bieu-do/ban-do-chon-bieu-do-hep.webp"
        },
        "quote": null,
        "table": {
          "caption": "",
          "headers": [
            "Người đọc cần thấy",
            "Nên dùng",
            "Nên tránh",
            "Ví dụ"
          ],
          "rows": [
            {
              "cells": [
                "Một con số thay đổi theo thời gian",
                "Cột khi có vài tháng, đường khi có nhiều tháng",
                "Hơn bốn đường trên một hình",
                "Doanh thu 12 tháng"
              ]
            },
            {
              "cells": [
                "So sánh vài thứ với nhau",
                "Thanh ngang, xếp từ lớn tới nhỏ",
                "Biểu đồ tròn nhiều lát",
                "Lợi nhuận từng điểm bán"
              ]
            },
            {
              "cells": [
                "Một tổng chia thành các phần",
                "Thanh xếp chồng, hoặc tròn khi tối đa năm phần",
                "Tròn bảy lát trở lên",
                "Doanh thu theo kênh bán"
              ]
            },
            {
              "cells": [
                "Khách đi qua từng bước",
                "Phễu có ghi tỷ lệ đi tiếp giữa các bước",
                "Các cột rời không ghi tỷ lệ",
                "Lượt truy cập, đơn đặt, đơn giao thành công"
              ]
            },
            {
              "cells": [
                "Vì sao số đổi từ A sang B",
                "Biểu đồ cầu: điểm đầu, từng phần cộng trừ, điểm cuối",
                "Chỉ hai cột đầu và cuối",
                "Tiền mặt đầu quý tới cuối quý"
              ]
            },
            {
              "cells": [
                "Nhóm khách giữ lại theo thời gian",
                "Bảng [[cohort-la-gi|cohort]] tô màu theo mức",
                "Một đường tỷ lệ giữ chân chung",
                "Tỷ lệ giữ chân theo tháng đăng ký"
              ]
            },
            {
              "cells": [
                "Một con số quan trọng nhất",
                "Ô số lớn kèm so sánh với kỳ trước hoặc mục tiêu",
                "Đồng hồ đo trang trí",
                "[[runway-la-gi|Runway]], tiền mặt"
              ]
            },
            {
              "cells": [
                "Những gì có thể xảy ra",
                "Dải khoảng hoặc ba kịch bản",
                "Một đường dự báo chắc nịch",
                "Dự báo doanh thu 12 tháng"
              ]
            },
            {
              "cells": [
                "Phân theo thời hạn hay tuổi",
                "Cột giữ thứ tự tự nhiên",
                "Xếp theo giá trị",
                "Công nợ theo tuổi nợ"
              ]
            }
          ]
        },
        "notes": []
      },
      {
        "heading": "Tám lỗi hay gặp và cách sửa",
        "paragraphs": [
          "Mỗi hình dưới đây vẽ cùng một bộ số theo hai cách: bên trái là cách hay gặp trong pitch deck và báo cáo của startup, bên phải là cách sửa. Số liệu chỉ để minh hoạ."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "",
        "paragraphs": [
          "Lỗi 1. Cột không bắt đầu từ 0. Cắt trục làm chênh lệch 4% trông như gấp năm lần, và người đọc có kinh nghiệm nhận ra ngay. Đường thì được phóng to, cột thì không."
        ],
        "bullets": [],
        "image": {
          "url": "https://fundraising.vn/anh/playbook/trinh-bay-so-lieu-cho-nha-dau-tu-chon-bieu-do/loi-1-cot-bat-dau-tu-0.webp",
          "alt": "Hai biểu đồ cột doanh thu bốn quý từ 96 tới 100: bên trái trục bắt đầu từ 95 nên trông như gấp năm lần, bên phải trục bắt đầu từ 0",
          "caption": "",
          "credit": "",
          "width": 1600,
          "height": 767,
          "fit": "nguyen-ban",
          "position": "cuoi",
          "urlHep": "https://fundraising.vn/anh/playbook/trinh-bay-so-lieu-cho-nha-dau-tu-chon-bieu-do/loi-1-cot-bat-dau-tu-0-hep.webp"
        },
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "",
        "paragraphs": [
          "Lỗi 2. Tô màu mọi thứ. Để xám phần bối cảnh, chỉ một màu cho điểm bạn muốn người đọc nhìn, ví dụ tháng báo cáo hay điểm bán đang lỗ."
        ],
        "bullets": [],
        "image": {
          "url": "https://fundraising.vn/anh/playbook/trinh-bay-so-lieu-cho-nha-dau-tu-chon-bieu-do/loi-2-to-mau-mot-diem.webp",
          "alt": "Hai biểu đồ doanh thu 6 tháng: bên trái mỗi cột một màu, bên phải các cột xám và chỉ tháng 10 màu cam",
          "caption": "",
          "credit": "",
          "width": 1600,
          "height": 767,
          "fit": "nguyen-ban",
          "position": "cuoi",
          "urlHep": "https://fundraising.vn/anh/playbook/trinh-bay-so-lieu-cho-nha-dau-tu-chon-bieu-do/loi-2-to-mau-mot-diem-hep.webp"
        },
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "",
        "paragraphs": [
          "Lỗi 3. Bắt người đọc dò chú giải. Ghi tên ngay cạnh đường, ghi số ngay trên cột."
        ],
        "bullets": [],
        "image": {
          "url": "https://fundraising.vn/anh/playbook/trinh-bay-so-lieu-cho-nha-dau-tu-chon-bieu-do/loi-3-ghi-nhan-truc-tiep.webp",
          "alt": "Hai biểu đồ đường đơn hàng ba thành phố: bên trái dùng chú giải Chuỗi 1, 2, 3, bên phải ghi tên thành phố ngay cuối mỗi đường",
          "caption": "",
          "credit": "",
          "width": 1600,
          "height": 767,
          "fit": "nguyen-ban",
          "position": "cuoi",
          "urlHep": "https://fundraising.vn/anh/playbook/trinh-bay-so-lieu-cho-nha-dau-tu-chon-bieu-do/loi-3-ghi-nhan-truc-tiep-hep.webp"
        },
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "",
        "paragraphs": [
          "Lỗi 4. Xếp theo thứ tự chữ cái. Thanh xếp theo giá trị tự kể câu chuyện. Chỉ giữ thứ tự tự nhiên cho thời gian và tuổi nợ."
        ],
        "bullets": [],
        "image": {
          "url": "https://fundraising.vn/anh/playbook/trinh-bay-so-lieu-cho-nha-dau-tu-chon-bieu-do/loi-4-xep-theo-gia-tri.webp",
          "alt": "Hai biểu đồ thanh lợi nhuận năm điểm bán: bên trái xếp theo tên, bên phải xếp từ cao xuống thấp",
          "caption": "",
          "credit": "",
          "width": 1600,
          "height": 751,
          "fit": "nguyen-ban",
          "position": "cuoi",
          "urlHep": "https://fundraising.vn/anh/playbook/trinh-bay-so-lieu-cho-nha-dau-tu-chon-bieu-do/loi-4-xep-theo-gia-tri-hep.webp"
        },
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "",
        "paragraphs": [
          "Lỗi 5. Biểu đồ tròn bảy, tám lát. Mắt không so được các lát mỏng; đổi sang thanh ngang đã xếp."
        ],
        "bullets": [],
        "image": {
          "url": "https://fundraising.vn/anh/playbook/trinh-bay-so-lieu-cho-nha-dau-tu-chon-bieu-do/loi-5-bieu-do-tron.webp",
          "alt": "Bên trái biểu đồ tròn tám kênh bán hàng, bên phải cùng số liệu vẽ thành thanh ngang đã xếp",
          "caption": "",
          "credit": "",
          "width": 1600,
          "height": 797,
          "fit": "nguyen-ban",
          "position": "cuoi",
          "urlHep": "https://fundraising.vn/anh/playbook/trinh-bay-so-lieu-cho-nha-dau-tu-chon-bieu-do/loi-5-bieu-do-tron-hep.webp"
        },
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "",
        "paragraphs": [
          "Lỗi 6. Dự báo là một đường duy nhất. Dự báo là một khoảng; vẽ ba kịch bản hoặc một dải sẽ thật hơn và đỡ bị hỏi vặn."
        ],
        "bullets": [],
        "image": {
          "url": "https://fundraising.vn/anh/playbook/trinh-bay-so-lieu-cho-nha-dau-tu-chon-bieu-do/loi-6-du-bao-la-khoang.webp",
          "alt": "Dự báo doanh thu 6 tháng: bên trái một đường dự báo duy nhất, bên phải ba kịch bản thuận lợi, cơ sở, thận trọng và dải ở giữa",
          "caption": "",
          "credit": "",
          "width": 1600,
          "height": 787,
          "fit": "nguyen-ban",
          "position": "cuoi",
          "urlHep": "https://fundraising.vn/anh/playbook/trinh-bay-so-lieu-cho-nha-dau-tu-chon-bieu-do/loi-6-du-bao-la-khoang-hep.webp"
        },
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "",
        "paragraphs": [
          "Lỗi 7. Tiêu đề chỉ là tên chỉ số. \"Doanh thu theo tháng\" không nói gì. Viết kết luận làm tiêu đề, để tên chỉ số ở dòng nhỏ."
        ],
        "bullets": [],
        "image": {
          "url": "https://fundraising.vn/anh/playbook/trinh-bay-so-lieu-cho-nha-dau-tu-chon-bieu-do/loi-7-tieu-de-noi-ket-luan.webp",
          "alt": "Cùng một biểu đồ doanh thu 6 tháng: bên trái tiêu đề chỉ là tên chỉ số, bên phải tiêu đề nói doanh thu tăng bình quân 18% mỗi tháng",
          "caption": "",
          "credit": "",
          "width": 1600,
          "height": 767,
          "fit": "nguyen-ban",
          "position": "cuoi",
          "urlHep": "https://fundraising.vn/anh/playbook/trinh-bay-so-lieu-cho-nha-dau-tu-chon-bieu-do/loi-7-tieu-de-noi-ket-luan-hep.webp"
        },
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "",
        "paragraphs": [
          "Lỗi 8. Hai trục tung trên một hình. Hai trục cho phép vẽ ra bất kỳ mối tương quan nào bạn muốn. Tách thành hai khung chung trục thời gian, hoặc quy cả hai về chỉ số 100."
        ],
        "bullets": [],
        "image": {
          "url": "https://fundraising.vn/anh/playbook/trinh-bay-so-lieu-cho-nha-dau-tu-chon-bieu-do/loi-8-mot-truc.webp",
          "alt": "Bên trái biểu đồ hai trục tung doanh thu và chi quảng cáo, bên phải cả hai quy về 100 trên một trục: doanh thu tăng 133%, quảng cáo tăng 35%",
          "caption": "",
          "credit": "",
          "width": 1600,
          "height": 826,
          "fit": "nguyen-ban",
          "position": "cuoi",
          "urlHep": "https://fundraising.vn/anh/playbook/trinh-bay-so-lieu-cho-nha-dau-tu-chon-bieu-do/loi-8-mot-truc-hep.webp"
        },
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Tiêu đề nói kết luận: viết lại thế nào",
        "paragraphs": [
          "Cùng một biểu đồ, tiêu đề kết luận giúp người đọc biết phải nhìn vào đâu. Vài ví dụ viết lại:"
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": {
          "caption": "",
          "headers": [
            "Tiêu đề chỉ là nhãn",
            "Tiêu đề nói kết luận"
          ],
          "rows": [
            {
              "cells": [
                "Doanh thu theo tháng",
                "Doanh thu tăng bình quân 18% mỗi tháng trong 5 tháng"
              ]
            },
            {
              "cells": [
                "Runway",
                "Còn 9,8 tháng tiền, đủ chạy hết một vòng gọi vốn"
              ]
            },
            {
              "cells": [
                "Tỷ lệ hoàn đơn",
                "Một phần tư đơn đặt không thành tiền"
              ]
            },
            {
              "cells": [
                "Công nợ phải thu",
                "760 triệu đang nằm ở khách, 70 triệu quá hạn trên 90 ngày"
              ]
            },
            {
              "cells": [
                "Lợi nhuận điểm bán",
                "4 trên 5 điểm có lãi tại điểm, điểm Quận 7 mở tháng 8 còn lỗ"
              ]
            }
          ]
        },
        "notes": [
          "Tiêu đề kết luận phải đúng với số. Nếu số không ủng hộ câu bạn muốn viết, sửa câu, đừng sửa biểu đồ."
        ]
      },
      {
        "heading": "Bốn cấp độ phân tích, và báo cáo tốt dừng ở đâu",
        "paragraphs": [
          "Số liệu trả lời được bốn loại câu hỏi, câu sau khó hơn và đáng giá hơn câu trước. Phần lớn báo cáo của startup dừng ở cấp một."
        ],
        "bullets": [
          "Mô tả: chuyện gì đã xảy ra. Doanh thu, chi phí, tiền mặt tháng này.",
          "Chẩn đoán: vì sao. Doanh thu tăng nhờ kênh nào, chi phí vượt ở khoản nào.",
          "Dự báo: sắp xảy ra gì. Với mức đốt tiền hiện tại thì hết tiền tháng nào, tuần nào tiền xuống thấp nhất.",
          "Đề xuất: nên làm gì. Cắt khoản nào, cần nhà đầu tư giúp việc gì."
        ],
        "image": {
          "url": "https://fundraising.vn/anh/playbook/trinh-bay-so-lieu-cho-nha-dau-tu-chon-bieu-do/bon-cap-do-phan-tich.webp",
          "alt": "Bậc thang bốn cấp: mô tả, chẩn đoán, dự báo, đề xuất, mỗi cấp có câu hỏi và ví dụ; phần lớn báo cáo dừng ở cấp một",
          "caption": "Ví dụ bằng số của startup giả định Sổ Chợ.",
          "credit": "",
          "width": 1600,
          "height": 855,
          "fit": "nguyen-ban",
          "position": "cuoi"
        },
        "quote": null,
        "table": null,
        "notes": [
          "Một báo cáo nhà đầu tư tốt có đủ cấp một, giải thích được cấp hai, nêu rủi ro ở cấp ba và kết bằng một hai lời nhờ cụ thể ở cấp bốn."
        ]
      },
      {
        "heading": "Số đặc thù của startup Việt cần nói rõ",
        "paragraphs": [
          "Ba chỗ dưới đây là nơi số của startup Việt hay bị đọc sai. Hình minh hoạ chỗ đầu tiên: từ giá trị đơn đặt tới doanh thu thực, vẽ bằng biểu đồ cầu."
        ],
        "bullets": [
          "Giá trị đơn đặt khác doanh thu thực. Bán hàng trả tiền khi nhận (COD) có phần đơn bị từ chối, hoàn, huỷ. Báo doanh thu sau hoàn huỷ, và tính [[cac-la-gi|CAC]], ROAS trên doanh thu thực.",
          "Doanh thu đã xuất hoá đơn khác tiền đã thu. Bán cho doanh nghiệp thường bị trả chậm 60, 90 ngày; nêu số phải thu và phần quá hạn cạnh doanh thu.",
          "Mùa Tết làm lệch so sánh tháng trước. Tháng 1, tháng 2 nên so cùng kỳ năm trước, và tách khoản thưởng Tết khỏi chi phí thường xuyên khi tính [[burn-rate|tốc độ đốt tiền]].",
          "Đơn vị thống nhất. Chọn triệu hoặc tỷ đồng cho cả báo cáo, ghi rõ ở đầu trang.",
          "Nói rõ số chưa kiểm toán. Một dòng chân trang là đủ, và nó giúp bạn không bị coi là phóng đại khi số sau này được điều chỉnh."
        ],
        "image": {
          "url": "https://fundraising.vn/anh/playbook/trinh-bay-so-lieu-cho-nha-dau-tu-chon-bieu-do/cau-doanh-thu-cod.webp",
          "alt": "Biểu đồ cầu: giá trị đơn đặt 362 triệu, trừ 60 triệu khách từ chối nhận, 21 triệu hoàn sau khi giao, 9 triệu huỷ trước khi giao, còn doanh thu thực 272 triệu",
          "caption": "Một tháng bán hàng trả tiền khi nhận, số liệu minh hoạ.",
          "credit": "",
          "width": 1600,
          "height": 842,
          "fit": "nguyen-ban",
          "position": "cuoi"
        },
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Dùng thử dashboard mẫu",
        "paragraphs": [
          "fundraising.vn có năm dashboard mẫu làm theo các nguyên tắc trên. Bạn nhập số ngay trên trang, không cần tài khoản, rồi in, lưu PDF hoặc tải Excel có công thức để sửa tiếp. Chưa nhập gì thì mỗi dashboard hiện số ví dụ của một startup giả định để bạn xem trước."
        ],
        "bullets": [
          "[[/mau/dashboard-bao-cao-nha-dau-tu|Báo cáo nhà đầu tư hằng tháng]]: một trang số chính, xu hướng 6 tháng, runway và bốn khối chữ.",
          "[[/mau/dashboard-dong-tien-13-tuan|Runway và dòng tiền 13 tuần]]: số dư từng tuần, tuần tiền thấp nhất, mức tối thiểu cần giữ.",
          "[[/mau/dashboard-chuoi-fnb|Chuỗi F&B]]: lợi nhuận tại từng điểm bán và thời gian hoàn vốn mở điểm.",
          "[[/mau/dashboard-thuong-mai-dien-tu|Thương mại điện tử]]: phễu, doanh thu thực sau hoàn huỷ, ROAS.",
          "[[/mau/dashboard-cong-no-phai-thu|Công nợ phải thu]]: tiền đang nằm ở khách theo tuổi nợ và số ngày thu tiền."
        ],
        "image": {
          "url": "https://fundraising.vn/anh/playbook/trinh-bay-so-lieu-cho-nha-dau-tu-chon-bieu-do/dashboard-bao-cao-nha-dau-tu.webp",
          "alt": "Dashboard báo cáo nhà đầu tư hằng tháng với số ví dụ: tiêu đề nói kết luận, năm ô chỉ số so với tháng trước, biểu đồ doanh thu 6 tháng và thanh runway",
          "caption": "Dashboard báo cáo nhà đầu tư hằng tháng trên fundraising.vn, đang hiện số ví dụ.",
          "credit": "",
          "width": 1600,
          "height": 992,
          "fit": "nguyen-ban",
          "position": "dau"
        },
        "quote": null,
        "table": null,
        "notes": [
          "Cách chọn biểu đồ và các nguyên tắc trong bài tham khảo CM Dashboard Atlas của Christian Martinez, viết lại cho bối cảnh startup Việt Nam."
        ]
      }
    ],
    "relatedTools": [
      {
        "slug": "tinh-runway",
        "label": "Tính runway"
      },
      {
        "slug": "chi-so-tang-truong",
        "label": "Soát chỉ số tăng trưởng"
      },
      {
        "slug": "kiem-tra-gia-dinh-kinh-te-don-vi",
        "label": "Kiểm tra kinh tế đơn vị"
      }
    ],
    "sources": [
      {
        "label": "Christian Martinez: CM Dashboard Atlas, cách chọn biểu đồ và nguyên tắc trình bày số liệu cho tài chính (truy cập 28/10/2026)",
        "url": "https://www.christianmartinez-thefinancialfox.com/dashboard-atlas"
      }
    ],
    "seoTitle": "Trình bày số liệu cho nhà đầu tư: chọn biểu đồ, 8 lỗi hay gặp, mẫu dashboard cho startup",
    "seoDescription": "Cách chọn biểu đồ cho investor update, pitch deck và báo cáo tháng: bắt đầu từ câu hỏi người đọc, 8 lỗi trình bày số liệu và cách sửa, viết tiêu đề nói kết luận, số đặc thù startup Việt Nam và 5 dashboard mẫu miễn phí.",
    "publishedAt": "2026-10-29",
    "updatedAt": "2026-10-29",
    "track": "cam-nang",
    "readingMinutes": 9
  },
  {
    "slug": "tu-pre-series-a-len-series-a-o-viet-nam",
    "title": "Từ pre-Series A lên Series A ở Việt Nam: khoảng cách thật qua số liệu 2023 đến 2025",
    "excerpt": "Gọi được vòng đầu chưa phải là qua cửa. Số liệu ba năm gần nhất cho thấy mỗi năm Việt Nam có khoảng 3 đến 6 thương vụ pre-Series A cho mỗi thương vụ Series A, và quy mô vòng nhảy từ vài trăm nghìn lên vài triệu USD. Bài này đọc các con số đó và chỉ ra startup cần chuẩn bị gì từ ngày nhận vòng đầu.",
    "category": "Góc nhìn quỹ",
    "stages": [
      "Pre-seed",
      "Seed",
      "Series A"
    ],
    "storyType": "huong-dan",
    "templates": [
      "theo-doi-tiep-can-nha-dau-tu"
    ],
    "consentConfirmed": false,
    "coverImage": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Ftu-pre-series-a-len-series-a-o-viet-nam%2F1793521196433-cover.webp?alt=media&token=8d18d9a4-87e8-4a90-8801-0bbbba7326c7",
    "coverAlt": "Năm 2025 Việt Nam có 70 thương vụ pre-Series A nhưng chỉ 23 thương vụ Series A; quy mô vòng trung vị năm 2024 tăng từ 0,3 lên 2 triệu USD",
    "coverCaption": "Mỗi năm có nhiều startup gọi được vòng đầu hơn số startup đi tiếp được tới Series A.",
    "ogImage": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Ftu-pre-series-a-len-series-a-o-viet-nam%2F1793521207162-cover.jpg?alt=media&token=95a88e28-4e1d-432f-925e-3c38865ea49f",
    "author": "Fundraising Vietnam",
    "authorRole": "",
    "status": "PUBLISHED",
    "featured": false,
    "sections": [
      {
        "heading": "Vòng đầu là cửa vào, không phải đích",
        "paragraphs": [
          "Nhiều founder dồn hết sức cho vòng đầu tiên, và khi tiền về thì nghĩ phần khó nhất đã qua. Số liệu cho thấy ngược lại: ở Việt Nam, số startup gọi được vòng pre-Series A mỗi năm luôn nhiều hơn hẳn số startup gọi được Series A. Khoảng 12 đến 24 tháng sau vòng đầu là lúc phần lớn startup bị loại.",
          "Bài này ghép số liệu từ các báo cáo đầu tư đổi mới sáng tạo hằng năm của Trung tâm Đổi mới sáng tạo Quốc gia (NIC), Do Ventures, Cơ quan Vốn tư nhân Việt Nam (VPCA) và BCG, cùng một số báo cáo và phát biểu khác được báo chí đưa tin."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Ba năm qua bằng số",
        "paragraphs": [],
        "bullets": [],
        "image": {
          "url": "https://fundraising.vn/anh/playbook/tu-pre-series-a-len-series-a-o-viet-nam/ba-nam-qua-bang-so.webp",
          "alt": "Hai biểu đồ: tổng vốn đầu tư mạo hiểm 529 triệu USD năm 2023 với 122 thương vụ, 398 triệu năm 2024 với 118 thương vụ, 509 triệu năm 2025 với khoảng 103 thương vụ; số thương vụ pre-Series A so với Seri",
          "caption": "",
          "credit": "",
          "width": 1600,
          "height": 883,
          "fit": "nguyen-ban",
          "position": "cuoi",
          "urlHep": "https://fundraising.vn/anh/playbook/tu-pre-series-a-len-series-a-o-viet-nam/ba-nam-qua-bang-so-hep.webp"
        },
        "quote": null,
        "table": {
          "caption": "Đầu tư mạo hiểm vào startup công nghệ Việt Nam",
          "headers": [
            "Năm",
            "Tổng vốn",
            "Số thương vụ",
            "Pre-Series A",
            "Series A"
          ],
          "rows": [
            {
              "cells": [
                "2023",
                "529 triệu USD",
                "122",
                "96",
                "15"
              ]
            },
            {
              "cells": [
                "2024",
                "398 triệu USD",
                "118",
                "chưa công bố",
                "chưa công bố"
              ]
            },
            {
              "cells": [
                "2025",
                "509 triệu USD",
                "khoảng 103",
                "70",
                "23"
              ]
            }
          ]
        },
        "notes": [
          "Số năm 2023 theo Vietnam Innovation & Tech Investment Report 2024 (NIC, Do Ventures). Số năm 2024 theo Vietnam Innovation & Private Capital Report 2025 (VPCA, NIC, BCG). Số năm 2025 theo bản 2026 của báo cáo này, do TechNode và Việt Nam News đưa tin; các ô ghi chưa công bố là phần mình chưa tìm thấy trong nguồn công khai.",
          "Các báo cáo khác đếm theo phạm vi khác nên ra số khác. Ví dụ báo cáo của VinVentures chỉ ghi nhận khoảng 41 thương vụ, 215 triệu USD trong năm 2025. Khi trích số liệu thị trường trong pitch deck, ghi rõ nguồn và năm."
        ]
      },
      {
        "heading": "Bốn điều đọc được từ bảng",
        "paragraphs": [],
        "bullets": [
          "Phễu hẹp: năm 2023 có khoảng 6 thương vụ pre-Series A cho mỗi thương vụ Series A; năm 2025 khoảng 3. Phễu có rộng hơn, nhưng vẫn là phần lớn startup vòng đầu không đi tiếp trong cùng năm.",
          "Bước nhảy lớn về tiền: năm 2023, trung vị Series A gấp khoảng 12 lần trung vị pre-Series A; năm 2024 khoảng 7 lần. Startup cần [[cot-moc-goi-von|cột mốc]] đủ thuyết phục cho một vòng lớn hơn nhiều lần vòng trước. Vì sao quỹ cần bước nhảy lớn như vậy: xem [[/playbook/toan-hoc-quy-vc-vi-sao-quy-tu-choi-startup-co-lai|Toán học của quỹ VC]].",
          "Quỹ ưu tiên công ty đã có trong danh mục: theo VinVentures và Chứng khoán Thiên Việt (TVS), khoảng 60% vốn năm 2025 được dùng cho vòng tiếp nối và vòng cầu nối của các startup đã đầu tư. Startup mới phải cạnh tranh với phần tiền nhỏ hơn.",
          "Vòng cỡ vừa tăng lên: theo TVS, tỷ lệ thương vụ từ 1 đến 5 triệu USD tăng từ khoảng 21% năm 2023 lên khoảng 41% năm 2025. Nhiều vòng Series A ở Việt Nam hiện nhỏ hơn hình dung của founder đọc tin tức quốc tế."
        ],
        "image": {
          "url": "https://fundraising.vn/anh/playbook/tu-pre-series-a-len-series-a-o-viet-nam/bon-dieu-doc-duoc.webp",
          "alt": "Ba thẻ: quy mô vòng trung vị Series A gấp 12 lần pre-Series A năm 2023 (6 so với 0,5 triệu USD) và gần 7 lần năm 2024 (2 so với 0,3); 60% vốn năm 2025 vào vòng tiếp nối và cầu nối; tỷ lệ thương vụ 1 đ",
          "caption": "",
          "credit": "",
          "width": 1600,
          "height": 727,
          "fit": "nguyen-ban",
          "position": "cuoi",
          "urlHep": "https://fundraising.vn/anh/playbook/tu-pre-series-a-len-series-a-o-viet-nam/bon-dieu-doc-duoc-hep.webp"
        },
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Nhà đầu tư Series A cần thấy gì",
        "paragraphs": [
          "Không có ngưỡng chung được công bố cho thị trường Việt Nam, và mỗi quỹ có khẩu vị riêng. Nhưng câu hỏi chuyển hẳn: ở vòng đầu, nhà đầu tư hỏi đội ngũ có làm được không; ở Series A, họ hỏi mô hình đã chạy chưa và đổ thêm tiền vào có tăng trưởng tương ứng không.",
          "Theo báo cáo của VinVentures, khoảng 70% số startup gọi được vốn năm 2025 đã có doanh thu. Với startup hướng tới Series A, ba nhóm bằng chứng thường được hỏi là doanh thu định kỳ tăng đều qua nhiều tháng, kinh tế đơn vị có lãi trên mỗi khách hàng, và một kênh tăng trưởng lặp lại được với chi phí biết trước."
        ],
        "bullets": [
          "Doanh thu và tăng trưởng: số theo tháng ít nhất 12 tháng gần nhất, định nghĩa chỉ số không đổi giữa các kỳ.",
          "Giữ chân khách hàng: tỷ lệ rời bỏ theo nhóm khách ([[cohort-la-gi|cohort]]) và [[nrr-net-revenue-retention|giữ chân doanh thu ròng]].",
          "Hiệu quả dùng vốn: [[payback-period|thời gian hoàn vốn chi phí có khách]], [[burn-multiple]], mức đốt tiền so với tăng trưởng.",
          "Đội ngũ đủ cho giai đoạn mở rộng: ai phụ trách bán hàng, vận hành, tài chính."
        ],
        "image": {
          "url": "https://fundraising.vn/anh/playbook/tu-pre-series-a-len-series-a-o-viet-nam/cau-hoi-nha-dau-tu-doi.webp",
          "alt": "So sánh câu hỏi của nhà đầu tư: vòng đầu hỏi đội ngũ có làm được không; Series A hỏi mô hình đã chạy chưa, kèm bốn nhóm bằng chứng doanh thu và tăng trưởng, giữ chân khách hàng, hiệu quả dùng vốn, đội",
          "caption": "",
          "credit": "",
          "width": 1600,
          "height": 920,
          "fit": "nguyen-ban",
          "position": "cuoi",
          "urlHep": "https://fundraising.vn/anh/playbook/tu-pre-series-a-len-series-a-o-viet-nam/cau-hoi-nha-dau-tu-doi-hep.webp"
        },
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Lập kế hoạch cho bước nhảy ngay từ vòng đầu",
        "paragraphs": [
          "Ví dụ: startup gọi pre-Series A khoảng 8 tỷ đồng (gần mức trung vị 0,3 triệu USD năm 2024, quy đổi khoảng 26.000 đồng một USD), đốt ròng 400 triệu đồng mỗi tháng. Tiền đủ dùng khoảng 20 tháng. Một vòng thường mất 4 đến 6 tháng để đóng, nên thực tế startup chỉ có khoảng 14 đến 16 tháng để đạt cột mốc cho Series A, quy mô có thể gấp 6 đến 7 lần vòng vừa gọi.",
          "Từ đó, vài nguyên tắc cho founder:"
        ],
        "bullets": [
          "Gọi đủ cho 18 đến 24 tháng, không phải 12. Thời gian gọi vòng sau ăn vào runway.",
          "Viết ra cột mốc cho Series A ngay khi nhận vòng đầu, bằng số, và báo cáo tiến độ cho nhà đầu tư hằng quý.",
          "Đừng đẩy định giá vòng đầu quá cao. Định giá cao làm vòng sau khó tăng giá và dễ thành [[vong-giam-gia|vòng giảm giá]] khi cần thêm tiền.",
          "Chuẩn bị sẵn phương án [[bridge-round|vòng cầu nối]], ưu tiên từ chính nhà đầu tư hiện hữu, vì phần lớn vốn năm 2025 đi vào các vòng tiếp nối.",
          "Bắt đầu quan hệ với quỹ Series A sớm 6 đến 9 tháng: gửi [[investor-update|thư cập nhật]] ngắn trước khi thật sự gọi vốn.",
          "Chọn nhà đầu tư vòng đầu có khả năng rót tiếp ở vòng sau. Hỏi thẳng họ để dành bao nhiêu phần trăm quỹ cho vòng tiếp nối."
        ],
        "image": {
          "url": "https://fundraising.vn/anh/playbook/tu-pre-series-a-len-series-a-o-viet-nam/runway-that-de-lam-cot-moc.webp",
          "alt": "Đường tiền còn lại giảm từ 8 tỷ đồng xuống 0 sau 20 tháng khi đốt 400 triệu mỗi tháng; tháng 0 đến 14 là thời gian làm cột mốc, còn 2,4 tỷ ở tháng 14; tháng 14 đến 20 là thời gian gọi vòng sau 4 đến 6",
          "caption": "",
          "credit": "",
          "width": 1600,
          "height": 1019,
          "fit": "nguyen-ban",
          "position": "cuoi",
          "urlHep": "https://fundraising.vn/anh/playbook/tu-pre-series-a-len-series-a-o-viet-nam/runway-that-de-lam-cot-moc-hep.webp"
        },
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Năm câu tự hỏi trước khi nhận vòng đầu",
        "paragraphs": [],
        "bullets": [
          "Với số tiền này, mình đi được tới cột mốc nào, và cột mốc đó có đủ cho một vòng lớn gấp 5 đến 10 lần không?",
          "Nếu vòng sau chậm 6 tháng, mình cắt chi phí ở đâu để sống tiếp?",
          "Nhà đầu tư vòng này có rót tiếp được không, và ai trong mạng lưới của họ đầu tư Series A?",
          "Định giá hôm nay có để lại dư địa cho một vòng tăng giá không?",
          "Mình đã đo đúng những chỉ số mà quỹ Series A sẽ hỏi từ bây giờ chưa?"
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Tóm lại",
        "paragraphs": [
          "Ở Việt Nam, khoảng cách giữa vòng đầu và Series A vừa hẹp về số lượng (khoảng 3 đến 6 thương vụ pre-Series A cho mỗi thương vụ Series A) vừa lớn về tiền (vòng sau thường gấp 7 đến 12 lần). Startup vượt qua được thường là startup lên kế hoạch cho Series A ngay từ ngày nhận vòng đầu: gọi đủ runway, đặt cột mốc bằng số, đo đúng chỉ số và giữ quan hệ với nhà đầu tư vòng sau từ sớm."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      }
    ],
    "relatedTools": [
      {
        "slug": "goi-bao-nhieu",
        "label": "Tính số vốn cần gọi tới cột mốc tiếp theo"
      },
      {
        "slug": "tinh-runway",
        "label": "Tính runway trước khi gọi vòng sau"
      },
      {
        "slug": "chi-so-tang-truong",
        "label": "Theo dõi chỉ số tăng trưởng nhà đầu tư Series A hỏi"
      },
      {
        "slug": "mo-phong-vong-goi-von",
        "label": "Mô phỏng hai vòng và phần còn lại của founder"
      }
    ],
    "sources": [
      {
        "label": "NIC, Do Ventures: Vietnam Innovation & Tech Investment Report 2024 (số liệu 2023)",
        "url": "https://nic.gov.vn/wp-content/uploads/2024/05/Vietnam-Innovation-Tech-Investment-Report-2024_ENG.pdf"
      },
      {
        "label": "VPCA, NIC, BCG: Vietnam Innovation & Private Capital Report 2025 (số liệu 2024)",
        "url": "https://investgame.net/wp-content/uploads/2026/02/2026-02-05-vietnam_innovation_private_capital_report_2025.pdf"
      },
      {
        "label": "TechNode Global: Vietnam's private capital surges to $4.5B (05/2026, số liệu 2025)",
        "url": "https://technode.global/2026/05/29/vietnams-private-capital-surges-to-4-5b-as-pe-hits-record-high-ipo-remains-shut-for-technology/"
      },
      {
        "label": "Việt Nam News: Private capital market rebounds as AI emerges as investment magnet (06/2026)",
        "url": "https://vietnamnews.vn/economy/1782451/private-capital-market-rebounds-as-ai-emerges-as-investment-magnet.html"
      },
      {
        "label": "Việt Nam News: Venture capital falls for fifth straight year in 2025 (báo cáo VinVentures, 01/2026)",
        "url": "https://vietnamnews.vn/economy/1763677/venture-capital-falls-for-fifth-straight-year-in-2025.html"
      },
      {
        "label": "VIR: Capital concentrated in later-stage startups, leaving funding gaps for early ventures (07/2026)",
        "url": "https://vir.com.vn/capital-concentrated-in-later-stage-startups-leaving-funding-gaps-for-early-ventures-156757.html"
      }
    ],
    "seoTitle": "Pre-Series A lên Series A ở Việt Nam: số thương vụ, quy mô vòng trung vị 2023, 2024, 2025 và cách chuẩn bị",
    "seoDescription": "Số liệu đầu tư mạo hiểm Việt Nam 2023 đến 2025 từ NIC, Do Ventures, VPCA và BCG: tổng vốn, số thương vụ pre-Series A và Series A, quy mô vòng trung vị, 60% vốn dành cho vòng tiếp nối, và kế hoạch runway, cột mốc để vượt khoảng cách giữa hai vòng.",
    "publishedAt": "2026-10-20",
    "updatedAt": "2026-11-01",
    "track": "kinh-nghiem",
    "readingMinutes": 6
  },
  {
    "slug": "uu-dai-khu-cong-nghe-so-tap-trung-tung-buoc",
    "title": "Ưu đãi khu công nghệ số tập trung: được gì và làm từng bước thế nào để hưởng",
    "excerpt": "Thuế TNDN 10% trong 15 năm, miễn 4 năm và giảm 50% trong 9 năm, thủ tục đầu tư đặc biệt. Chính sách đã có từ 01/01/2026, nhưng nằm rải rác ở nhiều văn bản. Bài này gom lại thành các bước làm được.",
    "category": "Chính sách & ưu đãi",
    "stages": [
      "Pre-seed",
      "Seed",
      "Series A"
    ],
    "storyType": "huong-dan",
    "templates": [],
    "consentConfirmed": false,
    "coverImage": "https://fundraising.vn/anh/playbook/uu-dai-khu-cong-nghe-so-tap-trung-tung-buoc.webp",
    "coverAlt": "Ưu đãi khu công nghệ số tập trung: thuế TNDN 10% trong 15 năm, miễn 4 năm, giảm 50% tối đa 9 năm, và 9 bước để hưởng",
    "coverCaption": "",
    "ogImage": "https://fundraising.vn/anh/playbook/uu-dai-khu-cong-nghe-so-tap-trung-tung-buoc-og.jpg",
    "author": "Fundraising Vietnam",
    "authorRole": "",
    "status": "PUBLISHED",
    "featured": false,
    "sections": [
      {
        "heading": "Chính sách nhiều, đường đi thì không ai vẽ",
        "paragraphs": [
          "Từ 01/01/2026, Luật Công nghiệp công nghệ số (số 71/2025/QH15) và Nghị định 354/2025/NĐ-CP về khu công nghệ số tập trung có hiệu lực. Trên giấy, doanh nghiệp công nghệ số đặt dự án trong khu được hưởng một trong những gói ưu đãi tốt nhất của pháp luật Việt Nam. Trên thực tế, các quy định nằm rải rác ở một luật chuyên ngành, hai nghị định, Luật Thuế thu nhập doanh nghiệp 2025 và vài thông tư, và gần như không văn bản nào nói rõ ai làm gì, theo thứ tự nào.",
          "Bài này gom các mảnh đó lại theo góc nhìn của người cần làm: doanh nghiệp, founder hoặc nhà đầu tư muốn đặt dự án vào khu và nhận được ưu đãi thật, không chỉ đọc về nó."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Khu công nghệ số tập trung là gì, hiện có những khu nào",
        "paragraphs": [
          "Đây là khu chuyên cho nghiên cứu, phát triển, ứng dụng công nghệ số; sản xuất, kinh doanh sản phẩm và dịch vụ công nghệ số; thiết kế, sản xuất, đóng gói, kiểm thử chip bán dẫn; đào tạo và ươm tạo doanh nghiệp. Khu phải có tối thiểu 5 ha (khu chỉ làm phần mềm, nội dung số, dịch vụ công nghệ số thì 1 ha), tối thiểu 2.000 lao động công nghệ số (khu phần mềm, nội dung, dịch vụ là 1.000) và lao động công nghệ số chiếm ít nhất 60% lao động trong khu.",
          "Mọi khu công nghệ thông tin tập trung đã thành lập hoặc công nhận theo Nghị định 154/2013/NĐ-CP tự động chuyển thành khu công nghệ số tập trung từ 01/01/2026. Theo Bộ Khoa học và Công nghệ, đến tháng 12/2025 cả nước có 8 khu tại Hà Nội, TP. Hồ Chí Minh, Đà Nẵng và Cần Thơ, với hơn 630 doanh nghiệp. Các khu đã được công nhận theo quy định cũ gồm Công viên phần mềm Quang Trung, Công viên phần mềm Đà Nẵng, Khu CNTT tập trung Đà Nẵng (DITP), Khu phức hợp văn phòng FPT Đà Nẵng, Khu CNTT tập trung Cầu Giấy và Khu CNTT tập trung Cần Thơ.",
          "Việc đầu tiên nên làm: xin đơn vị quản lý khu quyết định thành lập hoặc công nhận khu. Ưu đãi theo địa bàn chỉ áp dụng cho dự án nằm trong khu có tư cách này."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Được những ưu đãi gì, và ai được",
        "paragraphs": [],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": {
          "caption": "",
          "headers": [
            "Ưu đãi",
            "Ai được hưởng",
            "Căn cứ",
            "Nhận bằng cách nào"
          ],
          "rows": [
            {
              "cells": [
                "Thuế suất TNDN 10% trong 15 năm",
                "Dự án đầu tư mới đặt tại khu",
                "Luật Thuế TNDN 67/2025/QH15, khoản 1 Điều 13; Nghị định 320/2025/NĐ-CP",
                "Áp dụng khi doanh nghiệp kê khai, quyết toán thuế TNDN. Nên có tư vấn thuế xác nhận"
              ]
            },
            {
              "cells": [
                "Miễn thuế 4 năm, giảm 50% tối đa 9 năm tiếp theo",
                "Cùng dự án đầu tư mới đó",
                "Luật Thuế TNDN 67/2025/QH15, điểm a khoản 1 Điều 14",
                "Tính từ năm đầu có thu nhập chịu thuế; nếu 3 năm đầu chưa có thu nhập chịu thuế thì tính từ năm thứ 4 kể từ năm có doanh thu"
              ]
            },
            {
              "cells": [
                "Ưu đãi đầu tư như địa bàn kinh tế xã hội đặc biệt khó khăn",
                "Khu và các dự án trong khu",
                "Luật 71/2025/QH15, khoản 1 Điều 24",
                "Qua thủ tục đầu tư; hình thức và điều kiện theo luật đầu tư, luật thuế"
              ]
            },
            {
              "cells": [
                "Miễn, giảm tiền thuê đất",
                "Dự án sử dụng đất trong khu (thường là chủ đầu tư hạ tầng và doanh nghiệp thuê đất trực tiếp)",
                "Luật 71/2025/QH15, khoản 3 Điều 24",
                "Làm hồ sơ theo pháp luật đất đai. Doanh nghiệp thuê văn phòng của đơn vị vận hành chỉ hưởng gián tiếp qua giá thuê"
              ]
            },
            {
              "cells": [
                "Thủ tục đầu tư đặc biệt",
                "Dự án trung tâm R&D, trung tâm dữ liệu, chip bán dẫn, sản phẩm công nghệ chiến lược, công nghệ cao",
                "Nghị định 354/2025, Điều 17; Luật Đầu tư 143/2025/QH15, Điều 28",
                "Nhà đầu tư tự chọn ở bước đăng ký đầu tư"
              ]
            },
            {
              "cells": [
                "Miễn, giảm thuế thu nhập cá nhân",
                "Nhân lực công nghệ số chất lượng cao làm việc trong khu",
                "Nghị định 354/2025, Điều 17; Luật 71/2025, Điều 19 và 20; tiêu chí tại Nghị định 353/2025/NĐ-CP, Điều 5 đến 10",
                "Theo pháp luật thuế TNCN; quy trình do bộ, ngành, địa phương hướng dẫn (Nghị định 353, khoản 2 Điều 11)"
              ]
            },
            {
              "cells": [
                "Hỗ trợ chi phí sở hữu trí tuệ",
                "Doanh nghiệp đầu tư trong khu",
                "Nghị định 354/2025, Điều 17",
                "Tra cứu, đăng ký, duy trì, bảo vệ sáng chế, kiểu dáng, nhãn hiệu, bản quyền phần mềm, dữ liệu số. Hỏi đơn vị quản lý khu hoặc tỉnh về chương trình"
              ]
            }
          ]
        },
        "notes": [
          "Ngoài ưu đãi theo địa bàn còn có ưu đãi theo sản phẩm. Dự án sản xuất sản phẩm, dịch vụ công nghệ số trọng điểm trong danh mục của Thông tư 31/2025/TT-BKHCN (10 nhóm, gồm AI, blockchain, điện toán đám mây, dữ liệu lớn, chip bán dẫn) được hưởng ưu đãi đầu tư đặc biệt. Doanh nghiệp sản xuất thiết bị điện tử đáp ứng một trong bốn tiêu chí của Thông tư 33/2025/TT-BKHCN được thuế suất 10% trong 15 năm và miễn 4 năm, giảm 50% trong 9 năm."
        ]
      },
      {
        "heading": "Chín bước để thật sự nhận được ưu đãi",
        "paragraphs": [],
        "bullets": [
          "Bước 1, kiểm tra hoạt động có đúng chức năng khu không. Viết một đoạn mô tả ngắn công ty sẽ làm gì tại khu, đối chiếu với chức năng khu và, nếu có, danh mục sản phẩm trọng điểm của Thông tư 31/2025. Điều 4 Nghị định 353/2025 định nghĩa: sản xuất phần cứng là một hoặc một số khâu nghiên cứu phát triển, thiết kế, chế tạo, lắp ráp, thử nghiệm, kiểm thử, đóng gói; sản xuất phần mềm, nội dung số là một hoặc một số khâu nghiên cứu phát triển, phân tích, sáng tạo, thiết kế, lập trình, thử nghiệm, kiểm thử, đóng gói. Nhà đầu tư nước ngoài cần kiểm tra thêm điều kiện tiếp cận thị trường.",
          "Bước 2, xác nhận tư cách của khu và chọn mặt bằng. Xin đơn vị quản lý khu quyết định thành lập hoặc công nhận, hỏi mặt bằng của bạn thuộc phân khu nào (ít nhất một nửa đất của khu dành cho hoạt động công nghệ số). Lấy thư chào thuê hoặc thỏa thuận thuê nguyên tắc, vì hồ sơ đăng ký đầu tư cần giấy tờ địa điểm.",
          "Bước 3, xác định đây là dự án đầu tư mới. Thuế suất 10% và miễn giảm áp dụng cho dự án đầu tư mới. Chuyển một doanh nghiệp đang hoạt động vào khu, hoặc mở rộng dự án cũ, có thể được xử lý khác: hỏi tư vấn thuế trước khi ký thuê.",
          "Bước 4, chọn hình thức đầu tư. Nhà đầu tư nước ngoài thường lập công ty mới (lộ trình R1); dự án R&D, trung tâm dữ liệu, chip hoặc công nghệ chiến lược có thể chọn thủ tục đầu tư đặc biệt (lộ trình R4). Nhà đầu tư trong nước nên hỏi đơn vị quản lý khu và cơ quan đăng ký đầu tư xem dự án có cần, hoặc có nên, làm thủ tục đăng ký đầu tư để làm căn cứ ưu đãi.",
          "Bước 5, đăng ký đầu tư. Cơ quan đăng ký đầu tư cấp tỉnh cấp, điều chỉnh, thu hồi Giấy chứng nhận đăng ký đầu tư cho dự án trong khu. Với dự án công nghiệp công nghệ số, cơ quan này phải lấy ý kiến bằng văn bản của Sở Khoa học và Công nghệ (Nghị định 354/2025, Điều 21). Hãy tính thêm thời gian cho bước lấy ý kiến, và mô tả hoạt động trong hồ sơ bằng đúng từ ngữ chức năng của khu. Đơn vị quản lý khu có nhiệm vụ hỗ trợ thủ tục hành chính cho nhà đầu tư (Điều 20): nhờ họ đọc hồ sơ trước khi nộp.",
          "Bước 6, thành lập và vận hành đúng thứ tự. Đăng ký doanh nghiệp, tài khoản vốn, góp vốn, mặt bằng, giấy phép ngành nếu có. Muốn là doanh nghiệp chế xuất thì phải tính hàng rào, cổng, điều kiện giám sát hải quan trước khi hoàn thiện mặt bằng.",
          "Bước 7, hạch toán riêng thu nhập được ưu đãi ngay từ đầu. Thu nhập từ dự án ưu đãi phải tách khỏi thu nhập khác; không tách được thì ưu đãi bị phân bổ theo tỷ lệ. Lưu giấy tờ đầu tư, hợp đồng thuê và bằng chứng ngày dự án có doanh thu, vì thời gian miễn giảm tính theo các mốc này.",
          "Bước 8, kê khai ưu đãi thuế TNDN và làm các hồ sơ ưu đãi còn lại. Ưu đãi TNDN áp dụng khi kê khai, quyết toán; nên nhờ tư vấn thuế xác nhận năm bắt đầu trước lần quyết toán đầu tiên. Ưu đãi tiền thuê đất (nếu thuê đất trực tiếp), thuế TNCN cho nhân sự đạt tiêu chí và hỗ trợ chi phí sở hữu trí tuệ mỗi loại có hồ sơ riêng; một số quy trình vẫn đang được ban hành trong năm 2026, nên hỏi đơn vị quản lý khu và Sở Khoa học và Công nghệ loại nào đã mở.",
          "Bước 9, giữ điều kiện suốt thời gian hưởng. Hoạt động đúng chức năng khu và lưu hồ sơ. Nếu khu bị tạm đình chỉ hoặc chấm dứt công nhận, dự án mới không còn được hưởng ưu đãi từ thời điểm đó, còn doanh nghiệp đang hoạt động vẫn tiếp tục hưởng đến hết thời hạn (Nghị định 354/2025, Điều 15)."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Ai là nhân lực công nghệ số chất lượng cao",
        "paragraphs": [
          "Nghị định 353/2025/NĐ-CP định lượng rõ ai được hưởng chính sách thuế thu nhập cá nhân và thu hút nhân tài. Nhân sự đang làm tại doanh nghiệp công nghệ số đạt chuẩn khi đáp ứng một trong các tiêu chí (Điều 6):"
        ],
        "bullets": [
          "Chủ tịch, tổng giám đốc, giám đốc điều hành hoặc tương đương của doanh nghiệp công nghệ số có ít nhất một năm doanh thu từ 26.000 tỷ đồng trong 3 năm gần nhất.",
          "Người Việt Nam có thu nhập bình quân từ hoạt động công nghệ số trong 2 năm gần nhất tối thiểu 5 lần GDP bình quân đầu người của Việt Nam.",
          "Người nước ngoài đang làm việc tại quốc gia phát triển (theo Liên hợp quốc hoặc Ngân hàng Thế giới) có thu nhập bình quân từ hoạt động công nghệ số trong 2 năm gần nhất tối thiểu 3 lần GDP bình quân đầu người của quốc gia đó; người nước ngoài khác là 5 lần.",
          "Ngoài ra: tốt nghiệp loại giỏi, xuất sắc trong 3 năm gần nhất từ trường thuộc top 500 thế giới (QS, Times Higher Education, Shanghai Ranking, U.S. News) hoặc top 50 trong nước (Điều 7); giảng viên, nhà khoa học gắn với trường top 500 (Điều 8); có bài báo Q1 (Scopus/Web of Science) trong 5 năm gần nhất hoặc là tác giả đối tượng sở hữu trí tuệ thuộc danh mục công nghệ chiến lược, sản phẩm công nghệ số trọng điểm (Điều 10)."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": [
          "Tiêu chí đã có hiệu lực, nhưng quy trình áp dụng ưu đãi do bộ, ngành, địa phương ban hành (khoản 2 Điều 11). Doanh nghiệp nên lập sẵn danh sách nhân sự đạt chuẩn kèm bằng chứng để nộp ngay khi quy trình mở."
        ]
      },
      {
        "heading": "Sản phẩm mới chưa có khung pháp lý: cơ chế thử nghiệm có kiểm soát",
        "paragraphs": [
          "Chương IV Nghị định 353/2025 cho phép sản phẩm, dịch vụ công nghệ số mới chưa có quy định điều chỉnh được thử nghiệm, miễn tuân thủ một số quy định trong thời gian, không gian và phạm vi giới hạn."
        ],
        "bullets": [
          "Thẩm quyền cấp phép: UBND cấp tỉnh nếu thử nghiệm trong một tỉnh; bộ quản lý ngành nếu thử nghiệm từ 2 tỉnh trở lên hoặc thuộc lĩnh vực của bộ.",
          "Thời gian: tối đa 3 năm, gia hạn 1 lần, tối đa thêm 3 năm.",
          "Quy trình (Điều 25): nộp hồ sơ theo Mẫu TNCNS01 qua bưu điện, Bộ phận Một cửa hoặc Cổng Dịch vụ công quốc gia. Cơ quan cấp phép xác nhận hồ sơ hợp lệ trong 5 ngày làm việc, hoàn tất thẩm định (kể cả kiểm tra thực tế nếu cần) trong 60 ngày kể từ khi nhận hồ sơ hợp lệ, rồi ban hành Quyết định cấp phép theo Mẫu TNCNS02 hoặc trả lời từ chối bằng văn bản. Doanh nghiệp phải bắt đầu thử nghiệm trong 90 ngày kể từ ngày được cấp phép (khoản 7 Điều 25); muốn gia hạn phải nộp hồ sơ trước khi hết hạn tối thiểu 60 ngày (Điều 27).",
          "Doanh nghiệp và cơ quan cấp phép thực hiện đúng quy định thử nghiệm được miễn, loại trừ trách nhiệm."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Những lỗi hay gặp",
        "paragraphs": [],
        "bullets": [
          "Ký thuê trước khi kiểm tra mặt bằng có nằm trong khu đã được công nhận và đúng phân khu công nghệ số hay không.",
          "Nghĩ rằng doanh nghiệp đang hoạt động chuyển vào khu thì tự động được thuế suất của dự án mới.",
          "Mô tả dự án trong hồ sơ đăng ký đầu tư bằng từ ngữ không khớp chức năng khu, làm chậm bước lấy ý kiến Sở Khoa học và Công nghệ.",
          "Chờ ưu đãi tiền thuê đất khi chỉ thuê văn phòng: ưu đãi này thuộc về người sử dụng đất, thường là chủ đầu tư hạ tầng.",
          "Không hạch toán riêng thu nhập được ưu đãi, đến lúc quyết toán mới bị cắt bớt."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Nếu bạn là nhà đầu tư nước ngoài",
        "paragraphs": [
          "Bản tiếng Anh chi tiết hơn của hướng dẫn này, cùng lộ trình thủ tục đầu tư đặc biệt (R4) và công cụ xác định lộ trình đầu tư, nằm trên investor.fundraising.vn. Đường dẫn ở mục Nguồn tham khảo cuối bài.",
          "Bài viết tổng hợp từ văn bản pháp luật hiện hành tại thời điểm 09/10/2026 và chỉ mang tính định hướng. Điều kiện hưởng ưu đãi phụ thuộc vào từng dự án; hãy xác nhận với luật sư và tư vấn thuế trước khi quyết định."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      }
    ],
    "relatedTools": [
      {
        "slug": "ho-so-phap-ly-khoi-nghiep",
        "label": "Hồ sơ pháp lý khởi nghiệp"
      }
    ],
    "sources": [
      {
        "label": "investor.fundraising.vn: Centralized digital technology zones, incentives step by step (tiếng Anh)",
        "url": "https://investor.fundraising.vn/zones/centralized-digital-technology-zones"
      },
      {
        "label": "investor.fundraising.vn: Lộ trình R4, thủ tục đầu tư đặc biệt (tiếng Anh)",
        "url": "https://investor.fundraising.vn/routes/special-investment-procedure"
      },
      {
        "label": "Nghị định 354/2025/NĐ-CP về khu công nghệ số tập trung (Cổng văn bản Chính phủ)",
        "url": "https://vanban.chinhphu.vn/?docid=216385&pageid=27160"
      },
      {
        "label": "LuatVietnam: khu công nghệ số tập trung được hưởng ưu đãi như địa bàn đặc biệt khó khăn",
        "url": "https://luatvietnam.vn/tin-van-ban-moi/khu-cong-nghe-so-tap-trung-duoc-huong-uu-dai-nhu-dia-ban-dac-biet-kho-khan-186-112303-article.html"
      },
      {
        "label": "Thư viện Pháp luật: các trường hợp thuế suất TNDN 10% theo Luật Thuế TNDN 2025",
        "url": "https://thuvienphapluat.vn/phap-luat/thue-suat-uu-dai-thue-tndn-10-ap-dung-doi-voi-cac-truong-hop-nao-theo-luat-thue-thu-nhap-doanh-nghi-16744-261885.html"
      },
      {
        "label": "Luật Thuế TNDN 2025, Điều 14 (miễn, giảm thuế)",
        "url": "https://hethongphapluat.com/luat-thue-thu-nhap-doanh-nghiep-2025/dieu-14"
      },
      {
        "label": "Nghị định 353/2025/NĐ-CP ngày 31/12/2025 quy định chi tiết Luật Công nghiệp công nghệ số (LuatVietnam)",
        "url": "https://luatvietnam.vn/cong-nghiep/nghi-dinh-353-2025-nd-cp-quy-dinh-chi-tiet-luat-cong-nghiep-cong-nghe-so-423495-d1.html"
      },
      {
        "label": "Bộ Khoa học và Công nghệ: 6 thông tư hướng dẫn Luật Công nghiệp công nghệ số",
        "url": "https://mst.gov.vn/6-thong-tu-huong-dan-luat-cong-nghiep-cong-nghe-so-duoc-ban-hanh-trong-thang-11-197251206215152423.htm"
      },
      {
        "label": "Bộ Khoa học và Công nghệ: khu công nghệ số tập trung (12/2025)",
        "url": "https://mst.gov.vn/khu-cong-nghe-so-tap-trung-noi-tri-thuc-va-doi-moi-sang-tao-thuc-day-manh-me-197251206212622569.htm"
      }
    ],
    "seoTitle": "Ưu đãi khu công nghệ số tập trung 2026: điều kiện và các bước để được hưởng",
    "seoDescription": "Khu công nghệ số tập trung được ưu đãi gì theo Luật Công nghiệp công nghệ số, Nghị định 354/2025 và Luật Thuế TNDN 2025; ai được hưởng; hồ sơ và 9 bước để doanh nghiệp, nhà đầu tư nhận ưu đãi.",
    "publishedAt": "2026-10-09",
    "updatedAt": "2026-10-26",
    "track": "chinh-sach",
    "readingMinutes": 11
  },
  {
    "slug": "vi-sao-khong-co-doi-thu-la-cau-tra-loi-nguy-hiem",
    "title": "Vì sao “chúng tôi không có đối thủ” là câu trả lời nguy hiểm?",
    "excerpt": "Không có đối thủ trực tiếp không có nghĩa khách hàng chưa có cách thay thế sản phẩm của bạn.",
    "category": "Góc nhìn quỹ",
    "stages": [
      "Idea",
      "Pre-seed"
    ],
    "storyType": "huong-dan",
    "templates": [],
    "consentConfirmed": false,
    "coverImage": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Fvi-sao-khong-co-doi-thu-la-cau-tra-loi-nguy-hiem%2F1790080568839-cover.webp?alt=media&token=42e6a170-5b30-4da8-9e77-16885f695956",
    "coverAlt": "Vì sao “chúng tôi không có đối thủ” là câu trả lời nguy hiểm?",
    "coverCaption": "",
    "ogImage": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Fvi-sao-khong-co-doi-thu-la-cau-tra-loi-nguy-hiem%2F1790080569151-cover.jpg?alt=media&token=2423ca02-7dec-44b4-b187-82264d98d86e",
    "author": "Fundraising Vietnam",
    "authorRole": "",
    "status": "PUBLISHED",
    "featured": false,
    "sections": [
      {
        "heading": "Nhà đầu tư nghe câu này theo hai cách",
        "paragraphs": [
          "Khi founder nói “chúng tôi không có đối thủ”, nhà đầu tư thường hiểu theo một trong hai hướng. Hoặc founder chưa tìm hiểu thị trường đủ kỹ. Hoặc thị trường này không tồn tại — vì nếu vấn đề đủ lớn và đủ đau, hẳn đã có người thử giải nó.",
          "Cả hai cách hiểu đều bất lợi cho bạn. Câu trả lời nhằm thể hiện sự tự tin lại thành tín hiệu rủi ro."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Đối thủ lớn nhất có thể là hiện trạng",
        "paragraphs": [
          "Khách hàng có thể dùng Excel, thuê thêm người, tự xây công cụ, nhắn nhau qua nhóm Zalo hoặc đơn giản là chấp nhận vấn đề. Đây đều là phương án thay thế mà startup phải thắng.",
          "Ví dụ: một phần mềm quản lý tồn kho cho tiệm tạp hoá không cạnh tranh với phần mềm nào khác trong khu phố. Đối thủ thật của nó là cuốn sổ tay và trí nhớ của chủ tiệm — miễn phí, quen thuộc và không cần học. Thắng được đối thủ này khó hơn nhiều so với thắng một phần mềm khác."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Ba lớp đối thủ",
        "paragraphs": [
          "Liệt kê đủ ba lớp cho thấy bạn nhìn thị trường từ phía khách hàng, không chỉ từ phía sản phẩm."
        ],
        "bullets": [
          "Đối thủ trực tiếp: sản phẩm giải cùng vấn đề cho cùng nhóm khách, kể cả công ty nước ngoài có thể vào Việt Nam.",
          "Đối thủ gián tiếp: sản phẩm khác loại nhưng khách hàng dùng để giải cùng vấn đề, ví dụ phần mềm kế toán có kèm quản lý kho.",
          "Hiện trạng: cách khách hàng đang tự xoay xở — làm tay, thuê người, hoặc không làm gì."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Cách trình bày slide cạnh tranh",
        "paragraphs": [
          "Ma trận hai trục với công ty mình nằm một mình ở góc trên bên phải rất phổ biến, và cũng rất dễ bị bỏ qua, vì chính founder chọn hai trục. So sánh theo tiêu chí quyết định mua của khách hàng thuyết phục hơn: chi phí, thời gian triển khai, độ chính xác, rủi ro chuyển đổi.",
          "Hãy trung thực ở những chỗ đối thủ làm tốt hơn. Một bảng có vài ô bạn thua cho thấy bạn hiểu mình đang chọn thắng ở đâu — và nhà đầu tư sẽ tin các ô bạn thắng hơn."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Bằng chứng cần có",
        "paragraphs": [],
        "bullets": [
          "Khách hàng đã thử giải pháp nào trước đây?",
          "Vì sao họ đổi sang bạn, hoặc vì sao họ chưa đổi?",
          "Chi phí chuyển đổi là gì: tiền, thời gian, dữ liệu, thói quen?",
          "Lợi thế nào khó bị sao chép khi startup tăng trưởng: dữ liệu tích luỹ, mạng lưới, kênh phân phối, quan hệ độc quyền?",
          "Nếu một công ty lớn làm tính năng tương tự, điều gì giữ khách hàng lại với bạn?"
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Khi thật sự chưa có ai làm",
        "paragraphs": [
          "Đôi khi đúng là chưa có sản phẩm nào giải vấn đề theo cách của bạn. Khi đó hãy trả lời trước câu hỏi nhà đầu tư chắc chắn sẽ hỏi: vì sao chưa ai làm? Đã có người thử và thất bại chưa, họ thất bại vì đâu? Điều gì mới thay đổi — công nghệ, quy định, hành vi khách hàng — khiến bây giờ mới là thời điểm đúng?",
          "Câu trả lời tốt cho “vì sao bây giờ” biến khoảng trống thị trường từ dấu hiệu rủi ro thành cơ hội có lý do."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Mẫu câu trả lời",
        "paragraphs": [
          "“Hiện chưa có đối thủ trực tiếp tại Việt Nam, nhưng khách hàng của chúng tôi đang xử lý việc này bằng Excel và một nhân viên kho bán thời gian, tốn khoảng 8 triệu đồng mỗi tháng. Hai phần mềm quản lý bán hàng lớn có tính năng tồn kho, nhưng không dự báo được thời điểm hết hàng. Trong 30 khách đã chuyển sang chúng tôi, 22 khách trước đó dùng Excel. Rủi ro lớn nhất là các phần mềm bán hàng thêm tính năng dự báo; lợi thế của chúng tôi là dữ liệu bán hàng theo mùa của hơn 200 cửa hàng.”",
          "Câu trả lời này không né câu hỏi, nêu rõ phương án thay thế, có số liệu, và tự chỉ ra rủi ro trước khi bị hỏi."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      }
    ],
    "relatedTools": [
      {
        "slug": "quy-mo-thi-truong",
        "label": "Tính quy mô thị trường"
      },
      {
        "slug": "pitch-deck-10-slide",
        "label": "Kiểm tra pitch deck 10 slide"
      }
    ],
    "sources": [],
    "seoTitle": "Vì sao “chúng tôi không có đối thủ” là câu trả lời nguy hiểm khi gọi vốn",
    "seoDescription": "Nhà đầu tư nghe câu “không có đối thủ” theo hai cách, cả hai đều bất lợi. Cách phân ba lớp đối thủ, trình bày slide cạnh tranh trung thực và mẫu câu trả lời.",
    "publishedAt": "2026-09-16",
    "updatedAt": "2026-09-22",
    "track": "kinh-nghiem",
    "readingMinutes": 3
  },
  {
    "slug": "vi-sao-nha-dau-tu-thien-than-doi-loi-nhuan-30-lan",
    "title": "Vì sao nhà đầu tư thiên thần đòi lợi nhuận 30 lần: phép tính phía sau một con số nghe như tham",
    "excerpt": "Founder thường thấy con số 20 đến 30 lần là vô lý. Dữ liệu từ 117 khoản đầu tư thật cho thấy vì sao nó không phải lòng tham: phần lớn khoản đầu tư mất vốn hoặc chỉ hoà, một nhóm nhỏ gánh cả danh mục, và cổ phần của nhà đầu tư sớm tăng chậm hơn giá trị công ty nhiều lần vì pha loãng.",
    "category": "Định giá",
    "stages": [
      "Idea",
      "Pre-seed",
      "Seed"
    ],
    "storyType": "huong-dan",
    "templates": [
      "term-sheet-vong-seed"
    ],
    "consentConfirmed": false,
    "coverImage": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Fvi-sao-nha-dau-tu-thien-than-doi-loi-nhuan-30-lan%2F1793521210770-cover.webp?alt=media&token=b587a971-4941-422a-b614-9fb604970dd4",
    "coverAlt": "Danh mục 117 khoản đầu tư thiên thần: 14% số khoản tạo ra 84% lợi nhuận, khoản thành công lớn trung bình lãi 33 lần sau 8,6 năm",
    "coverCaption": "Trong danh mục của nhà đầu tư thiên thần, một nhóm nhỏ khoản đầu tư phải gánh lợi nhuận cho tất cả phần còn lại.",
    "ogImage": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Fvi-sao-nha-dau-tu-thien-than-doi-loi-nhuan-30-lan%2F1793521213958-cover.jpg?alt=media&token=e795801c-23f8-4e0d-95d4-d61e8acb02f0",
    "author": "Fundraising Vietnam",
    "authorRole": "",
    "status": "PUBLISHED",
    "featured": false,
    "sections": [
      {
        "heading": "Con số nghe như tham",
        "paragraphs": [
          "Một founder gọi 3 tỷ đồng ở vòng angel. Nhà đầu tư nói họ cần khoản đầu tư này có khả năng mang về gấp 20 đến 30 lần. Founder nghĩ: gửi ngân hàng được 6% một năm, cổ phiếu tốt được 15%, sao người này đòi tới 30 lần?",
          "Câu trả lời không nằm ở công ty của bạn, mà ở cả danh mục của nhà đầu tư. Họ không đặt cược vào một công ty, họ đặt cược vào mười hay hai mươi công ty cùng lúc, biết trước phần lớn sẽ không thành. Con số 30 lần là phép tính để cả danh mục có lãi, cộng với một hiệu ứng ít founder để ý: phân kỳ định giá.",
          "Bài này dựa trên bộ tài liệu về định giá công ty chưa có doanh thu của Quỹ Kauffman và Angel Capital Education Foundation, do các nhà đầu tư thiên thần Luis Villalobos (Tech Coast Angels) và Bill Payne viết."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Danh mục thật của bốn nhà đầu tư thiên thần",
        "paragraphs": [
          "Villalobos gom danh mục của bốn nhà đầu tư thiên thần có kinh nghiệm: 117 công ty, tổng vốn rót gần 9,94 triệu USD, tổng tiền thu về hơn 50 triệu USD. Nhìn tổng thì đẹp, khoảng 5 lần. Nhưng chia theo từng nhóm kết quả thì câu chuyện khác hẳn."
        ],
        "bullets": [],
        "image": {
          "url": "https://fundraising.vn/anh/playbook/vi-sao-nha-dau-tu-thien-than-doi-loi-nhuan-30-lan/danh-muc-117-khoan.webp",
          "alt": "Biểu đồ 117 khoản đầu tư thiên thần chia theo kết quả: 31 mất trắng, 26 lỗ, 23 chưa thoái tính bằng giá vốn, 21 lãi 1 đến 10 lần, 16 lãi trên 10 lần; 14% số khoản tạo ra 84% tổng lợi nhuận",
          "caption": "",
          "credit": "",
          "width": 1600,
          "height": 833,
          "fit": "nguyen-ban",
          "position": "cuoi",
          "urlHep": "https://fundraising.vn/anh/playbook/vi-sao-nha-dau-tu-thien-than-doi-loi-nhuan-30-lan/danh-muc-117-khoan-hep.webp"
        },
        "quote": null,
        "table": {
          "caption": "117 khoản đầu tư thiên thần, chia theo kết quả",
          "headers": [
            "Kết quả",
            "Số công ty",
            "Điều đáng chú ý"
          ],
          "rows": [
            {
              "cells": [
                "Mất trắng",
                "31",
                "Thất bại trung bình sau 2,6 năm, mất toàn bộ 2,3 triệu USD đã rót"
              ]
            },
            {
              "cells": [
                "Trả lại ít hơn vốn",
                "26",
                "Có thu về nhưng lỗ"
              ]
            },
            {
              "cells": [
                "Chưa có vòng định giá mới",
                "23",
                "Tạm tính bằng giá vốn, chưa thoái được"
              ]
            },
            {
              "cells": [
                "Lãi từ 1 đến 10 lần",
                "21",
                "Có lãi nhưng không đủ bù cho các khoản lỗ"
              ]
            },
            {
              "cells": [
                "Lãi trên 10 lần",
                "16",
                "Trung bình lãi 33,3 lần, mất trung bình 8,6 năm mới thoái vốn"
              ]
            }
          ]
        },
        "notes": [
          "Khoảng 14% số khoản đầu tư tạo ra 84% tổng lợi nhuận. Toàn bộ tiền thu về từ các khoản lãi dưới 10 lần cộng lại chỉ được khoảng 8,16 triệu USD, còn ít hơn tổng vốn rót cho cả danh mục. Nói cách khác, nếu không có nhóm thành công lớn, cả danh mục lỗ. Giới đầu tư gọi đây là [[luat-luy-thua|luật lũy thừa]]; ở cấp quỹ, xem [[/playbook/toan-hoc-quy-vc-vi-sao-quy-tu-choi-startup-co-lai|Toán học của quỹ VC]].",
          "Thời gian cũng lệch hẳn: trung bình một khoản đầu tư có kết quả sau 4 năm, nhưng các khoản thành công lớn mất 8,6 năm. Khoản hỏng lộ ra sớm, khoản tốt chín muộn."
        ]
      },
      {
        "heading": "Tính ngược bằng tiền Việt",
        "paragraphs": [
          "Giả sử một nhà đầu tư thiên thần rót 500 triệu đồng vào mỗi công ty, mười công ty, tổng 5 tỷ. Họ muốn sau 6 đến 8 năm cả danh mục mang về khoảng 3 lần, tức 15 tỷ. Mức này tương đương lợi suất khoảng 20% đến 25% một năm, không cao so với rủi ro họ chịu.",
          "Theo đúng tỷ lệ ở bảng trên: năm công ty mất trắng, ba công ty chỉ trả lại vốn (1,5 tỷ), một công ty lãi 3 lần (1,5 tỷ). Mười công ty mới mang về 3 tỷ. Phần còn thiếu, 12 tỷ, phải đến từ đúng một công ty. Công ty đó phải mang về 24 lần số tiền đã rót.",
          "Và 24 lần là số tiền nhà đầu tư thực nhận. Để phần của họ tăng 24 lần, giá trị công ty phải tăng nhiều hơn thế nhiều, vì lý do ở phần tiếp theo."
        ],
        "bullets": [],
        "image": {
          "url": "https://fundraising.vn/anh/playbook/vi-sao-nha-dau-tu-thien-than-doi-loi-nhuan-30-lan/tinh-nguoc-bang-tien-viet.webp",
          "alt": "Thanh tiền mười công ty mang về so với vốn rót 5 tỷ và mục tiêu 15 tỷ: 3 công ty hoà vốn 1,5 tỷ, 1 công ty lãi 3 lần 1,5 tỷ, 5 công ty mất trắng, một công ty phải mang về 12 tỷ tức 24 lần",
          "caption": "",
          "credit": "",
          "width": 1600,
          "height": 742,
          "fit": "nguyen-ban",
          "position": "cuoi",
          "urlHep": "https://fundraising.vn/anh/playbook/vi-sao-nha-dau-tu-thien-than-doi-loi-nhuan-30-lan/tinh-nguoc-bang-tien-viet-hep.webp"
        },
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Phân kỳ định giá: công ty tăng 100 lần, cổ phần chỉ tăng 30 lần",
        "paragraphs": [
          "Founder hay viết trong slide: bán cho anh 10% lấy 2 tỷ, sáu năm nữa công ty được bán 500 tỷ, anh nhận 50 tỷ, gấp 25 lần. Phép tính này bỏ quên các vòng gọi vốn sau. Mỗi vòng bán thêm 15% đến 25% công ty, mỗi lần mở rộng quỹ cổ phiếu thưởng lại pha loãng thêm.",
          "Villalobos gọi khoảng chênh này là [[phan-ky-dinh-gia|phân kỳ định giá]]: tỷ lệ giữa mức tăng giá trị công ty và mức tăng giá trị cổ phần của nhà đầu tư sớm. Ở các thương vụ thành công mà ông theo dõi, con số này thường từ 3 đến 5 lần. Ví dụ thật của ông là Gadzoox Networks: nhóm angel rót 2 triệu USD cho 30,3% cổ phần; tới lúc IPO, giá trị công ty tăng 284 lần nhưng giá mỗi cổ phần chỉ tăng 101 lần, vì phần sở hữu của họ đã giảm còn 10,8%.",
          "Ghép hai phần lại: nhà đầu tư cần khoản thắng lãi thực khoảng 5 đến 10 lần mới bù được danh mục, nhân với phân kỳ 3 đến 5 lần. Kết quả là khi tính bằng một bảng cổ phần chưa pha loãng, họ phải nhắm tới khoảng 20 đến 30 lần. Con số 30 lần không phải đòi hỏi thêm, mà là cùng một kỳ vọng được viết theo hai cách."
        ],
        "bullets": [],
        "image": {
          "url": "https://fundraising.vn/anh/playbook/vi-sao-nha-dau-tu-thien-than-doi-loi-nhuan-30-lan/phan-ky-dinh-gia.webp",
          "alt": "Hai biểu đồ: Gadzoox Networks giá trị công ty tăng 284 lần còn giá mỗi cổ phần tăng 101 lần; ví dụ minh hoạ tỷ lệ sở hữu angel từ 10% còn 8%, 6,4% rồi 5,1% sau ba vòng, nên khi bán công ty 500 tỷ chỉ",
          "caption": "",
          "credit": "",
          "width": 1600,
          "height": 866,
          "fit": "nguyen-ban",
          "position": "cuoi",
          "urlHep": "https://fundraising.vn/anh/playbook/vi-sao-nha-dau-tu-thien-than-doi-loi-nhuan-30-lan/phan-ky-dinh-gia-hep.webp"
        },
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Con số này đi vào định giá của bạn như thế nào",
        "paragraphs": [
          "[[phuong-phap-vc|Phương pháp VC]] (giáo sư William Sahlman, Harvard, 1987) dùng chính con số này để tính ngược định giá: định giá [[pre-money-post-money|post-money]] bằng giá trị công ty lúc thoái vốn chia cho bội số lợi nhuận nhà đầu tư cần.",
          "Ví dụ: nhà đầu tư tin công ty có thể được bán với giá 600 tỷ đồng sau 6 năm, và cần 30 lần. Định giá post-money hôm nay là 600 chia 30, tức 20 tỷ. Nếu bạn gọi 4 tỷ, định giá pre-money là 16 tỷ.",
          "Muốn định giá cao hơn, bạn có hai đòn bẩy: chứng minh giá trị thoái vốn lớn hơn một cách đáng tin, hoặc giảm rủi ro để nhà đầu tư chấp nhận bội số thấp hơn. Payne viết rằng 30 lần là mức ông dùng cho công ty chưa có doanh thu, founder lần đầu, mới có sản phẩm mẫu; công ty đã đạt thêm cột mốc thì ông chấp nhận bội số thấp hơn."
        ],
        "bullets": [
          "Giá trị thoái vốn lớn hơn: thị trường đủ rộng, có người mua cụ thể có lý do chiến lược, có thương vụ tương tự đã xảy ra.",
          "Rủi ro thấp hơn: khách hàng trả tiền thật, đội ngũ đã làm được việc tương tự, sở hữu trí tuệ nằm gọn trong công ty, bảng cổ phần sạch."
        ],
        "image": {
          "url": "https://fundraising.vn/anh/playbook/vi-sao-nha-dau-tu-thien-than-doi-loi-nhuan-30-lan/phuong-phap-vc-30-lan.webp",
          "alt": "Sơ đồ phương pháp VC: giá bán dự kiến 600 tỷ chia bội số 30 lần ra post-money 20 tỷ, trừ 4 tỷ gọi vốn ra pre-money 16 tỷ; hai đòn bẩy là giá bán lớn và đáng tin hơn, rủi ro thấp hơn",
          "caption": "",
          "credit": "",
          "width": 1600,
          "height": 679,
          "fit": "nguyen-ban",
          "position": "cuoi",
          "urlHep": "https://fundraising.vn/anh/playbook/vi-sao-nha-dau-tu-thien-than-doi-loi-nhuan-30-lan/phuong-phap-vc-30-lan-hep.webp"
        },
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Ở Việt Nam, kỳ vọng còn khắt khe hơn",
        "paragraphs": [
          "Dữ liệu trên là của thị trường Mỹ, nơi thoái vốn qua niêm yết và mua bán sáp nhập diễn ra thường xuyên. Ở Việt Nam, lối ra hẹp hơn nhiều. Theo báo cáo Vietnam Innovation & Private Capital Report 2026, năm 2025 cả nước có ba thương vụ IPO, đều trong ngành dịch vụ tài chính, và đã năm năm liền không có công ty công nghệ được quỹ đầu tư nào niêm yết trên sàn trong nước.",
          "Khi lối ra ít và chậm, nhà đầu tư càng cần mỗi khoản thắng thắng lớn. Đó là lý do quỹ Việt Nam hỏi rất sớm: ai sẽ mua công ty này, và vì sao."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Founder nên làm gì với hiểu biết này",
        "paragraphs": [],
        "bullets": [
          "Đừng tranh luận rằng 30 lần là tham. Hãy cho thấy công ty có đường đi tới quy mô gấp 50 đến 100 lần hôm nay, kể cả khi nhiều thứ không theo kế hoạch.",
          "Bỏ slide nhân tỷ lệ sở hữu hôm nay với giá bán công ty. Thay bằng kịch bản có pha loãng qua các vòng sau, công cụ mô phỏng vòng gọi vốn tính sẵn phần phân kỳ.",
          "Chuẩn bị câu trả lời cho câu hỏi thoái vốn: hai ba nhóm người mua tiềm năng, kèm một thương vụ tương tự đã xảy ra trong khu vực.",
          "Kiên nhẫn với nhà đầu tư và với chính mình. Khoản thành công lớn mất trung bình 8,6 năm; một nhà đầu tư thiên thần tốt cũng cần để dành tiền cho các vòng sau của bạn.",
          "Nếu mô hình kinh doanh tốt nhưng không thể tăng 10 lần, đó không phải lỗi. Đó là tín hiệu nên tìm nguồn vốn khác: vay, tài trợ không hoàn lại, hoặc tự thân."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Tóm lại",
        "paragraphs": [
          "Nhà đầu tư thiên thần đòi 20 đến 30 lần vì ba điều cùng lúc: phần lớn khoản đầu tư không có lãi, một nhóm nhỏ phải gánh lợi nhuận cho cả danh mục, và cổ phần của họ bị pha loãng 3 đến 5 lần trước khi tới lúc thoái vốn. Hiểu phép tính này, cuộc nói chuyện về định giá chuyển từ mặc cả sang cùng trả lời một câu hỏi: công ty này có thể lớn tới đâu."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      }
    ],
    "relatedTools": [
      {
        "slug": "dinh-gia-pre-seed",
        "label": "Ước khoảng định giá vòng đầu"
      },
      {
        "slug": "mo-phong-vong-goi-von",
        "label": "Xem phân kỳ định giá qua nhiều vòng"
      },
      {
        "slug": "dinh-gia-co-doanh-thu",
        "label": "Tính ngược định giá bằng phương pháp VC"
      },
      {
        "slug": "bang-co-phan-va-pha-loang",
        "label": "Dựng bảng cổ phần sau mỗi vòng"
      }
    ],
    "sources": [
      {
        "label": "Angel Capital Education Foundation, Kauffman Foundation: Valuing Pre-revenue Companies (Villalobos, Payne, Lipper)",
        "url": "https://www.angelcapitalassociation.org/data/Documents/Resources/AngelCapitalEducation/ACEF_-_Valuing_Pre-revenue_Companies.pdf?rev=FD23"
      },
      {
        "label": "TechNode Global: Vietnam's private capital surges to $4.5B, IPO remains shut for technology (05/2026)",
        "url": "https://technode.global/2026/05/29/vietnams-private-capital-surges-to-4-5b-as-pe-hits-record-high-ipo-remains-shut-for-technology/"
      }
    ],
    "seoTitle": "Vì sao nhà đầu tư thiên thần đòi lợi nhuận 20 đến 30 lần: dữ liệu 117 khoản đầu tư và phân kỳ định giá",
    "seoDescription": "Giải thích bằng số vì sao angel và quỹ vòng sớm cần mỗi khoản đầu tư có khả năng lãi 20 đến 30 lần: luật số mũ của danh mục, home run mất 8,6 năm, phân kỳ định giá 3 đến 5 lần và phương pháp VC, kèm ví dụ bằng VNĐ.",
    "publishedAt": "2026-10-20",
    "updatedAt": "2026-11-01",
    "track": "cam-nang",
    "readingMinutes": 8
  },
  {
    "slug": "xay-mo-hinh-tai-chinh-cho-startup",
    "title": "Xây mô hình tài chính cho startup: cấu trúc chuẩn và 3 lỗi khiến quỹ mất niềm tin",
    "excerpt": "Một mô hình tài chính không phải để dự đoán đúng tương lai, mà để chứng minh bạn hiểu doanh nghiệp của mình vận hành bằng biến số nào.",
    "category": "Mô hình tài chính",
    "stages": [
      "Pre-seed",
      "Seed"
    ],
    "storyType": "huong-dan",
    "templates": [
      "mo-hinh-tai-chinh-saas"
    ],
    "consentConfirmed": false,
    "coverImage": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Fxay-mo-hinh-tai-chinh-cho-startup%2F1790080570740-cover.webp?alt=media&token=17866034-4744-46a6-885d-6ef3792ee800",
    "coverAlt": "Xây mô hình tài chính cho startup: cấu trúc chuẩn và 3 lỗi khiến quỹ mất niềm tin",
    "coverCaption": "",
    "ogImage": "https://firebasestorage.googleapis.com/v0/b/fundraising-vn.firebasestorage.app/o/playbook%2Fxay-mo-hinh-tai-chinh-cho-startup%2F1790080571020-cover.jpg?alt=media&token=68b78c5f-3754-4816-9780-d39138b6a3ec",
    "author": "Fundraising Vietnam",
    "authorRole": "",
    "status": "PUBLISHED",
    "featured": false,
    "sections": [
      {
        "heading": "Mô hình tài chính dùng để làm gì",
        "paragraphs": [
          "Nhiều founder dựng mô hình tài chính như dựng một bài thuyết trình: đặt mục tiêu doanh thu ba năm rồi tìm cách lấp số vào cho khớp. Nhà đầu tư đọc bảng đó trong khoảng ba mươi giây là nhận ra, vì mọi dòng đều tăng trưởng đều tắp và không có dòng nào giải thích vì sao.",
          "Mô hình tài chính không có nhiệm vụ dự đoán đúng tương lai. Không ai tin con số doanh thu tháng thứ ba mươi sáu của một startup pre-seed, kể cả người viết ra nó. Nhiệm vụ của nó là chứng minh bạn biết doanh nghiệp mình chạy bằng biến số nào, biến số nào bạn kiểm soát được, và tiền của nhà đầu tư sẽ tác động vào biến số nào.",
          "Nói cách khác: người đọc không mua con số, họ mua cách bạn suy nghĩ về con số."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Cấu trúc bốn tầng",
        "paragraphs": [
          "Một mô hình dùng được luôn có bốn tầng, xếp theo đúng thứ tự này. Đảo thứ tự là nguồn gốc của phần lớn bảng tính không thể kiểm chứng."
        ],
        "bullets": [
          "Tầng 1 — Giả định: mọi con số bạn nhập tay, tách riêng một tab, mỗi dòng có ghi chú nguồn. Không con số nào được nhúng thẳng vào công thức.",
          "Tầng 2 — Biến số điều khiển: ba đến năm biến quyết định doanh thu của ngành bạn. Với SaaS là khách mới, tỷ lệ rời đi và doanh thu mỗi khách; với chuỗi F&B là số điểm bán, số hoá đơn mỗi ngày và giá trị mỗi hoá đơn.",
          "Tầng 3 — Báo cáo: doanh thu, lợi nhuận gộp, chi phí, đốt ròng, tiền mặt cuối kỳ. Toàn bộ là công thức trỏ về hai tầng trên.",
          "Tầng 4 — Kết luận: runway, tháng hết tiền, số vốn cần gọi và cột mốc số vốn đó mở khoá. Đây là phần bạn đưa vào pitch deck."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Lỗi 1: tính đốt ròng theo doanh thu thay vì lợi nhuận gộp",
        "paragraphs": [
          "Đây là lỗi phổ biến nhất và cũng dễ sửa nhất. Đốt ròng phải bằng tổng chi phí trừ lợi nhuận gộp, không phải trừ doanh thu. Lấy doanh thu là bỏ qua giá vốn, và bảng của bạn trông đẹp hơn thực tế.",
          "Khoảng cách này rất lớn với các mô hình biên thấp. Một startup thương mại điện tử có doanh thu 10 tỷ đồng nhưng biên gộp 40% chỉ thực sự mang về 4 tỷ để bù chi phí vận hành. Tính theo doanh thu, runway của bạn dài hơn thực tế gấp hơn hai lần — và bạn sẽ hết tiền vào đúng tháng mà bảng nói vẫn còn an toàn."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Lỗi 2: tăng trưởng đều tắp",
        "paragraphs": [
          "Mười phần trăm mỗi tháng trong ba mươi sáu tháng liền là dấu hiệu rõ nhất của một bảng dựng ngược từ mục tiêu. Trong thực tế, tăng trưởng chậm lại theo quy mô: mười khách đầu tiên đến từ mạng quan hệ của founder, một trăm khách tiếp theo cần một quy trình bán hàng, và một nghìn khách cần một tổ chức.",
          "Cách xử lý đơn giản là để tốc độ tăng trưởng giảm dần theo thời gian, và nói rõ trong ghi chú vì sao bạn giả định như vậy. Một mô hình giảm tốc có lý do đáng tin hơn một mô hình tăng đều không có lý do."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Lỗi 3: không có kịch bản xấu",
        "paragraphs": [
          "Nhà đầu tư nào cũng sẽ tự thử: hạ tăng trưởng một nửa, nâng chi phí hai mươi phần trăm, rồi xem tháng nào bạn hết tiền. Nếu bạn chưa làm việc đó trước, bạn sẽ phải trả lời tại chỗ trong cuộc họp, và câu trả lời ứng biến thường tệ hơn câu trả lời đã chuẩn bị.",
          "Ba kịch bản là đủ: kế hoạch cơ sở, kế hoạch chậm hơn, và kế hoạch phòng vệ khi không gọi được vốn. Kịch bản thứ ba quan trọng nhất, vì nó cho thấy bạn kiểm soát được chi phí chứ không chỉ kiểm soát được kỳ vọng."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Mỗi ngành cần một mô hình khác nhau",
        "paragraphs": [
          "Đây là lý do một mẫu dùng cho mọi startup thường không dùng được cho ai. Biến số điều khiển doanh thu khác nhau về bản chất, nên cấu trúc bảng cũng phải khác."
        ],
        "bullets": [
          "SaaS và phần mềm B2B: doanh thu định kỳ, tỷ lệ rời đi, thời gian hoàn vốn chi phí thu hút khách.",
          "F&B và chuỗi bán lẻ: doanh thu mỗi điểm bán, vốn đầu tư mở một điểm, thời gian hoàn vốn một điểm.",
          "Thương mại điện tử: lưu lượng, tỷ lệ chuyển đổi, giá trị đơn, tỷ lệ mua lại và tỷ lệ hoàn hàng.",
          "Logistics: công suất, tỷ lệ chuyến rỗng, doanh thu trên mỗi chuyến.",
          "Sản xuất: biên gộp theo dây chuyền và vòng quay vốn lưu động."
        ],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      },
      {
        "heading": "Bắt đầu từ đâu",
        "paragraphs": [
          "Đừng mở một tệp trắng. Lấy mẫu theo ngành của bạn bên dưới, thay giả định mặc định bằng số thực tế của ba tháng gần nhất, rồi đọc tab Tóm tắt. Nếu tiền mặt cuối tháng 12 là số âm, bạn vừa biết một điều quan trọng hơn mọi slide trong deck: bạn cần vốn sớm hơn bạn nghĩ."
        ],
        "bullets": [],
        "image": null,
        "quote": null,
        "table": null,
        "notes": []
      }
    ],
    "relatedTools": [
      {
        "slug": "tinh-runway",
        "label": "Tính runway"
      },
      {
        "slug": "goi-bao-nhieu",
        "label": "Lập kế hoạch số vốn"
      },
      {
        "slug": "kiem-tra-gia-dinh-kinh-te-don-vi",
        "label": "Kiểm tra kinh tế đơn vị"
      }
    ],
    "sources": [],
    "seoTitle": "Xây mô hình tài chính cho startup: cấu trúc chuẩn và 3 lỗi khiến quỹ mất niềm tin",
    "seoDescription": "Một mô hình tài chính không phải để dự đoán đúng tương lai, mà để chứng minh bạn hiểu doanh nghiệp của mình vận hành bằng biến số nào.",
    "publishedAt": "2026-09-18",
    "updatedAt": "2026-09-22",
    "track": "cam-nang",
    "readingMinutes": 4
  }
];
